var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 931.167,
    height: 162.601,
    viewBox: "0 0 931.167 162.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-387 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31359",
    "data-name": "Path 31359",
    d: "M796.559,16.949H785.63V81.9H778v9.073h76.5V81.9h-7.63V16.949h-7.217c-.794,0-2.128.247-2.821-.212-1-.66-1.309-4-1.8-5.149a19.013,19.013,0,0,0-5.891-7.58C817.654-4.775,797.79,1.489,796.559,16.949Z",
    transform: "translate(-310.372 0)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31360",
    "data-name": "Path 31360",
    d: "M1012,127.18v.206h.619Z",
    transform: "translate(-496.119 -100.952)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31361",
    "data-name": "Path 31361",
    d: "M918,128.18l.206.206Z",
    transform: "translate(-421.503 -101.746)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31362",
    "data-name": "Path 31362",
    d: "M919,128.18l.206.619.412-.619Z",
    transform: "translate(-422.297 -101.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31363",
    "data-name": "Path 31363",
    d: "M921.206,128.18,921,129.417h.206Z",
    transform: "translate(-423.884 -101.746)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31364",
    "data-name": "Path 31364",
    d: "M922.206,128.18l.825.619V129L922,128.8v.619l4.33.412v-.206Z",
    transform: "translate(-424.678 -101.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31365",
    "data-name": "Path 31365",
    d: "M924,128.18l.206.206Z",
    transform: "translate(-426.265 -101.746)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31366",
    "data-name": "Path 31366",
    d: "M925,128.18l.206.206L925,128.18m3.506,0,.206.206Z",
    transform: "translate(-427.059 -101.746)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31367",
    "data-name": "Path 31367",
    d: "M943,128.18l.206.206Z",
    transform: "translate(-441.347 -101.746)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31368",
    "data-name": "Path 31368",
    d: "M944,128.18l.206.206Z",
    transform: "translate(-442.141 -101.746)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31369",
    "data-name": "Path 31369",
    d: "M1011,128.18l.206.206Z",
    transform: "translate(-495.325 -101.746)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31370",
    "data-name": "Path 31370",
    d: "M1005,129l1.856,1.237,1.443-.619v-.206h-1.237v-.206l2.268-.206,5.155.656,1.65.169.619.206.412-.619-2.062.206-2.681-.214-4.124-1.229.619.619V129l-1.443-.619.412.619-1.444-.206v-.412h.825Z",
    transform: "translate(-490.563 -101.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31371",
    "data-name": "Path 31371",
    d: "M1016,128.18l.206.206Z",
    transform: "translate(-499.294 -101.746)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31372",
    "data-name": "Path 31372",
    d: "M1020,128.18l.412.619Z",
    transform: "translate(-502.469 -101.746)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31373",
    "data-name": "Path 31373",
    d: "M1022,128.18l.206.206Z",
    transform: "translate(-504.057 -101.746)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31374",
    "data-name": "Path 31374",
    d: "M908.694,128.18l.206.206-.206-.206M879,128.386l.206.206Z",
    transform: "translate(-390.545 -101.746)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31375",
    "data-name": "Path 31375",
    d: "M879.206,129.18l-.206.412Z",
    transform: "translate(-390.545 -102.539)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31376",
    "data-name": "Path 31376",
    d: "M911,129.18v.206h.619L911,129.18m1.443,0,.206.206Z",
    transform: "translate(-415.946 -102.539)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31377",
    "data-name": "Path 31377",
    d: "M926,129.18l.206.206Z",
    transform: "translate(-427.853 -102.539)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31378",
    "data-name": "Path 31378",
    d: "M927,129.18l.206.206Z",
    transform: "translate(-428.647 -102.539)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31379",
    "data-name": "Path 31379",
    d: "M942,129.18l.206.206Z",
    transform: "translate(-440.554 -102.539)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31380",
    "data-name": "Path 31380",
    d: "M943,129.18v.412l.412-.412Z",
    transform: "translate(-441.347 -102.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31381",
    "data-name": "Path 31381",
    d: "M943.412,129.18,943,129.8l.206.206Z",
    transform: "translate(-441.347 -102.539)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31382",
    "data-name": "Path 31382",
    d: "M946,129.18v.206h.619Z",
    transform: "translate(-443.729 -102.539)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31383",
    "data-name": "Path 31383",
    d: "M949,129.18l.206.206Z",
    transform: "translate(-446.11 -102.539)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31384",
    "data-name": "Path 31384",
    d: "M1012.33,129.85l.07.138Z",
    transform: "translate(-496.381 -103.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31385",
    "data-name": "Path 31385",
    d: "M1013,129.592l.619-.412Z",
    transform: "translate(-496.913 -102.539)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31386",
    "data-name": "Path 31386",
    d: "M1016,129.18l.206.206Z",
    transform: "translate(-499.294 -102.539)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31387",
    "data-name": "Path 31387",
    d: "M1018,129.18l.206.206Z",
    transform: "translate(-500.882 -102.539)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31388",
    "data-name": "Path 31388",
    d: "M1024,129.18l.206.206Z",
    transform: "translate(-505.645 -102.539)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31389",
    "data-name": "Path 31389",
    d: "M858,130.18v.206h.619Z",
    transform: "translate(-373.875 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31390",
    "data-name": "Path 31390",
    d: "M880,130.18v.206l.619.206v.206H880V131c.773.043,2.056.967,2.268,0l3.506.412v-.206Z",
    transform: "translate(-391.339 -103.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31391",
    "data-name": "Path 31391",
    d: "M881,130.18l.206.206Z",
    transform: "translate(-392.132 -103.333)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31392",
    "data-name": "Path 31392",
    d: "M882,130.18l.206.206L882,130.18m4.949,0,.206.206Z",
    transform: "translate(-392.926 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31393",
    "data-name": "Path 31393",
    d: "M907,130.18l1.856,1.65-.206-1.443v-.206Z",
    transform: "translate(-412.771 -103.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31394",
    "data-name": "Path 31394",
    d: "M908,130.18l.206.206Z",
    transform: "translate(-413.565 -103.333)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31395",
    "data-name": "Path 31395",
    d: "M915.33,130.85l.068.138Z",
    transform: "translate(-419.383 -103.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31396",
    "data-name": "Path 31396",
    d: "M916,130.18l.206.206L916,130.18m.687.138.068.138-.068-.138m.551-.138v.206h.619v-.206Z",
    transform: "translate(-419.915 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31397",
    "data-name": "Path 31397",
    d: "M923,130.18l.206.206Z",
    transform: "translate(-425.472 -103.333)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31398",
    "data-name": "Path 31398",
    d: "M925,130.18l.206.206Z",
    transform: "translate(-427.059 -103.333)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31399",
    "data-name": "Path 31399",
    d: "M929,130.18l.412.412L929,130.18m2.681,0,.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-430.234 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31400",
    "data-name": "Path 31400",
    d: "M946,130.18l.619,1.443h.206v-1.237Z",
    transform: "translate(-443.729 -103.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31401",
    "data-name": "Path 31401",
    d: "M948.412,130.18l-.412.206.619.619Z",
    transform: "translate(-445.316 -103.333)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31402",
    "data-name": "Path 31402",
    d: "M951.67,130.51l.138.068Z",
    transform: "translate(-448.23 -103.595)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31403",
    "data-name": "Path 31403",
    d: "M1009.67,130.51l.136.068Z",
    transform: "translate(-494.269 -103.595)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31404",
    "data-name": "Path 31404",
    d: "M1015.67,130.51l.136.068Z",
    transform: "translate(-499.032 -103.595)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31405",
    "data-name": "Path 31405",
    d: "M1017,130.18l.206.206Z",
    transform: "translate(-500.088 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31406",
    "data-name": "Path 31406",
    d: "M1020,130.18l.206.206Z",
    transform: "translate(-502.469 -103.333)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31407",
    "data-name": "Path 31407",
    d: "M1022,130.18l.412.412-.412-.412m.825,0,.206.206Z",
    transform: "translate(-504.057 -103.333)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31408",
    "data-name": "Path 31408",
    d: "M1027,130.18l.206.206Z",
    transform: "translate(-508.026 -103.333)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31409",
    "data-name": "Path 31409",
    d: "M1028,130.18l.206.206-.206-.206m8.248,0,.206.206Z",
    transform: "translate(-508.82 -103.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31410",
    "data-name": "Path 31410",
    d: "M858,131.18l.206.825h.206l-.206-.619.412.619v.206h2.268Z",
    transform: "translate(-373.875 -104.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31411",
    "data-name": "Path 31411",
    d: "M862,131.18l.206.206Z",
    transform: "translate(-377.05 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31412",
    "data-name": "Path 31412",
    d: "M863,131.18l.206.206L863,131.18m1.512.138.068.138Z",
    transform: "translate(-377.844 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31413",
    "data-name": "Path 31413",
    d: "M871,131.18l.206.206Z",
    transform: "translate(-384.195 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31414",
    "data-name": "Path 31414",
    d: "M871,132.18l1.443.619v-.206c-.4-.134-.526-.206,0-.206Z",
    transform: "translate(-384.195 -104.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31415",
    "data-name": "Path 31415",
    d: "M874,131.18l.412.412v-.412Z",
    transform: "translate(-386.576 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31416",
    "data-name": "Path 31416",
    d: "M876,131.18l.206.206L876,131.18m.825,0v.412h.412Z",
    transform: "translate(-388.164 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31417",
    "data-name": "Path 31417",
    d: "M884,131.18l.206.206Z",
    transform: "translate(-394.514 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31418",
    "data-name": "Path 31418",
    d: "M887,131.18l.206.206Z",
    transform: "translate(-396.895 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31419",
    "data-name": "Path 31419",
    d: "M888,131.18l.206.206Z",
    transform: "translate(-397.689 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31420",
    "data-name": "Path 31420",
    d: "M907,131.18l.206.206Z",
    transform: "translate(-412.771 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31421",
    "data-name": "Path 31421",
    d: "M912,131.18v.412l.412-.412Z",
    transform: "translate(-416.74 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31422",
    "data-name": "Path 31422",
    d: "M914,131.18l.206.206Z",
    transform: "translate(-418.328 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31423",
    "data-name": "Path 31423",
    d: "M916,131.18v.206l.825.206v-.206Z",
    transform: "translate(-419.915 -104.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31424",
    "data-name": "Path 31424",
    d: "M918,131.18l.206.206Z",
    transform: "translate(-421.503 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31425",
    "data-name": "Path 31425",
    d: "M920,131.18l.206.206L920,131.18m.963.068.138.068Z",
    transform: "translate(-423.09 -104.127)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31426",
    "data-name": "Path 31426",
    d: "M926,131.18l.206.206Z",
    transform: "translate(-427.853 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31427",
    "data-name": "Path 31427",
    d: "M929,131.18l.206.206Z",
    transform: "translate(-430.234 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31428",
    "data-name": "Path 31428",
    d: "M945,131.18l.412.412Z",
    transform: "translate(-442.935 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31429",
    "data-name": "Path 31429",
    d: "M946,131.18l.206.206Z",
    transform: "translate(-443.729 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31430",
    "data-name": "Path 31430",
    d: "M949,131.18l.206.206Z",
    transform: "translate(-446.11 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31431",
    "data-name": "Path 31431",
    d: "M951,131.18v.206l1.443.619v-.619Z",
    transform: "translate(-447.698 -104.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31432",
    "data-name": "Path 31432",
    d: "M956,131.18l.206.206Z",
    transform: "translate(-451.667 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31433",
    "data-name": "Path 31433",
    d: "M957,131.18l.206.206L957,131.18m4.811.138.068.138Z",
    transform: "translate(-452.461 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31434",
    "data-name": "Path 31434",
    d: "M981,131.18l.206.206Z",
    transform: "translate(-471.512 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31435",
    "data-name": "Path 31435",
    d: "M982,131.18l.206.206L982,131.18m4.6.138.07.138Z",
    transform: "translate(-472.305 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31436",
    "data-name": "Path 31436",
    d: "M1005.67,131.51l.136.068Z",
    transform: "translate(-491.094 -104.389)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31437",
    "data-name": "Path 31437",
    d: "M1007,131.18l.206.206Z",
    transform: "translate(-492.15 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31438",
    "data-name": "Path 31438",
    d: "M1008,131.18l.206.206Z",
    transform: "translate(-492.944 -104.127)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31439",
    "data-name": "Path 31439",
    d: "M1017.67,131.51l.136.068Z",
    transform: "translate(-500.62 -104.389)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31440",
    "data-name": "Path 31440",
    d: "M1022,131.18l.206.206Z",
    transform: "translate(-504.057 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31441",
    "data-name": "Path 31441",
    d: "M1030,131.18l.206.206Z",
    transform: "translate(-510.407 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31442",
    "data-name": "Path 31442",
    d: "M1031,131.18l.206.206Z",
    transform: "translate(-511.201 -104.127)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31443",
    "data-name": "Path 31443",
    d: "M1067,131.18l.206.206Z",
    transform: "translate(-539.778 -104.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31444",
    "data-name": "Path 31444",
    d: "M1068.33,131.85l.07.138Z",
    transform: "translate(-540.833 -104.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31445",
    "data-name": "Path 31445",
    d: "M859.33,132.85l.068.138Z",
    transform: "translate(-374.931 -105.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31446",
    "data-name": "Path 31446",
    d: "M865,132.18l.206.206Z",
    transform: "translate(-379.432 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31447",
    "data-name": "Path 31447",
    d: "M878,132.18l.412.412v-.412H878m.825,0,.206.206-.206-.206m1.65,0v.206h.825Z",
    transform: "translate(-389.751 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31448",
    "data-name": "Path 31448",
    d: "M894,132.18v.206h1.443Z",
    transform: "translate(-402.452 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31449",
    "data-name": "Path 31449",
    d: "M901.67,132.51l.138.068Z",
    transform: "translate(-408.54 -105.183)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31450",
    "data-name": "Path 31450",
    d: "M908,132.18l.206.206L908,132.18m1.856,0,.206.206-.206-.206m.825,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-413.565 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31451",
    "data-name": "Path 31451",
    d: "M925,132.18l.206.206L925,132.18m1.443,0v.206h.619Z",
    transform: "translate(-427.059 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31452",
    "data-name": "Path 31452",
    d: "M935,132.18l.206.206Z",
    transform: "translate(-434.997 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31453",
    "data-name": "Path 31453",
    d: "M936,132.18l.206.206Z",
    transform: "translate(-435.791 -104.921)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31454",
    "data-name": "Path 31454",
    d: "M945,132.18l.412.412Z",
    transform: "translate(-442.935 -104.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31455",
    "data-name": "Path 31455",
    d: "M947,132.18v1.031h.412Z",
    transform: "translate(-444.523 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31456",
    "data-name": "Path 31456",
    d: "M950,132.18l.206.206Z",
    transform: "translate(-446.904 -104.921)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31457",
    "data-name": "Path 31457",
    d: "M951,132.18l.206.206Z",
    transform: "translate(-447.698 -104.921)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31458",
    "data-name": "Path 31458",
    d: "M952,132.18l.206.206L952,132.18m.619,0,.206.206-.206-.206m.619,0-.206.825Z",
    transform: "translate(-448.492 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31459",
    "data-name": "Path 31459",
    d: "M959,132.18l.206.206Z",
    transform: "translate(-454.048 -104.921)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31460",
    "data-name": "Path 31460",
    d: "M981,132.18v.206l1.856,1.237L982.65,133l1.443-.206v-.206Z",
    transform: "translate(-471.512 -104.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31461",
    "data-name": "Path 31461",
    d: "M983,132.18l.206.206Z",
    transform: "translate(-473.099 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31462",
    "data-name": "Path 31462",
    d: "M984,132.18l.206.206L984,132.18m8.8.068.136.068Z",
    transform: "translate(-473.893 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31463",
    "data-name": "Path 31463",
    d: "M1033,132.18l.206.206Z",
    transform: "translate(-512.789 -104.921)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31464",
    "data-name": "Path 31464",
    d: "M1034,132.18l.206.206Z",
    transform: "translate(-513.582 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31465",
    "data-name": "Path 31465",
    d: "M1050,132.18l.206.206Z",
    transform: "translate(-526.283 -104.921)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31466",
    "data-name": "Path 31466",
    d: "M1059,132.18l.206.206Z",
    transform: "translate(-533.427 -104.921)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31467",
    "data-name": "Path 31467",
    d: "M1060,132.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-534.221 -104.921)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31468",
    "data-name": "Path 31468",
    d: "M861,133.18l.206.206L861,133.18m1.237,0,.206.206Z",
    transform: "translate(-376.257 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31469",
    "data-name": "Path 31469",
    d: "M868,133.18l.206.206Z",
    transform: "translate(-381.813 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31470",
    "data-name": "Path 31470",
    d: "M872,133.18l.206.206L872,133.18m.825,0v.206h.619Z",
    transform: "translate(-384.988 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31471",
    "data-name": "Path 31471",
    d: "M904.67,133.51l.138.068Z",
    transform: "translate(-410.921 -105.977)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31472",
    "data-name": "Path 31472",
    d: "M906,133.18l.206.206L906,133.18m.619,0,.206.206Z",
    transform: "translate(-411.977 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31473",
    "data-name": "Path 31473",
    d: "M913,133.18l.206.206Z",
    transform: "translate(-417.534 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31474",
    "data-name": "Path 31474",
    d: "M919,133.18l.206.206Z",
    transform: "translate(-422.297 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31475",
    "data-name": "Path 31475",
    d: "M920,133.18l.206.206Z",
    transform: "translate(-423.09 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31476",
    "data-name": "Path 31476",
    d: "M940,133.18l.206.206Z",
    transform: "translate(-438.966 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31477",
    "data-name": "Path 31477",
    d: "M945,133.18l.206.206L945,133.18m.412,0,.206.206Z",
    transform: "translate(-442.935 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31478",
    "data-name": "Path 31478",
    d: "M953,133.18l.206.206Z",
    transform: "translate(-449.285 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31479",
    "data-name": "Path 31479",
    d: "M956,133.18l.206.206Z",
    transform: "translate(-451.667 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31480",
    "data-name": "Path 31480",
    d: "M957,133.18l.206.206Z",
    transform: "translate(-452.461 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31481",
    "data-name": "Path 31481",
    d: "M959,133.18c.652.971,2.033.728,3.093.825V133.8l-.619-.412Z",
    transform: "translate(-454.048 -105.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31482",
    "data-name": "Path 31482",
    d: "M960,133.18l.206.206Z",
    transform: "translate(-454.842 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31483",
    "data-name": "Path 31483",
    d: "M961,133.18v.206h.825Z",
    transform: "translate(-455.636 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31484",
    "data-name": "Path 31484",
    d: "M965,133.18l.206.206Z",
    transform: "translate(-458.811 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31485",
    "data-name": "Path 31485",
    d: "M970,133.18l.206.206Z",
    transform: "translate(-462.78 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31486",
    "data-name": "Path 31486",
    d: "M971,133.18v.619h.206Z",
    transform: "translate(-463.574 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31487",
    "data-name": "Path 31487",
    d: "M972,133.18v.206h1.031Z",
    transform: "translate(-464.367 -105.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31488",
    "data-name": "Path 31488",
    d: "M977,133.18v.206h1.031L977,133.18m1.65,0,.206.206Z",
    transform: "translate(-468.336 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31489",
    "data-name": "Path 31489",
    d: "M991.67,133.51l.138.068Z",
    transform: "translate(-479.981 -105.977)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31490",
    "data-name": "Path 31490",
    d: "M1003.412,133.18l-.412.206v.206Z",
    transform: "translate(-488.975 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31491",
    "data-name": "Path 31491",
    d: "M1009,133.18l.206.206-.206-.206m1.375.068.136.068Z",
    transform: "translate(-493.738 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31492",
    "data-name": "Path 31492",
    d: "M1017,133.18l.206.206Z",
    transform: "translate(-500.088 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31493",
    "data-name": "Path 31493",
    d: "M1018,133.18v.206l1.031.206Z",
    transform: "translate(-500.882 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31494",
    "data-name": "Path 31494",
    d: "M1023,133.18l.206.206-.206-.206m1.237,0,.206.206-.206-.206m1.444,0v.206h2.062Z",
    transform: "translate(-504.851 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31495",
    "data-name": "Path 31495",
    d: "M1046,133.18v.206h.619Z",
    transform: "translate(-523.108 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31496",
    "data-name": "Path 31496",
    d: "M1049,133.18l.206.206Z",
    transform: "translate(-525.489 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31497",
    "data-name": "Path 31497",
    d: "M1054,133.18l.206.206Z",
    transform: "translate(-529.458 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31498",
    "data-name": "Path 31498",
    d: "M1055.67,133.51l.136.068Z",
    transform: "translate(-530.784 -105.977)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31499",
    "data-name": "Path 31499",
    d: "M1057,133.18l.206.206Z",
    transform: "translate(-531.84 -105.715)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31500",
    "data-name": "Path 31500",
    d: "M1058,133.18l.206.206Z",
    transform: "translate(-532.633 -105.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31501",
    "data-name": "Path 31501",
    d: "M1062,133.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-535.809 -105.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31502",
    "data-name": "Path 31502",
    d: "M858,134.18l.206.206L858,134.18m.619,0,.206.206Z",
    transform: "translate(-373.875 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31503",
    "data-name": "Path 31503",
    d: "M862,134.18l.206.206L862,134.18m1.65,0v.206l.825.206Z",
    transform: "translate(-377.05 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31504",
    "data-name": "Path 31504",
    d: "M878.33,134.588l.068.138-.068-.138m.687-.068.138.068Z",
    transform: "translate(-390.013 -106.778)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31505",
    "data-name": "Path 31505",
    d: "M883,134.18l.206.206Z",
    transform: "translate(-393.72 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31506",
    "data-name": "Path 31506",
    d: "M884,134.18l.206.206L884,134.18m1.443,0,.206.206-.206-.206m.619,0v.412h.412l-.412-.412m.963.068.138.068Z",
    transform: "translate(-394.514 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31507",
    "data-name": "Path 31507",
    d: "M907,134.18l.206.206Z",
    transform: "translate(-412.771 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31508",
    "data-name": "Path 31508",
    d: "M910,134.18l.206.206Z",
    transform: "translate(-415.152 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31509",
    "data-name": "Path 31509",
    d: "M908.619,134.18l-.619.206v.206l.619-.412m.619,0,.206.206Z",
    transform: "translate(-413.565 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31510",
    "data-name": "Path 31510",
    d: "M923,134.18l.206.206Z",
    transform: "translate(-425.472 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31511",
    "data-name": "Path 31511",
    d: "M924.67,134.51l.138.068Z",
    transform: "translate(-426.797 -106.77)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31512",
    "data-name": "Path 31512",
    d: "M926.67,134.51l.138.068-.138-.068m1.031,0,.138.068Z",
    transform: "translate(-428.385 -106.77)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31513",
    "data-name": "Path 31513",
    d: "M933,134.18v.206h.619Z",
    transform: "translate(-433.41 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31514",
    "data-name": "Path 31514",
    d: "M936.67,134.248l.138.068-.138-.068m.893-.068.206.206Z",
    transform: "translate(-436.323 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31515",
    "data-name": "Path 31515",
    d: "M942,134.18l.206.206L942,134.18m.825,0-.206.412Z",
    transform: "translate(-440.554 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31516",
    "data-name": "Path 31516",
    d: "M949,134.18l.206.206L949,134.18m.412,0v.412h.412Z",
    transform: "translate(-446.11 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31517",
    "data-name": "Path 31517",
    d: "M955,134.18l.206.206Z",
    transform: "translate(-450.873 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31518",
    "data-name": "Path 31518",
    d: "M967,134.18l.206.206Z",
    transform: "translate(-460.398 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31519",
    "data-name": "Path 31519",
    d: "M968,134.18l.206.206L968,134.18m.893.138.068.138Z",
    transform: "translate(-461.192 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31520",
    "data-name": "Path 31520",
    d: "M973,135.386l1.031-.206Z",
    transform: "translate(-465.161 -107.302)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31521",
    "data-name": "Path 31521",
    d: "M978,134.18v.206h1.031Z",
    transform: "translate(-469.13 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31522",
    "data-name": "Path 31522",
    d: "M983,134.18l.206.206Z",
    transform: "translate(-473.099 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31523",
    "data-name": "Path 31523",
    d: "M986,134.18l.206.206L986,134.18m.412,0,.206.206Z",
    transform: "translate(-475.48 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31524",
    "data-name": "Path 31524",
    d: "M989,134.18l.206.206Z",
    transform: "translate(-477.862 -106.508)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31525",
    "data-name": "Path 31525",
    d: "M996,134.18l.412.412v-.412Z",
    transform: "translate(-483.418 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31526",
    "data-name": "Path 31526",
    d: "M998.67,134.51l.138.068Z",
    transform: "translate(-485.538 -106.77)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31527",
    "data-name": "Path 31527",
    d: "M999,134.386v.206l1.65-.412Z",
    transform: "translate(-485.8 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31528",
    "data-name": "Path 31528",
    d: "M1009.67,134.51l.136.068Z",
    transform: "translate(-494.269 -106.77)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31529",
    "data-name": "Path 31529",
    d: "M1020,134.592h.619l-.206-.412Z",
    transform: "translate(-502.469 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31530",
    "data-name": "Path 31530",
    d: "M1025.67,134.51l.136.068Z",
    transform: "translate(-506.97 -106.77)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31531",
    "data-name": "Path 31531",
    d: "M1030,134.18l.206.206-.206-.206m5.087.068.136.068-.136-.068m1.992.068.07.138Z",
    transform: "translate(-510.407 -106.508)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31532",
    "data-name": "Path 31532",
    d: "M1065,134.18l.206.206Z",
    transform: "translate(-538.19 -106.508)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31533",
    "data-name": "Path 31533",
    d: "M858,135.18v.412l.412-.412H858m1.443,0,.206.206Z",
    transform: "translate(-373.875 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31534",
    "data-name": "Path 31534",
    d: "M874,135.18v.206h.825L874,135.18m2.474,0,.206.206Z",
    transform: "translate(-386.576 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31535",
    "data-name": "Path 31535",
    d: "M889,135.18l.206.206Z",
    transform: "translate(-398.483 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31536",
    "data-name": "Path 31536",
    d: "M891,135.18l.206.206L891,135.18m.412,0,.206.206Z",
    transform: "translate(-400.07 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31537",
    "data-name": "Path 31537",
    d: "M896,135.18l.206.206L896,135.18m1.237,0,.206.206Z",
    transform: "translate(-404.039 -107.302)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31538",
    "data-name": "Path 31538",
    d: "M903.67,135.51l.138.068Z",
    transform: "translate(-410.128 -107.564)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31539",
    "data-name": "Path 31539",
    d: "M905,135.18l.206.206L905,135.18m2.062,0,.206.206Z",
    transform: "translate(-411.183 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31540",
    "data-name": "Path 31540",
    d: "M939,135.18l.206.206Z",
    transform: "translate(-438.172 -107.302)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31541",
    "data-name": "Path 31541",
    d: "M940,135.18l.206.206L940,135.18m.619,0,.412.412Z",
    transform: "translate(-438.966 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31542",
    "data-name": "Path 31542",
    d: "M944,135.18l.206.206Z",
    transform: "translate(-442.141 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31543",
    "data-name": "Path 31543",
    d: "M946.67,135.51l.138.068Z",
    transform: "translate(-444.261 -107.564)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31544",
    "data-name": "Path 31544",
    d: "M950.33,135.318l.068.138-.068-.138m1.169-.138.206.206Z",
    transform: "translate(-447.166 -107.302)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31545",
    "data-name": "Path 31545",
    d: "M959,135.18l.206.206Z",
    transform: "translate(-454.048 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31546",
    "data-name": "Path 31546",
    d: "M960,135.18l.206.206L960,135.18m4.949,0,.206.206-.206-.206m.619,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-454.842 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31547",
    "data-name": "Path 31547",
    d: "M991,135.18v.206h.825Z",
    transform: "translate(-479.449 -107.302)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31548",
    "data-name": "Path 31548",
    d: "M995.67,135.51l.138.068Z",
    transform: "translate(-483.156 -107.564)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31549",
    "data-name": "Path 31549",
    d: "M998,135.18l.206.206Z",
    transform: "translate(-485.006 -107.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31550",
    "data-name": "Path 31550",
    d: "M1011,135.18l.206.206Z",
    transform: "translate(-495.325 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31551",
    "data-name": "Path 31551",
    d: "M1011.206,135.18l-.206.412.206-.412m.757.068.136.068Z",
    transform: "translate(-495.325 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31552",
    "data-name": "Path 31552",
    d: "M1017.67,135.51l.136.068Z",
    transform: "translate(-500.62 -107.564)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31553",
    "data-name": "Path 31553",
    d: "M1019,135.18l.206.206Z",
    transform: "translate(-501.676 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31554",
    "data-name": "Path 31554",
    d: "M1031.67,135.51l.136.068Z",
    transform: "translate(-511.733 -107.564)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31555",
    "data-name": "Path 31555",
    d: "M1033,135.18l.206.206Z",
    transform: "translate(-512.789 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31556",
    "data-name": "Path 31556",
    d: "M1034,135.18l.206.206-.206-.206m1.031,0,.206.206-.206-.206m1.443,0v.206h1.65Z",
    transform: "translate(-513.582 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31557",
    "data-name": "Path 31557",
    d: "M1062.33,135.85l.07.138Z",
    transform: "translate(-536.07 -107.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31558",
    "data-name": "Path 31558",
    d: "M1063,135.18l.206.206Z",
    transform: "translate(-536.602 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31559",
    "data-name": "Path 31559",
    d: "M1065,135.18l.206.206Z",
    transform: "translate(-538.19 -107.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31560",
    "data-name": "Path 31560",
    d: "M1066,135.18l.619.412Z",
    transform: "translate(-538.984 -107.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31561",
    "data-name": "Path 31561",
    d: "M1068,135.18l.206.206Z",
    transform: "translate(-540.571 -107.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31562",
    "data-name": "Path 31562",
    d: "M859,136.18l.206.206Z",
    transform: "translate(-374.669 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31563",
    "data-name": "Path 31563",
    d: "M861,136.18l.206.206Z",
    transform: "translate(-376.257 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31564",
    "data-name": "Path 31564",
    d: "M862,136.18l.206.206Z",
    transform: "translate(-377.05 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31565",
    "data-name": "Path 31565",
    d: "M863,136.18l.206.206Z",
    transform: "translate(-377.844 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31566",
    "data-name": "Path 31566",
    d: "M867,136.18l.206.206Z",
    transform: "translate(-381.019 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31567",
    "data-name": "Path 31567",
    d: "M868,136.18l.206.206Z",
    transform: "translate(-381.813 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31568",
    "data-name": "Path 31568",
    d: "M871,136.18l.206.206Z",
    transform: "translate(-384.195 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31569",
    "data-name": "Path 31569",
    d: "M888,136.18l.206.206Z",
    transform: "translate(-397.689 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31570",
    "data-name": "Path 31570",
    d: "M891,136.18l.206.206Z",
    transform: "translate(-400.07 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31571",
    "data-name": "Path 31571",
    d: "M908,136.18v.206h.825Z",
    transform: "translate(-413.565 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31572",
    "data-name": "Path 31572",
    d: "M912,136.18l.206.206Z",
    transform: "translate(-416.74 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31573",
    "data-name": "Path 31573",
    d: "M913,136.18l.206.206Z",
    transform: "translate(-417.534 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31574",
    "data-name": "Path 31574",
    d: "M916,136.18l.206.206Z",
    transform: "translate(-419.915 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31575",
    "data-name": "Path 31575",
    d: "M942,136.18l.206.206Z",
    transform: "translate(-440.554 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31576",
    "data-name": "Path 31576",
    d: "M943,136.18l.206.206Z",
    transform: "translate(-441.347 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31577",
    "data-name": "Path 31577",
    d: "M945.67,136.51l.138.068Z",
    transform: "translate(-443.467 -108.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31578",
    "data-name": "Path 31578",
    d: "M952,136.18l.206.206L952,136.18m2.062,0,.206.206Z",
    transform: "translate(-448.492 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31579",
    "data-name": "Path 31579",
    d: "M964,136.18l.206.206Z",
    transform: "translate(-458.017 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31580",
    "data-name": "Path 31580",
    d: "M965,136.18l.206.206Z",
    transform: "translate(-458.811 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31581",
    "data-name": "Path 31581",
    d: "M966,136.18l.206.206Z",
    transform: "translate(-459.605 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31582",
    "data-name": "Path 31582",
    d: "M968,136.18l.206.206Z",
    transform: "translate(-461.192 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31583",
    "data-name": "Path 31583",
    d: "M969,136.18l.206.206Z",
    transform: "translate(-461.986 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31584",
    "data-name": "Path 31584",
    d: "M970,136.18l.206.206L970,136.18m.893.138.068.138Z",
    transform: "translate(-462.78 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31585",
    "data-name": "Path 31585",
    d: "M975,136.18l.206.206Z",
    transform: "translate(-466.749 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31586",
    "data-name": "Path 31586",
    d: "M984,136.18l.206.206L984,136.18m1.031,0,.206.206-.206-.206m3.918,0,.206.206Z",
    transform: "translate(-473.893 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31587",
    "data-name": "Path 31587",
    d: "M1009,136.18l.206.206Z",
    transform: "translate(-493.738 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31588",
    "data-name": "Path 31588",
    d: "M1012,136.18l.206.206-.206-.206m.48.138.07.138-.07-.138m5.5-.138.206.206Z",
    transform: "translate(-496.119 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31589",
    "data-name": "Path 31589",
    d: "M1042,136.18l.206.206Z",
    transform: "translate(-519.933 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31590",
    "data-name": "Path 31590",
    d: "M1043.67,136.51l.136.068Z",
    transform: "translate(-521.258 -108.358)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31591",
    "data-name": "Path 31591",
    d: "M1054,136.18l.206.206Z",
    transform: "translate(-529.458 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31592",
    "data-name": "Path 31592",
    d: "M1055,136.18l.206.206-.206-.206m.963.068.136.068Z",
    transform: "translate(-530.252 -108.096)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31593",
    "data-name": "Path 31593",
    d: "M1065,136.18l.206.206Z",
    transform: "translate(-538.19 -108.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31594",
    "data-name": "Path 31594",
    d: "M1066,136.18l.206.206Z",
    transform: "translate(-538.984 -108.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31595",
    "data-name": "Path 31595",
    d: "M890,137.18l.206.206L890,137.18m4.949,0,.206.206Z",
    transform: "translate(-399.277 -108.89)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31596",
    "data-name": "Path 31596",
    d: "M916,137.18l.206.206Z",
    transform: "translate(-419.915 -108.89)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31597",
    "data-name": "Path 31597",
    d: "M946,137.18l.206.206Z",
    transform: "translate(-443.729 -108.89)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31598",
    "data-name": "Path 31598",
    d: "M947,137.18v.206h.619Z",
    transform: "translate(-444.523 -108.89)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31599",
    "data-name": "Path 31599",
    d: "M972,137.18l.206.206Z",
    transform: "translate(-464.367 -108.89)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31600",
    "data-name": "Path 31600",
    d: "M973,137.18l.206.206Z",
    transform: "translate(-465.161 -108.89)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31601",
    "data-name": "Path 31601",
    d: "M975,137.18l.206.206Z",
    transform: "translate(-466.749 -108.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31602",
    "data-name": "Path 31602",
    d: "M976,137.18l.206.206L976,137.18m1.856,0,.206.206Z",
    transform: "translate(-467.543 -108.89)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31603",
    "data-name": "Path 31603",
    d: "M989,137.18l.206.206Z",
    transform: "translate(-477.862 -108.89)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31604",
    "data-name": "Path 31604",
    d: "M1010,137.18l.206.206Z",
    transform: "translate(-494.531 -108.89)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31605",
    "data-name": "Path 31605",
    d: "M1056,137.18l.206.206-.206-.206m.893.138.07.138Z",
    transform: "translate(-531.046 -108.89)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31606",
    "data-name": "Path 31606",
    d: "M987,138.18l.206.206Z",
    transform: "translate(-476.274 -109.684)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31607",
    "data-name": "Path 31607",
    d: "M990,138.18l.206.206L990,138.18m4.33,0,.206.206Z",
    transform: "translate(-478.656 -109.684)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31608",
    "data-name": "Path 31608",
    d: "M1012,138.18l.206.206Z",
    transform: "translate(-496.119 -109.684)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31609",
    "data-name": "Path 31609",
    d: "M1013,138.18l.206.206-.206-.206m9.279,0,.206.206Z",
    transform: "translate(-496.913 -109.684)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31610",
    "data-name": "Path 31610",
    d: "M944.694,138.18l.206.206-.206-.206M915,140.242l.619-.619Z",
    transform: "translate(-419.121 -109.684)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31611",
    "data-name": "Path 31611",
    d: "M918,145.18l.206.206Z",
    transform: "translate(-421.503 -115.24)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31612",
    "data-name": "Path 31612",
    d: "M1026.67,145.51l.136.068Z",
    transform: "translate(-507.764 -115.502)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31613",
    "data-name": "Path 31613",
    d: "M1028,145.18l.206.206Z",
    transform: "translate(-508.82 -115.24)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31614",
    "data-name": "Path 31614",
    d: "M860.67,146.51l.138.068Z",
    transform: "translate(-375.995 -116.296)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31615",
    "data-name": "Path 31615",
    d: "M909,146.18l.206.206Z",
    transform: "translate(-414.359 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31616",
    "data-name": "Path 31616",
    d: "M868.723,146.18l.619.412v.206l-10.929-.412.825,1.237L858,147.211l1.65.619-.825-1.237c3.99,1.54,7.026,1.291,11.135.586.905-.155,2.466.518,3.093-.173l.825.206-.206-.412h1.856l6.8,1.237-1.031-.619v-.206l5.774.412-.206-.412,1.444-.412h-1.237V147c-.7-.093-2.541-.967-2.681,0l-4.743-.21-5.155-.615.412.412v.206l-3.3-.619v.412l-1.443-.412v.206l.412.206Z",
    transform: "translate(-373.875 -116.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31617",
    "data-name": "Path 31617",
    d: "M912,146.18l.206.206Z",
    transform: "translate(-416.74 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31618",
    "data-name": "Path 31618",
    d: "M913,146.18l.206.206Z",
    transform: "translate(-417.534 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31619",
    "data-name": "Path 31619",
    d: "M919,146.18l.206.206Z",
    transform: "translate(-422.297 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31620",
    "data-name": "Path 31620",
    d: "M920,146.18l.206.206Z",
    transform: "translate(-423.09 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31621",
    "data-name": "Path 31621",
    d: "M923,146.18l.206.206L923,146.18m.619,0,.206.206Z",
    transform: "translate(-425.472 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31622",
    "data-name": "Path 31622",
    d: "M927,146.18l.206.206Z",
    transform: "translate(-428.647 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31623",
    "data-name": "Path 31623",
    d: "M929.67,146.51l.138.068Z",
    transform: "translate(-430.766 -116.296)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31624",
    "data-name": "Path 31624",
    d: "M931,146.18l.206.206Z",
    transform: "translate(-431.822 -116.034)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31625",
    "data-name": "Path 31625",
    d: "M932,146.18l.206.206Z",
    transform: "translate(-432.616 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31626",
    "data-name": "Path 31626",
    d: "M944,146.18l.206.206Z",
    transform: "translate(-442.141 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31627",
    "data-name": "Path 31627",
    d: "M945,146.18l.206.206L945,146.18m1.856,0,.206.206Z",
    transform: "translate(-442.935 -116.034)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31628",
    "data-name": "Path 31628",
    d: "M955,146.18l.206.206L955,146.18m8.661,0-.206.412Z",
    transform: "translate(-450.873 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31629",
    "data-name": "Path 31629",
    d: "M998,146.18l.206.206Z",
    transform: "translate(-485.006 -116.034)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31630",
    "data-name": "Path 31630",
    d: "M999,146.18l.206.206Z",
    transform: "translate(-485.8 -116.034)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31631",
    "data-name": "Path 31631",
    d: "M1025,146.18l.206.206Z",
    transform: "translate(-506.438 -116.034)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31632",
    "data-name": "Path 31632",
    d: "M1010.124,146.18l.825,1.65L1006,146.592v.206l5.361,1.237-.412-1.65c-.305.918.557.746,1.237,1.031.641.268,4.681.456,4.537,1.031h.825l.206-.825c-.482-.016-1.922-.146-1.237-.825v-.206c-.625.1-.839.179-.825.825Z",
    transform: "translate(-491.356 -116.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31633",
    "data-name": "Path 31633",
    d: "M894.262,146.18l.206.206-.206-.206M859,146.386l.206.206-.206-.206m1.031,0,.206.206-.206-.206m9.279,0,.206.206Z",
    transform: "translate(-374.669 -116.034)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31634",
    "data-name": "Path 31634",
    d: "M916.67,147.51l.138.068Z",
    transform: "translate(-420.447 -117.09)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31635",
    "data-name": "Path 31635",
    d: "M918,147.18l.206.206Z",
    transform: "translate(-421.503 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31636",
    "data-name": "Path 31636",
    d: "M922,147.18l.206.206Z",
    transform: "translate(-424.678 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31637",
    "data-name": "Path 31637",
    d: "M923,147.18l.206.206Z",
    transform: "translate(-425.472 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31638",
    "data-name": "Path 31638",
    d: "M928,147.18l.206.206L928,147.18m1.237,0,.206.206Z",
    transform: "translate(-429.441 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31639",
    "data-name": "Path 31639",
    d: "M935,147.18l.206.206Z",
    transform: "translate(-434.997 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31640",
    "data-name": "Path 31640",
    d: "M940,147.18l.206.206L940,147.18m1.443,0,.206.206Z",
    transform: "translate(-438.966 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31641",
    "data-name": "Path 31641",
    d: "M948,147.18l.206.206L948,147.18m1.031,0-.206.412Z",
    transform: "translate(-445.316 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31642",
    "data-name": "Path 31642",
    d: "M957,147.18l.206.206Z",
    transform: "translate(-452.461 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31643",
    "data-name": "Path 31643",
    d: "M958,147.18l.206.206Z",
    transform: "translate(-453.254 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31644",
    "data-name": "Path 31644",
    d: "M985,147.18l.206.206Z",
    transform: "translate(-474.687 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31645",
    "data-name": "Path 31645",
    d: "M986,147.18l.206.206L986,147.18m.412,0,.206.206Z",
    transform: "translate(-475.48 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31646",
    "data-name": "Path 31646",
    d: "M989,147.18l.206.206Z",
    transform: "translate(-477.862 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31647",
    "data-name": "Path 31647",
    d: "M990,147.18l.206.206Z",
    transform: "translate(-478.656 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31648",
    "data-name": "Path 31648",
    d: "M997,147.18l.206.206Z",
    transform: "translate(-484.212 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31649",
    "data-name": "Path 31649",
    d: "M1001,147.18l.206.206Z",
    transform: "translate(-487.387 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31650",
    "data-name": "Path 31650",
    d: "M1002,147.18l.206.206Z",
    transform: "translate(-488.181 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31651",
    "data-name": "Path 31651",
    d: "M1006,147.18v.206h.619Z",
    transform: "translate(-491.356 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31652",
    "data-name": "Path 31652",
    d: "M1009,147.18l.206.206Z",
    transform: "translate(-493.738 -116.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31653",
    "data-name": "Path 31653",
    d: "M1025,147.18l.206.206Z",
    transform: "translate(-506.438 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31654",
    "data-name": "Path 31654",
    d: "M1027.67,147.51l.136.068Z",
    transform: "translate(-508.558 -117.09)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31655",
    "data-name": "Path 31655",
    d: "M1029,147.18l.206.206Z",
    transform: "translate(-509.613 -116.828)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31656",
    "data-name": "Path 31656",
    d: "M894.674,147.18l.206.206-.206-.206M859,147.386l.206.206Z",
    transform: "translate(-374.669 -116.828)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31657",
    "data-name": "Path 31657",
    d: "M862,148.18l.206.206Z",
    transform: "translate(-377.05 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31658",
    "data-name": "Path 31658",
    d: "M863,148.18l.206.206L863,148.18m1.375.068.138.068Z",
    transform: "translate(-377.844 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31659",
    "data-name": "Path 31659",
    d: "M871,148.18l.206.206Z",
    transform: "translate(-384.195 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31660",
    "data-name": "Path 31660",
    d: "M911,148.18l.206.206Z",
    transform: "translate(-415.946 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31661",
    "data-name": "Path 31661",
    d: "M912,148.18l.206.206L912,148.18m1.031,0,.206.206Z",
    transform: "translate(-416.74 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31662",
    "data-name": "Path 31662",
    d: "M924,148.18l.206.206Z",
    transform: "translate(-426.265 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31663",
    "data-name": "Path 31663",
    d: "M925,148.18l.206.206L925,148.18m2.474,0,.206.206Z",
    transform: "translate(-427.059 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31664",
    "data-name": "Path 31664",
    d: "M938,148.18l.206.206Z",
    transform: "translate(-437.379 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31665",
    "data-name": "Path 31665",
    d: "M939,148.18l.206.206L939,148.18m2.474,0,.206.206Z",
    transform: "translate(-438.172 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31666",
    "data-name": "Path 31666",
    d: "M953,148.18l.206.206Z",
    transform: "translate(-449.285 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31667",
    "data-name": "Path 31667",
    d: "M960,148.18l.206.206Z",
    transform: "translate(-454.842 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31668",
    "data-name": "Path 31668",
    d: "M961,148.18l.206.206Z",
    transform: "translate(-455.636 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31669",
    "data-name": "Path 31669",
    d: "M965,148.18l.206.206L965,148.18m.412,0,.206.206Z",
    transform: "translate(-458.811 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31670",
    "data-name": "Path 31670",
    d: "M968,148.18l.206.206Z",
    transform: "translate(-461.192 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31671",
    "data-name": "Path 31671",
    d: "M969,148.18l.206.206L969,148.18m1.031,0,.206.206Z",
    transform: "translate(-461.986 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31672",
    "data-name": "Path 31672",
    d: "M975,148.18v.206h.825Z",
    transform: "translate(-466.749 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31673",
    "data-name": "Path 31673",
    d: "M979,148.18l.206.206Z",
    transform: "translate(-469.924 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31674",
    "data-name": "Path 31674",
    d: "M992,148.18l.206.206Z",
    transform: "translate(-480.243 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31675",
    "data-name": "Path 31675",
    d: "M993,148.18l.206.206Z",
    transform: "translate(-481.037 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31676",
    "data-name": "Path 31676",
    d: "M996,148.18l.412.412Z",
    transform: "translate(-483.418 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31677",
    "data-name": "Path 31677",
    d: "M1004,148.18l.619.412-.619-.412m1.65,0,.206.206Z",
    transform: "translate(-489.769 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31678",
    "data-name": "Path 31678",
    d: "M1013,148.18l.206.206Z",
    transform: "translate(-496.913 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31679",
    "data-name": "Path 31679",
    d: "M1014,148.18l.206.206-.206-.206m2.268,0,.206.206Z",
    transform: "translate(-497.707 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31680",
    "data-name": "Path 31680",
    d: "M1027,148.18v.206l.619.206Z",
    transform: "translate(-508.026 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31681",
    "data-name": "Path 31681",
    d: "M1033,148.18l.206.206-.206-.206m3.918,0,.206.206Z",
    transform: "translate(-512.789 -117.621)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31682",
    "data-name": "Path 31682",
    d: "M1057.33,148.85l.07.138Z",
    transform: "translate(-532.102 -118.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31683",
    "data-name": "Path 31683",
    d: "M1058,148.18l.206.206Z",
    transform: "translate(-532.633 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31684",
    "data-name": "Path 31684",
    d: "M1060.33,148.85l.07.138Z",
    transform: "translate(-534.483 -118.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31685",
    "data-name": "Path 31685",
    d: "M1058.619,149.289l-.412-.206H1058v.206l2.268.619C1059.926,149.315,1059.217,148.715,1058.619,149.289Z",
    transform: "translate(-532.633 -118.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31686",
    "data-name": "Path 31686",
    d: "M1063,148.18l.206.206Z",
    transform: "translate(-536.602 -117.621)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31687",
    "data-name": "Path 31687",
    d: "M1064,148.18l.206.206Z",
    transform: "translate(-537.396 -117.621)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31688",
    "data-name": "Path 31688",
    d: "M860,149.18l.206.206Z",
    transform: "translate(-375.463 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31689",
    "data-name": "Path 31689",
    d: "M862,149.18l.206.206L862,149.18m.619,0,.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-377.05 -118.415)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31690",
    "data-name": "Path 31690",
    d: "M875,149.18l.206.206Z",
    transform: "translate(-387.37 -118.415)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31691",
    "data-name": "Path 31691",
    d: "M906.67,149.51l.138.068Z",
    transform: "translate(-412.509 -118.677)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31692",
    "data-name": "Path 31692",
    d: "M908.67,149.51l.138.068Z",
    transform: "translate(-414.097 -118.677)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31693",
    "data-name": "Path 31693",
    d: "M926,149.18l.206.206L926,149.18m1.788.068.138.068Z",
    transform: "translate(-427.853 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31694",
    "data-name": "Path 31694",
    d: "M936,149.18l.206.206L936,149.18m1.582.068.138.068-.138-.068m3.78-.068.206.206Z",
    transform: "translate(-435.791 -118.415)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31695",
    "data-name": "Path 31695",
    d: "M963,149.18l.206.206Z",
    transform: "translate(-457.223 -118.415)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31696",
    "data-name": "Path 31696",
    d: "M971.67,149.248l.138.068-.138-.068m2.681,0,.138.068-.138-.068m.893-.068v.206l.619.206-.619-.412m1.375.068.138.068-.138-.068m.48-.068.206.206-.206-.206m4.33,0,.206.206Z",
    transform: "translate(-464.105 -118.415)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31697",
    "data-name": "Path 31697",
    d: "M1020,149.18l.206.206Z",
    transform: "translate(-502.469 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31698",
    "data-name": "Path 31698",
    d: "M1026,149.18l.206.206Z",
    transform: "translate(-507.232 -118.415)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31699",
    "data-name": "Path 31699",
    d: "M1028,149.18l.206.206Z",
    transform: "translate(-508.82 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31700",
    "data-name": "Path 31700",
    d: "M1035,149.18v.206h.825Z",
    transform: "translate(-514.376 -118.415)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31701",
    "data-name": "Path 31701",
    d: "M1039,149.18v.206h.619Z",
    transform: "translate(-517.551 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31702",
    "data-name": "Path 31702",
    d: "M1054.67,149.51l.136.068Z",
    transform: "translate(-529.99 -118.677)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31703",
    "data-name": "Path 31703",
    d: "M901.211,149.18l.206.206-.206-.206m2.062,0,.206.206-.206-.206M861,149.386l.206.206Z",
    transform: "translate(-376.257 -118.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31704",
    "data-name": "Path 31704",
    d: "M863,150.18l.206.206Z",
    transform: "translate(-377.844 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31705",
    "data-name": "Path 31705",
    d: "M867,150.18l.206.206Z",
    transform: "translate(-381.019 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31706",
    "data-name": "Path 31706",
    d: "M868,150.18l.206.206L868,150.18m3.093,0v.206h1.443Z",
    transform: "translate(-381.813 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31707",
    "data-name": "Path 31707",
    d: "M890,150.18v.206h.825Z",
    transform: "translate(-399.277 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31708",
    "data-name": "Path 31708",
    d: "M897,150.18l.206.206Z",
    transform: "translate(-404.833 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31709",
    "data-name": "Path 31709",
    d: "M898,150.18l.206.206Z",
    transform: "translate(-405.627 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31710",
    "data-name": "Path 31710",
    d: "M899.67,150.248l.138.068-.138-.068m3.367-.068.206.206Z",
    transform: "translate(-406.952 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31711",
    "data-name": "Path 31711",
    d: "M917.67,150.51l.138.068Z",
    transform: "translate(-421.241 -119.471)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31712",
    "data-name": "Path 31712",
    d: "M919,150.18l.206.206L919,150.18m1.031,0,.206.206-.206-.206m.825,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-422.297 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31713",
    "data-name": "Path 31713",
    d: "M938,150.18l.206.206Z",
    transform: "translate(-437.379 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31714",
    "data-name": "Path 31714",
    d: "M939,150.18l.206.206L939,150.18m1.856,0,.206.206Z",
    transform: "translate(-438.172 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31715",
    "data-name": "Path 31715",
    d: "M949,150.18l.206.206L949,150.18m2.474,0,.206.206Z",
    transform: "translate(-446.11 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31716",
    "data-name": "Path 31716",
    d: "M965,150.18l.206.206Z",
    transform: "translate(-458.811 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31717",
    "data-name": "Path 31717",
    d: "M966,150.18l.206.206L966,150.18m.825,0,.206.206Z",
    transform: "translate(-459.605 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31718",
    "data-name": "Path 31718",
    d: "M992.67,150.51l.138.068Z",
    transform: "translate(-480.775 -119.471)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31719",
    "data-name": "Path 31719",
    d: "M994,150.18l.206.206Z",
    transform: "translate(-481.831 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31720",
    "data-name": "Path 31720",
    d: "M1003,150.18l.206.206Z",
    transform: "translate(-488.975 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31721",
    "data-name": "Path 31721",
    d: "M1004,150.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-489.769 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31722",
    "data-name": "Path 31722",
    d: "M1010,150.18l.206.206-.206-.206m2.681,0,.206.206Z",
    transform: "translate(-494.531 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31723",
    "data-name": "Path 31723",
    d: "M1024,150.18l.206.206-.206-.206m1.031,0,.412.412v-.412Z",
    transform: "translate(-505.645 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31724",
    "data-name": "Path 31724",
    d: "M1046,150.18l.206.206Z",
    transform: "translate(-523.108 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31725",
    "data-name": "Path 31725",
    d: "M1047,150.18l.206.206Z",
    transform: "translate(-523.902 -119.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31726",
    "data-name": "Path 31726",
    d: "M1048,150.18l.206.206Z",
    transform: "translate(-524.695 -119.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31727",
    "data-name": "Path 31727",
    d: "M1054,150.18v.206l2.062.412Z",
    transform: "translate(-529.458 -119.209)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31728",
    "data-name": "Path 31728",
    d: "M900.242,150.18l.206.206-.206-.206m1.856,0,.206.206-.206-.206m-43.1.206.206.206Z",
    transform: "translate(-374.669 -119.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31729",
    "data-name": "Path 31729",
    d: "M860,151.18l.206.206Z",
    transform: "translate(-375.463 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31730",
    "data-name": "Path 31730",
    d: "M861,151.18l.206.206Z",
    transform: "translate(-376.257 -120.003)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31731",
    "data-name": "Path 31731",
    d: "M862,151.18l.412.412L862,151.18m1.65,0,.206.206Z",
    transform: "translate(-377.05 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31732",
    "data-name": "Path 31732",
    d: "M871,151.18l.206.206L871,151.18m8.661,0,.206.206Z",
    transform: "translate(-384.195 -120.003)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31733",
    "data-name": "Path 31733",
    d: "M914,151.18l.206.206Z",
    transform: "translate(-418.328 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31734",
    "data-name": "Path 31734",
    d: "M926,151.18l.206.206L926,151.18m1.582.068.138.068Z",
    transform: "translate(-427.853 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31735",
    "data-name": "Path 31735",
    d: "M951,151.18l.206.206Z",
    transform: "translate(-447.698 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31736",
    "data-name": "Path 31736",
    d: "M952.67,151.51l.138.068Z",
    transform: "translate(-449.023 -120.265)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31737",
    "data-name": "Path 31737",
    d: "M957,151.18l.206.206Z",
    transform: "translate(-452.461 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31738",
    "data-name": "Path 31738",
    d: "M958,151.18l.206.206Z",
    transform: "translate(-453.254 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31739",
    "data-name": "Path 31739",
    d: "M959,151.18l.206.206Z",
    transform: "translate(-454.048 -120.003)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31740",
    "data-name": "Path 31740",
    d: "M967,151.18l.206.206L967,151.18m.825,0,.206.206Z",
    transform: "translate(-460.398 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31741",
    "data-name": "Path 31741",
    d: "M972,151.18l.206.206Z",
    transform: "translate(-464.367 -120.003)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31742",
    "data-name": "Path 31742",
    d: "M973,151.18l.206.206Z",
    transform: "translate(-465.161 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31743",
    "data-name": "Path 31743",
    d: "M974,151.18l.206.206Z",
    transform: "translate(-465.955 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31744",
    "data-name": "Path 31744",
    d: "M975.67,151.51l.138.068Z",
    transform: "translate(-467.281 -120.265)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31745",
    "data-name": "Path 31745",
    d: "M998,151.18l.206.206Z",
    transform: "translate(-485.006 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31746",
    "data-name": "Path 31746",
    d: "M1013,151.18l.206.206Z",
    transform: "translate(-496.913 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31747",
    "data-name": "Path 31747",
    d: "M1014,151.18l.206.206Z",
    transform: "translate(-497.707 -120.003)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31748",
    "data-name": "Path 31748",
    d: "M1025,151.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-506.438 -120.003)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31749",
    "data-name": "Path 31749",
    d: "M1051.67,151.51l.136.068Z",
    transform: "translate(-527.609 -120.265)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31750",
    "data-name": "Path 31750",
    d: "M1055,151.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-530.252 -120.003)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31751",
    "data-name": "Path 31751",
    d: "M1062,151.18l.206.206Z",
    transform: "translate(-535.809 -120.003)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31752",
    "data-name": "Path 31752",
    d: "M862,152.18l.206.206Z",
    transform: "translate(-377.05 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31753",
    "data-name": "Path 31753",
    d: "M865,152.18l.206.206Z",
    transform: "translate(-379.432 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31754",
    "data-name": "Path 31754",
    d: "M873,152.18l.206.206Z",
    transform: "translate(-385.782 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31755",
    "data-name": "Path 31755",
    d: "M874,152.18l.206.206L874,152.18m2.819.068.138.068-.138-.068m1.512-.068v.206h.825l-.825-.206m2.887,0,.206.206Z",
    transform: "translate(-386.576 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31756",
    "data-name": "Path 31756",
    d: "M910,152.18l.206.206Z",
    transform: "translate(-415.152 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31757",
    "data-name": "Path 31757",
    d: "M961,152.18l.206.206Z",
    transform: "translate(-455.636 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31758",
    "data-name": "Path 31758",
    d: "M962,152.18l.206.206Z",
    transform: "translate(-456.43 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31759",
    "data-name": "Path 31759",
    d: "M969,152.18l.206.206L969,152.18m.825,0,.206.206Z",
    transform: "translate(-461.986 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31760",
    "data-name": "Path 31760",
    d: "M984,152.18l.206.206Z",
    transform: "translate(-473.893 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31761",
    "data-name": "Path 31761",
    d: "M985.67,152.51l.138.068Z",
    transform: "translate(-475.219 -121.059)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31762",
    "data-name": "Path 31762",
    d: "M987.67,152.51l.138.068Z",
    transform: "translate(-476.806 -121.059)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31763",
    "data-name": "Path 31763",
    d: "M999,152.18l.206.206Z",
    transform: "translate(-485.8 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31764",
    "data-name": "Path 31764",
    d: "M1017,152.18l.206.206Z",
    transform: "translate(-500.088 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31765",
    "data-name": "Path 31765",
    d: "M1018,152.18l.206.206Z",
    transform: "translate(-500.882 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31766",
    "data-name": "Path 31766",
    d: "M1019,152.18l.206.206Z",
    transform: "translate(-501.676 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31767",
    "data-name": "Path 31767",
    d: "M1025,152.18l.206.206Z",
    transform: "translate(-506.438 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31768",
    "data-name": "Path 31768",
    d: "M1031,152.18l.206.206Z",
    transform: "translate(-511.201 -120.797)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31769",
    "data-name": "Path 31769",
    d: "M1036,152.18l.206.206Z",
    transform: "translate(-515.17 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31770",
    "data-name": "Path 31770",
    d: "M1056,152.18l.206.206Z",
    transform: "translate(-531.046 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31771",
    "data-name": "Path 31771",
    d: "M1057.67,152.51l.136.068Z",
    transform: "translate(-532.371 -121.059)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31772",
    "data-name": "Path 31772",
    d: "M1064,152.18l.206.206Z",
    transform: "translate(-537.396 -120.797)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31773",
    "data-name": "Path 31773",
    d: "M1065,152.18l.206.206Z",
    transform: "translate(-538.19 -120.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31774",
    "data-name": "Path 31774",
    d: "M858,153.18l.206.206Z",
    transform: "translate(-373.875 -121.59)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31775",
    "data-name": "Path 31775",
    d: "M859,153.18l.206.206Z",
    transform: "translate(-374.669 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31776",
    "data-name": "Path 31776",
    d: "M860,153.18l.206.206Z",
    transform: "translate(-375.463 -121.59)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31777",
    "data-name": "Path 31777",
    d: "M877,153.18l.206.206Z",
    transform: "translate(-388.957 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31778",
    "data-name": "Path 31778",
    d: "M878,153.18l.206.206L878,153.18m5.774,0,.206.206Z",
    transform: "translate(-389.751 -121.59)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31779",
    "data-name": "Path 31779",
    d: "M907,153.18l.206.206L907,153.18m11.754,0,.206.206Z",
    transform: "translate(-412.771 -121.59)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31780",
    "data-name": "Path 31780",
    d: "M965,153.18l.206.206L965,153.18m1.237,0,.206.206Z",
    transform: "translate(-458.811 -121.59)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31781",
    "data-name": "Path 31781",
    d: "M975,153.18l.206.206Z",
    transform: "translate(-466.749 -121.59)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31782",
    "data-name": "Path 31782",
    d: "M1022,153.18l.206.206Z",
    transform: "translate(-504.057 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31783",
    "data-name": "Path 31783",
    d: "M1023,153.18l.206.206Z",
    transform: "translate(-504.851 -121.59)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31784",
    "data-name": "Path 31784",
    d: "M1027,153.18l.206.206Z",
    transform: "translate(-508.026 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31785",
    "data-name": "Path 31785",
    d: "M1028,153.18l.206.206Z",
    transform: "translate(-508.82 -121.59)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31786",
    "data-name": "Path 31786",
    d: "M1029,153.18l.206.206Z",
    transform: "translate(-509.613 -121.59)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31787",
    "data-name": "Path 31787",
    d: "M1032.33,153.85l.07.138Z",
    transform: "translate(-512.257 -122.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31788",
    "data-name": "Path 31788",
    d: "M1040,153.18l.206.206-.206-.206m4.743,0,.206.206Z",
    transform: "translate(-518.345 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31789",
    "data-name": "Path 31789",
    d: "M1067,153.18l.206.206Z",
    transform: "translate(-539.778 -121.59)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31790",
    "data-name": "Path 31790",
    d: "M905.8,153.18l.206.206-.206-.206m-42.135.274.138.068Z",
    transform: "translate(-378.376 -121.59)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31791",
    "data-name": "Path 31791",
    d: "M865,154.18l.206.206L865,154.18m3.093,0,.206.206Z",
    transform: "translate(-379.432 -122.384)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31792",
    "data-name": "Path 31792",
    d: "M881,154.18l.206.206Z",
    transform: "translate(-392.132 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31793",
    "data-name": "Path 31793",
    d: "M882,154.18l.206.206Z",
    transform: "translate(-392.926 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31794",
    "data-name": "Path 31794",
    d: "M887,154.18l.206.206Z",
    transform: "translate(-396.895 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31795",
    "data-name": "Path 31795",
    d: "M888,154.18v.206h.619Z",
    transform: "translate(-397.689 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31796",
    "data-name": "Path 31796",
    d: "M891,154.18v.206h.619L891,154.18m1.237,0,.206.206Z",
    transform: "translate(-400.07 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31797",
    "data-name": "Path 31797",
    d: "M898,154.18v.206h.825Z",
    transform: "translate(-405.627 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31798",
    "data-name": "Path 31798",
    d: "M902,154.18l.206.206Z",
    transform: "translate(-408.802 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31799",
    "data-name": "Path 31799",
    d: "M903,154.18l.206.206L903,154.18m13.4,0,.206.206Z",
    transform: "translate(-409.596 -122.384)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31800",
    "data-name": "Path 31800",
    d: "M969,154.18l.206.206Z",
    transform: "translate(-461.986 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31801",
    "data-name": "Path 31801",
    d: "M970,154.18l.206.206Z",
    transform: "translate(-462.78 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31802",
    "data-name": "Path 31802",
    d: "M1025,154.18l.206.206Z",
    transform: "translate(-506.438 -122.384)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31803",
    "data-name": "Path 31803",
    d: "M1026,154.18l.206.206Z",
    transform: "translate(-507.232 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31804",
    "data-name": "Path 31804",
    d: "M1042,154.18l.206.206Z",
    transform: "translate(-519.933 -122.384)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31805",
    "data-name": "Path 31805",
    d: "M1043,154.18l.206.206Z",
    transform: "translate(-520.727 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31806",
    "data-name": "Path 31806",
    d: "M1044,154.18l.206.206-.206-.206m.825,0v.412h.412Z",
    transform: "translate(-521.52 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31807",
    "data-name": "Path 31807",
    d: "M1049,154.18l.206.206Z",
    transform: "translate(-525.489 -122.384)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31808",
    "data-name": "Path 31808",
    d: "M1050,154.18l.206.206Z",
    transform: "translate(-526.283 -122.384)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31809",
    "data-name": "Path 31809",
    d: "M1051.67,154.51l.136.068Z",
    transform: "translate(-527.609 -122.646)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31810",
    "data-name": "Path 31810",
    d: "M1053,154.18v.206l1.237.206v-.206l-.619.206-.619-.412m2.062,0,.206.206Z",
    transform: "translate(-528.664 -122.384)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31811",
    "data-name": "Path 31811",
    d: "M885,155.18l.206.206L885,155.18m17.94,0,.206.206Z",
    transform: "translate(-395.308 -123.178)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31812",
    "data-name": "Path 31812",
    d: "M973,155.18l.206.206L973,155.18m.412,0,.206.206Z",
    transform: "translate(-465.161 -123.178)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31813",
    "data-name": "Path 31813",
    d: "M1029,155.18l.206.206Z",
    transform: "translate(-509.613 -123.178)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31814",
    "data-name": "Path 31814",
    d: "M1030.67,155.51l.136.068Z",
    transform: "translate(-510.939 -123.44)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31815",
    "data-name": "Path 31815",
    d: "M1046,155.18l.206.206Z",
    transform: "translate(-523.108 -123.178)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31816",
    "data-name": "Path 31816",
    d: "M1047,155.18l.206.206Z",
    transform: "translate(-523.902 -123.178)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31817",
    "data-name": "Path 31817",
    d: "M1050,155.18v.206h.825Z",
    transform: "translate(-526.283 -123.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31818",
    "data-name": "Path 31818",
    d: "M1056.67,155.51l.136.068Z",
    transform: "translate(-531.578 -123.44)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31819",
    "data-name": "Path 31819",
    d: "M1061,155.18l.206.206Z",
    transform: "translate(-535.015 -123.178)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31820",
    "data-name": "Path 31820",
    d: "M1053,156.18l.206.206Z",
    transform: "translate(-528.664 -123.972)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31821",
    "data-name": "Path 31821",
    d: "M989.047,156.51l.136.068-.136-.068M972,158.092l.206.206Z",
    transform: "translate(-464.367 -124.234)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31822",
    "data-name": "Path 31822",
    d: "M971.412,164.18l.412.412v.206H971V165l4.743,1.443-.825-.619v-.206l3.506.206c-.561-.876-1.912-.905-2.887-1.031V165l1.031.412v.206Z",
    transform: "translate(-463.574 -130.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31823",
    "data-name": "Path 31823",
    d: "M916.053,164.18l.206.206-.206-.206M901,164.386v.206h.619Z",
    transform: "translate(-408.008 -130.322)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31824",
    "data-name": "Path 31824",
    d: "M904,165.18l.206.206L904,165.18m7.562.068.138.068Z",
    transform: "translate(-410.39 -131.116)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31825",
    "data-name": "Path 31825",
    d: "M972,165.18l.206.206Z",
    transform: "translate(-464.367 -131.116)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31826",
    "data-name": "Path 31826",
    d: "M882.333,165.18l.206.206-.206-.206M858,165.386l.206.206Z",
    transform: "translate(-373.875 -131.116)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31827",
    "data-name": "Path 31827",
    d: "M885,166.18l.206.206Z",
    transform: "translate(-395.308 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31828",
    "data-name": "Path 31828",
    d: "M886,166.18l.206.206Z",
    transform: "translate(-396.101 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31829",
    "data-name": "Path 31829",
    d: "M886,166.386l4.33,1.65L888.681,167V166.8c2.444.361,6.516,2.233,8.867.825l-.825-.412V167l2.474,1.031v-.206l-.825-.412v-.206l5.774.619-2.062-1.443h1.237v-.206h-1.443V167c-1.017,0-4.619-1.19-4.743-.206l-1.856-.619.619.619V167l-1.856-.412c-.913,1.4-3.6-.351-4.949-.412v.206Z",
    transform: "translate(-396.101 -131.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31830",
    "data-name": "Path 31830",
    d: "M889,166.18l.206.206Z",
    transform: "translate(-398.483 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31831",
    "data-name": "Path 31831",
    d: "M890,166.18l.206.206Z",
    transform: "translate(-399.277 -131.91)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31832",
    "data-name": "Path 31832",
    d: "M906,166.18l.206.206Z",
    transform: "translate(-411.977 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31833",
    "data-name": "Path 31833",
    d: "M907,166.18l.206.206Z",
    transform: "translate(-412.771 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31834",
    "data-name": "Path 31834",
    d: "M934,166.18l.206.206Z",
    transform: "translate(-434.203 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31835",
    "data-name": "Path 31835",
    d: "M935,166.18l.206.206Z",
    transform: "translate(-434.997 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31836",
    "data-name": "Path 31836",
    d: "M939,166.18l.206.206L939,166.18m1.031,0,.206.206Z",
    transform: "translate(-438.172 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31837",
    "data-name": "Path 31837",
    d: "M945,166.18l.206.206L945,166.18m3.506,0,.206.206Z",
    transform: "translate(-442.935 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31838",
    "data-name": "Path 31838",
    d: "M969.206,166.18l-.206.412h.412Z",
    transform: "translate(-461.986 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31839",
    "data-name": "Path 31839",
    d: "M971,166.18l.206.206Z",
    transform: "translate(-463.574 -131.91)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31840",
    "data-name": "Path 31840",
    d: "M972.67,166.51l.138.068Z",
    transform: "translate(-464.899 -132.172)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31841",
    "data-name": "Path 31841",
    d: "M974,166.18l.206.206Z",
    transform: "translate(-465.955 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31842",
    "data-name": "Path 31842",
    d: "M978,166.18l.206.206Z",
    transform: "translate(-469.13 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31843",
    "data-name": "Path 31843",
    d: "M979,166.18l.206.206Z",
    transform: "translate(-469.924 -131.91)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31844",
    "data-name": "Path 31844",
    d: "M1064,166.18l.412.412Z",
    transform: "translate(-537.396 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31845",
    "data-name": "Path 31845",
    d: "M1065,166.18v.206l.825.206Z",
    transform: "translate(-538.19 -131.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31846",
    "data-name": "Path 31846",
    d: "M1068,166.18l.206.206Z",
    transform: "translate(-540.571 -131.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31847",
    "data-name": "Path 31847",
    d: "M858,167.18V168a19.228,19.228,0,0,0,7.836.412C864.1,167.227,860.116,167.465,858,167.18Z",
    transform: "translate(-373.875 -132.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31848",
    "data-name": "Path 31848",
    d: "M861,167.18l.206.206Z",
    transform: "translate(-376.257 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31849",
    "data-name": "Path 31849",
    d: "M862,167.18l.206.206Z",
    transform: "translate(-377.05 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31850",
    "data-name": "Path 31850",
    d: "M892,167.18l.206.206Z",
    transform: "translate(-400.864 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31851",
    "data-name": "Path 31851",
    d: "M893,167.18l.206.206Z",
    transform: "translate(-401.658 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31852",
    "data-name": "Path 31852",
    d: "M895,167.18l.206.206L895,167.18m1.031,0,.206.206Z",
    transform: "translate(-403.246 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31853",
    "data-name": "Path 31853",
    d: "M901,167.18l.206.206Z",
    transform: "translate(-408.008 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31854",
    "data-name": "Path 31854",
    d: "M902,167.18l.206.206L902,167.18m1.443,0,.206.206Z",
    transform: "translate(-408.802 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31855",
    "data-name": "Path 31855",
    d: "M936,167.18l.206.206Z",
    transform: "translate(-435.791 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31856",
    "data-name": "Path 31856",
    d: "M947,167.18l.206.206L947,167.18m3.093,0,.206.206Z",
    transform: "translate(-444.523 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31857",
    "data-name": "Path 31857",
    d: "M964,167.18l.206.206Z",
    transform: "translate(-458.017 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31858",
    "data-name": "Path 31858",
    d: "M965,167.18l.206.206L965,167.18m.412,0,.206.206Z",
    transform: "translate(-458.811 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31859",
    "data-name": "Path 31859",
    d: "M968,167.18l.206.206Z",
    transform: "translate(-461.192 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31860",
    "data-name": "Path 31860",
    d: "M975,167.18l.206.206Z",
    transform: "translate(-466.749 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31861",
    "data-name": "Path 31861",
    d: "M976,167.18l.206.206L976,167.18m1.031,0,.206.206Z",
    transform: "translate(-467.543 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31862",
    "data-name": "Path 31862",
    d: "M992,167.18l.206.206Z",
    transform: "translate(-480.243 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31863",
    "data-name": "Path 31863",
    d: "M996,167.18l.206.206Z",
    transform: "translate(-483.418 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31864",
    "data-name": "Path 31864",
    d: "M997,167.18l.206.206Z",
    transform: "translate(-484.212 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31865",
    "data-name": "Path 31865",
    d: "M1014,167.18l.206.206Z",
    transform: "translate(-497.707 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31866",
    "data-name": "Path 31866",
    d: "M1015,167.18l.206.206Z",
    transform: "translate(-498.5 -132.703)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31867",
    "data-name": "Path 31867",
    d: "M1016,167.18l.206.206Z",
    transform: "translate(-499.294 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31868",
    "data-name": "Path 31868",
    d: "M1046.67,167.51l.136.068Z",
    transform: "translate(-523.64 -132.965)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31869",
    "data-name": "Path 31869",
    d: "M1052,167.18l.206.206Z",
    transform: "translate(-527.871 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31870",
    "data-name": "Path 31870",
    d: "M1053.67,167.248l.136.068-.136-.068m.893-.068v.619h.206Z",
    transform: "translate(-529.196 -132.703)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31871",
    "data-name": "Path 31871",
    d: "M1018.517,167.18v.206l1.65.825v.206c-.769-.3-2.225-1.3-2.887-.619l-5.774-.412v.206h.412v.206l-3.918-.412c.208.973,2.017.94,2.887,1.031,0-.835,1.693-.008,2.268,0,1.291.019,2.823-.571,4.124-.138a22.613,22.613,0,0,0,2.474,1.169l-1.031-1.237,1.856.619V167.8Z",
    transform: "translate(-492.944 -132.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31872",
    "data-name": "Path 31872",
    d: "M1062,167.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-535.809 -132.703)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31873",
    "data-name": "Path 31873",
    d: "M865,168.18l.206.206Z",
    transform: "translate(-379.432 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31874",
    "data-name": "Path 31874",
    d: "M866.67,168.51l.138.068Z",
    transform: "translate(-380.758 -133.759)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31875",
    "data-name": "Path 31875",
    d: "M886,168.18l.206.206Z",
    transform: "translate(-396.101 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31876",
    "data-name": "Path 31876",
    d: "M887,168.18l.206.206L887,168.18m3.3,0,.206.206Z",
    transform: "translate(-396.895 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31877",
    "data-name": "Path 31877",
    d: "M904,168.18l.206.206Z",
    transform: "translate(-410.39 -133.497)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31878",
    "data-name": "Path 31878",
    d: "M905,168.18l.206.206Z",
    transform: "translate(-411.183 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31879",
    "data-name": "Path 31879",
    d: "M911,168.18l.206.206Z",
    transform: "translate(-415.946 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31880",
    "data-name": "Path 31880",
    d: "M912,168.18l.206.206Z",
    transform: "translate(-416.74 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31881",
    "data-name": "Path 31881",
    d: "M924,168.18l.206.206Z",
    transform: "translate(-426.265 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31882",
    "data-name": "Path 31882",
    d: "M928,168.18l.206.206Z",
    transform: "translate(-429.441 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31883",
    "data-name": "Path 31883",
    d: "M929,168.18l.206.206Z",
    transform: "translate(-430.234 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31884",
    "data-name": "Path 31884",
    d: "M931,168.18l.206.206Z",
    transform: "translate(-431.822 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31885",
    "data-name": "Path 31885",
    d: "M934.67,168.51l.138.068-.138-.068m.825,0,.138.068Z",
    transform: "translate(-434.735 -133.759)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31886",
    "data-name": "Path 31886",
    d: "M949,168.18l.206.206Z",
    transform: "translate(-446.11 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31887",
    "data-name": "Path 31887",
    d: "M950,168.18l.206.206Z",
    transform: "translate(-446.904 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31888",
    "data-name": "Path 31888",
    d: "M951,168.18l.206.206Z",
    transform: "translate(-447.698 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31889",
    "data-name": "Path 31889",
    d: "M962,168.18l.206.206Z",
    transform: "translate(-456.43 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31890",
    "data-name": "Path 31890",
    d: "M964,168.18l.206.206Z",
    transform: "translate(-458.017 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31891",
    "data-name": "Path 31891",
    d: "M985.67,168.51l.138.068Z",
    transform: "translate(-475.219 -133.759)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31892",
    "data-name": "Path 31892",
    d: "M987,168.18l.206.206Z",
    transform: "translate(-476.274 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31893",
    "data-name": "Path 31893",
    d: "M993,168.18l.206.206L993,168.18m1.65,0,.206.206Z",
    transform: "translate(-481.037 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31894",
    "data-name": "Path 31894",
    d: "M1002,168.18l.206.206Z",
    transform: "translate(-488.181 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31895",
    "data-name": "Path 31895",
    d: "M1007,168.18l.206.206Z",
    transform: "translate(-492.15 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31896",
    "data-name": "Path 31896",
    d: "M1011.67,168.51l.136.068-.136-.068m1.65,0,.136.068Z",
    transform: "translate(-495.857 -133.759)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31897",
    "data-name": "Path 31897",
    d: "M1021,168.18l.206.206Z",
    transform: "translate(-503.263 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31898",
    "data-name": "Path 31898",
    d: "M1030,168.18l.206.206Z",
    transform: "translate(-510.407 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31899",
    "data-name": "Path 31899",
    d: "M1031.67,168.51l.136.068Z",
    transform: "translate(-511.733 -133.759)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31900",
    "data-name": "Path 31900",
    d: "M1033.67,168.51l.136.068Z",
    transform: "translate(-513.32 -133.759)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31901",
    "data-name": "Path 31901",
    d: "M1049,168.18l.206.206Z",
    transform: "translate(-525.489 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31902",
    "data-name": "Path 31902",
    d: "M1052,168.18l.206.206Z",
    transform: "translate(-527.871 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31903",
    "data-name": "Path 31903",
    d: "M1056,168.18l.206.206Z",
    transform: "translate(-531.046 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31904",
    "data-name": "Path 31904",
    d: "M1057,168.18l.206.206Z",
    transform: "translate(-531.84 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31905",
    "data-name": "Path 31905",
    d: "M1058,168.18l.206.206Z",
    transform: "translate(-532.633 -133.497)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31906",
    "data-name": "Path 31906",
    d: "M1064,168.18l.206.206Z",
    transform: "translate(-537.396 -133.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31907",
    "data-name": "Path 31907",
    d: "M1065.67,168.51l.136.068Z",
    transform: "translate(-538.722 -133.759)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31908",
    "data-name": "Path 31908",
    d: "M1067,168.18l.412.412Z",
    transform: "translate(-539.778 -133.497)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31909",
    "data-name": "Path 31909",
    d: "M902.1,168.18l.206.206-.206-.206m-43.1.206.206.206-.206-.206m2.681,0v.206h.825Z",
    transform: "translate(-374.669 -133.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31910",
    "data-name": "Path 31910",
    d: "M876,169.18l.206.206Z",
    transform: "translate(-388.164 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31911",
    "data-name": "Path 31911",
    d: "M879,169.18l.206.206Z",
    transform: "translate(-390.545 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31912",
    "data-name": "Path 31912",
    d: "M880,169.18v.206h.619Z",
    transform: "translate(-391.339 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31913",
    "data-name": "Path 31913",
    d: "M883,169.18l.206.206Z",
    transform: "translate(-393.72 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31914",
    "data-name": "Path 31914",
    d: "M884,169.18l.206.206L884,169.18m1.237,0,.412.412Z",
    transform: "translate(-394.514 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31915",
    "data-name": "Path 31915",
    d: "M891,169.18l.206.206Z",
    transform: "translate(-400.07 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31916",
    "data-name": "Path 31916",
    d: "M892,169.18l.206.206Z",
    transform: "translate(-400.864 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31917",
    "data-name": "Path 31917",
    d: "M899,169.18l.206.206Z",
    transform: "translate(-406.421 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31918",
    "data-name": "Path 31918",
    d: "M900,169.18l.206.206Z",
    transform: "translate(-407.215 -134.291)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31919",
    "data-name": "Path 31919",
    d: "M901,169.18l.206.206Z",
    transform: "translate(-408.008 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31920",
    "data-name": "Path 31920",
    d: "M901.206,169.18l-.206.412.206-.412m.825,0,.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-408.008 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31921",
    "data-name": "Path 31921",
    d: "M914,169.18l.206.206Z",
    transform: "translate(-418.328 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31922",
    "data-name": "Path 31922",
    d: "M922.412,169.18l-.412.206v.206l.412-.412m.619,0,.412.412-.412-.412m.825,0,.206.206Z",
    transform: "translate(-424.678 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31923",
    "data-name": "Path 31923",
    d: "M932,169.18l.206.206Z",
    transform: "translate(-432.616 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31924",
    "data-name": "Path 31924",
    d: "M933,169.18l.206.206Z",
    transform: "translate(-433.41 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31925",
    "data-name": "Path 31925",
    d: "M936,169.18l.206.206Z",
    transform: "translate(-435.791 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31926",
    "data-name": "Path 31926",
    d: "M937,169.18l.206.206L937,169.18m.619,0,.206.206Z",
    transform: "translate(-436.585 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31927",
    "data-name": "Path 31927",
    d: "M943,169.18l.412.412Z",
    transform: "translate(-441.347 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31928",
    "data-name": "Path 31928",
    d: "M944,169.18l.206.206L944,169.18m2.062,0v.206h.619Z",
    transform: "translate(-442.141 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31929",
    "data-name": "Path 31929",
    d: "M957.67,169.51l.138.068Z",
    transform: "translate(-452.992 -134.553)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31930",
    "data-name": "Path 31930",
    d: "M959,169.18l.206.206Z",
    transform: "translate(-454.048 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31931",
    "data-name": "Path 31931",
    d: "M962,169.18l.206.206Z",
    transform: "translate(-456.43 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31932",
    "data-name": "Path 31932",
    d: "M965,169.18l.206.206Z",
    transform: "translate(-458.811 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31933",
    "data-name": "Path 31933",
    d: "M966,169.18l.206.206Z",
    transform: "translate(-459.605 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31934",
    "data-name": "Path 31934",
    d: "M990,169.18l.206.206Z",
    transform: "translate(-478.656 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31935",
    "data-name": "Path 31935",
    d: "M991,169.18l.206.206L991,169.18m.619,0,.412.412Z",
    transform: "translate(-479.449 -134.291)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31936",
    "data-name": "Path 31936",
    d: "M995,169.18l.206.206L995,169.18m2.268,0,.206.619h.206v-.619h-.412m3.712,0v.206h.619l-.619-.206m3.025.068.136.068Z",
    transform: "translate(-482.625 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31937",
    "data-name": "Path 31937",
    d: "M1040,169.18l.206.206Z",
    transform: "translate(-518.345 -134.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31938",
    "data-name": "Path 31938",
    d: "M1051,169.18l.206.206Z",
    transform: "translate(-527.077 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31939",
    "data-name": "Path 31939",
    d: "M1052,169.18l.206.206-.206-.206m1.582.068.136.068Z",
    transform: "translate(-527.871 -134.291)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31940",
    "data-name": "Path 31940",
    d: "M901.448,169.18l-.206.412.206-.412m1.237,0,.206.206-.206-.206M860,169.386l.206.206-.206-.206m5.912.068.138.068Z",
    transform: "translate(-375.463 -134.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31941",
    "data-name": "Path 31941",
    d: "M890,170.18l.206.206Z",
    transform: "translate(-399.277 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31942",
    "data-name": "Path 31942",
    d: "M892.67,170.51l.138.068Z",
    transform: "translate(-401.396 -135.347)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31943",
    "data-name": "Path 31943",
    d: "M894,170.18l.206.206Z",
    transform: "translate(-402.452 -135.085)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31944",
    "data-name": "Path 31944",
    d: "M894,170.386l.825.412-.412-.619Z",
    transform: "translate(-402.452 -135.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31945",
    "data-name": "Path 31945",
    d: "M902,170.18l.206.206Z",
    transform: "translate(-408.802 -135.085)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31946",
    "data-name": "Path 31946",
    d: "M903,170.18l.206.206Z",
    transform: "translate(-409.596 -135.085)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31947",
    "data-name": "Path 31947",
    d: "M904,170.18l.206.206Z",
    transform: "translate(-410.39 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31948",
    "data-name": "Path 31948",
    d: "M905,170.18l.206.206L905,170.18m2.819.068.138.068Z",
    transform: "translate(-411.183 -135.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31949",
    "data-name": "Path 31949",
    d: "M920.67,170.248l.138.068-.138-.068m1.718-.068.206.206Z",
    transform: "translate(-423.622 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31950",
    "data-name": "Path 31950",
    d: "M930,170.18l.206.206L930,170.18m.825,0-.206.412Z",
    transform: "translate(-431.028 -135.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31951",
    "data-name": "Path 31951",
    d: "M938,170.18l.206.206Z",
    transform: "translate(-437.379 -135.085)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31952",
    "data-name": "Path 31952",
    d: "M939.33,170.85l.068.138Z",
    transform: "translate(-438.434 -135.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31953",
    "data-name": "Path 31953",
    d: "M968,170.18l.206.206L968,170.18m1.443,0,.206.206Z",
    transform: "translate(-461.192 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31954",
    "data-name": "Path 31954",
    d: "M976,170.18l.206.206L976,170.18m2.406.068.138.068Z",
    transform: "translate(-467.543 -135.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31955",
    "data-name": "Path 31955",
    d: "M994,170.18l.206.206Z",
    transform: "translate(-481.831 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31956",
    "data-name": "Path 31956",
    d: "M996,170.18l.206.206Z",
    transform: "translate(-483.418 -135.085)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31957",
    "data-name": "Path 31957",
    d: "M997,170.18l.206.206Z",
    transform: "translate(-484.212 -135.085)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31958",
    "data-name": "Path 31958",
    d: "M1018.67,170.51l.136.068Z",
    transform: "translate(-501.414 -135.347)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31959",
    "data-name": "Path 31959",
    d: "M1061,170.18l.206.206Z",
    transform: "translate(-535.015 -135.085)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31960",
    "data-name": "Path 31960",
    d: "M1062,170.18l.206.206Z",
    transform: "translate(-535.809 -135.085)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31961",
    "data-name": "Path 31961",
    d: "M900.341,170.85l.07.138-.07-.138M858,170.918l.206.206Z",
    transform: "translate(-373.875 -135.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31962",
    "data-name": "Path 31962",
    d: "M859,171.18l.206.206L859,171.18m9.073,0,.206.206Z",
    transform: "translate(-374.669 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31963",
    "data-name": "Path 31963",
    d: "M904,171.18l.206.206Z",
    transform: "translate(-410.39 -135.879)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31964",
    "data-name": "Path 31964",
    d: "M905.67,171.51l.138.068Z",
    transform: "translate(-411.715 -136.141)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31965",
    "data-name": "Path 31965",
    d: "M907,171.18l.206.206Z",
    transform: "translate(-412.771 -135.879)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31966",
    "data-name": "Path 31966",
    d: "M908,171.18l.206.206L908,171.18m5.774,0v.206l.619.206Z",
    transform: "translate(-413.565 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31967",
    "data-name": "Path 31967",
    d: "M940,171.18l.206.206Z",
    transform: "translate(-438.966 -135.879)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31968",
    "data-name": "Path 31968",
    d: "M941,171.18l.206.206Z",
    transform: "translate(-439.76 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31969",
    "data-name": "Path 31969",
    d: "M946,171.18v.206h1.237Z",
    transform: "translate(-443.729 -135.879)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31970",
    "data-name": "Path 31970",
    d: "M952,171.18v.206h.619L952,171.18m4.124,0,.206.206Z",
    transform: "translate(-448.492 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31971",
    "data-name": "Path 31971",
    d: "M973,171.18l.206.206L973,171.18m1.237,0,.206.206Z",
    transform: "translate(-465.161 -135.879)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31972",
    "data-name": "Path 31972",
    d: "M980,171.18l.206.206Z",
    transform: "translate(-470.718 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31973",
    "data-name": "Path 31973",
    d: "M990,171.18l.206.206Z",
    transform: "translate(-478.656 -135.879)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31974",
    "data-name": "Path 31974",
    d: "M991,171.18l.206.206Z",
    transform: "translate(-479.449 -135.879)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31975",
    "data-name": "Path 31975",
    d: "M992.33,171.85l.068.138Z",
    transform: "translate(-480.505 -136.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31976",
    "data-name": "Path 31976",
    d: "M993,171.18l.206.206L993,171.18m.825.412h.619l-.206-.412Z",
    transform: "translate(-481.037 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31977",
    "data-name": "Path 31977",
    d: "M1001,171.18l.206.206-.206-.206m1.994.068.136.068Z",
    transform: "translate(-487.387 -135.879)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31978",
    "data-name": "Path 31978",
    d: "M1012,171.18l.206.206Z",
    transform: "translate(-496.119 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31979",
    "data-name": "Path 31979",
    d: "M1021,171.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-503.263 -135.879)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31980",
    "data-name": "Path 31980",
    d: "M1024,171.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-505.645 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31981",
    "data-name": "Path 31981",
    d: "M1064,171.18l.206.206Z",
    transform: "translate(-537.396 -135.879)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31982",
    "data-name": "Path 31982",
    d: "M1065,171.18l.206.206Z",
    transform: "translate(-538.19 -135.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31983",
    "data-name": "Path 31983",
    d: "M901.3,171.18l.206.206-.206-.206m-43.3.206.206.206-.206-.206m2.474,0,.206.206Z",
    transform: "translate(-373.875 -135.879)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31984",
    "data-name": "Path 31984",
    d: "M871.67,172.51l.138.068Z",
    transform: "translate(-384.726 -136.934)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31985",
    "data-name": "Path 31985",
    d: "M873,172.18l.206.206L873,172.18m3.3,0,.206.206Z",
    transform: "translate(-385.782 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31986",
    "data-name": "Path 31986",
    d: "M898,172.18l.206.206Z",
    transform: "translate(-405.627 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31987",
    "data-name": "Path 31987",
    d: "M899.67,172.51l.138.068Z",
    transform: "translate(-406.952 -136.934)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31988",
    "data-name": "Path 31988",
    d: "M906,172.18l.206.206Z",
    transform: "translate(-411.977 -136.672)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31989",
    "data-name": "Path 31989",
    d: "M910,172.18l.206.206L910,172.18m3.505,0,.206.206Z",
    transform: "translate(-415.152 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31990",
    "data-name": "Path 31990",
    d: "M928,172.18v.206h.619Z",
    transform: "translate(-429.441 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31991",
    "data-name": "Path 31991",
    d: "M931.33,172.85l.068.138Z",
    transform: "translate(-432.084 -137.204)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31992",
    "data-name": "Path 31992",
    d: "M941,172.18l.206.206Z",
    transform: "translate(-439.76 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31993",
    "data-name": "Path 31993",
    d: "M942,172.18l.206.206Z",
    transform: "translate(-440.554 -136.672)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31994",
    "data-name": "Path 31994",
    d: "M947,172.18l.206.206Z",
    transform: "translate(-444.523 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31995",
    "data-name": "Path 31995",
    d: "M948,172.18l.206.206Z",
    transform: "translate(-445.316 -136.672)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31996",
    "data-name": "Path 31996",
    d: "M956,172.18l.206.206Z",
    transform: "translate(-451.667 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31997",
    "data-name": "Path 31997",
    d: "M957,172.18v.206h.619Z",
    transform: "translate(-452.461 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31998",
    "data-name": "Path 31998",
    d: "M983,172.18l.206.206L983,172.18m2.681,0,.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-473.099 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31999",
    "data-name": "Path 31999",
    d: "M1006.67,172.51l.136.068Z",
    transform: "translate(-491.888 -136.934)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32000",
    "data-name": "Path 32000",
    d: "M1016,172.18l.206.206Z",
    transform: "translate(-499.294 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32001",
    "data-name": "Path 32001",
    d: "M1017.67,172.51l.136.068Z",
    transform: "translate(-500.62 -136.934)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32002",
    "data-name": "Path 32002",
    d: "M1030,172.18l.206.206Z",
    transform: "translate(-510.407 -136.672)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32003",
    "data-name": "Path 32003",
    d: "M1035,172.18l.206.206Z",
    transform: "translate(-514.376 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32004",
    "data-name": "Path 32004",
    d: "M1036.67,172.51l.136.068Z",
    transform: "translate(-515.702 -136.934)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32005",
    "data-name": "Path 32005",
    d: "M1038,172.18v.206h1.237Z",
    transform: "translate(-516.758 -136.672)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32006",
    "data-name": "Path 32006",
    d: "M1044,172.18v.206h.619Z",
    transform: "translate(-521.52 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32007",
    "data-name": "Path 32007",
    d: "M1047,172.18l.206.206Z",
    transform: "translate(-523.902 -136.672)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32008",
    "data-name": "Path 32008",
    d: "M1053,172.18l.206.206Z",
    transform: "translate(-528.664 -136.672)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32009",
    "data-name": "Path 32009",
    d: "M1060.67,172.51l.136.068Z",
    transform: "translate(-534.753 -136.934)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32010",
    "data-name": "Path 32010",
    d: "M1065.67,172.51l.136.068Z",
    transform: "translate(-538.722 -136.934)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32011",
    "data-name": "Path 32011",
    d: "M858,173.18l.206.206Z",
    transform: "translate(-373.875 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32012",
    "data-name": "Path 32012",
    d: "M876.67,173.51l.138.068Z",
    transform: "translate(-388.695 -137.728)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32013",
    "data-name": "Path 32013",
    d: "M878.67,173.248l.138.068-.138-.068m2.955-.068.206.206Z",
    transform: "translate(-390.283 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32014",
    "data-name": "Path 32014",
    d: "M894,173.18l.206.206L894,173.18m1.65,0,.206.206Z",
    transform: "translate(-402.452 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32015",
    "data-name": "Path 32015",
    d: "M903,173.18l.206.206Z",
    transform: "translate(-409.596 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32016",
    "data-name": "Path 32016",
    d: "M907,173.18l.206.206Z",
    transform: "translate(-412.771 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32017",
    "data-name": "Path 32017",
    d: "M911,173.18l.206.206Z",
    transform: "translate(-415.946 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32018",
    "data-name": "Path 32018",
    d: "M912,173.18l.206.206L912,173.18m1.237,0,.206.206Z",
    transform: "translate(-416.74 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32019",
    "data-name": "Path 32019",
    d: "M919,173.18l.206.206L919,173.18m.825,0-.206.412Z",
    transform: "translate(-422.297 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32020",
    "data-name": "Path 32020",
    d: "M924,173.18l.206.206Z",
    transform: "translate(-426.265 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32021",
    "data-name": "Path 32021",
    d: "M925,173.18l.206.206Z",
    transform: "translate(-427.059 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32022",
    "data-name": "Path 32022",
    d: "M932,173.18l.206.206Z",
    transform: "translate(-432.616 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32023",
    "data-name": "Path 32023",
    d: "M933,173.18l.206.206Z",
    transform: "translate(-433.41 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32024",
    "data-name": "Path 32024",
    d: "M934,173.18l.206.206Z",
    transform: "translate(-434.203 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32025",
    "data-name": "Path 32025",
    d: "M935,173.18l.206.206Z",
    transform: "translate(-434.997 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32026",
    "data-name": "Path 32026",
    d: "M944,173.18l.206.206L944,173.18m1.031,0,.206.206Z",
    transform: "translate(-442.141 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32027",
    "data-name": "Path 32027",
    d: "M964,173.18l.206.206Z",
    transform: "translate(-458.017 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32028",
    "data-name": "Path 32028",
    d: "M965,173.18l.206.206Z",
    transform: "translate(-458.811 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32029",
    "data-name": "Path 32029",
    d: "M966.67,173.51l.138.068Z",
    transform: "translate(-460.136 -137.728)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32030",
    "data-name": "Path 32030",
    d: "M986,173.18l.206.206Z",
    transform: "translate(-475.48 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32031",
    "data-name": "Path 32031",
    d: "M993,173.18l.206.206Z",
    transform: "translate(-481.037 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32032",
    "data-name": "Path 32032",
    d: "M1020,173.18l.206.206Z",
    transform: "translate(-502.469 -137.466)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32033",
    "data-name": "Path 32033",
    d: "M1055,173.18l.206.206Z",
    transform: "translate(-530.252 -137.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32034",
    "data-name": "Path 32034",
    d: "M1060,173.18l.206.206Z",
    transform: "translate(-534.221 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32035",
    "data-name": "Path 32035",
    d: "M1061.67,173.51l.136.068Z",
    transform: "translate(-535.547 -137.728)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32036",
    "data-name": "Path 32036",
    d: "M900.273,173.18l.206.206-.206-.206M858,173.386l.206.206Z",
    transform: "translate(-373.875 -137.466)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32037",
    "data-name": "Path 32037",
    d: "M884,174.18l.206.206Z",
    transform: "translate(-394.514 -138.26)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32038",
    "data-name": "Path 32038",
    d: "M885,174.18l.206.206Z",
    transform: "translate(-395.308 -138.26)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32039",
    "data-name": "Path 32039",
    d: "M886,174.18l.206.206Z",
    transform: "translate(-396.101 -138.26)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32040",
    "data-name": "Path 32040",
    d: "M890,174.18l.206.206Z",
    transform: "translate(-399.277 -138.26)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32041",
    "data-name": "Path 32041",
    d: "M905,174.18l.206.206Z",
    transform: "translate(-411.183 -138.26)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32042",
    "data-name": "Path 32042",
    d: "M907,174.18l.206.206L907,174.18m2.887,0,.206.206Z",
    transform: "translate(-412.771 -138.26)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32043",
    "data-name": "Path 32043",
    d: "M923,174.18l.206.206Z",
    transform: "translate(-425.472 -138.26)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32044",
    "data-name": "Path 32044",
    d: "M929,174.18l.206.206Z",
    transform: "translate(-430.234 -138.26)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32045",
    "data-name": "Path 32045",
    d: "M930,174.18l.206.206L930,174.18m1.237,0,.619.412v-.206Z",
    transform: "translate(-431.028 -138.26)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32046",
    "data-name": "Path 32046",
    d: "M939,174.18l.206.206Z",
    transform: "translate(-438.172 -138.26)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32047",
    "data-name": "Path 32047",
    d: "M940.67,174.248l.138.068-.138-.068m1.1-.068.206.206Z",
    transform: "translate(-439.498 -138.26)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32048",
    "data-name": "Path 32048",
    d: "M988,174.18l.206.206Z",
    transform: "translate(-477.068 -138.26)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32049",
    "data-name": "Path 32049",
    d: "M989,174.18l.206.206Z",
    transform: "translate(-477.862 -138.26)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32050",
    "data-name": "Path 32050",
    d: "M994,174.18l.206.206L994,174.18m12.785,0,.206.206-.206-.206m1.237,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-481.831 -138.26)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32051",
    "data-name": "Path 32051",
    d: "M1066.67,174.51l.136.068Z",
    transform: "translate(-539.516 -138.522)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32052",
    "data-name": "Path 32052",
    d: "M934,175.18v.206h.619Z",
    transform: "translate(-434.203 -139.054)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32053",
    "data-name": "Path 32053",
    d: "M939,175.18l.206.206Z",
    transform: "translate(-438.172 -139.054)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32054",
    "data-name": "Path 32054",
    d: "M948,175.18l.206.206Z",
    transform: "translate(-445.316 -139.054)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32055",
    "data-name": "Path 32055",
    d: "M949,175.18l.206.206Z",
    transform: "translate(-446.11 -139.054)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32056",
    "data-name": "Path 32056",
    d: "M992.67,175.51l.138.068Z",
    transform: "translate(-480.775 -139.316)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32057",
    "data-name": "Path 32057",
    d: "M1058,175.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-532.633 -139.054)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32058",
    "data-name": "Path 32058",
    d: "M1060,176.18l.206.206Z",
    transform: "translate(-534.221 -139.848)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32059",
    "data-name": "Path 32059",
    d: "M1064,176.18l.206.206Z",
    transform: "translate(-537.396 -139.848)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32060",
    "data-name": "Path 32060",
    d: "M1061,177.18l.206.206Z",
    transform: "translate(-535.015 -140.641)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32061",
    "data-name": "Path 32061",
    d: "M1062,177.18l.206.206Z",
    transform: "translate(-535.809 -140.641)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32062",
    "data-name": "Path 32062",
    d: "M955.206,183.18l-.206.412Z",
    transform: "translate(-450.873 -145.404)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32063",
    "data-name": "Path 32063",
    d: "M957.67,183.51l.138.068Z",
    transform: "translate(-452.992 -145.666)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32064",
    "data-name": "Path 32064",
    d: "M959,183.18v.206h.619Z",
    transform: "translate(-454.048 -145.404)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32065",
    "data-name": "Path 32065",
    d: "M1048.206,183.18l-.206.412Z",
    transform: "translate(-524.695 -145.404)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32066",
    "data-name": "Path 32066",
    d: "M895.943,184.8l.206.619-5.155-.619c0,.749-1.258.355-1.856.412-2.052.2-3.949-.656-5.98-1.031l1.237,1.65-6.186-1.65.619.825-3.093-.412v.206l1.031.825-6.6-1.237.412.412V185l-2.268-.206.412.619-3.3-.619.412.825L858,184.8v.825l5.98.619c0-.86,1.437-.412,2.062-.412l-.206-.825.825.206-.206.619c.746-.039,3.161.214,3.3-.619.8.153,2.681,1.153,2.887.206l5.155.825-1.031-1.443a29.8,29.8,0,0,1,5.774.825c.734.21,1.848.794,2.062-.206l.619.412-.825-1.031,5.568,1.237v-.206l-.825-.206v-.206l3.712.825c.2-1.567,4.06-.227,4.949,0l1.856-.619v-.206h-.619v-.206l1.443.206V185l1.031.619V184.8l-2.268-.619.412.619C898.011,184.056,897.59,184.473,895.943,184.8Z",
    transform: "translate(-373.875 -146.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32067",
    "data-name": "Path 32067",
    d: "M1052,183.18l.206.206Z",
    transform: "translate(-527.871 -145.404)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32068",
    "data-name": "Path 32068",
    d: "M1053,183.18l.206.206Z",
    transform: "translate(-528.664 -145.404)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32069",
    "data-name": "Path 32069",
    d: "M1058.67,183.51l.136.068Z",
    transform: "translate(-533.165 -145.666)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32070",
    "data-name": "Path 32070",
    d: "M963,184.18l.206.206Z",
    transform: "translate(-457.223 -146.198)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32071",
    "data-name": "Path 32071",
    d: "M964,184.18l.206.206L964,184.18m3.161.138.068.138Z",
    transform: "translate(-458.017 -146.198)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32072",
    "data-name": "Path 32072",
    d: "M982,184.18l.206.206Z",
    transform: "translate(-472.305 -146.198)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32073",
    "data-name": "Path 32073",
    d: "M1055,184.18l.206.206Z",
    transform: "translate(-530.252 -146.198)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32074",
    "data-name": "Path 32074",
    d: "M945.9,184.18l.206.206-.206-.206m-29.9.206.206.206Z",
    transform: "translate(-419.915 -146.198)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32075",
    "data-name": "Path 32075",
    d: "M918,185.18l.206.206Z",
    transform: "translate(-421.503 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32076",
    "data-name": "Path 32076",
    d: "M919,185.18l.206.206L919,185.18m5.293.068.138.068Z",
    transform: "translate(-422.297 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32077",
    "data-name": "Path 32077",
    d: "M947,185.18l.206.206Z",
    transform: "translate(-444.523 -146.992)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32078",
    "data-name": "Path 32078",
    d: "M948,185.18l.206.206L948,185.18m.619,0,.206.206Z",
    transform: "translate(-445.316 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32079",
    "data-name": "Path 32079",
    d: "M952,185.18l.206.206Z",
    transform: "translate(-448.492 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32080",
    "data-name": "Path 32080",
    d: "M956,185.18l.206.206Z",
    transform: "translate(-451.667 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32081",
    "data-name": "Path 32081",
    d: "M959,185.18l.206.206Z",
    transform: "translate(-454.048 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32082",
    "data-name": "Path 32082",
    d: "M960.33,185.85l.068.138Z",
    transform: "translate(-455.104 -147.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32083",
    "data-name": "Path 32083",
    d: "M966,185.18l.206.206Z",
    transform: "translate(-459.605 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32084",
    "data-name": "Path 32084",
    d: "M987,185.18l.206.206Z",
    transform: "translate(-476.274 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32085",
    "data-name": "Path 32085",
    d: "M1046,185.18l.206.206Z",
    transform: "translate(-523.108 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32086",
    "data-name": "Path 32086",
    d: "M1047,185.18l.206.206Z",
    transform: "translate(-523.902 -146.992)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32087",
    "data-name": "Path 32087",
    d: "M1050,185.18v.206h.619Z",
    transform: "translate(-526.283 -146.992)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32088",
    "data-name": "Path 32088",
    d: "M1053,185.18l.206.206Z",
    transform: "translate(-528.664 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32089",
    "data-name": "Path 32089",
    d: "M1056,185.18l.206.206Z",
    transform: "translate(-531.046 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32090",
    "data-name": "Path 32090",
    d: "M1057,185.18l.206.206Z",
    transform: "translate(-531.84 -146.992)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32091",
    "data-name": "Path 32091",
    d: "M1058,185.18l.412.412Z",
    transform: "translate(-532.633 -146.992)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32092",
    "data-name": "Path 32092",
    d: "M1062,185.18l.206.206Z",
    transform: "translate(-535.809 -146.992)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32093",
    "data-name": "Path 32093",
    d: "M928.849,185.18l.206.206-.206-.206M894,185.386l.206.206Z",
    transform: "translate(-402.452 -146.992)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32094",
    "data-name": "Path 32094",
    d: "M895,186.18l.206.206L895,186.18m.619,0,.206.206Z",
    transform: "translate(-403.246 -147.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32095",
    "data-name": "Path 32095",
    d: "M899,186.18l.206.206Z",
    transform: "translate(-406.421 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32096",
    "data-name": "Path 32096",
    d: "M908,186.18l.206.206Z",
    transform: "translate(-413.565 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32097",
    "data-name": "Path 32097",
    d: "M909.67,186.51l.138.068Z",
    transform: "translate(-414.89 -148.047)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32098",
    "data-name": "Path 32098",
    d: "M911,186.18l.206.206Z",
    transform: "translate(-415.946 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32099",
    "data-name": "Path 32099",
    d: "M912,186.18l.206.206Z",
    transform: "translate(-416.74 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32100",
    "data-name": "Path 32100",
    d: "M920,186.18l.206.206Z",
    transform: "translate(-423.09 -147.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32101",
    "data-name": "Path 32101",
    d: "M921,186.18l.206.206Z",
    transform: "translate(-423.884 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32102",
    "data-name": "Path 32102",
    d: "M922,186.18l.206.206Z",
    transform: "translate(-424.678 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32103",
    "data-name": "Path 32103",
    d: "M923.67,186.248l.138.068-.138-.068m4.6-.068.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-426.003 -147.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32104",
    "data-name": "Path 32104",
    d: "M955,186.18l.206.206Z",
    transform: "translate(-450.873 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32105",
    "data-name": "Path 32105",
    d: "M956,186.18l.206.206Z",
    transform: "translate(-451.667 -147.786)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32106",
    "data-name": "Path 32106",
    d: "M957.33,186.85l.068.138Z",
    transform: "translate(-452.722 -148.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32107",
    "data-name": "Path 32107",
    d: "M961,186.18l.206.206Z",
    transform: "translate(-455.636 -147.786)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32108",
    "data-name": "Path 32108",
    d: "M961.206,186.18l-.206.412h.412Z",
    transform: "translate(-455.636 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32109",
    "data-name": "Path 32109",
    d: "M963,186.18l.206.206Z",
    transform: "translate(-457.223 -147.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32110",
    "data-name": "Path 32110",
    d: "M982,186.18l.206.206Z",
    transform: "translate(-472.305 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32111",
    "data-name": "Path 32111",
    d: "M990.67,186.51l.138.068Z",
    transform: "translate(-479.187 -148.047)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32112",
    "data-name": "Path 32112",
    d: "M992.67,186.248l.138.068-.138-.068m10.172-.068.206.206Z",
    transform: "translate(-480.775 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32113",
    "data-name": "Path 32113",
    d: "M1043,186.18l.206.206Z",
    transform: "translate(-520.727 -147.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32114",
    "data-name": "Path 32114",
    d: "M1052.67,186.51l.136.068Z",
    transform: "translate(-528.403 -148.047)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32115",
    "data-name": "Path 32115",
    d: "M1054,186.18l.206.206Z",
    transform: "translate(-529.458 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32116",
    "data-name": "Path 32116",
    d: "M1055,186.18l.206.206-.206-.206m.619,0,.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-530.252 -147.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32117",
    "data-name": "Path 32117",
    d: "M1067,186.18l.206.206Z",
    transform: "translate(-539.778 -147.786)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32118",
    "data-name": "Path 32118",
    d: "M859,187.18l.206.206Z",
    transform: "translate(-374.669 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32119",
    "data-name": "Path 32119",
    d: "M860,187.18l.206.206Z",
    transform: "translate(-375.463 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32120",
    "data-name": "Path 32120",
    d: "M901,187.18l.206.206Z",
    transform: "translate(-408.008 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32121",
    "data-name": "Path 32121",
    d: "M902,187.18l.206.206Z",
    transform: "translate(-408.802 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32122",
    "data-name": "Path 32122",
    d: "M915,187.18l.206.206Z",
    transform: "translate(-419.121 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32123",
    "data-name": "Path 32123",
    d: "M916,187.18l.206.206Z",
    transform: "translate(-419.915 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32124",
    "data-name": "Path 32124",
    d: "M917,187.18l.206.206Z",
    transform: "translate(-420.709 -148.579)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32125",
    "data-name": "Path 32125",
    d: "M918,187.18l.206.206Z",
    transform: "translate(-421.503 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32126",
    "data-name": "Path 32126",
    d: "M926,187.18l.206.206Z",
    transform: "translate(-427.853 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32127",
    "data-name": "Path 32127",
    d: "M927,187.18v.206h.619Z",
    transform: "translate(-428.647 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32128",
    "data-name": "Path 32128",
    d: "M930,187.18l.206.206L930,187.18m2.887,0,.206.206Z",
    transform: "translate(-431.028 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32129",
    "data-name": "Path 32129",
    d: "M949,187.18l.206.206L949,187.18m.619,0,.206.206Z",
    transform: "translate(-446.11 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32130",
    "data-name": "Path 32130",
    d: "M953,187.18l.206.206Z",
    transform: "translate(-449.285 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32131",
    "data-name": "Path 32131",
    d: "M958,187.18l.206.206Z",
    transform: "translate(-453.254 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32132",
    "data-name": "Path 32132",
    d: "M963,187.18l.206.206Z",
    transform: "translate(-457.223 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32133",
    "data-name": "Path 32133",
    d: "M968,187.18l.206.206Z",
    transform: "translate(-461.192 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32134",
    "data-name": "Path 32134",
    d: "M969,187.18v.206h.619Z",
    transform: "translate(-461.986 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32135",
    "data-name": "Path 32135",
    d: "M980,187.18l.206.206L980,187.18m.619,0,.206.206Z",
    transform: "translate(-470.718 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32136",
    "data-name": "Path 32136",
    d: "M986,187.18l.619.619v-.619Z",
    transform: "translate(-475.48 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32137",
    "data-name": "Path 32137",
    d: "M987,187.18l.206.206Z",
    transform: "translate(-476.274 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32138",
    "data-name": "Path 32138",
    d: "M995,187.18l.206.206Z",
    transform: "translate(-482.625 -148.579)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32139",
    "data-name": "Path 32139",
    d: "M1020,187.18l.206.206Z",
    transform: "translate(-502.469 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32140",
    "data-name": "Path 32140",
    d: "M1041,187.18l.206.206Z",
    transform: "translate(-519.139 -148.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32141",
    "data-name": "Path 32141",
    d: "M1063,187.18l.206.206Z",
    transform: "translate(-536.602 -148.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32142",
    "data-name": "Path 32142",
    d: "M862,188.18l.206.206Z",
    transform: "translate(-377.05 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32143",
    "data-name": "Path 32143",
    d: "M864,188.18l.206.206Z",
    transform: "translate(-378.638 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32144",
    "data-name": "Path 32144",
    d: "M865,188.18v.206h1.237Z",
    transform: "translate(-379.432 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32145",
    "data-name": "Path 32145",
    d: "M871,188.18l.206.206L871,188.18m.825,0,.206.206Z",
    transform: "translate(-384.195 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32146",
    "data-name": "Path 32146",
    d: "M876,188.18l.206.206L876,188.18m.551.068.138.068Z",
    transform: "translate(-388.164 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32147",
    "data-name": "Path 32147",
    d: "M880,188.18l.206.206Z",
    transform: "translate(-391.339 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32148",
    "data-name": "Path 32148",
    d: "M887,188.18l.206.206Z",
    transform: "translate(-396.895 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32149",
    "data-name": "Path 32149",
    d: "M888,188.18l.206.206L888,188.18m1.237,0,.206.206Z",
    transform: "translate(-397.689 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32150",
    "data-name": "Path 32150",
    d: "M896,188.18l.206.206Z",
    transform: "translate(-404.039 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32151",
    "data-name": "Path 32151",
    d: "M897,188.18l.206.206Z",
    transform: "translate(-404.833 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32152",
    "data-name": "Path 32152",
    d: "M904,188.18l.206.206Z",
    transform: "translate(-410.39 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32153",
    "data-name": "Path 32153",
    d: "M907,188.592h.619l-.206-.412Z",
    transform: "translate(-412.771 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32154",
    "data-name": "Path 32154",
    d: "M913,188.18l.206.206L913,188.18m1.237,0,.206.206-.206-.206m4.33,0,.206.206Z",
    transform: "translate(-417.534 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32155",
    "data-name": "Path 32155",
    d: "M941,188.18l.206.206Z",
    transform: "translate(-439.76 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32156",
    "data-name": "Path 32156",
    d: "M942,188.18l.206.206Z",
    transform: "translate(-440.554 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32157",
    "data-name": "Path 32157",
    d: "M946,188.18l.206.206Z",
    transform: "translate(-443.729 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32158",
    "data-name": "Path 32158",
    d: "M950,188.18l.206.206L950,188.18m1.031,0,.206.206Z",
    transform: "translate(-446.904 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32159",
    "data-name": "Path 32159",
    d: "M974,188.18v.206h.619Z",
    transform: "translate(-465.955 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32160",
    "data-name": "Path 32160",
    d: "M977,188.18l.206.206Z",
    transform: "translate(-468.336 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32161",
    "data-name": "Path 32161",
    d: "M981,188.18l.206.206Z",
    transform: "translate(-471.512 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32162",
    "data-name": "Path 32162",
    d: "M984,188.18l.206.206Z",
    transform: "translate(-473.893 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32163",
    "data-name": "Path 32163",
    d: "M988,188.18l.206.206Z",
    transform: "translate(-477.068 -149.373)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32164",
    "data-name": "Path 32164",
    d: "M989,188.18l.206.206Z",
    transform: "translate(-477.862 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32165",
    "data-name": "Path 32165",
    d: "M990,188.18l.206.206L990,188.18m.619,0,.206.206Z",
    transform: "translate(-478.656 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32166",
    "data-name": "Path 32166",
    d: "M997,188.18l.206.206Z",
    transform: "translate(-484.212 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32167",
    "data-name": "Path 32167",
    d: "M1008.67,188.51l.136.068Z",
    transform: "translate(-493.476 -149.635)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32168",
    "data-name": "Path 32168",
    d: "M1010,188.18v.206h.825Z",
    transform: "translate(-494.531 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32169",
    "data-name": "Path 32169",
    d: "M1014,188.18v.206h.825Z",
    transform: "translate(-497.707 -149.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32170",
    "data-name": "Path 32170",
    d: "M1018,188.18l.206.206-.206-.206m.825,0,.206.206-.206-.206m6.737.068.136.068Z",
    transform: "translate(-500.882 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32171",
    "data-name": "Path 32171",
    d: "M1064,188.18l.206.206Z",
    transform: "translate(-537.396 -149.373)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32172",
    "data-name": "Path 32172",
    d: "M1065,188.18l.206.206Z",
    transform: "translate(-538.19 -149.373)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32173",
    "data-name": "Path 32173",
    d: "M881,189.18l.206.206L881,189.18m1.856,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-392.132 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32174",
    "data-name": "Path 32174",
    d: "M897,189.18l.206.206Z",
    transform: "translate(-404.833 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32175",
    "data-name": "Path 32175",
    d: "M898,189.18l.206.206Z",
    transform: "translate(-405.627 -150.167)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32176",
    "data-name": "Path 32176",
    d: "M899,189.18l.206.206Z",
    transform: "translate(-406.421 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32177",
    "data-name": "Path 32177",
    d: "M906,189.18l.206.206Z",
    transform: "translate(-411.977 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32178",
    "data-name": "Path 32178",
    d: "M915.67,189.51l.138.068Z",
    transform: "translate(-419.653 -150.429)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32179",
    "data-name": "Path 32179",
    d: "M917,189.18l.206.206L917,189.18m5.568,0,.206.206Z",
    transform: "translate(-420.709 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32180",
    "data-name": "Path 32180",
    d: "M945.412,189.18l-.412.206v.206Z",
    transform: "translate(-442.935 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32181",
    "data-name": "Path 32181",
    d: "M951,189.18l.206.206Z",
    transform: "translate(-447.698 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32182",
    "data-name": "Path 32182",
    d: "M958,189.18l.206.206Z",
    transform: "translate(-453.254 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32183",
    "data-name": "Path 32183",
    d: "M959,189.18l.206.206L959,189.18m1.582.068.138.068-.138-.068m3.367-.068.206.206Z",
    transform: "translate(-454.048 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32184",
    "data-name": "Path 32184",
    d: "M991,189.18l.206.206Z",
    transform: "translate(-479.449 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32185",
    "data-name": "Path 32185",
    d: "M995,189.18l.206.206L995,189.18m1.65,0,.206.206Z",
    transform: "translate(-482.625 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32186",
    "data-name": "Path 32186",
    d: "M1004,189.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-489.769 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32187",
    "data-name": "Path 32187",
    d: "M1023,189.18l.206.206Z",
    transform: "translate(-504.851 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32188",
    "data-name": "Path 32188",
    d: "M1027,189.18l.206.206Z",
    transform: "translate(-508.026 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32189",
    "data-name": "Path 32189",
    d: "M1028,189.18v.206h1.031Z",
    transform: "translate(-508.82 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32190",
    "data-name": "Path 32190",
    d: "M1033,189.18l.206.206Z",
    transform: "translate(-512.789 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32191",
    "data-name": "Path 32191",
    d: "M1034,189.18l.206.206Z",
    transform: "translate(-513.582 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32192",
    "data-name": "Path 32192",
    d: "M1038,189.18l.206.206Z",
    transform: "translate(-516.758 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32193",
    "data-name": "Path 32193",
    d: "M1039,189.18l.206.206Z",
    transform: "translate(-517.551 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32194",
    "data-name": "Path 32194",
    d: "M1046,189.18l.206.206Z",
    transform: "translate(-523.108 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32195",
    "data-name": "Path 32195",
    d: "M1047,189.18l.206.206Z",
    transform: "translate(-523.902 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32196",
    "data-name": "Path 32196",
    d: "M1057,189.18l.206.206Z",
    transform: "translate(-531.84 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32197",
    "data-name": "Path 32197",
    d: "M1058,189.18l.206.206Z",
    transform: "translate(-532.633 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32198",
    "data-name": "Path 32198",
    d: "M1059,189.18l.206.619h.206v-.619Z",
    transform: "translate(-533.427 -150.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32199",
    "data-name": "Path 32199",
    d: "M1061,189.18l.206.206Z",
    transform: "translate(-535.015 -150.167)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32200",
    "data-name": "Path 32200",
    d: "M1064,189.18l.206.206Z",
    transform: "translate(-537.396 -150.167)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32201",
    "data-name": "Path 32201",
    d: "M888,190.18l.206.206L888,190.18m.825,0,.206.206Z",
    transform: "translate(-397.689 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32202",
    "data-name": "Path 32202",
    d: "M893,190.18l.206.206Z",
    transform: "translate(-401.658 -150.961)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32203",
    "data-name": "Path 32203",
    d: "M897,190.18l.412.412Z",
    transform: "translate(-404.833 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32204",
    "data-name": "Path 32204",
    d: "M898,190.18l.206.206Z",
    transform: "translate(-405.627 -150.961)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32205",
    "data-name": "Path 32205",
    d: "M921,190.18l.206.206Z",
    transform: "translate(-423.884 -150.961)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32206",
    "data-name": "Path 32206",
    d: "M922,190.18l.206.206Z",
    transform: "translate(-424.678 -150.961)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32207",
    "data-name": "Path 32207",
    d: "M929,190.18l.206.206Z",
    transform: "translate(-430.234 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32208",
    "data-name": "Path 32208",
    d: "M935.67,190.51l.138.068Z",
    transform: "translate(-435.529 -151.223)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32209",
    "data-name": "Path 32209",
    d: "M937.67,190.248l.138.068-.138-.068m2.13-.068.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-437.117 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32210",
    "data-name": "Path 32210",
    d: "M972,190.18l.206.206Z",
    transform: "translate(-464.367 -150.961)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32211",
    "data-name": "Path 32211",
    d: "M973.67,190.51l.138.068Z",
    transform: "translate(-465.693 -151.223)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32212",
    "data-name": "Path 32212",
    d: "M975,190.18l.206.206L975,190.18m1.031,0,.206.206Z",
    transform: "translate(-466.749 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32213",
    "data-name": "Path 32213",
    d: "M981,190.18l.206.206L981,190.18m.619,0,.206.206Z",
    transform: "translate(-471.512 -150.961)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32214",
    "data-name": "Path 32214",
    d: "M987,190.18v.619h.206L987,190.18m.412,0,.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-476.274 -150.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32215",
    "data-name": "Path 32215",
    d: "M1009,190.18l.206.206-.206-.206m1.856,0v.206h.619l-.619-.206m1.375.068.136.068Z",
    transform: "translate(-493.738 -150.961)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32216",
    "data-name": "Path 32216",
    d: "M1063,190.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-536.602 -150.961)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32217",
    "data-name": "Path 32217",
    d: "M861,191.18l.206.206Z",
    transform: "translate(-376.257 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32218",
    "data-name": "Path 32218",
    d: "M862,191.18v.206h.825Z",
    transform: "translate(-377.05 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32219",
    "data-name": "Path 32219",
    d: "M866,191.18l.206.206Z",
    transform: "translate(-380.226 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32220",
    "data-name": "Path 32220",
    d: "M867,191.18l.206.206L867,191.18m1.031,0v.206h1.031Z",
    transform: "translate(-381.019 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32221",
    "data-name": "Path 32221",
    d: "M877,191.18v.206h.825Z",
    transform: "translate(-388.957 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32222",
    "data-name": "Path 32222",
    d: "M890,191.18l.206.206Z",
    transform: "translate(-399.277 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32223",
    "data-name": "Path 32223",
    d: "M891,191.18l.206.206Z",
    transform: "translate(-400.07 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32224",
    "data-name": "Path 32224",
    d: "M897,191.18l.206.206Z",
    transform: "translate(-404.833 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32225",
    "data-name": "Path 32225",
    d: "M902,191.18l.206.206Z",
    transform: "translate(-408.802 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32226",
    "data-name": "Path 32226",
    d: "M903,191.18l.206.206Z",
    transform: "translate(-409.596 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32227",
    "data-name": "Path 32227",
    d: "M909.67,191.51l.138.068Z",
    transform: "translate(-414.89 -152.016)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32228",
    "data-name": "Path 32228",
    d: "M911,191.18l.206.206Z",
    transform: "translate(-415.946 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32229",
    "data-name": "Path 32229",
    d: "M914,191.18l.206.206Z",
    transform: "translate(-418.328 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32230",
    "data-name": "Path 32230",
    d: "M915,191.18l.206.206Z",
    transform: "translate(-419.121 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32231",
    "data-name": "Path 32231",
    d: "M924,191.18l.206.206Z",
    transform: "translate(-426.265 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32232",
    "data-name": "Path 32232",
    d: "M931,191.18l.206.206Z",
    transform: "translate(-431.822 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32233",
    "data-name": "Path 32233",
    d: "M932,191.18l.206.206L932,191.18m2.2.068.138.068Z",
    transform: "translate(-432.616 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32234",
    "data-name": "Path 32234",
    d: "M944,191.18l.206.206L944,191.18m1.856,0,.206.206Z",
    transform: "translate(-442.141 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32235",
    "data-name": "Path 32235",
    d: "M977,191.18l.206.206Z",
    transform: "translate(-468.336 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32236",
    "data-name": "Path 32236",
    d: "M978,191.18l.206.206L978,191.18m1.031,0,.206.206Z",
    transform: "translate(-469.13 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32237",
    "data-name": "Path 32237",
    d: "M984.67,191.248l.138.068-.138-.068m.687-.068.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-474.425 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32238",
    "data-name": "Path 32238",
    d: "M994,191.18l.206.206Z",
    transform: "translate(-481.831 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M995,191.18l.206.206Z",
    transform: "translate(-482.625 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32240",
    "data-name": "Path 32240",
    d: "M996.67,191.51l.138.068Z",
    transform: "translate(-483.95 -152.016)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32241",
    "data-name": "Path 32241",
    d: "M998,191.18l.206.206L998,191.18m2.681,0,.206.206Z",
    transform: "translate(-485.006 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M1012,191.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-496.119 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32243",
    "data-name": "Path 32243",
    d: "M1027,191.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-508.026 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32244",
    "data-name": "Path 32244",
    d: "M1035.67,191.51l.136.068Z",
    transform: "translate(-514.908 -152.016)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32245",
    "data-name": "Path 32245",
    d: "M1037,191.18v.206h1.65Z",
    transform: "translate(-515.964 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32246",
    "data-name": "Path 32246",
    d: "M1045,191.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-522.314 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32247",
    "data-name": "Path 32247",
    d: "M1049,191.18l.206.206Z",
    transform: "translate(-525.489 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32248",
    "data-name": "Path 32248",
    d: "M1052.67,191.51l.136.068Z",
    transform: "translate(-528.403 -152.016)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32249",
    "data-name": "Path 32249",
    d: "M1054,191.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-529.458 -151.754)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32250",
    "data-name": "Path 32250",
    d: "M1058,191.18l.206.206Z",
    transform: "translate(-532.633 -151.754)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32251",
    "data-name": "Path 32251",
    d: "M1059,191.18l.206.206Z",
    transform: "translate(-533.427 -151.754)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32252",
    "data-name": "Path 32252",
    d: "M869,192.18l.206.206Z",
    transform: "translate(-382.607 -152.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32253",
    "data-name": "Path 32253",
    d: "M870,192.18l.206.206Z",
    transform: "translate(-383.401 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32254",
    "data-name": "Path 32254",
    d: "M871,192.18l.206.206Z",
    transform: "translate(-384.195 -152.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32255",
    "data-name": "Path 32255",
    d: "M882,192.18l.206.206L882,192.18m.825,0v.206h.619Z",
    transform: "translate(-392.926 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32256",
    "data-name": "Path 32256",
    d: "M894,192.18v.206h.619L894,192.18m1.169.068.138.068Z",
    transform: "translate(-402.452 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32257",
    "data-name": "Path 32257",
    d: "M905,192.18l.206.206Z",
    transform: "translate(-411.183 -152.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32258",
    "data-name": "Path 32258",
    d: "M906,192.18v.206h.619Z",
    transform: "translate(-411.977 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32259",
    "data-name": "Path 32259",
    d: "M926,192.18l.206.206Z",
    transform: "translate(-427.853 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32260",
    "data-name": "Path 32260",
    d: "M929,192.18l.206.206Z",
    transform: "translate(-430.234 -152.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32261",
    "data-name": "Path 32261",
    d: "M950,192.18l.206.206L950,192.18m.893.138.068.138-.068-.138m5.5-.138.206.206Z",
    transform: "translate(-446.904 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32262",
    "data-name": "Path 32262",
    d: "M982,192.18l.206.206Z",
    transform: "translate(-472.305 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32263",
    "data-name": "Path 32263",
    d: "M989.67,192.51l.138.068Z",
    transform: "translate(-478.394 -152.81)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32264",
    "data-name": "Path 32264",
    d: "M1000,192.18l.206.206Z",
    transform: "translate(-486.594 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32265",
    "data-name": "Path 32265",
    d: "M1001,192.18l.206.206Z",
    transform: "translate(-487.387 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32266",
    "data-name": "Path 32266",
    d: "M1002,192.18l.206.206Z",
    transform: "translate(-488.181 -152.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32267",
    "data-name": "Path 32267",
    d: "M1003,192.18l.206.206Z",
    transform: "translate(-488.975 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32268",
    "data-name": "Path 32268",
    d: "M1004,192.18l.206.206Z",
    transform: "translate(-489.769 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32269",
    "data-name": "Path 32269",
    d: "M1005,192.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-490.563 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32270",
    "data-name": "Path 32270",
    d: "M1008,192.18l.206.206-.206-.206m1.031,0-.206.412.206-.412m1.856,0,.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-492.944 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32271",
    "data-name": "Path 32271",
    d: "M1046,192.18l.206.206Z",
    transform: "translate(-523.108 -152.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32272",
    "data-name": "Path 32272",
    d: "M1051,192.18l.206.206Z",
    transform: "translate(-527.077 -152.548)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32273",
    "data-name": "Path 32273",
    d: "M883,193.18l.206.206Z",
    transform: "translate(-393.72 -153.342)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32274",
    "data-name": "Path 32274",
    d: "M884,193.18l.206.206Z",
    transform: "translate(-394.514 -153.342)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32275",
    "data-name": "Path 32275",
    d: "M887,193.18l.206.206Z",
    transform: "translate(-396.895 -153.342)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32276",
    "data-name": "Path 32276",
    d: "M952,193.18l.206.206Z",
    transform: "translate(-448.492 -153.342)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32277",
    "data-name": "Path 32277",
    d: "M1011,193.18l.206.206Z",
    transform: "translate(-495.325 -153.342)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32278",
    "data-name": "Path 32278",
    d: "M1013,193.18l.206.206-.206-.206m2.062,0,.206.206Z",
    transform: "translate(-496.913 -153.342)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32279",
    "data-name": "Path 32279",
    d: "M1025.412,193.18l-.412.206v.206l.412-.412m4.33,0,.206.206Z",
    transform: "translate(-506.438 -153.342)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32280",
    "data-name": "Path 32280",
    d: "M920.025,193.18l.206.206-.206-.206M886,193.386l.206.206-.206-.206m28.457,0,.206.206-.206-.206m-18.765,1.65.206.206Z",
    transform: "translate(-396.101 -153.342)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32281",
    "data-name": "Path 32281",
    d: "M934,202.18l.206.206Z",
    transform: "translate(-434.203 -160.486)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32282",
    "data-name": "Path 32282",
    d: "M1033,202.18l.206.206Z",
    transform: "translate(-512.789 -160.486)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32283",
    "data-name": "Path 32283",
    d: "M1032.412,202.18l-.412.619Z",
    transform: "translate(-511.995 -160.486)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32284",
    "data-name": "Path 32284",
    d: "M904,203.18l.206.206Z",
    transform: "translate(-410.39 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32285",
    "data-name": "Path 32285",
    d: "M905,203.18l.206.206Z",
    transform: "translate(-411.183 -161.28)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32286",
    "data-name": "Path 32286",
    d: "M932,203.18l.206.206Z",
    transform: "translate(-432.616 -161.28)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32287",
    "data-name": "Path 32287",
    d: "M932,204.18l1.443,1.65-1.031-1.65h.206a2.247,2.247,0,0,0,2.474,1.031c.652.852,2.679.6,3.712.619v.206h-.619v.206l1.65-.412v-.206L937.774,205V204.8l.412-.412-.619.825Z",
    transform: "translate(-432.616 -162.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32288",
    "data-name": "Path 32288",
    d: "M936,203.18l.206.206L936,203.18m18.627.138.07.138Z",
    transform: "translate(-435.791 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32289",
    "data-name": "Path 32289",
    d: "M978.579,203.18l.412.825-10.723-.619.825,1.237-2.475-1.031h-.206l-.412.619,3.3.825.206-.206-.825-1.237c5.194,2.429,9.743.217,15.053.825l-.206-.619h1.237l2.474.412c-.373-.759-2.435-1.555-2.681-.412l-3.093-.619.206.619-1.65-.619.412.619Z",
    transform: "translate(-459.605 -161.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32290",
    "data-name": "Path 32290",
    d: "M1028,203.18l.206.206Z",
    transform: "translate(-508.82 -161.28)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32291",
    "data-name": "Path 32291",
    d: "M1029,203.18l.206.206Z",
    transform: "translate(-509.613 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32292",
    "data-name": "Path 32292",
    d: "M1036,203.18l.206.206Z",
    transform: "translate(-515.17 -161.28)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32293",
    "data-name": "Path 32293",
    d: "M1040,203.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-518.345 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32294",
    "data-name": "Path 32294",
    d: "M1046,203.18l.206.206Z",
    transform: "translate(-523.108 -161.28)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32295",
    "data-name": "Path 32295",
    d: "M1047,203.18l.206.206Z",
    transform: "translate(-523.902 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32296",
    "data-name": "Path 32296",
    d: "M1048,203.18l.206.206Z",
    transform: "translate(-524.695 -161.28)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32297",
    "data-name": "Path 32297",
    d: "M1055.33,203.318l.07.138-.07-.138m.963-.138.206.206Z",
    transform: "translate(-530.514 -161.28)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32298",
    "data-name": "Path 32298",
    d: "M1061,203.18l.206.206Z",
    transform: "translate(-535.015 -161.28)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32299",
    "data-name": "Path 32299",
    d: "M860.33,204.85l.068.138Z",
    transform: "translate(-375.725 -162.606)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32300",
    "data-name": "Path 32300",
    d: "M858.619,204.18l-.619.412.206.619,4.743.825-1.031-.825V205l5.98.412v-.206h-.412V205l5.774.619V205l-5.568-.412v.206l-6.8-.206.412.619Z",
    transform: "translate(-373.875 -162.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32301",
    "data-name": "Path 32301",
    d: "M863,204.18l.206.206Z",
    transform: "translate(-377.844 -162.074)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32302",
    "data-name": "Path 32302",
    d: "M864,204.18l.206.206L864,204.18m5.774,0,.206.206Z",
    transform: "translate(-378.638 -162.074)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32303",
    "data-name": "Path 32303",
    d: "M893,204.18v.206h.619Z",
    transform: "translate(-401.658 -162.074)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32304",
    "data-name": "Path 32304",
    d: "M903,204.18l.206.206Z",
    transform: "translate(-409.596 -162.074)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32305",
    "data-name": "Path 32305",
    d: "M907,204.18l.206.206L907,204.18m1.375.068.138.068Z",
    transform: "translate(-412.771 -162.074)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32306",
    "data-name": "Path 32306",
    d: "M934,204.18l.206.206L934,204.18m.825,0,.206.206Z",
    transform: "translate(-434.203 -162.074)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32307",
    "data-name": "Path 32307",
    d: "M980,204.18l.206.206Z",
    transform: "translate(-470.718 -162.074)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32308",
    "data-name": "Path 32308",
    d: "M981,204.18l.206.206Z",
    transform: "translate(-471.512 -162.074)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32309",
    "data-name": "Path 32309",
    d: "M1033,204.18l.206.206Z",
    transform: "translate(-512.789 -162.074)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32310",
    "data-name": "Path 32310",
    d: "M1034,204.18l.412.412Z",
    transform: "translate(-513.582 -162.074)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32311",
    "data-name": "Path 32311",
    d: "M1038,204.18l.206.206Z",
    transform: "translate(-516.758 -162.074)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32312",
    "data-name": "Path 32312",
    d: "M1039,204.18v.206l.619.206Z",
    transform: "translate(-517.551 -162.074)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32313",
    "data-name": "Path 32313",
    d: "M1045,204.18l.206.206Z",
    transform: "translate(-522.314 -162.074)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32314",
    "data-name": "Path 32314",
    d: "M1050,204.18l.206.206Z",
    transform: "translate(-526.283 -162.074)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32315",
    "data-name": "Path 32315",
    d: "M1051,204.18l.206.206-.206-.206m2.681,0,.206.206Z",
    transform: "translate(-527.077 -162.074)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32316",
    "data-name": "Path 32316",
    d: "M858,205.18l.206.206Z",
    transform: "translate(-373.875 -162.868)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32317",
    "data-name": "Path 32317",
    d: "M866,205.18l.206.206Z",
    transform: "translate(-380.226 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32318",
    "data-name": "Path 32318",
    d: "M871,205.18l.206.206Z",
    transform: "translate(-384.195 -162.868)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32319",
    "data-name": "Path 32319",
    d: "M872,205.18l.206.206Z",
    transform: "translate(-384.988 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32320",
    "data-name": "Path 32320",
    d: "M873,205.18l.206.206Z",
    transform: "translate(-385.782 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32321",
    "data-name": "Path 32321",
    d: "M874,205.18l.206.206L874,205.18m3.506,0,.206.206Z",
    transform: "translate(-386.576 -162.868)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32322",
    "data-name": "Path 32322",
    d: "M898,205.18l.206.206Z",
    transform: "translate(-405.627 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32323",
    "data-name": "Path 32323",
    d: "M910,205.18l.206.206Z",
    transform: "translate(-415.152 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32324",
    "data-name": "Path 32324",
    d: "M911,205.18l.206.206Z",
    transform: "translate(-415.946 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32325",
    "data-name": "Path 32325",
    d: "M912,205.18l.206.206L912,205.18m1.031,0,.206.206Z",
    transform: "translate(-416.74 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32326",
    "data-name": "Path 32326",
    d: "M918,205.18l.206.206Z",
    transform: "translate(-421.503 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32327",
    "data-name": "Path 32327",
    d: "M934,205.18l.206.206Z",
    transform: "translate(-434.203 -162.868)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32328",
    "data-name": "Path 32328",
    d: "M939,205.18l.206.206Z",
    transform: "translate(-438.172 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32329",
    "data-name": "Path 32329",
    d: "M959,205.18l.206.206L959,205.18m.619,0-.206.412h.412Z",
    transform: "translate(-454.048 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32330",
    "data-name": "Path 32330",
    d: "M963,205.18l.206.206Z",
    transform: "translate(-457.223 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32331",
    "data-name": "Path 32331",
    d: "M967.33,205.85l.068.138Z",
    transform: "translate(-460.66 -163.399)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32332",
    "data-name": "Path 32332",
    d: "M969,205.18l.206.206Z",
    transform: "translate(-461.986 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32333",
    "data-name": "Path 32333",
    d: "M979,205.18l.412.619L979,205.18m.825,0v.206h.619Z",
    transform: "translate(-469.924 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32334",
    "data-name": "Path 32334",
    d: "M986.67,205.51l.138.068Z",
    transform: "translate(-476.012 -163.13)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32335",
    "data-name": "Path 32335",
    d: "M988,205.18l.206.206Z",
    transform: "translate(-477.068 -162.868)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32336",
    "data-name": "Path 32336",
    d: "M1028,205.18l.206.206Z",
    transform: "translate(-508.82 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32337",
    "data-name": "Path 32337",
    d: "M1034,205.18l.206.206-.206-.206m1.237,0,.206.206-.206-.206m2.681,0,.206.206Z",
    transform: "translate(-513.582 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32338",
    "data-name": "Path 32338",
    d: "M1054,205.18l.206.206Z",
    transform: "translate(-529.458 -162.868)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32339",
    "data-name": "Path 32339",
    d: "M1055,205.18l.206.206Z",
    transform: "translate(-530.252 -162.868)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32340",
    "data-name": "Path 32340",
    d: "M1058,205.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-532.633 -162.868)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32341",
    "data-name": "Path 32341",
    d: "M1068,205.18l.206.206Z",
    transform: "translate(-540.571 -162.868)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32342",
    "data-name": "Path 32342",
    d: "M868,206.18l.206.206Z",
    transform: "translate(-381.813 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32343",
    "data-name": "Path 32343",
    d: "M869,206.18l.206.206Z",
    transform: "translate(-382.607 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32344",
    "data-name": "Path 32344",
    d: "M870,206.386v.206l.412.206h.206l-.206-.619-.412.206m1.443-.206.206.206Z",
    transform: "translate(-383.401 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32345",
    "data-name": "Path 32345",
    d: "M878,206.18l.206.206Z",
    transform: "translate(-389.751 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32346",
    "data-name": "Path 32346",
    d: "M879,206.18l.206.206L879,206.18m1.994.068.138.068Z",
    transform: "translate(-390.545 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32347",
    "data-name": "Path 32347",
    d: "M890.67,206.51l.138.068Z",
    transform: "translate(-399.808 -163.923)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32348",
    "data-name": "Path 32348",
    d: "M895,206.18v.206l.619.206L895,206.18m1.237,0,.206.206Z",
    transform: "translate(-403.246 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32349",
    "data-name": "Path 32349",
    d: "M902.67,206.51l.138.068Z",
    transform: "translate(-409.334 -163.923)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32350",
    "data-name": "Path 32350",
    d: "M904,206.18l.206.206L904,206.18m4.056.068.138.068Z",
    transform: "translate(-410.39 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32351",
    "data-name": "Path 32351",
    d: "M925,206.18l.206.206Z",
    transform: "translate(-427.059 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32352",
    "data-name": "Path 32352",
    d: "M926,206.18l.206.206Z",
    transform: "translate(-427.853 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32353",
    "data-name": "Path 32353",
    d: "M932,206.18l.206.206Z",
    transform: "translate(-432.616 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32354",
    "data-name": "Path 32354",
    d: "M934.67,206.248l.138.068-.138-.068m1.305-.068.206.206Z",
    transform: "translate(-434.735 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32355",
    "data-name": "Path 32355",
    d: "M942.67,206.51l.138.068Z",
    transform: "translate(-441.086 -163.923)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32356",
    "data-name": "Path 32356",
    d: "M944,206.18l.206.206Z",
    transform: "translate(-442.141 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32357",
    "data-name": "Path 32357",
    d: "M963.67,206.51l.138.068Z",
    transform: "translate(-457.755 -163.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32358",
    "data-name": "Path 32358",
    d: "M965.33,206.85l.068.138Z",
    transform: "translate(-459.073 -164.193)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32359",
    "data-name": "Path 32359",
    d: "M966,206.18l.206.206Z",
    transform: "translate(-459.605 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32360",
    "data-name": "Path 32360",
    d: "M971,206.18l.206.206Z",
    transform: "translate(-463.574 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32361",
    "data-name": "Path 32361",
    d: "M972,206.18l.206.206Z",
    transform: "translate(-464.367 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32362",
    "data-name": "Path 32362",
    d: "M977,206.18l.206.206Z",
    transform: "translate(-468.336 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32363",
    "data-name": "Path 32363",
    d: "M980,206.18l.206.206Z",
    transform: "translate(-470.718 -163.661)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32364",
    "data-name": "Path 32364",
    d: "M981,206.18l.206.206Z",
    transform: "translate(-471.512 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32365",
    "data-name": "Path 32365",
    d: "M982,206.18l.206.206L982,206.18m1.65,0,.206.206Z",
    transform: "translate(-472.305 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32366",
    "data-name": "Path 32366",
    d: "M991,206.18l.206.206L991,206.18m7.011,0,.206.206Z",
    transform: "translate(-479.449 -163.661)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32367",
    "data-name": "Path 32367",
    d: "M1026,206.18l.206.206Z",
    transform: "translate(-507.232 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32368",
    "data-name": "Path 32368",
    d: "M1027.67,206.248l.136.068-.136-.068m2.955-.068.206.206Z",
    transform: "translate(-508.558 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32369",
    "data-name": "Path 32369",
    d: "M1043,206.18l.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-520.727 -163.661)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32370",
    "data-name": "Path 32370",
    d: "M905.149,206.18l.206.206-.206-.206m.893.138.07.138-.07-.138M867,206.386l.206.206Z",
    transform: "translate(-381.019 -163.661)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32371",
    "data-name": "Path 32371",
    d: "M871,207.18l.206.206L871,207.18m5.568,0,.206.206Z",
    transform: "translate(-384.195 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32372",
    "data-name": "Path 32372",
    d: "M899,207.18l.206.206Z",
    transform: "translate(-406.421 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32373",
    "data-name": "Path 32373",
    d: "M900,207.18l.206.206L900,207.18m1.65,0v.206h.619Z",
    transform: "translate(-407.215 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32374",
    "data-name": "Path 32374",
    d: "M911,207.18l.206.206L911,207.18m.619,0,.206.206Z",
    transform: "translate(-415.946 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32375",
    "data-name": "Path 32375",
    d: "M915,207.18l.206.206Z",
    transform: "translate(-419.121 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32376",
    "data-name": "Path 32376",
    d: "M916,207.18l.206.206L916,207.18m2.474,0,.206.206Z",
    transform: "translate(-419.915 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32377",
    "data-name": "Path 32377",
    d: "M929,207.18l.206.206Z",
    transform: "translate(-430.234 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32378",
    "data-name": "Path 32378",
    d: "M933,207.18l.206.206Z",
    transform: "translate(-433.41 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32379",
    "data-name": "Path 32379",
    d: "M935,207.18l.412.412v-.412Z",
    transform: "translate(-434.997 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32380",
    "data-name": "Path 32380",
    d: "M951,207.18l.206.206Z",
    transform: "translate(-447.698 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32381",
    "data-name": "Path 32381",
    d: "M952.67,207.248l.138.068-.138-.068m1.1-.068-.206.412Z",
    transform: "translate(-449.023 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32382",
    "data-name": "Path 32382",
    d: "M960,207.18l.412.412Z",
    transform: "translate(-454.842 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32383",
    "data-name": "Path 32383",
    d: "M961,207.18v.206l1.856.412Z",
    transform: "translate(-455.636 -164.455)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32384",
    "data-name": "Path 32384",
    d: "M964,207.18l.206.206Z",
    transform: "translate(-458.017 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32385",
    "data-name": "Path 32385",
    d: "M974,207.18l.206.206L974,207.18m.825,0,.206.206Z",
    transform: "translate(-465.955 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32386",
    "data-name": "Path 32386",
    d: "M984,207.18l.206.206L984,207.18m2.062,0v.206h.619l-.619-.206m.963.068.138.068Z",
    transform: "translate(-473.893 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32387",
    "data-name": "Path 32387",
    d: "M1000,207.18v.206h1.031Z",
    transform: "translate(-486.594 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32388",
    "data-name": "Path 32388",
    d: "M1005,207.18l.206.206Z",
    transform: "translate(-490.563 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32389",
    "data-name": "Path 32389",
    d: "M1017.67,207.51l.136.068Z",
    transform: "translate(-500.62 -164.717)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32390",
    "data-name": "Path 32390",
    d: "M1019.67,207.248l.136.068-.136-.068m3.161-.068.206.206-.206-.206m1.994.068.136.068Z",
    transform: "translate(-502.207 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32391",
    "data-name": "Path 32391",
    d: "M1055,207.18l.206.206Z",
    transform: "translate(-530.252 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32392",
    "data-name": "Path 32392",
    d: "M1060,207.18l.206.206Z",
    transform: "translate(-534.221 -164.455)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32393",
    "data-name": "Path 32393",
    d: "M1064,207.18l.206.206Z",
    transform: "translate(-537.396 -164.455)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32394",
    "data-name": "Path 32394",
    d: "M900.685,207.18l.206.206-.206-.206M858,207.386l.206.206Z",
    transform: "translate(-373.875 -164.455)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32395",
    "data-name": "Path 32395",
    d: "M860,208.18l.206.206Z",
    transform: "translate(-375.463 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32396",
    "data-name": "Path 32396",
    d: "M862,208.18l.206.206Z",
    transform: "translate(-377.05 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32397",
    "data-name": "Path 32397",
    d: "M863,208.18l.206.206Z",
    transform: "translate(-377.844 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32398",
    "data-name": "Path 32398",
    d: "M864,208.18l.206.206Z",
    transform: "translate(-378.638 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32399",
    "data-name": "Path 32399",
    d: "M873,208.18l.206.206Z",
    transform: "translate(-385.782 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32400",
    "data-name": "Path 32400",
    d: "M877,208.18l.206.206Z",
    transform: "translate(-388.957 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32401",
    "data-name": "Path 32401",
    d: "M878,208.18l.412.412Z",
    transform: "translate(-389.751 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32402",
    "data-name": "Path 32402",
    d: "M879,208.18l.206.206Z",
    transform: "translate(-390.545 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32403",
    "data-name": "Path 32403",
    d: "M880,208.18l.206.206L880,208.18m4.537,0,.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-391.339 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32404",
    "data-name": "Path 32404",
    d: "M905,208.18v.206h.619Z",
    transform: "translate(-411.183 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32405",
    "data-name": "Path 32405",
    d: "M918,208.18l.206.206Z",
    transform: "translate(-421.503 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32406",
    "data-name": "Path 32406",
    d: "M919,208.18l.206.206Z",
    transform: "translate(-422.297 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32407",
    "data-name": "Path 32407",
    d: "M920,208.18l.206.206L920,208.18m2.887,0,.206.206Z",
    transform: "translate(-423.09 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32408",
    "data-name": "Path 32408",
    d: "M937,208.18l.206.206Z",
    transform: "translate(-436.585 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32409",
    "data-name": "Path 32409",
    d: "M938.67,208.51l.138.068Z",
    transform: "translate(-437.91 -165.511)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32410",
    "data-name": "Path 32410",
    d: "M940,208.18l.206.206L940,208.18m3.3,0,.206.206Z",
    transform: "translate(-438.966 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32411",
    "data-name": "Path 32411",
    d: "M958,208.18l.206.206Z",
    transform: "translate(-453.254 -165.249)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32412",
    "data-name": "Path 32412",
    d: "M967,208.18l.206.206Z",
    transform: "translate(-460.398 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32413",
    "data-name": "Path 32413",
    d: "M976,208.18l.206.206Z",
    transform: "translate(-467.543 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32414",
    "data-name": "Path 32414",
    d: "M979,208.18l.206.206L979,208.18m1.65,0,.206.206Z",
    transform: "translate(-469.924 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32415",
    "data-name": "Path 32415",
    d: "M1031,208.18l.206.206Z",
    transform: "translate(-511.201 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32416",
    "data-name": "Path 32416",
    d: "M1032,208.18l.206.206-.206-.206m2.062,0,.206.206Z",
    transform: "translate(-511.995 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32417",
    "data-name": "Path 32417",
    d: "M1043,208.18l.206.206Z",
    transform: "translate(-520.727 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32418",
    "data-name": "Path 32418",
    d: "M1048.67,208.51l.136.068Z",
    transform: "translate(-525.227 -165.511)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32419",
    "data-name": "Path 32419",
    d: "M1050,208.18l.206.206Z",
    transform: "translate(-526.283 -165.249)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32420",
    "data-name": "Path 32420",
    d: "M1058.67,208.248l.136.068-.136-.068m1.718-.068.206.206Z",
    transform: "translate(-533.165 -165.249)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32421",
    "data-name": "Path 32421",
    d: "M908.448,208.18l.206.206-.206-.206M867,208.386l.206.206Z",
    transform: "translate(-381.019 -165.249)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32422",
    "data-name": "Path 32422",
    d: "M868,209.18l.206.206Z",
    transform: "translate(-381.813 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32423",
    "data-name": "Path 32423",
    d: "M875,209.18l.206.206L875,209.18m2.062,0v.206H878.3Z",
    transform: "translate(-387.37 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32424",
    "data-name": "Path 32424",
    d: "M891.67,209.51l.138.068Z",
    transform: "translate(-400.602 -166.305)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32425",
    "data-name": "Path 32425",
    d: "M923,209.18l.206.206Z",
    transform: "translate(-425.472 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32426",
    "data-name": "Path 32426",
    d: "M924,209.18l.206.206L924,209.18m1.443,0,.206.206-.206-.206m.825,0,.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-426.265 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32427",
    "data-name": "Path 32427",
    d: "M942,209.18l.206.206Z",
    transform: "translate(-440.554 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32428",
    "data-name": "Path 32428",
    d: "M945,209.18l.206.206Z",
    transform: "translate(-442.935 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32429",
    "data-name": "Path 32429",
    d: "M946,209.18l.206.206Z",
    transform: "translate(-443.729 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32430",
    "data-name": "Path 32430",
    d: "M962,209.18l.206.206Z",
    transform: "translate(-456.43 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32431",
    "data-name": "Path 32431",
    d: "M963,209.18l.206.206Z",
    transform: "translate(-457.223 -166.043)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32432",
    "data-name": "Path 32432",
    d: "M970,209.18l.206.206Z",
    transform: "translate(-462.78 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32433",
    "data-name": "Path 32433",
    d: "M971,209.18l.206.206L971,209.18m1.443,0,.206.206Z",
    transform: "translate(-463.574 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32434",
    "data-name": "Path 32434",
    d: "M979.67,209.51l.138.068Z",
    transform: "translate(-470.456 -166.305)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32435",
    "data-name": "Path 32435",
    d: "M982,209.18l.206.206Z",
    transform: "translate(-472.305 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32436",
    "data-name": "Path 32436",
    d: "M989,209.18l.206.206Z",
    transform: "translate(-477.862 -166.043)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32437",
    "data-name": "Path 32437",
    d: "M990,209.18l.206.206L990,209.18m2.681,0,.206.206Z",
    transform: "translate(-478.656 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32438",
    "data-name": "Path 32438",
    d: "M1004,209.18l.206.206Z",
    transform: "translate(-489.769 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32439",
    "data-name": "Path 32439",
    d: "M1005,209.18l.206.206Z",
    transform: "translate(-490.563 -166.043)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32440",
    "data-name": "Path 32440",
    d: "M1006,209.18l.206.206Z",
    transform: "translate(-491.356 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32441",
    "data-name": "Path 32441",
    d: "M1013,209.18v.206h1.031Z",
    transform: "translate(-496.913 -166.043)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32442",
    "data-name": "Path 32442",
    d: "M1028,209.18l.206.206Z",
    transform: "translate(-508.82 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32443",
    "data-name": "Path 32443",
    d: "M1029,209.18l.206.206-.206-.206m3.3,0,.206.206Z",
    transform: "translate(-509.613 -166.043)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32444",
    "data-name": "Path 32444",
    d: "M1046,209.18l.206.206Z",
    transform: "translate(-523.108 -166.043)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32445",
    "data-name": "Path 32445",
    d: "M1047,209.18l.206.206Z",
    transform: "translate(-523.902 -166.043)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32446",
    "data-name": "Path 32446",
    d: "M870,210.18l.206.206Z",
    transform: "translate(-383.401 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32447",
    "data-name": "Path 32447",
    d: "M871,210.18l.206.206L871,210.18m1.237,0,.206.206Z",
    transform: "translate(-384.195 -166.836)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32448",
    "data-name": "Path 32448",
    d: "M881,210.18l.206.206Z",
    transform: "translate(-392.132 -166.836)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32449",
    "data-name": "Path 32449",
    d: "M899,210.18v.206h1.443Z",
    transform: "translate(-406.421 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32450",
    "data-name": "Path 32450",
    d: "M927,210.18l.206.206Z",
    transform: "translate(-428.647 -166.836)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32451",
    "data-name": "Path 32451",
    d: "M928,210.18l.206.206L928,210.18m.893.138.068.138Z",
    transform: "translate(-429.441 -166.836)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32452",
    "data-name": "Path 32452",
    d: "M933,210.18l.206.206Z",
    transform: "translate(-433.41 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32453",
    "data-name": "Path 32453",
    d: "M936,210.18l.412.619L936,210.18m.412,0,.206.206-.206-.206m6.118.068.138.068Z",
    transform: "translate(-435.791 -166.836)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32454",
    "data-name": "Path 32454",
    d: "M969,210.18l.206.206Z",
    transform: "translate(-461.986 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32455",
    "data-name": "Path 32455",
    d: "M973,210.18l.206.206Z",
    transform: "translate(-465.161 -166.836)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32456",
    "data-name": "Path 32456",
    d: "M974,210.18v.206h.619Z",
    transform: "translate(-465.955 -166.836)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32457",
    "data-name": "Path 32457",
    d: "M993,210.18l.206.206Z",
    transform: "translate(-481.037 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32458",
    "data-name": "Path 32458",
    d: "M994,210.18l.206.206L994,210.18m6.186,0,.206.206Z",
    transform: "translate(-481.831 -166.836)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32459",
    "data-name": "Path 32459",
    d: "M1025,210.18l.206.206Z",
    transform: "translate(-506.438 -166.836)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32460",
    "data-name": "Path 32460",
    d: "M873,211.18l.206.206Z",
    transform: "translate(-385.782 -167.63)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32461",
    "data-name": "Path 32461",
    d: "M874,211.18l.206.206Z",
    transform: "translate(-386.576 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32462",
    "data-name": "Path 32462",
    d: "M875,211.18l.206.206Z",
    transform: "translate(-387.37 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32463",
    "data-name": "Path 32463",
    d: "M882,211.18l.206.206Z",
    transform: "translate(-392.926 -167.63)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32464",
    "data-name": "Path 32464",
    d: "M931,211.18l.206.206Z",
    transform: "translate(-431.822 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32465",
    "data-name": "Path 32465",
    d: "M933,211.18v.206h.619Z",
    transform: "translate(-433.41 -167.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32466",
    "data-name": "Path 32466",
    d: "M948,211.18l.206.206Z",
    transform: "translate(-445.316 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32467",
    "data-name": "Path 32467",
    d: "M949,211.18l.206.206L949,211.18m.893.138.068.138Z",
    transform: "translate(-446.11 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32468",
    "data-name": "Path 32468",
    d: "M954,211.18v.206h.619Z",
    transform: "translate(-450.079 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32469",
    "data-name": "Path 32469",
    d: "M957,211.18v.206l1.031.412v-.206Z",
    transform: "translate(-452.461 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32470",
    "data-name": "Path 32470",
    d: "M970,211.18l.206.206L970,211.18m1.65,0,.206.206Z",
    transform: "translate(-462.78 -167.63)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32471",
    "data-name": "Path 32471",
    d: "M979,211.18l.206.206Z",
    transform: "translate(-469.924 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32472",
    "data-name": "Path 32472",
    d: "M980,211.18l.206.206L980,211.18m.412,0,.206.206Z",
    transform: "translate(-470.718 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32473",
    "data-name": "Path 32473",
    d: "M996,211.18l.206.206Z",
    transform: "translate(-483.418 -167.63)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32474",
    "data-name": "Path 32474",
    d: "M997.67,211.248l.138.068-.138-.068m2.13-.068v.206h.825Z",
    transform: "translate(-484.744 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32475",
    "data-name": "Path 32475",
    d: "M1012,211.18v.206h.619Z",
    transform: "translate(-496.119 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32476",
    "data-name": "Path 32476",
    d: "M1020,211.18l.206.206Z",
    transform: "translate(-502.469 -167.63)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32477",
    "data-name": "Path 32477",
    d: "M907.488,211.18l.206.206-.206-.206M878,211.386l.206.206Z",
    transform: "translate(-389.751 -167.63)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32478",
    "data-name": "Path 32478",
    d: "M879,212.18l.206.206Z",
    transform: "translate(-390.545 -168.424)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32479",
    "data-name": "Path 32479",
    d: "M882,212.18l.206.206Z",
    transform: "translate(-392.926 -168.424)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32480",
    "data-name": "Path 32480",
    d: "M934,212.18l.206.206Z",
    transform: "translate(-434.203 -168.424)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32481",
    "data-name": "Path 32481",
    d: "M935,212.18l.206.206L935,212.18m.619,0,.206.206Z",
    transform: "translate(-434.997 -168.424)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32482",
    "data-name": "Path 32482",
    d: "M951,212.18l.206.206Z",
    transform: "translate(-447.698 -168.424)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32483",
    "data-name": "Path 32483",
    d: "M952,212.18l.206.206Z",
    transform: "translate(-448.492 -168.424)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32484",
    "data-name": "Path 32484",
    d: "M954,212.18v.206h.825Z",
    transform: "translate(-450.079 -168.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32485",
    "data-name": "Path 32485",
    d: "M960.67,212.51l.138.068Z",
    transform: "translate(-455.374 -168.686)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32486",
    "data-name": "Path 32486",
    d: "M962.67,212.51l.138.068Z",
    transform: "translate(-456.961 -168.686)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32487",
    "data-name": "Path 32487",
    d: "M964,212.18l.206.206Z",
    transform: "translate(-458.017 -168.424)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32488",
    "data-name": "Path 32488",
    d: "M968.33,212.85l.068.138Z",
    transform: "translate(-461.454 -168.956)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32489",
    "data-name": "Path 32489",
    d: "M969,212.18l.206.206Z",
    transform: "translate(-461.986 -168.424)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32490",
    "data-name": "Path 32490",
    d: "M1001,212.18l.206.206Z",
    transform: "translate(-487.387 -168.424)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32491",
    "data-name": "Path 32491",
    d: "M1002,212.18l.206.206Z",
    transform: "translate(-488.181 -168.424)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32492",
    "data-name": "Path 32492",
    d: "M1003,212.18l.206.206Z",
    transform: "translate(-488.975 -168.424)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32493",
    "data-name": "Path 32493",
    d: "M958.67,213.51l.138.068Z",
    transform: "translate(-453.786 -169.48)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32494",
    "data-name": "Path 32494",
    d: "M965,214.18l.206.206Z",
    transform: "translate(-458.811 -170.012)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32495",
    "data-name": "Path 32495",
    d: "M966.67,214.51l.138.068Z",
    transform: "translate(-460.136 -170.274)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32496",
    "data-name": "Path 32496",
    d: "M998,220.18l.206.206Z",
    transform: "translate(-485.006 -174.774)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32497",
    "data-name": "Path 32497",
    d: "M996.619,220.18l.825.619V221L996,220.8V221l4.949,1.443-1.031-.619v-.206l1.65.206v-.206Z",
    transform: "translate(-483.418 -174.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32498",
    "data-name": "Path 32498",
    d: "M1000,220.18l.206.206Z",
    transform: "translate(-486.594 -174.774)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32499",
    "data-name": "Path 32499",
    d: "M926,221.18l.412.619Z",
    transform: "translate(-427.853 -175.568)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32500",
    "data-name": "Path 32500",
    d: "M927,221.18v.206h.619Z",
    transform: "translate(-428.647 -175.568)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32501",
    "data-name": "Path 32501",
    d: "M930,221.18l.206.206Z",
    transform: "translate(-431.028 -175.568)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32502",
    "data-name": "Path 32502",
    d: "M998,221.18l.206.206Z",
    transform: "translate(-485.006 -175.568)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32503",
    "data-name": "Path 32503",
    d: "M1002,221.18l.206.206Z",
    transform: "translate(-488.181 -175.568)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32504",
    "data-name": "Path 32504",
    d: "M879,222.18l.206.206Z",
    transform: "translate(-390.545 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32505",
    "data-name": "Path 32505",
    d: "M880,222.18l1.237,1.237,7.424.206v-.206Z",
    transform: "translate(-391.339 -176.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32506",
    "data-name": "Path 32506",
    d: "M882.67,222.51l.138.068Z",
    transform: "translate(-393.458 -176.624)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32507",
    "data-name": "Path 32507",
    d: "M884,222.18l.206.206L884,222.18m5.568,0,.206.206Z",
    transform: "translate(-394.514 -176.362)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32508",
    "data-name": "Path 32508",
    d: "M912,222.18l.206.206Z",
    transform: "translate(-416.74 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32509",
    "data-name": "Path 32509",
    d: "M912,222.386l4.33,1.65L914.474,223V222.8l6.6,1.031v-.206h-.825v-.206l1.856.206v.206h-.825v.206c.672-.025,1.945.169,2.062-.619l1.856.619v-.206l-.825-.412v-.206l5.568.619-2.062-1.237,1.237-.206v-.206c-.72.023-1.252.019-1.237.825l-4.949-.825.206.825-1.856-.825.412.825c-.631-.2-1.538-.662-1.65.206l-4.949-1.031v.206l1.237.412Z",
    transform: "translate(-416.74 -176.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32510",
    "data-name": "Path 32510",
    d: "M915,222.18l.206.206Z",
    transform: "translate(-419.121 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32511",
    "data-name": "Path 32511",
    d: "M916,222.18l.206.206Z",
    transform: "translate(-419.915 -176.362)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32512",
    "data-name": "Path 32512",
    d: "M932,222.18l.206.206Z",
    transform: "translate(-432.616 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32513",
    "data-name": "Path 32513",
    d: "M955.206,222.18,955,222.8Z",
    transform: "translate(-450.873 -176.362)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32514",
    "data-name": "Path 32514",
    d: "M960,222.18l.206.206Z",
    transform: "translate(-454.842 -176.362)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32515",
    "data-name": "Path 32515",
    d: "M964,222.18v.619h.206Z",
    transform: "translate(-458.017 -176.362)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32516",
    "data-name": "Path 32516",
    d: "M970,222.18l.206.206Z",
    transform: "translate(-462.78 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32517",
    "data-name": "Path 32517",
    d: "M988,222.18l.206.206Z",
    transform: "translate(-477.068 -176.362)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32518",
    "data-name": "Path 32518",
    d: "M995,222.18v.412l.412-.412Z",
    transform: "translate(-482.625 -176.362)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32519",
    "data-name": "Path 32519",
    d: "M997,222.18l.206.206Z",
    transform: "translate(-484.212 -176.362)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32520",
    "data-name": "Path 32520",
    d: "M998.67,222.51l.138.068Z",
    transform: "translate(-485.538 -176.624)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32521",
    "data-name": "Path 32521",
    d: "M1000.33,222.85l.07.138Z",
    transform: "translate(-486.855 -176.894)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32522",
    "data-name": "Path 32522",
    d: "M1004,222.18l.206.206Z",
    transform: "translate(-489.769 -176.362)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32523",
    "data-name": "Path 32523",
    d: "M861,223.18l.206.206Z",
    transform: "translate(-376.257 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32524",
    "data-name": "Path 32524",
    d: "M862,223.18l.206.206Z",
    transform: "translate(-377.05 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32525",
    "data-name": "Path 32525",
    d: "M867,223.18l.206.206Z",
    transform: "translate(-381.019 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32526",
    "data-name": "Path 32526",
    d: "M867,223.592l.619-.206-.619.206m1.237-.412v.619h.206Z",
    transform: "translate(-381.019 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32527",
    "data-name": "Path 32527",
    d: "M861.3,223.18v.206l1.65.825v.206c-.769-.3-2.225-1.3-2.887-.619-.86-.318-1.547-.478-2.062.412l4.537,1.237-1.031-1.237,1.856.619.206-.825Z",
    transform: "translate(-373.875 -177.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32528",
    "data-name": "Path 32528",
    d: "M877,223.18l.206.206L877,223.18m.412,0,.206.206Z",
    transform: "translate(-388.957 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32529",
    "data-name": "Path 32529",
    d: "M886,223.18l.206.206Z",
    transform: "translate(-396.101 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32530",
    "data-name": "Path 32530",
    d: "M887,223.18l.206.206Z",
    transform: "translate(-396.895 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32531",
    "data-name": "Path 32531",
    d: "M888,223.18l.206.206Z",
    transform: "translate(-397.689 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32532",
    "data-name": "Path 32532",
    d: "M911,223.18l.206.206Z",
    transform: "translate(-415.946 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32533",
    "data-name": "Path 32533",
    d: "M918,223.18l.206.206Z",
    transform: "translate(-421.503 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32534",
    "data-name": "Path 32534",
    d: "M919.67,223.51l.138.068Z",
    transform: "translate(-422.828 -177.418)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32535",
    "data-name": "Path 32535",
    d: "M921,223.18l.206.206Z",
    transform: "translate(-423.884 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32536",
    "data-name": "Path 32536",
    d: "M926,223.18l.206.206Z",
    transform: "translate(-427.853 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32537",
    "data-name": "Path 32537",
    d: "M928.33,223.318l.068.138-.068-.138m1.169-.138.206.206Z",
    transform: "translate(-429.703 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32538",
    "data-name": "Path 32538",
    d: "M935,223.18l.206.206Z",
    transform: "translate(-434.997 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32539",
    "data-name": "Path 32539",
    d: "M962,223.18l.206.206Z",
    transform: "translate(-456.43 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32540",
    "data-name": "Path 32540",
    d: "M972,223.18l.206.206Z",
    transform: "translate(-464.367 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32541",
    "data-name": "Path 32541",
    d: "M973,223.18l.206.206Z",
    transform: "translate(-465.161 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32542",
    "data-name": "Path 32542",
    d: "M990,223.18l.206.206Z",
    transform: "translate(-478.656 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32543",
    "data-name": "Path 32543",
    d: "M990,223.989l2.062.619A2.084,2.084,0,0,0,990,223.989Z",
    transform: "translate(-478.656 -177.759)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32544",
    "data-name": "Path 32544",
    d: "M993,223.18l.206.206Z",
    transform: "translate(-481.037 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32545",
    "data-name": "Path 32545",
    d: "M994,223.18l.206.206L994,223.18m1.443,0,.206.206Z",
    transform: "translate(-481.831 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32546",
    "data-name": "Path 32546",
    d: "M1002,223.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-488.181 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32547",
    "data-name": "Path 32547",
    d: "M1007,223.18l.206.206Z",
    transform: "translate(-492.15 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32548",
    "data-name": "Path 32548",
    d: "M1018,223.18l.206.206Z",
    transform: "translate(-500.882 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32549",
    "data-name": "Path 32549",
    d: "M1019,223.18c1.076,1.483,4.116,1.023,5.774,1.237l4.537-.206V223.8l-3.712-.412v.206h.412v.206l-4.124-.412V224Z",
    transform: "translate(-501.676 -177.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32550",
    "data-name": "Path 32550",
    d: "M1022,223.18l.206.206Z",
    transform: "translate(-504.057 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32551",
    "data-name": "Path 32551",
    d: "M1039,223.18l.206.206Z",
    transform: "translate(-517.551 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32552",
    "data-name": "Path 32552",
    d: "M1040,223.18l.206.206Z",
    transform: "translate(-518.345 -177.156)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32553",
    "data-name": "Path 32553",
    d: "M1041,223.18l.206.206Z",
    transform: "translate(-519.139 -177.156)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32554",
    "data-name": "Path 32554",
    d: "M1042,223.18l.206.206Z",
    transform: "translate(-519.933 -177.156)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32555",
    "data-name": "Path 32555",
    d: "M864,224.18l.206.206L864,224.18m1.443,0,.206.206Z",
    transform: "translate(-378.638 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32556",
    "data-name": "Path 32556",
    d: "M879,224.18l.206.206Z",
    transform: "translate(-390.545 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32557",
    "data-name": "Path 32557",
    d: "M880.67,224.51l.138.068Z",
    transform: "translate(-391.871 -178.211)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32558",
    "data-name": "Path 32558",
    d: "M882,224.18l.206.206Z",
    transform: "translate(-392.926 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32559",
    "data-name": "Path 32559",
    d: "M882.206,224.18l-.206.412.206-.412m1.65,0,.206.206Z",
    transform: "translate(-392.926 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32560",
    "data-name": "Path 32560",
    d: "M892,224.18l.206.206Z",
    transform: "translate(-400.864 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32561",
    "data-name": "Path 32561",
    d: "M893,224.18l.206.206L893,224.18m3.918,0,.206.206Z",
    transform: "translate(-401.658 -177.95)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32562",
    "data-name": "Path 32562",
    d: "M913,224.18l.206.206Z",
    transform: "translate(-417.534 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32563",
    "data-name": "Path 32563",
    d: "M929,224.18l.206.206Z",
    transform: "translate(-430.234 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32564",
    "data-name": "Path 32564",
    d: "M930,224.18l.206.206Z",
    transform: "translate(-431.028 -177.95)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32565",
    "data-name": "Path 32565",
    d: "M931,224.18l.206.206L931,224.18m1.237,0,.206.206Z",
    transform: "translate(-431.822 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32566",
    "data-name": "Path 32566",
    d: "M950,224.18l.206.206L950,224.18m.825,0,.206.206Z",
    transform: "translate(-446.904 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32567",
    "data-name": "Path 32567",
    d: "M956,224.18l.206.206Z",
    transform: "translate(-451.667 -177.95)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32568",
    "data-name": "Path 32568",
    d: "M957,224.18l.412.412Z",
    transform: "translate(-452.461 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32569",
    "data-name": "Path 32569",
    d: "M960,224.18l.206.206Z",
    transform: "translate(-454.842 -177.95)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32570",
    "data-name": "Path 32570",
    d: "M961.33,224.318l.068.138-.068-.138m.825,0,.068.138-.068-.138m1.994-.138.206.206Z",
    transform: "translate(-455.898 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32571",
    "data-name": "Path 32571",
    d: "M976,224.18l.206.206Z",
    transform: "translate(-467.543 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32572",
    "data-name": "Path 32572",
    d: "M989,224.18l.206.206Z",
    transform: "translate(-477.862 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32573",
    "data-name": "Path 32573",
    d: "M998.33,224.85l.068.138Z",
    transform: "translate(-485.268 -178.481)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M1011,224.18l.206.206Z",
    transform: "translate(-495.325 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32575",
    "data-name": "Path 32575",
    d: "M1012,224.18l.206.206Z",
    transform: "translate(-496.119 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32576",
    "data-name": "Path 32576",
    d: "M1013,224.18l.206.206-.206-.206m1.031,0-.206.412Z",
    transform: "translate(-496.913 -177.95)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32577",
    "data-name": "Path 32577",
    d: "M1027,224.18l.206.206Z",
    transform: "translate(-508.026 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32578",
    "data-name": "Path 32578",
    d: "M1037.67,224.248l.136.068-.136-.068m1.511-.068.206.206Z",
    transform: "translate(-516.496 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32579",
    "data-name": "Path 32579",
    d: "M1046,224.18l.206.206Z",
    transform: "translate(-523.108 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32580",
    "data-name": "Path 32580",
    d: "M1047,224.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-523.902 -177.95)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32581",
    "data-name": "Path 32581",
    d: "M1055,224.18l.206.206Z",
    transform: "translate(-530.252 -177.95)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32582",
    "data-name": "Path 32582",
    d: "M1056,224.18l.206.206-.206-.206m.551.068.136.068Z",
    transform: "translate(-531.046 -177.95)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32583",
    "data-name": "Path 32583",
    d: "M1060,224.18l.206.206Z",
    transform: "translate(-534.221 -177.95)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32584",
    "data-name": "Path 32584",
    d: "M866,225.18l.206.206Z",
    transform: "translate(-380.226 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32585",
    "data-name": "Path 32585",
    d: "M867,225.18l.206.206L867,225.18m1.582.068.138.068Z",
    transform: "translate(-381.019 -178.743)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32586",
    "data-name": "Path 32586",
    d: "M875.206,225.18l-.206.412Z",
    transform: "translate(-387.37 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32587",
    "data-name": "Path 32587",
    d: "M883.67,225.51l.138.068Z",
    transform: "translate(-394.252 -179.005)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32588",
    "data-name": "Path 32588",
    d: "M885,225.18v.619h.206L885,225.18m2.681,0v.206h.619Z",
    transform: "translate(-395.308 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32589",
    "data-name": "Path 32589",
    d: "M901.67,225.248l.138.068-.138-.068m.687-.068.206.206Z",
    transform: "translate(-408.54 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32590",
    "data-name": "Path 32590",
    d: "M906,225.18v.206h.619Z",
    transform: "translate(-411.977 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32591",
    "data-name": "Path 32591",
    d: "M909,225.18l.206.206Z",
    transform: "translate(-414.359 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32592",
    "data-name": "Path 32592",
    d: "M910,225.18l.206.206Z",
    transform: "translate(-415.152 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32593",
    "data-name": "Path 32593",
    d: "M915,225.592l.619-.412Z",
    transform: "translate(-419.121 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32594",
    "data-name": "Path 32594",
    d: "M918,225.18l.206.206L918,225.18m1.237,0,.206.206Z",
    transform: "translate(-421.503 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32595",
    "data-name": "Path 32595",
    d: "M925,225.18l.206.206Z",
    transform: "translate(-427.059 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32596",
    "data-name": "Path 32596",
    d: "M926,225.18l.206.206Z",
    transform: "translate(-427.853 -178.743)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32597",
    "data-name": "Path 32597",
    d: "M927,225.18l.206.206Z",
    transform: "translate(-428.647 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32598",
    "data-name": "Path 32598",
    d: "M931.67,225.248l.138.068-.138-.068m1.512-.068.206.206-.206-.206m2.681,0v.206l.619.206-.619-.412m1.031,0,.206.206Z",
    transform: "translate(-432.354 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32599",
    "data-name": "Path 32599",
    d: "M962,225.18l.206.206Z",
    transform: "translate(-456.43 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32600",
    "data-name": "Path 32600",
    d: "M963.33,225.318l.068.138-.068-.138m.963-.138.206.206Z",
    transform: "translate(-457.485 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32601",
    "data-name": "Path 32601",
    d: "M969,225.18l.206.206Z",
    transform: "translate(-461.986 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32602",
    "data-name": "Path 32602",
    d: "M970.33,225.318l.068.138-.068-.138m1.994-.138v.206h.619Z",
    transform: "translate(-463.042 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32603",
    "data-name": "Path 32603",
    d: "M983.67,225.51l.138.068Z",
    transform: "translate(-473.631 -179.005)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32604",
    "data-name": "Path 32604",
    d: "M985,225.18l.206.206Z",
    transform: "translate(-474.687 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32605",
    "data-name": "Path 32605",
    d: "M988,225.18l.206.206L988,225.18m.619,0,.206.206-.206-.206m4.949,0,.206.206Z",
    transform: "translate(-477.068 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32606",
    "data-name": "Path 32606",
    d: "M1016,225.18l.206.206Z",
    transform: "translate(-499.294 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32607",
    "data-name": "Path 32607",
    d: "M1018.67,225.51l.136.068Z",
    transform: "translate(-501.414 -179.005)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32608",
    "data-name": "Path 32608",
    d: "M1020,225.18l.206.206Z",
    transform: "translate(-502.469 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32609",
    "data-name": "Path 32609",
    d: "M1021,225.18l.206.206-.206-.206m2.268,0v.412l.412-.412h-.412m3.712,0v.206h.619l-.619-.206m2.819.068.136.068Z",
    transform: "translate(-503.263 -178.743)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32610",
    "data-name": "Path 32610",
    d: "M1065,225.18l.206.206Z",
    transform: "translate(-538.19 -178.743)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32611",
    "data-name": "Path 32611",
    d: "M915.18,225.18l.206.206-.206-.206m-39.18.206.206.206Z",
    transform: "translate(-388.164 -178.743)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32612",
    "data-name": "Path 32612",
    d: "M877,226.18l.206.206Z",
    transform: "translate(-388.957 -179.537)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32613",
    "data-name": "Path 32613",
    d: "M878,226.18l.206.206L878,226.18m7.355.068.138.068Z",
    transform: "translate(-389.751 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32614",
    "data-name": "Path 32614",
    d: "M917,226.18v.206h.619Z",
    transform: "translate(-420.709 -179.537)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32615",
    "data-name": "Path 32615",
    d: "M920,226.18l.206.206Z",
    transform: "translate(-423.09 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32616",
    "data-name": "Path 32616",
    d: "M927,226.18l.206.206Z",
    transform: "translate(-428.647 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32617",
    "data-name": "Path 32617",
    d: "M928,226.18v.206l1.031.206v-.206Z",
    transform: "translate(-429.441 -179.537)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32618",
    "data-name": "Path 32618",
    d: "M930,226.18l.206.206Z",
    transform: "translate(-431.028 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32619",
    "data-name": "Path 32619",
    d: "M943,226.18v.206h.619Z",
    transform: "translate(-441.347 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32620",
    "data-name": "Path 32620",
    d: "M946,226.18v.206h.825Z",
    transform: "translate(-443.729 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32621",
    "data-name": "Path 32621",
    d: "M950,226.18l.206.206Z",
    transform: "translate(-446.904 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32622",
    "data-name": "Path 32622",
    d: "M955,226.18l.206.206Z",
    transform: "translate(-450.873 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32623",
    "data-name": "Path 32623",
    d: "M959.67,226.51l.138.068Z",
    transform: "translate(-454.58 -179.799)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32624",
    "data-name": "Path 32624",
    d: "M964,226.18l.206.206Z",
    transform: "translate(-458.017 -179.537)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32625",
    "data-name": "Path 32625",
    d: "M993,226.18l.206.206Z",
    transform: "translate(-481.037 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32626",
    "data-name": "Path 32626",
    d: "M994,226.18l.206.206Z",
    transform: "translate(-481.831 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32627",
    "data-name": "Path 32627",
    d: "M1000,226.18l.206.206Z",
    transform: "translate(-486.594 -179.537)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32628",
    "data-name": "Path 32628",
    d: "M1001,226.18l.206.206-.206-.206m2.613.068.136.068-.136-.068m1.1-.068.206.206Z",
    transform: "translate(-487.387 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32629",
    "data-name": "Path 32629",
    d: "M1020,226.18l.206.206Z",
    transform: "translate(-502.469 -179.537)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32630",
    "data-name": "Path 32630",
    d: "M1021,226.18l.206.206Z",
    transform: "translate(-503.263 -179.537)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32631",
    "data-name": "Path 32631",
    d: "M1022,226.18l.206.206Z",
    transform: "translate(-504.057 -179.537)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32632",
    "data-name": "Path 32632",
    d: "M1023,226.18l.619.619-.619-.619m4.124,0v.206h.619Z",
    transform: "translate(-504.851 -179.537)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32633",
    "data-name": "Path 32633",
    d: "M878,227.18l.206.206Z",
    transform: "translate(-389.751 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32634",
    "data-name": "Path 32634",
    d: "M879,227.18l.206.206Z",
    transform: "translate(-390.545 -180.331)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32635",
    "data-name": "Path 32635",
    d: "M880,227.18l.206.206Z",
    transform: "translate(-391.339 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32636",
    "data-name": "Path 32636",
    d: "M883,227.18l.206.206Z",
    transform: "translate(-393.72 -180.331)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32637",
    "data-name": "Path 32637",
    d: "M884,227.18l.206.206Z",
    transform: "translate(-394.514 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32638",
    "data-name": "Path 32638",
    d: "M920,227.18v.206l1.443.206v-.206Z",
    transform: "translate(-423.09 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32639",
    "data-name": "Path 32639",
    d: "M929,227.18l.206.206L929,227.18m.825,0,.206.206Z",
    transform: "translate(-430.234 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32640",
    "data-name": "Path 32640",
    d: "M934,227.18l.206.206L934,227.18m5.774,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-434.203 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32641",
    "data-name": "Path 32641",
    d: "M966,227.18l.206.206Z",
    transform: "translate(-459.605 -180.331)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32642",
    "data-name": "Path 32642",
    d: "M972,227.18v.206h1.237Z",
    transform: "translate(-464.367 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32643",
    "data-name": "Path 32643",
    d: "M978,227.18v.206h.619L978,227.18m4.124,0,.206.619h.206Z",
    transform: "translate(-469.13 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32644",
    "data-name": "Path 32644",
    d: "M999,227.18l.206.206Z",
    transform: "translate(-485.8 -180.331)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32645",
    "data-name": "Path 32645",
    d: "M1005,227.18l.206.206Z",
    transform: "translate(-490.563 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32646",
    "data-name": "Path 32646",
    d: "M1006,227.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-491.356 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32647",
    "data-name": "Path 32647",
    d: "M1016,227.18v.206l.619.206Z",
    transform: "translate(-499.294 -180.331)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32648",
    "data-name": "Path 32648",
    d: "M1018,227.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-500.882 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32649",
    "data-name": "Path 32649",
    d: "M1033,227.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-512.789 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32650",
    "data-name": "Path 32650",
    d: "M1037.67,227.248l.136.068-.136-.068m1.718-.068.412.412Z",
    transform: "translate(-516.496 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32651",
    "data-name": "Path 32651",
    d: "M1047.67,227.51l.136.068Z",
    transform: "translate(-524.434 -180.593)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32652",
    "data-name": "Path 32652",
    d: "M1049,227.18l.206.206Z",
    transform: "translate(-525.489 -180.331)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32653",
    "data-name": "Path 32653",
    d: "M897.592,227.18l.206.206-.206-.206M858,227.386l.206.206Z",
    transform: "translate(-373.875 -180.331)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32654",
    "data-name": "Path 32654",
    d: "M859,228.18v.206h.825L859,228.18m1.856,0,.206.206Z",
    transform: "translate(-374.669 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32655",
    "data-name": "Path 32655",
    d: "M875.67,228.51l.138.068Z",
    transform: "translate(-387.901 -181.387)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32656",
    "data-name": "Path 32656",
    d: "M880.67,228.248l.138.068-.138-.068m2.749-.068v.206h1.031Z",
    transform: "translate(-391.871 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32657",
    "data-name": "Path 32657",
    d: "M915,228.18l.206.206L915,228.18m3.3,0,.206.206Z",
    transform: "translate(-419.121 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32658",
    "data-name": "Path 32658",
    d: "M932,228.18l.206.206Z",
    transform: "translate(-432.616 -181.125)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32659",
    "data-name": "Path 32659",
    d: "M952,228.18l.206.206Z",
    transform: "translate(-448.492 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32660",
    "data-name": "Path 32660",
    d: "M953,228.18v.206h.619Z",
    transform: "translate(-449.285 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32661",
    "data-name": "Path 32661",
    d: "M956,228.18v.619h.206L956,228.18m1.65,0,.206.206Z",
    transform: "translate(-451.667 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32662",
    "data-name": "Path 32662",
    d: "M967,228.18l.206.206Z",
    transform: "translate(-460.398 -181.125)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32663",
    "data-name": "Path 32663",
    d: "M968,228.18l.206.206Z",
    transform: "translate(-461.192 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32664",
    "data-name": "Path 32664",
    d: "M982,228.18v.206h.619Z",
    transform: "translate(-472.305 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32665",
    "data-name": "Path 32665",
    d: "M1008,228.18l.206.206Z",
    transform: "translate(-492.944 -181.125)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32666",
    "data-name": "Path 32666",
    d: "M1009,228.18l.206.206Z",
    transform: "translate(-493.738 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32667",
    "data-name": "Path 32667",
    d: "M1021,228.18l.206.206Z",
    transform: "translate(-503.263 -181.125)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32668",
    "data-name": "Path 32668",
    d: "M1022,228.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-504.057 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32669",
    "data-name": "Path 32669",
    d: "M1032.67,228.248l.136.068-.136-.068m1.718-.068.206.206Z",
    transform: "translate(-512.527 -181.125)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32670",
    "data-name": "Path 32670",
    d: "M1042,228.18l.206.206Z",
    transform: "translate(-519.933 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32671",
    "data-name": "Path 32671",
    d: "M1043,228.18l.206.206Z",
    transform: "translate(-520.727 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32672",
    "data-name": "Path 32672",
    d: "M1056,228.18l.206.206Z",
    transform: "translate(-531.046 -181.125)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32673",
    "data-name": "Path 32673",
    d: "M1061,228.18l.206.206Z",
    transform: "translate(-535.015 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32674",
    "data-name": "Path 32674",
    d: "M1062.67,228.51l.136.068Z",
    transform: "translate(-536.34 -181.387)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32675",
    "data-name": "Path 32675",
    d: "M910,228.18v.206h1.031L910,228.18m-40,.206.206.206Z",
    transform: "translate(-383.401 -181.125)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32676",
    "data-name": "Path 32676",
    d: "M875,229.18l.206.206Z",
    transform: "translate(-387.37 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32677",
    "data-name": "Path 32677",
    d: "M876.67,229.51l.138.068Z",
    transform: "translate(-388.695 -182.18)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32678",
    "data-name": "Path 32678",
    d: "M878,229.18l.206.206Z",
    transform: "translate(-389.751 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32679",
    "data-name": "Path 32679",
    d: "M884.33,229.318l.068.138-.068-.138m3.438-.138.206.206Z",
    transform: "translate(-394.776 -181.919)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32680",
    "data-name": "Path 32680",
    d: "M902.67,229.51l.138.068Z",
    transform: "translate(-409.334 -182.18)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32681",
    "data-name": "Path 32681",
    d: "M904.67,229.248l.138.068-.138-.068m2.955-.068.206.206Z",
    transform: "translate(-410.921 -181.918)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32682",
    "data-name": "Path 32682",
    d: "M920,229.18l.206.206Z",
    transform: "translate(-423.09 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32683",
    "data-name": "Path 32683",
    d: "M928,229.18l.206.206L928,229.18m1.856,0,.206.206Z",
    transform: "translate(-429.441 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32684",
    "data-name": "Path 32684",
    d: "M938,229.18l.206.206Z",
    transform: "translate(-437.379 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32685",
    "data-name": "Path 32685",
    d: "M944,229.18l.206.206L944,229.18m1.169.068.138.068Z",
    transform: "translate(-442.141 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32686",
    "data-name": "Path 32686",
    d: "M951,229.18l.206.206Z",
    transform: "translate(-447.698 -181.918)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32687",
    "data-name": "Path 32687",
    d: "M957,229.18l.206.206Z",
    transform: "translate(-452.461 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32688",
    "data-name": "Path 32688",
    d: "M958,229.18l.206.206Z",
    transform: "translate(-453.254 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32689",
    "data-name": "Path 32689",
    d: "M959,229.18l.206.206Z",
    transform: "translate(-454.048 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32690",
    "data-name": "Path 32690",
    d: "M960,229.18l.206.206L960,229.18m2.062,0,.206.206Z",
    transform: "translate(-454.842 -181.918)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32691",
    "data-name": "Path 32691",
    d: "M975,229.18l.206.206Z",
    transform: "translate(-466.749 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32692",
    "data-name": "Path 32692",
    d: "M990,229.18l.206.206Z",
    transform: "translate(-478.656 -181.918)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32693",
    "data-name": "Path 32693",
    d: "M991.67,229.51l.138.068Z",
    transform: "translate(-479.981 -182.18)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32694",
    "data-name": "Path 32694",
    d: "M1011,229.18l.206.206Z",
    transform: "translate(-495.325 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32695",
    "data-name": "Path 32695",
    d: "M1012,229.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-496.119 -181.918)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32696",
    "data-name": "Path 32696",
    d: "M907.087,229.18l.206.206-.206-.206M871,229.386l.206.206-.206-.206m1.237,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-384.195 -181.918)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32697",
    "data-name": "Path 32697",
    d: "M881,230.18l.206.206Z",
    transform: "translate(-392.132 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32698",
    "data-name": "Path 32698",
    d: "M910.67,230.51l.138.068Z",
    transform: "translate(-415.684 -182.974)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32699",
    "data-name": "Path 32699",
    d: "M912,230.18l.206.206Z",
    transform: "translate(-416.74 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32700",
    "data-name": "Path 32700",
    d: "M916,230.18l.206.206L916,230.18m2.887,0,.206.206Z",
    transform: "translate(-419.915 -182.712)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32701",
    "data-name": "Path 32701",
    d: "M931,230.18l.206.206Z",
    transform: "translate(-431.822 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32702",
    "data-name": "Path 32702",
    d: "M946,230.18l.206.206Z",
    transform: "translate(-443.729 -182.712)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32703",
    "data-name": "Path 32703",
    d: "M947.67,230.51l.138.068Z",
    transform: "translate(-445.055 -182.974)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32704",
    "data-name": "Path 32704",
    d: "M955,230.18l.206.206Z",
    transform: "translate(-450.873 -182.712)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32705",
    "data-name": "Path 32705",
    d: "M961,230.18l.619.412v-.206Z",
    transform: "translate(-455.636 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32706",
    "data-name": "Path 32706",
    d: "M965,230.18l.206.206Z",
    transform: "translate(-458.811 -182.712)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32707",
    "data-name": "Path 32707",
    d: "M966.67,230.51l.138.068Z",
    transform: "translate(-460.136 -182.974)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32708",
    "data-name": "Path 32708",
    d: "M971,230.18l.206.206Z",
    transform: "translate(-463.574 -182.712)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32709",
    "data-name": "Path 32709",
    d: "M972,230.18l.206.206Z",
    transform: "translate(-464.367 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32710",
    "data-name": "Path 32710",
    d: "M1014,230.18l.206.206Z",
    transform: "translate(-497.707 -182.712)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32711",
    "data-name": "Path 32711",
    d: "M1015,230.18l.206.206Z",
    transform: "translate(-498.5 -182.712)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32712",
    "data-name": "Path 32712",
    d: "M873,231.18l.206.206L873,231.18m1.031,0,.206.206Z",
    transform: "translate(-385.782 -183.506)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32713",
    "data-name": "Path 32713",
    d: "M959,231.18l.206.206Z",
    transform: "translate(-454.048 -183.506)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32714",
    "data-name": "Path 32714",
    d: "M960.67,231.248l.138.068-.138-.068m.687-.068.206.206Z",
    transform: "translate(-455.374 -183.506)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32715",
    "data-name": "Path 32715",
    d: "M973,231.18l.206.206Z",
    transform: "translate(-465.161 -183.506)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32716",
    "data-name": "Path 32716",
    d: "M974.67,231.51l.138.068Z",
    transform: "translate(-466.487 -183.768)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32717",
    "data-name": "Path 32717",
    d: "M1018,231.18l.206.206Z",
    transform: "translate(-500.882 -183.506)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32718",
    "data-name": "Path 32718",
    d: "M1019,231.18l.206.206Z",
    transform: "translate(-501.676 -183.506)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32719",
    "data-name": "Path 32719",
    d: "M875,232.18l.206.206Z",
    transform: "translate(-387.37 -184.3)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32720",
    "data-name": "Path 32720",
    d: "M879,232.18l.206.206Z",
    transform: "translate(-390.545 -184.3)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32721",
    "data-name": "Path 32721",
    d: "M876,233.18l.206.206Z",
    transform: "translate(-388.164 -185.094)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32722",
    "data-name": "Path 32722",
    d: "M877,233.18l.206.206Z",
    transform: "translate(-388.957 -185.094)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32723",
    "data-name": "Path 32723",
    d: "M969,239.18l.206.206Z",
    transform: "translate(-461.986 -189.856)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32724",
    "data-name": "Path 32724",
    d: "M893.8,239.18l.206.206-.206-.206m-19.8.206.412.619Z",
    transform: "translate(-386.576 -189.856)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32725",
    "data-name": "Path 32725",
    d: "M861.506,240.18l.619,1.031-2.887-.619.619,1.031L858,241.211l3.093,1.031-1.031-1.443c1.86.431,3.722.45,5.568.874.771.177,1.677.625,2.268-.049l.619.206-.825-1.031,5.774,1.443v-.206l-1.031-.206v-.206l3.918.825-.412-.619,4.708.28,2.3-.28v-.206l-1.237-.206v-.206l2.062.412V241h.206c1.429,1.25,3.244.68,4.949.852.841.085,1.516.6,2.062-.233l1.65.412.206-.206-.206-.825.619.206-.206.619.206.206,3.3-.206-.412-.412v-.206l3.3.825-.206-.412h2.268v-.412l-4.537-.619.412.619-2.268-.412.412.412v.206l-3.3-.619.412,1.031-6.718-.606-3.386-1.043.206.619H879.24l.206.825L874.5,240.8h-.206c-2.114,1.6-5.537-.115-7.836-.412l1.237,1.237Z",
    transform: "translate(-373.875 -190.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32726",
    "data-name": "Path 32726",
    d: "M881,240.18l.206.206L881,240.18m3.85.068.138.068-.138-.068m13.884-.068.206.206Z",
    transform: "translate(-392.132 -190.65)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32727",
    "data-name": "Path 32727",
    d: "M972,240.18l.206.206Z",
    transform: "translate(-464.367 -190.65)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32728",
    "data-name": "Path 32728",
    d: "M973,240.18l.206.206Z",
    transform: "translate(-465.161 -190.65)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32729",
    "data-name": "Path 32729",
    d: "M979,240.18l.206.206Z",
    transform: "translate(-469.924 -190.65)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32730",
    "data-name": "Path 32730",
    d: "M867,241.18l.206.206Z",
    transform: "translate(-381.019 -191.444)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32731",
    "data-name": "Path 32731",
    d: "M868.67,241.51l.138.068Z",
    transform: "translate(-382.345 -191.706)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32732",
    "data-name": "Path 32732",
    d: "M878.33,241.318l.068.138-.068-.138m.963-.138.206.206Z",
    transform: "translate(-390.013 -191.444)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32733",
    "data-name": "Path 32733",
    d: "M884,241.18l.206.206Z",
    transform: "translate(-394.514 -191.444)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32734",
    "data-name": "Path 32734",
    d: "M898,241.18l.206.206Z",
    transform: "translate(-405.627 -191.444)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32735",
    "data-name": "Path 32735",
    d: "M902,241.18v.206h.619Z",
    transform: "translate(-408.802 -191.444)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32736",
    "data-name": "Path 32736",
    d: "M905,241.18l.206.206Z",
    transform: "translate(-411.183 -191.444)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32737",
    "data-name": "Path 32737",
    d: "M969,241.18l.206.206Z",
    transform: "translate(-461.986 -191.444)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32738",
    "data-name": "Path 32738",
    d: "M969,241.592l.619-.412Z",
    transform: "translate(-461.986 -191.444)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32739",
    "data-name": "Path 32739",
    d: "M974,241.18l.206.206Z",
    transform: "translate(-465.955 -191.444)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32740",
    "data-name": "Path 32740",
    d: "M975,241.18l.206.206L975,241.18m1.237,0,.206.206-.206-.206m13.4,0,.206.206Z",
    transform: "translate(-466.749 -191.444)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32741",
    "data-name": "Path 32741",
    d: "M900.943,241.18l.206.206-.206-.206M863,241.386l.206.206Z",
    transform: "translate(-377.844 -191.444)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32742",
    "data-name": "Path 32742",
    d: "M865,242.18l.206.206Z",
    transform: "translate(-379.432 -192.238)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32743",
    "data-name": "Path 32743",
    d: "M866,242.18l.206.206Z",
    transform: "translate(-380.226 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32744",
    "data-name": "Path 32744",
    d: "M872,242.18l.206.206Z",
    transform: "translate(-384.988 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32745",
    "data-name": "Path 32745",
    d: "M879,242.18l.619.412v-.206Z",
    transform: "translate(-390.545 -192.238)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32746",
    "data-name": "Path 32746",
    d: "M880,242.18l.206.206Z",
    transform: "translate(-391.339 -192.238)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32747",
    "data-name": "Path 32747",
    d: "M881,242.18l.206.206L881,242.18m.825,0,.206.206-.206-.206m3.093,0,.619.619-.619-.619m1.443,0,.206.206Z",
    transform: "translate(-392.132 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32748",
    "data-name": "Path 32748",
    d: "M908,242.18l.206.206Z",
    transform: "translate(-413.565 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32749",
    "data-name": "Path 32749",
    d: "M965,242.18l.206.206Z",
    transform: "translate(-458.811 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32750",
    "data-name": "Path 32750",
    d: "M971.67,242.51l.138.068Z",
    transform: "translate(-464.105 -192.5)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32751",
    "data-name": "Path 32751",
    d: "M973,242.18l.206.206Z",
    transform: "translate(-465.161 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32752",
    "data-name": "Path 32752",
    d: "M976,242.18l.206.206Z",
    transform: "translate(-467.543 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32753",
    "data-name": "Path 32753",
    d: "M977,242.18l.206.206Z",
    transform: "translate(-468.336 -192.238)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32754",
    "data-name": "Path 32754",
    d: "M983,242.18l.206.206Z",
    transform: "translate(-473.099 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32755",
    "data-name": "Path 32755",
    d: "M984,242.18l.206.206Z",
    transform: "translate(-473.893 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32756",
    "data-name": "Path 32756",
    d: "M985,242.18l.206.206Z",
    transform: "translate(-474.687 -192.238)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32757",
    "data-name": "Path 32757",
    d: "M1025,242.18v.206h.619Z",
    transform: "translate(-506.438 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32758",
    "data-name": "Path 32758",
    d: "M1046,242.18l.206.206Z",
    transform: "translate(-523.108 -192.238)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32759",
    "data-name": "Path 32759",
    d: "M901.355,242.18l.206.206-.206-.206M863,242.386l.206.206Z",
    transform: "translate(-377.844 -192.238)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32760",
    "data-name": "Path 32760",
    d: "M868.33,243.85l.068.138Z",
    transform: "translate(-382.075 -193.563)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32761",
    "data-name": "Path 32761",
    d: "M869,243.18l.206.206Z",
    transform: "translate(-382.607 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32762",
    "data-name": "Path 32762",
    d: "M870,243.18l.206.206L870,243.18m.825,0,.206.206Z",
    transform: "translate(-383.401 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32763",
    "data-name": "Path 32763",
    d: "M875,243.18l.206.206Z",
    transform: "translate(-387.37 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32764",
    "data-name": "Path 32764",
    d: "M876,243.18l.206.206Z",
    transform: "translate(-388.164 -193.032)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32765",
    "data-name": "Path 32765",
    d: "M877.33,243.85l.068.138Z",
    transform: "translate(-389.219 -193.563)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32766",
    "data-name": "Path 32766",
    d: "M882,243.18l.206.206Z",
    transform: "translate(-392.926 -193.032)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32767",
    "data-name": "Path 32767",
    d: "M886,243.18l.206.206L886,243.18m2.681,0,.206.206-.206-.206m.619,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-396.101 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32768",
    "data-name": "Path 32768",
    d: "M906,243.18l.206.206Z",
    transform: "translate(-411.977 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32769",
    "data-name": "Path 32769",
    d: "M913,243.18l.206.206Z",
    transform: "translate(-417.534 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32770",
    "data-name": "Path 32770",
    d: "M938,243.18l.206.206Z",
    transform: "translate(-437.379 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32771",
    "data-name": "Path 32771",
    d: "M960.33,243.85l.068.138Z",
    transform: "translate(-455.104 -193.563)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32772",
    "data-name": "Path 32772",
    d: "M963,243.18l.206.206Z",
    transform: "translate(-457.223 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32773",
    "data-name": "Path 32773",
    d: "M964,243.18l.206.206Z",
    transform: "translate(-458.017 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32774",
    "data-name": "Path 32774",
    d: "M978.67,243.248l.138.068-.138-.068m1.718-.068.206.206Z",
    transform: "translate(-469.662 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32775",
    "data-name": "Path 32775",
    d: "M988,243.18l.206.206L988,243.18m7.217,0,.206.206Z",
    transform: "translate(-477.068 -193.032)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32776",
    "data-name": "Path 32776",
    d: "M1030,243.18l.206.206Z",
    transform: "translate(-510.407 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32777",
    "data-name": "Path 32777",
    d: "M1037.33,243.85l.07.138Z",
    transform: "translate(-516.226 -193.563)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32778",
    "data-name": "Path 32778",
    d: "M1042,243.18l.206.206Z",
    transform: "translate(-519.933 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32779",
    "data-name": "Path 32779",
    d: "M1043,243.18l.206.206Z",
    transform: "translate(-520.727 -193.032)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32780",
    "data-name": "Path 32780",
    d: "M1044,243.18l.206.206Z",
    transform: "translate(-521.52 -193.032)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32781",
    "data-name": "Path 32781",
    d: "M1047.33,243.85l.07.138Z",
    transform: "translate(-524.164 -193.563)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32782",
    "data-name": "Path 32782",
    d: "M1051,243.18l.206.206Z",
    transform: "translate(-527.077 -193.032)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32783",
    "data-name": "Path 32783",
    d: "M1055,243.18l.206.206Z",
    transform: "translate(-530.252 -193.032)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32784",
    "data-name": "Path 32784",
    d: "M858,244.18l.206.206L858,244.18m1.237,0,.206.206Z",
    transform: "translate(-373.875 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32785",
    "data-name": "Path 32785",
    d: "M873,244.18l.206.206L873,244.18m1.443,0,.206.206-.206-.206m2.268,0,.206.206Z",
    transform: "translate(-385.782 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32786",
    "data-name": "Path 32786",
    d: "M892,244.18l.206.206Z",
    transform: "translate(-400.864 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32787",
    "data-name": "Path 32787",
    d: "M900,244.18l.206.206Z",
    transform: "translate(-407.215 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32788",
    "data-name": "Path 32788",
    d: "M903,244.18l.206.206Z",
    transform: "translate(-409.596 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32789",
    "data-name": "Path 32789",
    d: "M906,244.18l.412.412v-.412Z",
    transform: "translate(-411.977 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32790",
    "data-name": "Path 32790",
    d: "M908,244.18l.206.206Z",
    transform: "translate(-413.565 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32791",
    "data-name": "Path 32791",
    d: "M915,244.18l.206.206Z",
    transform: "translate(-419.121 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32792",
    "data-name": "Path 32792",
    d: "M936,244.18l.206.206Z",
    transform: "translate(-435.791 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32793",
    "data-name": "Path 32793",
    d: "M940,244.18l.206.206Z",
    transform: "translate(-438.966 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32794",
    "data-name": "Path 32794",
    d: "M941,244.18l.206.206Z",
    transform: "translate(-439.76 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32795",
    "data-name": "Path 32795",
    d: "M983.33,244.318l.068.138-.068-.138m1.375-.138.206.206Z",
    transform: "translate(-473.361 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32796",
    "data-name": "Path 32796",
    d: "M991,244.18l.206.206Z",
    transform: "translate(-479.449 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32797",
    "data-name": "Path 32797",
    d: "M1006,244.18l.206.206Z",
    transform: "translate(-491.356 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32798",
    "data-name": "Path 32798",
    d: "M1007,244.18l.206.206Z",
    transform: "translate(-492.15 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32799",
    "data-name": "Path 32799",
    d: "M1015.67,244.248l.136.068-.136-.068m2.13-.068.206.206Z",
    transform: "translate(-499.032 -193.825)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32800",
    "data-name": "Path 32800",
    d: "M1032,244.18l.206.206Z",
    transform: "translate(-511.995 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32801",
    "data-name": "Path 32801",
    d: "M1033,244.18l.206.206Z",
    transform: "translate(-512.789 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32802",
    "data-name": "Path 32802",
    d: "M1046,244.18l.206.206Z",
    transform: "translate(-523.108 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32803",
    "data-name": "Path 32803",
    d: "M1048,244.18l.206.206Z",
    transform: "translate(-524.695 -193.825)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32804",
    "data-name": "Path 32804",
    d: "M1060,244.18v.206h1.443Z",
    transform: "translate(-534.221 -193.825)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32805",
    "data-name": "Path 32805",
    d: "M1067.67,244.51l.136.068Z",
    transform: "translate(-540.309 -194.087)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32806",
    "data-name": "Path 32806",
    d: "M862,245.18l.206.206Z",
    transform: "translate(-377.05 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32807",
    "data-name": "Path 32807",
    d: "M863,245.18l.206.206Z",
    transform: "translate(-377.844 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32808",
    "data-name": "Path 32808",
    d: "M864,245.18l.619.412v-.206Z",
    transform: "translate(-378.638 -194.619)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32809",
    "data-name": "Path 32809",
    d: "M865,245.18l.206.206L865,245.18m1.031,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-379.432 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32810",
    "data-name": "Path 32810",
    d: "M876,245.18l.206.206Z",
    transform: "translate(-388.164 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32811",
    "data-name": "Path 32811",
    d: "M897,245.18l.206.206L897,245.18m.825,0,.206.206Z",
    transform: "translate(-404.833 -194.619)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32812",
    "data-name": "Path 32812",
    d: "M904,245.18l.206.206Z",
    transform: "translate(-410.39 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32813",
    "data-name": "Path 32813",
    d: "M908,245.18l.206.206Z",
    transform: "translate(-413.565 -194.619)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32814",
    "data-name": "Path 32814",
    d: "M909,245.18l.206.206Z",
    transform: "translate(-414.359 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32815",
    "data-name": "Path 32815",
    d: "M913,245.18l.206.206L913,245.18m.825,0v.206h.825Z",
    transform: "translate(-417.534 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32816",
    "data-name": "Path 32816",
    d: "M921,245.18l.206.206L921,245.18m1.031,0,.206.206Z",
    transform: "translate(-423.884 -194.619)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32817",
    "data-name": "Path 32817",
    d: "M937,245.18l.206.206Z",
    transform: "translate(-436.585 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32818",
    "data-name": "Path 32818",
    d: "M942,245.18l.206.206Z",
    transform: "translate(-440.554 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32819",
    "data-name": "Path 32819",
    d: "M961,245.18l.206.206Z",
    transform: "translate(-455.636 -194.619)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32820",
    "data-name": "Path 32820",
    d: "M973,245.18l.206.206Z",
    transform: "translate(-465.161 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32821",
    "data-name": "Path 32821",
    d: "M974,245.18v.206h1.031Z",
    transform: "translate(-465.955 -194.619)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32822",
    "data-name": "Path 32822",
    d: "M979,245.18l.206.206L979,245.18m1.237,0,.206.206-.206-.206m1.65,0,.206.206-.206-.206m1.65,0v.206h.825l-.825-.206m1.856,0v.206h.619v-.206Z",
    transform: "translate(-469.924 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32823",
    "data-name": "Path 32823",
    d: "M1011,245.18l.206.206-.206-.206m.551.068.136.068Z",
    transform: "translate(-495.325 -194.619)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32824",
    "data-name": "Path 32824",
    d: "M1019,245.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-501.676 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32825",
    "data-name": "Path 32825",
    d: "M1026,245.18l.206.206Z",
    transform: "translate(-507.232 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32826",
    "data-name": "Path 32826",
    d: "M1027,245.18l.206.206Z",
    transform: "translate(-508.026 -194.619)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32827",
    "data-name": "Path 32827",
    d: "M1028,245.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-508.82 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32828",
    "data-name": "Path 32828",
    d: "M1035,245.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-514.376 -194.619)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32829",
    "data-name": "Path 32829",
    d: "M1039,245.18l.206.206-.206-.206m.825,0v.206h.619Z",
    transform: "translate(-517.551 -194.619)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32830",
    "data-name": "Path 32830",
    d: "M871,246.18l.206.206Z",
    transform: "translate(-384.195 -195.413)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32831",
    "data-name": "Path 32831",
    d: "M879,246.18l.206.206Z",
    transform: "translate(-390.545 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32832",
    "data-name": "Path 32832",
    d: "M880,246.18v.206h.619Z",
    transform: "translate(-391.339 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32833",
    "data-name": "Path 32833",
    d: "M883.67,246.51l.138.068-.138-.068m.825,0,.138.068Z",
    transform: "translate(-394.252 -195.675)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32834",
    "data-name": "Path 32834",
    d: "M889,246.18v.206h.619Z",
    transform: "translate(-398.483 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32835",
    "data-name": "Path 32835",
    d: "M898,246.18l.206.206Z",
    transform: "translate(-405.627 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32836",
    "data-name": "Path 32836",
    d: "M901.206,246.18l-.206.412Z",
    transform: "translate(-408.008 -195.413)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32837",
    "data-name": "Path 32837",
    d: "M908,246.18l.206.206L908,246.18m.619,0,.206.206Z",
    transform: "translate(-413.565 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32838",
    "data-name": "Path 32838",
    d: "M924,246.18l.206.206L924,246.18m1.031,0-.206.412Z",
    transform: "translate(-426.265 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32839",
    "data-name": "Path 32839",
    d: "M930,246.18v.206h.825Z",
    transform: "translate(-431.028 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32840",
    "data-name": "Path 32840",
    d: "M934,246.18v.206h.619Z",
    transform: "translate(-434.203 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32841",
    "data-name": "Path 32841",
    d: "M945,246.18l.206.206Z",
    transform: "translate(-442.935 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32842",
    "data-name": "Path 32842",
    d: "M954,246.18v.206h.619L954,246.18m.825,0v.206h.825l-.825-.206m1.443,0v.206l.619.206-.619-.412m2.681,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-450.079 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32843",
    "data-name": "Path 32843",
    d: "M983,246.18l.206.206Z",
    transform: "translate(-473.099 -195.413)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32844",
    "data-name": "Path 32844",
    d: "M986,246.18l.206.206Z",
    transform: "translate(-475.48 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32845",
    "data-name": "Path 32845",
    d: "M1021,246.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-503.263 -195.413)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32846",
    "data-name": "Path 32846",
    d: "M1027.67,246.51l.136.068Z",
    transform: "translate(-508.558 -195.675)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32847",
    "data-name": "Path 32847",
    d: "M1045.33,246.588l.07.138-.07-.138m.689-.068.136.068Z",
    transform: "translate(-522.576 -195.683)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32848",
    "data-name": "Path 32848",
    d: "M1050,246.18l.206.206Z",
    transform: "translate(-526.283 -195.413)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32849",
    "data-name": "Path 32849",
    d: "M858.67,247.51l.138.068Z",
    transform: "translate(-374.407 -196.469)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32850",
    "data-name": "Path 32850",
    d: "M860,247.18l.206.206Z",
    transform: "translate(-375.463 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32851",
    "data-name": "Path 32851",
    d: "M872,247.18l.206.206L872,247.18m4.743,0,.206.206Z",
    transform: "translate(-384.988 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32852",
    "data-name": "Path 32852",
    d: "M896,247.18l.206.206L896,247.18m.825,0,.206.206Z",
    transform: "translate(-404.039 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32853",
    "data-name": "Path 32853",
    d: "M902.67,247.51l.138.068Z",
    transform: "translate(-409.334 -196.469)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32854",
    "data-name": "Path 32854",
    d: "M903.206,247.18l.206.206-.206-.206m.412,0-.619.412v.206Z",
    transform: "translate(-409.596 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32855",
    "data-name": "Path 32855",
    d: "M909,247.18l.206.206L909,247.18m.619,0,.206.206Z",
    transform: "translate(-414.359 -196.207)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32856",
    "data-name": "Path 32856",
    d: "M913,247.18l.206.206Z",
    transform: "translate(-417.534 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32857",
    "data-name": "Path 32857",
    d: "M915,247.18l.206.206L915,247.18m2.887,0,.206.206Z",
    transform: "translate(-419.121 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32858",
    "data-name": "Path 32858",
    d: "M940,247.18l.206.206L940,247.18m1.443,0,.206.206Z",
    transform: "translate(-438.966 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32859",
    "data-name": "Path 32859",
    d: "M948,247.18v.206h.619Z",
    transform: "translate(-445.316 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32860",
    "data-name": "Path 32860",
    d: "M951.67,247.248l.138.068-.138-.068m4.4-.068.206.206Z",
    transform: "translate(-448.23 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32861",
    "data-name": "Path 32861",
    d: "M974,247.18l.206.206Z",
    transform: "translate(-465.955 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32862",
    "data-name": "Path 32862",
    d: "M975.67,247.51l.138.068Z",
    transform: "translate(-467.281 -196.469)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32863",
    "data-name": "Path 32863",
    d: "M979,247.18l.206.206Z",
    transform: "translate(-469.924 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32864",
    "data-name": "Path 32864",
    d: "M987,247.18l.206.206Z",
    transform: "translate(-476.274 -196.207)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32865",
    "data-name": "Path 32865",
    d: "M988,247.18l.206.206Z",
    transform: "translate(-477.068 -196.207)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32866",
    "data-name": "Path 32866",
    d: "M989.67,247.51l.138.068Z",
    transform: "translate(-478.394 -196.469)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32867",
    "data-name": "Path 32867",
    d: "M1018.67,247.51l.136.068Z",
    transform: "translate(-501.414 -196.469)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32868",
    "data-name": "Path 32868",
    d: "M1024.67,247.248l.136.068-.136-.068m3.367-.068v.206h.619l-.619-.206m2.474,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-506.176 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32869",
    "data-name": "Path 32869",
    d: "M1059,247.18l.206.206Z",
    transform: "translate(-533.427 -196.207)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32870",
    "data-name": "Path 32870",
    d: "M1060,247.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-534.221 -196.207)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32871",
    "data-name": "Path 32871",
    d: "M1064,247.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-537.396 -196.207)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32872",
    "data-name": "Path 32872",
    d: "M864.67,248.51l.138.068Z",
    transform: "translate(-379.17 -197.262)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32873",
    "data-name": "Path 32873",
    d: "M866,248.18v.206h.619Z",
    transform: "translate(-380.226 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32874",
    "data-name": "Path 32874",
    d: "M873,248.18l.206.206L873,248.18m5.155,0,.206.206Z",
    transform: "translate(-385.782 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32875",
    "data-name": "Path 32875",
    d: "M899,248.18l.206.206L899,248.18m1.856,0,.206.206Z",
    transform: "translate(-406.421 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32876",
    "data-name": "Path 32876",
    d: "M909,248.18l.206.206L909,248.18m1.856,0,.206.206Z",
    transform: "translate(-414.359 -197.001)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32877",
    "data-name": "Path 32877",
    d: "M921,248.18l.206.206L921,248.18m.757.068.138.068Z",
    transform: "translate(-423.884 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32878",
    "data-name": "Path 32878",
    d: "M932,248.18l.206.206L932,248.18m1.65,0,.206.206Z",
    transform: "translate(-432.616 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32879",
    "data-name": "Path 32879",
    d: "M945,248.18l.206.206Z",
    transform: "translate(-442.935 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32880",
    "data-name": "Path 32880",
    d: "M964,248.18l.206.206Z",
    transform: "translate(-458.017 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32881",
    "data-name": "Path 32881",
    d: "M968,248.18l.206.206Z",
    transform: "translate(-461.192 -197.001)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32882",
    "data-name": "Path 32882",
    d: "M968.412,248.18l-.412.412v.206Z",
    transform: "translate(-461.192 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32883",
    "data-name": "Path 32883",
    d: "M997,248.18l.206.206Z",
    transform: "translate(-484.212 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32884",
    "data-name": "Path 32884",
    d: "M998,248.18l.206.206Z",
    transform: "translate(-485.006 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32885",
    "data-name": "Path 32885",
    d: "M1001,248.18l.206.206Z",
    transform: "translate(-487.387 -197.001)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32886",
    "data-name": "Path 32886",
    d: "M1010,248.18l.206.206Z",
    transform: "translate(-494.531 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32887",
    "data-name": "Path 32887",
    d: "M1011,248.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-495.325 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32888",
    "data-name": "Path 32888",
    d: "M1021,248.18l.206.206Z",
    transform: "translate(-503.263 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32889",
    "data-name": "Path 32889",
    d: "M1022,248.18l.206.206Z",
    transform: "translate(-504.057 -197.001)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32890",
    "data-name": "Path 32890",
    d: "M1023,248.18l.206.206-.206-.206m.619,0,.206.206-.206-.206m.412,0,.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-504.851 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32891",
    "data-name": "Path 32891",
    d: "M1031,248.18l.206.206Z",
    transform: "translate(-511.201 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32892",
    "data-name": "Path 32892",
    d: "M1034,248.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-513.582 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32893",
    "data-name": "Path 32893",
    d: "M1054,248.18l.206.206Z",
    transform: "translate(-529.458 -197.001)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32894",
    "data-name": "Path 32894",
    d: "M1055,248.18l.206.206Z",
    transform: "translate(-530.252 -197.001)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32895",
    "data-name": "Path 32895",
    d: "M870,249.18l.206.206Z",
    transform: "translate(-383.401 -197.794)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32896",
    "data-name": "Path 32896",
    d: "M873,249.18l.206.206L873,249.18m5.98,0,.206.206Z",
    transform: "translate(-385.782 -197.794)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32897",
    "data-name": "Path 32897",
    d: "M906,249.18l.206.206L906,249.18m4.537,0,.206.206Z",
    transform: "translate(-411.977 -197.794)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32898",
    "data-name": "Path 32898",
    d: "M929,249.18l.206.206Z",
    transform: "translate(-430.234 -197.794)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32899",
    "data-name": "Path 32899",
    d: "M930,249.18l.206.206Z",
    transform: "translate(-431.028 -197.794)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32900",
    "data-name": "Path 32900",
    d: "M941,249.18l.206.206L941,249.18m1.031,0,.206.206Z",
    transform: "translate(-439.76 -197.794)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32901",
    "data-name": "Path 32901",
    d: "M966,249.18l.206.206Z",
    transform: "translate(-459.605 -197.794)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32902",
    "data-name": "Path 32902",
    d: "M1012,249.18l.206.206-.206-.206m5.293.068.136.068Z",
    transform: "translate(-496.119 -197.794)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32903",
    "data-name": "Path 32903",
    d: "M1057,249.18l.206.206Z",
    transform: "translate(-531.84 -197.794)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32904",
    "data-name": "Path 32904",
    d: "M1058,249.18l.206.206Z",
    transform: "translate(-532.633 -197.794)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32905",
    "data-name": "Path 32905",
    d: "M872,250.18l.206.206Z",
    transform: "translate(-384.988 -198.588)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32906",
    "data-name": "Path 32906",
    d: "M970,250.18l.206.206L970,250.18m9.073,0,.206.206Z",
    transform: "translate(-462.78 -198.588)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32907",
    "data-name": "Path 32907",
    d: "M1015.67,250.51l.136.068Z",
    transform: "translate(-499.032 -198.85)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32908",
    "data-name": "Path 32908",
    d: "M865.206,261.18l-.206.412Z",
    transform: "translate(-379.432 -207.32)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32909",
    "data-name": "Path 32909",
    d: "M867,261.18l.206.206Z",
    transform: "translate(-381.019 -207.32)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32910",
    "data-name": "Path 32910",
    d: "M872,261.18l.206.206Z",
    transform: "translate(-384.988 -207.32)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32911",
    "data-name": "Path 32911",
    d: "M861.093,261.18l.619.412v.206l-2.062-.412v.206l.619.206V262l-2.268.206v.825c2.25-.3,3.681-.938,5.98-.412v-.412l.825.206c2.279-1.32,6.052.633,8.455.825l-.825-.619v-.206l5.12.3,2.3-.577,4.124.9v-.206h-.619c-.134-.986-2.058-.9-2.887-1.054-3.068-.577-6.159.392-9.279.023l.619.619v.206c-.579-.235-2.722-1.6-2.887-.619l-3.3-.619.206.619c-.621-.2-2.934-1.114-3.093-.206Z",
    transform: "translate(-373.875 -207.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32912",
    "data-name": "Path 32912",
    d: "M874,261.18l.206.206Z",
    transform: "translate(-386.576 -207.32)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32913",
    "data-name": "Path 32913",
    d: "M875,261.18l.206.206Z",
    transform: "translate(-387.37 -207.32)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32914",
    "data-name": "Path 32914",
    d: "M880.67,261.51l.138.068Z",
    transform: "translate(-391.871 -207.582)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32915",
    "data-name": "Path 32915",
    d: "M894,261.18l.206.206Z",
    transform: "translate(-402.452 -207.32)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32916",
    "data-name": "Path 32916",
    d: "M895,261.18v.206h.825Z",
    transform: "translate(-403.246 -207.32)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32917",
    "data-name": "Path 32917",
    d: "M899,261.18l.206.206Z",
    transform: "translate(-406.421 -207.32)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32918",
    "data-name": "Path 32918",
    d: "M982,261.18l.206.206Z",
    transform: "translate(-472.305 -207.32)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32919",
    "data-name": "Path 32919",
    d: "M983,261.18l.412,1.856v.206l.825-.206-.619-.825,5.568.825v.206h-1.031v.206l2.062.206.412-.825L988.568,262h.825V261.8h-1.031v.825Z",
    transform: "translate(-473.099 -207.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32920",
    "data-name": "Path 32920",
    d: "M985,261.18l.206.206Z",
    transform: "translate(-474.687 -207.32)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32921",
    "data-name": "Path 32921",
    d: "M869,262.18l.206.206Z",
    transform: "translate(-382.607 -208.114)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32922",
    "data-name": "Path 32922",
    d: "M870,262.18l.206.206Z",
    transform: "translate(-383.401 -208.114)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32923",
    "data-name": "Path 32923",
    d: "M872,262.18l.206.206Z",
    transform: "translate(-384.988 -208.114)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32924",
    "data-name": "Path 32924",
    d: "M876,262.18l.206.206Z",
    transform: "translate(-388.164 -208.114)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32925",
    "data-name": "Path 32925",
    d: "M877,262.18l.206.206L877,262.18m.48.138.068.138Z",
    transform: "translate(-388.957 -208.114)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32926",
    "data-name": "Path 32926",
    d: "M883,262.18l.206.206L883,262.18m.412,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-393.72 -208.114)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32927",
    "data-name": "Path 32927",
    d: "M889,262.18l.206.206Z",
    transform: "translate(-398.483 -208.114)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32928",
    "data-name": "Path 32928",
    d: "M894,262.18l.206.206Z",
    transform: "translate(-402.452 -208.114)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32929",
    "data-name": "Path 32929",
    d: "M902,262.18l.206.206L902,262.18m1.65,0,.206.206Z",
    transform: "translate(-408.802 -208.114)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32930",
    "data-name": "Path 32930",
    d: "M911,262.18l.206.206Z",
    transform: "translate(-415.946 -208.114)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32931",
    "data-name": "Path 32931",
    d: "M912,262.18l.206.206Z",
    transform: "translate(-416.74 -208.114)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32932",
    "data-name": "Path 32932",
    d: "M954.67,262.51l.138.068Z",
    transform: "translate(-450.611 -208.376)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32933",
    "data-name": "Path 32933",
    d: "M956,262.18l.206.206Z",
    transform: "translate(-451.667 -208.114)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32934",
    "data-name": "Path 32934",
    d: "M987,262.18l.206.206Z",
    transform: "translate(-476.274 -208.114)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32935",
    "data-name": "Path 32935",
    d: "M1027.67,262.51l.136.068Z",
    transform: "translate(-508.558 -208.376)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32936",
    "data-name": "Path 32936",
    d: "M1029,262.18l.206.206Z",
    transform: "translate(-509.613 -208.114)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32937",
    "data-name": "Path 32937",
    d: "M866,263.18l.206.206L866,263.18m1.237,0,.206.206Z",
    transform: "translate(-380.226 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32938",
    "data-name": "Path 32938",
    d: "M873,263.18l.206.206Z",
    transform: "translate(-385.782 -208.907)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32939",
    "data-name": "Path 32939",
    d: "M874,263.18l.206.206Z",
    transform: "translate(-386.576 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32940",
    "data-name": "Path 32940",
    d: "M875,263.18l.206.206Z",
    transform: "translate(-387.37 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32941",
    "data-name": "Path 32941",
    d: "M880,263.18l.206.206Z",
    transform: "translate(-391.339 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32942",
    "data-name": "Path 32942",
    d: "M891,263.18l.206.206Z",
    transform: "translate(-400.07 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32943",
    "data-name": "Path 32943",
    d: "M892,263.18l.206.206L892,263.18m.412,0,.206.206Z",
    transform: "translate(-400.864 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32944",
    "data-name": "Path 32944",
    d: "M897,263.18l.206.206Z",
    transform: "translate(-404.833 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32945",
    "data-name": "Path 32945",
    d: "M904,263.18l.206.206Z",
    transform: "translate(-410.39 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32946",
    "data-name": "Path 32946",
    d: "M905,263.18l.206.206Z",
    transform: "translate(-411.183 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32947",
    "data-name": "Path 32947",
    d: "M906,263.18l.206.206Z",
    transform: "translate(-411.977 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32948",
    "data-name": "Path 32948",
    d: "M915,263.18l.206.206Z",
    transform: "translate(-419.121 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32949",
    "data-name": "Path 32949",
    d: "M941,263.18l.206.206Z",
    transform: "translate(-439.76 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32950",
    "data-name": "Path 32950",
    d: "M946,263.18l.206.206Z",
    transform: "translate(-443.729 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32951",
    "data-name": "Path 32951",
    d: "M947,263.18l.206.206L947,263.18m1.1.138.068.138Z",
    transform: "translate(-444.523 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32952",
    "data-name": "Path 32952",
    d: "M953,263.18l.206.206L953,263.18m1.031,0,.206.206Z",
    transform: "translate(-449.285 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32953",
    "data-name": "Path 32953",
    d: "M959,263.18l.206.206Z",
    transform: "translate(-454.048 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32954",
    "data-name": "Path 32954",
    d: "M962,263.18l.206.206Z",
    transform: "translate(-456.43 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32955",
    "data-name": "Path 32955",
    d: "M965,263.18l.206.206Z",
    transform: "translate(-458.811 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32956",
    "data-name": "Path 32956",
    d: "M966,263.18l.206.206Z",
    transform: "translate(-459.605 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32957",
    "data-name": "Path 32957",
    d: "M983,263.18l.206.206Z",
    transform: "translate(-473.099 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32958",
    "data-name": "Path 32958",
    d: "M984,263.18l.206.206Z",
    transform: "translate(-473.893 -208.907)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32959",
    "data-name": "Path 32959",
    d: "M985,263.18l.206.206L985,263.18m.619,0,.206.206Z",
    transform: "translate(-474.687 -208.907)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32960",
    "data-name": "Path 32960",
    d: "M1009,263.18l.206.206Z",
    transform: "translate(-493.738 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32961",
    "data-name": "Path 32961",
    d: "M1010.67,263.51l.136.068Z",
    transform: "translate(-495.063 -209.169)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32962",
    "data-name": "Path 32962",
    d: "M1012,263.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-496.119 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32963",
    "data-name": "Path 32963",
    d: "M1018,263.18l.206.206Z",
    transform: "translate(-500.882 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32964",
    "data-name": "Path 32964",
    d: "M1026,263.18l.206.206Z",
    transform: "translate(-507.232 -208.907)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32965",
    "data-name": "Path 32965",
    d: "M1017.474,263.18l.825,1.237-3.3-.825v.206l3.712.825-.825-1.237,8.248,1.237V263.8Z",
    transform: "translate(-498.5 -208.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32966",
    "data-name": "Path 32966",
    d: "M901.818,263.18l.206.206-.206-.206M868,263.386l.206.206Z",
    transform: "translate(-381.813 -208.907)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32967",
    "data-name": "Path 32967",
    d: "M881,264.18l.206.206Z",
    transform: "translate(-392.132 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32968",
    "data-name": "Path 32968",
    d: "M890,264.18l.206.206L890,264.18m.825,0,.206.206Z",
    transform: "translate(-399.277 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32969",
    "data-name": "Path 32969",
    d: "M895,264.18l.206.206Z",
    transform: "translate(-403.246 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32970",
    "data-name": "Path 32970",
    d: "M909.67,264.248l.138.068-.138-.068m1.512-.068.206.206Z",
    transform: "translate(-414.89 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32971",
    "data-name": "Path 32971",
    d: "M918,264.18l.206.206Z",
    transform: "translate(-421.503 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32972",
    "data-name": "Path 32972",
    d: "M921,264.18l.206.206L921,264.18m.825,0,.206.206Z",
    transform: "translate(-423.884 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32973",
    "data-name": "Path 32973",
    d: "M926,264.18l.206.206Z",
    transform: "translate(-427.853 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32974",
    "data-name": "Path 32974",
    d: "M930,264.18l.206.206Z",
    transform: "translate(-431.028 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32975",
    "data-name": "Path 32975",
    d: "M931,264.18l.206.206L931,264.18m.412,0v.206h.619Z",
    transform: "translate(-431.822 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32976",
    "data-name": "Path 32976",
    d: "M936.67,264.51l.138.068Z",
    transform: "translate(-436.323 -209.963)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32977",
    "data-name": "Path 32977",
    d: "M938,264.18l.206.206Z",
    transform: "translate(-437.379 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32978",
    "data-name": "Path 32978",
    d: "M941,264.18l.206.206Z",
    transform: "translate(-439.76 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32979",
    "data-name": "Path 32979",
    d: "M949,264.18l.206.206Z",
    transform: "translate(-446.11 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32980",
    "data-name": "Path 32980",
    d: "M950,264.18l.206.206Z",
    transform: "translate(-446.904 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32981",
    "data-name": "Path 32981",
    d: "M969.67,264.51l.138.068Z",
    transform: "translate(-462.518 -209.963)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32982",
    "data-name": "Path 32982",
    d: "M971.67,264.51l.138.068Z",
    transform: "translate(-464.105 -209.963)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32983",
    "data-name": "Path 32983",
    d: "M973,264.18l.206.206L973,264.18m2.268,0,.206.206Z",
    transform: "translate(-465.161 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32984",
    "data-name": "Path 32984",
    d: "M990,264.18l.206.206Z",
    transform: "translate(-478.656 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32985",
    "data-name": "Path 32985",
    d: "M1008,264.18l.206.206Z",
    transform: "translate(-492.944 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32986",
    "data-name": "Path 32986",
    d: "M1014.33,264.85l.07.138Z",
    transform: "translate(-497.969 -210.233)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32987",
    "data-name": "Path 32987",
    d: "M1015,264.18l.206.206Z",
    transform: "translate(-498.5 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32988",
    "data-name": "Path 32988",
    d: "M1020,264.18l.206.206Z",
    transform: "translate(-502.469 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32989",
    "data-name": "Path 32989",
    d: "M1021,264.18l.206.206-.206-.206m1.65,0,.825.412v-.206Z",
    transform: "translate(-503.263 -209.701)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32990",
    "data-name": "Path 32990",
    d: "M1030,264.18l.206.206Z",
    transform: "translate(-510.407 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32991",
    "data-name": "Path 32991",
    d: "M1031,264.18l.206.206Z",
    transform: "translate(-511.201 -209.701)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32992",
    "data-name": "Path 32992",
    d: "M1039,264.18l.206.206Z",
    transform: "translate(-517.551 -209.701)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32993",
    "data-name": "Path 32993",
    d: "M859,265.18l.206.206Z",
    transform: "translate(-374.669 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32994",
    "data-name": "Path 32994",
    d: "M860.67,265.51l.138.068Z",
    transform: "translate(-375.995 -210.757)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32995",
    "data-name": "Path 32995",
    d: "M862.67,265.248l.138.068-.138-.068m3.986-.068.206.206Z",
    transform: "translate(-377.582 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32996",
    "data-name": "Path 32996",
    d: "M883,265.18l.206.206Z",
    transform: "translate(-393.72 -210.495)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32997",
    "data-name": "Path 32997",
    d: "M891,265.18l.206.206Z",
    transform: "translate(-400.07 -210.495)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32998",
    "data-name": "Path 32998",
    d: "M892,265.18l.206.206Z",
    transform: "translate(-400.864 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32999",
    "data-name": "Path 32999",
    d: "M893,265.18l.206.206L893,265.18m1.237,0,.206.206Z",
    transform: "translate(-401.658 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33000",
    "data-name": "Path 33000",
    d: "M900.67,265.51l.138.068Z",
    transform: "translate(-407.746 -210.757)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33001",
    "data-name": "Path 33001",
    d: "M902,265.18l.206.206L902,265.18m2.887,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-408.802 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33002",
    "data-name": "Path 33002",
    d: "M920,265.18l.206.206Z",
    transform: "translate(-423.09 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33003",
    "data-name": "Path 33003",
    d: "M921,265.18l.206.206L921,265.18m5.293.068.138.068Z",
    transform: "translate(-423.884 -210.495)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33004",
    "data-name": "Path 33004",
    d: "M948,265.18l.206.206L948,265.18m1.031,0,.206.206Z",
    transform: "translate(-445.316 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33005",
    "data-name": "Path 33005",
    d: "M954,265.18l.206.206L954,265.18m1.582.068.138.068Z",
    transform: "translate(-450.079 -210.495)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33006",
    "data-name": "Path 33006",
    d: "M963.67,265.248l.138.068-.138-.068m2.749-.068.206.206Z",
    transform: "translate(-457.755 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33007",
    "data-name": "Path 33007",
    d: "M978,265.18l.206.206L978,265.18m.825,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-469.13 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33008",
    "data-name": "Path 33008",
    d: "M995,265.18v.206h.825Z",
    transform: "translate(-482.625 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33009",
    "data-name": "Path 33009",
    d: "M999.67,265.51l.136.068-.136-.068m1.786.068.07.138Z",
    transform: "translate(-486.332 -210.757)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33010",
    "data-name": "Path 33010",
    d: "M1010,265.18l.206.206Z",
    transform: "translate(-494.531 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33011",
    "data-name": "Path 33011",
    d: "M1013,265.18l.206.206-.206-.206m2.062,0,.206.206Z",
    transform: "translate(-496.913 -210.495)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33012",
    "data-name": "Path 33012",
    d: "M1027,265.18l.206.206Z",
    transform: "translate(-508.026 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33013",
    "data-name": "Path 33013",
    d: "M1031,265.18l.206.206Z",
    transform: "translate(-511.201 -210.495)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33014",
    "data-name": "Path 33014",
    d: "M1033,265.18l.206.206-.206-.206m1.856,0,.206.206Z",
    transform: "translate(-512.789 -210.495)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33015",
    "data-name": "Path 33015",
    d: "M1043,265.18l.206.206-.206-.206m.757.068.136.068Z",
    transform: "translate(-520.727 -210.495)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33016",
    "data-name": "Path 33016",
    d: "M1048,265.18l.206.206Z",
    transform: "translate(-524.695 -210.495)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33017",
    "data-name": "Path 33017",
    d: "M871,266.18l.206.206Z",
    transform: "translate(-384.195 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33018",
    "data-name": "Path 33018",
    d: "M872,266.18l.206.206Z",
    transform: "translate(-384.988 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33019",
    "data-name": "Path 33019",
    d: "M873,266.18l.206.206L873,266.18m.412,0,.206.206Z",
    transform: "translate(-385.782 -211.289)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33020",
    "data-name": "Path 33020",
    d: "M876,266.18v.206h.825Z",
    transform: "translate(-388.164 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33021",
    "data-name": "Path 33021",
    d: "M880,266.18l.206.206Z",
    transform: "translate(-391.339 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33022",
    "data-name": "Path 33022",
    d: "M881,266.18l.206.206Z",
    transform: "translate(-392.132 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33023",
    "data-name": "Path 33023",
    d: "M887,266.18l.206.206Z",
    transform: "translate(-396.895 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33024",
    "data-name": "Path 33024",
    d: "M888,266.18l.206.206Z",
    transform: "translate(-397.689 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33025",
    "data-name": "Path 33025",
    d: "M891,266.18l.206.206L891,266.18m1.031,0,.206.206Z",
    transform: "translate(-400.07 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33026",
    "data-name": "Path 33026",
    d: "M897.67,266.51l.138.068Z",
    transform: "translate(-405.365 -211.551)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33027",
    "data-name": "Path 33027",
    d: "M905,266.18l.206.206Z",
    transform: "translate(-411.183 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33028",
    "data-name": "Path 33028",
    d: "M906,266.18l.206.206L906,266.18m.825,0,.206.206Z",
    transform: "translate(-411.977 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33029",
    "data-name": "Path 33029",
    d: "M911,266.18l.206.206Z",
    transform: "translate(-415.946 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33030",
    "data-name": "Path 33030",
    d: "M912,266.18l.206.206L912,266.18m1.856,0,.206.206Z",
    transform: "translate(-416.74 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33031",
    "data-name": "Path 33031",
    d: "M922,266.18l.206.206Z",
    transform: "translate(-424.678 -211.289)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33032",
    "data-name": "Path 33032",
    d: "M923.33,266.326l.068.138-.068-.138m.687-.068.138.068-.138-.068m4.6-.068.206.206Z",
    transform: "translate(-425.734 -211.297)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33033",
    "data-name": "Path 33033",
    d: "M950,266.18l.206.206Z",
    transform: "translate(-446.904 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33034",
    "data-name": "Path 33034",
    d: "M951.67,266.51l.138.068Z",
    transform: "translate(-448.23 -211.551)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33035",
    "data-name": "Path 33035",
    d: "M967,266.18l.206.206Z",
    transform: "translate(-460.398 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33036",
    "data-name": "Path 33036",
    d: "M968,266.18l.206.206L968,266.18m2.474,0,.206.206Z",
    transform: "translate(-461.192 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33037",
    "data-name": "Path 33037",
    d: "M981,266.18l.206.206Z",
    transform: "translate(-471.512 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33038",
    "data-name": "Path 33038",
    d: "M982,266.18l.619.619Z",
    transform: "translate(-472.305 -211.289)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33039",
    "data-name": "Path 33039",
    d: "M983,266.18l.206.206Z",
    transform: "translate(-473.099 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33040",
    "data-name": "Path 33040",
    d: "M986,266.18l.206.206Z",
    transform: "translate(-475.48 -211.289)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33041",
    "data-name": "Path 33041",
    d: "M987,266.18l.206.206L987,266.18m3.505,0,.206.206Z",
    transform: "translate(-476.274 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33042",
    "data-name": "Path 33042",
    d: "M1005,266.18l.206.206Z",
    transform: "translate(-490.563 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33043",
    "data-name": "Path 33043",
    d: "M1010,266.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-494.531 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33044",
    "data-name": "Path 33044",
    d: "M1025,266.18l.206.206Z",
    transform: "translate(-506.438 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33045",
    "data-name": "Path 33045",
    d: "M1035,266.18l.206.206Z",
    transform: "translate(-514.376 -211.289)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33046",
    "data-name": "Path 33046",
    d: "M1036,266.18l.206.206-.206-.206m4.537,0v.206h.619Z",
    transform: "translate(-515.17 -211.289)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33047",
    "data-name": "Path 33047",
    d: "M1061,266.18v.206h.619Z",
    transform: "translate(-535.015 -211.289)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33048",
    "data-name": "Path 33048",
    d: "M908.555,266.51l.136.068-.136-.068M868,266.648l.206.206Z",
    transform: "translate(-381.813 -211.551)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33049",
    "data-name": "Path 33049",
    d: "M869,267.18l.206.206L869,267.18m2.887,0,.206.206Z",
    transform: "translate(-382.607 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33050",
    "data-name": "Path 33050",
    d: "M884,267.18l.206.206Z",
    transform: "translate(-394.514 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33051",
    "data-name": "Path 33051",
    d: "M887,267.18l.206.206L887,267.18m.619,0,.206.206Z",
    transform: "translate(-396.895 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33052",
    "data-name": "Path 33052",
    d: "M915,267.18l.206.206Z",
    transform: "translate(-419.121 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33053",
    "data-name": "Path 33053",
    d: "M916,267.18l.206.206Z",
    transform: "translate(-419.915 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33054",
    "data-name": "Path 33054",
    d: "M924,267.18l.206.206L924,267.18m.825,0,.206.206Z",
    transform: "translate(-426.265 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33055",
    "data-name": "Path 33055",
    d: "M929.67,267.51l.138.068Z",
    transform: "translate(-430.766 -212.344)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33056",
    "data-name": "Path 33056",
    d: "M931,267.18l.206.206Z",
    transform: "translate(-431.822 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33057",
    "data-name": "Path 33057",
    d: "M932,267.18l.206.206Z",
    transform: "translate(-432.616 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33058",
    "data-name": "Path 33058",
    d: "M933.67,267.51l.138.068Z",
    transform: "translate(-433.941 -212.344)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33059",
    "data-name": "Path 33059",
    d: "M955,267.18l.206.206L955,267.18m3.3,0,.206.206Z",
    transform: "translate(-450.873 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33060",
    "data-name": "Path 33060",
    d: "M972,267.18l.206.206Z",
    transform: "translate(-464.367 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33061",
    "data-name": "Path 33061",
    d: "M984,267.18l.206.206Z",
    transform: "translate(-473.893 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33062",
    "data-name": "Path 33062",
    d: "M987,267.18l.206.206Z",
    transform: "translate(-476.274 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33063",
    "data-name": "Path 33063",
    d: "M991,267.18l.206.206Z",
    transform: "translate(-479.449 -212.083)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33064",
    "data-name": "Path 33064",
    d: "M1008,267.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-492.944 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33065",
    "data-name": "Path 33065",
    d: "M1012,267.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-496.119 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33066",
    "data-name": "Path 33066",
    d: "M1019,267.18l.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-501.676 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33067",
    "data-name": "Path 33067",
    d: "M1028,267.18l.206.206Z",
    transform: "translate(-508.82 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33068",
    "data-name": "Path 33068",
    d: "M1029,267.18l.206.206Z",
    transform: "translate(-509.613 -212.083)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33069",
    "data-name": "Path 33069",
    d: "M1030.33,267.85l.07.138Z",
    transform: "translate(-510.669 -212.614)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33070",
    "data-name": "Path 33070",
    d: "M1032,267.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-511.995 -212.083)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33071",
    "data-name": "Path 33071",
    d: "M900.88,267.18l.206.206-.206-.206m2.887,0v.206h.825l-.825-.206m2.681,0,.206.206-.206-.206M865,267.386l.206.206Z",
    transform: "translate(-379.432 -212.083)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33072",
    "data-name": "Path 33072",
    d: "M866,268.18l.206.206L866,268.18m10.723,0,.206.206Z",
    transform: "translate(-380.226 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33073",
    "data-name": "Path 33073",
    d: "M919,268.18l.206.206Z",
    transform: "translate(-422.297 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33074",
    "data-name": "Path 33074",
    d: "M926,268.18l.206.206Z",
    transform: "translate(-427.853 -212.876)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33075",
    "data-name": "Path 33075",
    d: "M930,268.18l.206.206Z",
    transform: "translate(-431.028 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33076",
    "data-name": "Path 33076",
    d: "M943,268.18v.206h.619Z",
    transform: "translate(-441.347 -212.876)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33077",
    "data-name": "Path 33077",
    d: "M946,268.18v.206h1.237L946,268.18m1.856,0,.206.206Z",
    transform: "translate(-443.729 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33078",
    "data-name": "Path 33078",
    d: "M975,268.18l.206.206Z",
    transform: "translate(-466.749 -212.876)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33079",
    "data-name": "Path 33079",
    d: "M976,268.18l.206.206L976,268.18m1.031,0,.206.206Z",
    transform: "translate(-467.543 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33080",
    "data-name": "Path 33080",
    d: "M982,268.18l.206.206Z",
    transform: "translate(-472.305 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33081",
    "data-name": "Path 33081",
    d: "M985,268.18v.412h.412Z",
    transform: "translate(-474.687 -212.876)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33082",
    "data-name": "Path 33082",
    d: "M988,268.18l.206.206L988,268.18m1.031,0,.206.206Z",
    transform: "translate(-477.068 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33083",
    "data-name": "Path 33083",
    d: "M994,268.18l.206.206Z",
    transform: "translate(-481.831 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33084",
    "data-name": "Path 33084",
    d: "M995,268.18l.206.206Z",
    transform: "translate(-482.625 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33085",
    "data-name": "Path 33085",
    d: "M996,268.18l.206.206Z",
    transform: "translate(-483.418 -212.876)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33086",
    "data-name": "Path 33086",
    d: "M1014,268.18l.206.206Z",
    transform: "translate(-497.707 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33087",
    "data-name": "Path 33087",
    d: "M1015.67,268.51l.136.068Z",
    transform: "translate(-499.032 -213.138)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33088",
    "data-name": "Path 33088",
    d: "M1021,268.18l.206.206Z",
    transform: "translate(-503.263 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33089",
    "data-name": "Path 33089",
    d: "M1022,268.18l.206.206Z",
    transform: "translate(-504.057 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33090",
    "data-name": "Path 33090",
    d: "M1041,268.18l.206.206Z",
    transform: "translate(-519.139 -212.876)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33091",
    "data-name": "Path 33091",
    d: "M898.324,268.18l.206.206-.206-.206m4.262.068.136.068-.136-.068M861,268.386l.206.206Z",
    transform: "translate(-376.257 -212.876)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33092",
    "data-name": "Path 33092",
    d: "M862,269.18l.206.206Z",
    transform: "translate(-377.05 -213.67)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33093",
    "data-name": "Path 33093",
    d: "M921,269.18l.206.206Z",
    transform: "translate(-423.884 -213.67)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33094",
    "data-name": "Path 33094",
    d: "M922,269.18l.206.206L922,269.18m1.237,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-424.678 -213.67)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33095",
    "data-name": "Path 33095",
    d: "M979,269.18l.206.206Z",
    transform: "translate(-469.924 -213.67)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33096",
    "data-name": "Path 33096",
    d: "M980,269.18l.206.206L980,269.18m.893.138.068.138Z",
    transform: "translate(-470.718 -213.67)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33097",
    "data-name": "Path 33097",
    d: "M997,269.18l.206.206Z",
    transform: "translate(-484.212 -213.67)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33098",
    "data-name": "Path 33098",
    d: "M1003.67,269.51l.136.068Z",
    transform: "translate(-489.507 -213.932)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33099",
    "data-name": "Path 33099",
    d: "M1027,269.18l.206.206Z",
    transform: "translate(-508.026 -213.67)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33100",
    "data-name": "Path 33100",
    d: "M1028,269.18l.206.206Z",
    transform: "translate(-508.82 -213.67)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33101",
    "data-name": "Path 33101",
    d: "M1045,269.18l.206.206Z",
    transform: "translate(-522.314 -213.67)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33102",
    "data-name": "Path 33102",
    d: "M1046,269.18l.206.206Z",
    transform: "translate(-523.108 -213.67)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33103",
    "data-name": "Path 33103",
    d: "M926,270.18l.206.206Z",
    transform: "translate(-427.853 -214.464)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33104",
    "data-name": "Path 33104",
    d: "M927,270.18l.206.206Z",
    transform: "translate(-428.647 -214.464)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33105",
    "data-name": "Path 33105",
    d: "M932.33,270.85l.068.138Z",
    transform: "translate(-432.878 -214.996)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33106",
    "data-name": "Path 33106",
    d: "M983,270.18l.206.206Z",
    transform: "translate(-473.099 -214.464)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33107",
    "data-name": "Path 33107",
    d: "M988,270.18l.206.206Z",
    transform: "translate(-477.068 -214.464)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33108",
    "data-name": "Path 33108",
    d: "M1000,270.18l.206.206Z",
    transform: "translate(-486.594 -214.464)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33109",
    "data-name": "Path 33109",
    d: "M1001,270.18l.206.206-.206-.206m.825,0,.619.412Z",
    transform: "translate(-487.387 -214.464)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33110",
    "data-name": "Path 33110",
    d: "M1007.67,270.51l.136.068Z",
    transform: "translate(-492.682 -214.726)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33111",
    "data-name": "Path 33111",
    d: "M1009,270.18l.206.206Z",
    transform: "translate(-493.738 -214.464)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33112",
    "data-name": "Path 33112",
    d: "M1010.67,270.51l.136.068Z",
    transform: "translate(-495.063 -214.726)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33113",
    "data-name": "Path 33113",
    d: "M1012,270.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-496.119 -214.464)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33114",
    "data-name": "Path 33114",
    d: "M1031,270.18l.206.206Z",
    transform: "translate(-511.201 -214.464)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33115",
    "data-name": "Path 33115",
    d: "M1049,270.18l.206.206Z",
    transform: "translate(-525.489 -214.464)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33116",
    "data-name": "Path 33116",
    d: "M1050,270.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-526.283 -214.464)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33117",
    "data-name": "Path 33117",
    d: "M1055.67,270.51l.136.068Z",
    transform: "translate(-530.784 -214.726)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33118",
    "data-name": "Path 33118",
    d: "M1057,270.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-531.84 -214.464)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33119",
    "data-name": "Path 33119",
    d: "M957.838,270.18v.206h.825l-.825-.206M930,270.386l.206.206Z",
    transform: "translate(-431.028 -214.464)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33120",
    "data-name": "Path 33120",
    d: "M931,271.18l.206.206Z",
    transform: "translate(-431.822 -215.258)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33121",
    "data-name": "Path 33121",
    d: "M1004.67,271.51l.136.068Z",
    transform: "translate(-490.3 -215.52)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33122",
    "data-name": "Path 33122",
    d: "M1013,271.18l.619.412Z",
    transform: "translate(-496.913 -215.258)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33123",
    "data-name": "Path 33123",
    d: "M1012.67,272.51l.136.068Z",
    transform: "translate(-496.651 -216.313)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33124",
    "data-name": "Path 33124",
    d: "M1018,272.18l.206.206Z",
    transform: "translate(-500.882 -216.051)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33125",
    "data-name": "Path 33125",
    d: "M928.206,280.18v.206l.619.206v.206H928V281l4.537,1.443-.619-.619v-.206l3.506.206-.206-.412h.206l2.887.619c.755-.493,1.609-.146,2.475-.159a13.5,13.5,0,0,1,6.392,1.19l-1.031-1.237,2.062.412-.412-.619,9.279.206-.825-.619V281l.825.206V281l-3.3-.412v.206l2.268.619v.206l-8.867-1.031v.206l1.443.412v.206l-2.681-.619V281l1.856.825v.206L944.7,280.8l.206.619-1.443-.619c-.612.942-2.107.445-3.093.326-2.66-.322-5.372-.113-8.042-.326V281l1.237.412v.206Z",
    transform: "translate(-429.441 -222.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33126",
    "data-name": "Path 33126",
    d: "M931,280.18l.206.206Z",
    transform: "translate(-431.822 -222.402)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33127",
    "data-name": "Path 33127",
    d: "M858,281.18l1.031.619V282L858,281.8V282l6.186,1.031v-.206h-.825v-.206l1.856.206v.206h-.825v.206l1.856-.619,1.65.619-.825-.619v-.206l5.774.619-2.062-1.443h1.443v-.206h-1.65l.206.825c-1.095-.019-4.706-1.34-4.949-.206l-1.65-.619.412.825-3.506-.043Z",
    transform: "translate(-373.875 -223.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33128",
    "data-name": "Path 33128",
    d: "M861,281.18l.206.206L861,281.18m7.217,0,.206.206Z",
    transform: "translate(-376.257 -223.196)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33129",
    "data-name": "Path 33129",
    d: "M897,281.18l.206.206Z",
    transform: "translate(-404.833 -223.196)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33130",
    "data-name": "Path 33130",
    d: "M898.67,281.248l.138.068-.138-.068m4.4-.068v.206H904.1l-1.031-.206m1.856,0-.206.412.206-.412m.825,0,.206.206Z",
    transform: "translate(-406.159 -223.196)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33131",
    "data-name": "Path 33131",
    d: "M1021.67,281.51l.136.068Z",
    transform: "translate(-503.795 -223.458)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33132",
    "data-name": "Path 33132",
    d: "M905.273,281.18v.619h.206l-.206-.619M863,281.386l.206.206Z",
    transform: "translate(-377.844 -223.196)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33133",
    "data-name": "Path 33133",
    d: "M864,282.18l.206.206Z",
    transform: "translate(-378.638 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33134",
    "data-name": "Path 33134",
    d: "M887,282.18l.206.206L887,282.18m.825,0,.206.206Z",
    transform: "translate(-396.895 -223.989)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33135",
    "data-name": "Path 33135",
    d: "M895,282.18v.619h.206Z",
    transform: "translate(-403.246 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33136",
    "data-name": "Path 33136",
    d: "M901,282.18l.206.206Z",
    transform: "translate(-408.008 -223.989)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33137",
    "data-name": "Path 33137",
    d: "M902,282.18l.206.206Z",
    transform: "translate(-408.802 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33138",
    "data-name": "Path 33138",
    d: "M927.33,282.85l.068.138Z",
    transform: "translate(-428.909 -224.521)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33139",
    "data-name": "Path 33139",
    d: "M929,282.18l.206.206Z",
    transform: "translate(-430.234 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33140",
    "data-name": "Path 33140",
    d: "M930,282.18l.206.206Z",
    transform: "translate(-431.028 -223.989)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33141",
    "data-name": "Path 33141",
    d: "M931,282.18l.206.206Z",
    transform: "translate(-431.822 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33142",
    "data-name": "Path 33142",
    d: "M935,282.18l.206.206Z",
    transform: "translate(-434.997 -223.989)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33143",
    "data-name": "Path 33143",
    d: "M936,282.18l.206.206L936,282.18m2.681,0,.206.206Z",
    transform: "translate(-435.791 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33144",
    "data-name": "Path 33144",
    d: "M950.67,282.51l.138.068Z",
    transform: "translate(-447.436 -224.251)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33145",
    "data-name": "Path 33145",
    d: "M1014.33,282.85l.07.138Z",
    transform: "translate(-497.969 -224.521)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33146",
    "data-name": "Path 33146",
    d: "M1015.67,282.248l.136.068-.136-.068m.893-.068.206.206Z",
    transform: "translate(-499.032 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33147",
    "data-name": "Path 33147",
    d: "M1025,282.18l.206.206Z",
    transform: "translate(-506.438 -223.989)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33148",
    "data-name": "Path 33148",
    d: "M1026,282.18l.206.206Z",
    transform: "translate(-507.232 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33149",
    "data-name": "Path 33149",
    d: "M1057,282.18l.206.206Z",
    transform: "translate(-531.84 -223.989)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33150",
    "data-name": "Path 33150",
    d: "M1058,282.18l.206.206Z",
    transform: "translate(-532.633 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33151",
    "data-name": "Path 33151",
    d: "M1063,282.18l.206.206Z",
    transform: "translate(-536.602 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33152",
    "data-name": "Path 33152",
    d: "M1064,282.18l.206.206Z",
    transform: "translate(-537.396 -223.989)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33153",
    "data-name": "Path 33153",
    d: "M900.685,282.18l.206.206-.206-.206M858,282.386l.206.206Z",
    transform: "translate(-373.875 -223.989)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33154",
    "data-name": "Path 33154",
    d: "M859,283.18l.206.206Z",
    transform: "translate(-374.669 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33155",
    "data-name": "Path 33155",
    d: "M860.33,283.85l.068.138Z",
    transform: "translate(-375.725 -225.315)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33156",
    "data-name": "Path 33156",
    d: "M866,283.18l.206.206Z",
    transform: "translate(-380.226 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33157",
    "data-name": "Path 33157",
    d: "M881,283.18l.206.206Z",
    transform: "translate(-392.132 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33158",
    "data-name": "Path 33158",
    d: "M882.67,283.248l.138.068-.138-.068m.687.138v.206l.825.206-.412-.619Z",
    transform: "translate(-393.458 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33159",
    "data-name": "Path 33159",
    d: "M890,283.18l.206.206L890,283.18m.619,0,.206.206Z",
    transform: "translate(-399.277 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33160",
    "data-name": "Path 33160",
    d: "M904,283.18l.206.206L904,283.18m3.3,0,.206.206Z",
    transform: "translate(-410.39 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33161",
    "data-name": "Path 33161",
    d: "M925,283.18l.206.206Z",
    transform: "translate(-427.059 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33162",
    "data-name": "Path 33162",
    d: "M926,283.18l.206.206Z",
    transform: "translate(-427.853 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33163",
    "data-name": "Path 33163",
    d: "M932.67,283.51l.138.068Z",
    transform: "translate(-433.148 -225.045)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33164",
    "data-name": "Path 33164",
    d: "M938,283.18l.206.206Z",
    transform: "translate(-437.379 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33165",
    "data-name": "Path 33165",
    d: "M953,283.18l.206.206Z",
    transform: "translate(-449.285 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33166",
    "data-name": "Path 33166",
    d: "M954,283.18v.206h.619L954,283.18m2.2.068.138.068Z",
    transform: "translate(-450.079 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33167",
    "data-name": "Path 33167",
    d: "M970,283.18l.206.206L970,283.18m.412,0,.206.206Z",
    transform: "translate(-462.78 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33168",
    "data-name": "Path 33168",
    d: "M973,283.18l.206.206Z",
    transform: "translate(-465.161 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33169",
    "data-name": "Path 33169",
    d: "M974,283.18l.206.206L974,283.18m1.443,0,.206.206Z",
    transform: "translate(-465.955 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33170",
    "data-name": "Path 33170",
    d: "M982,283.18v.206h.619Z",
    transform: "translate(-472.305 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33171",
    "data-name": "Path 33171",
    d: "M985,283.18l.206.206L985,283.18m3.506,0,.206.206Z",
    transform: "translate(-474.687 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33172",
    "data-name": "Path 33172",
    d: "M1004,283.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-489.769 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33173",
    "data-name": "Path 33173",
    d: "M1019,283.18l.206.206Z",
    transform: "translate(-501.676 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33174",
    "data-name": "Path 33174",
    d: "M1020,283.18l.206.206Z",
    transform: "translate(-502.469 -224.783)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33175",
    "data-name": "Path 33175",
    d: "M1021,283.18l.206.206Z",
    transform: "translate(-503.263 -224.783)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33176",
    "data-name": "Path 33176",
    d: "M1022,283.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-504.057 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33177",
    "data-name": "Path 33177",
    d: "M1030,283.18l.206.206Z",
    transform: "translate(-510.407 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33178",
    "data-name": "Path 33178",
    d: "M1053,283.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-528.664 -224.783)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33179",
    "data-name": "Path 33179",
    d: "M1061,283.18l.206.206Z",
    transform: "translate(-535.015 -224.783)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33180",
    "data-name": "Path 33180",
    d: "M861.67,284.51l.138.068Z",
    transform: "translate(-376.788 -225.839)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33181",
    "data-name": "Path 33181",
    d: "M868,284.18l.206.206Z",
    transform: "translate(-381.813 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33182",
    "data-name": "Path 33182",
    d: "M869,284.18l.206.206Z",
    transform: "translate(-382.607 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33183",
    "data-name": "Path 33183",
    d: "M887,284.18l.206.206Z",
    transform: "translate(-396.895 -225.577)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33184",
    "data-name": "Path 33184",
    d: "M891,284.18l.206.206Z",
    transform: "translate(-400.07 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33185",
    "data-name": "Path 33185",
    d: "M892.33,284.588l.068.138-.068-.138m2.955-.068.138.068Z",
    transform: "translate(-401.126 -225.847)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33186",
    "data-name": "Path 33186",
    d: "M908,284.18l.206.206Z",
    transform: "translate(-413.565 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33187",
    "data-name": "Path 33187",
    d: "M920,284.18l.206.206L920,284.18m1.856,0,.412.412-.412-.412m2.887,0,.206.206Z",
    transform: "translate(-423.09 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33188",
    "data-name": "Path 33188",
    d: "M944,284.18l.206.206Z",
    transform: "translate(-442.141 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33189",
    "data-name": "Path 33189",
    d: "M949,284.18l.206.206Z",
    transform: "translate(-446.11 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33190",
    "data-name": "Path 33190",
    d: "M950,284.18l.206.206L950,284.18m1.65,0,.206.206Z",
    transform: "translate(-446.904 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33191",
    "data-name": "Path 33191",
    d: "M959.67,284.51l.138.068Z",
    transform: "translate(-454.58 -225.839)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33192",
    "data-name": "Path 33192",
    d: "M977,284.18l.206.206Z",
    transform: "translate(-468.336 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33193",
    "data-name": "Path 33193",
    d: "M978,284.18l.206.206Z",
    transform: "translate(-469.13 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33194",
    "data-name": "Path 33194",
    d: "M979,284.18l.206.206Z",
    transform: "translate(-469.924 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33195",
    "data-name": "Path 33195",
    d: "M981,284.18l.206.206Z",
    transform: "translate(-471.512 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33196",
    "data-name": "Path 33196",
    d: "M987,284.18l.206.206Z",
    transform: "translate(-476.274 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33197",
    "data-name": "Path 33197",
    d: "M988,284.18l.206.206Z",
    transform: "translate(-477.068 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33198",
    "data-name": "Path 33198",
    d: "M989.67,284.51l.138.068Z",
    transform: "translate(-478.394 -225.839)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33199",
    "data-name": "Path 33199",
    d: "M991,284.18l.206.206Z",
    transform: "translate(-479.449 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33200",
    "data-name": "Path 33200",
    d: "M992,284.18l.206.206Z",
    transform: "translate(-480.243 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33201",
    "data-name": "Path 33201",
    d: "M1002,284.18l.206.206Z",
    transform: "translate(-488.181 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33202",
    "data-name": "Path 33202",
    d: "M1006,284.18l.206.206Z",
    transform: "translate(-491.356 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33203",
    "data-name": "Path 33203",
    d: "M1013,284.18l.206.206Z",
    transform: "translate(-496.913 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33204",
    "data-name": "Path 33204",
    d: "M1014,284.18v.206l.825.206v-.206Z",
    transform: "translate(-497.707 -225.577)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33205",
    "data-name": "Path 33205",
    d: "M1016,284.18l.206.206Z",
    transform: "translate(-499.294 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33206",
    "data-name": "Path 33206",
    d: "M1021,284.18l.206.206Z",
    transform: "translate(-503.263 -225.577)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33207",
    "data-name": "Path 33207",
    d: "M1022.67,284.51l.136.068Z",
    transform: "translate(-504.589 -225.839)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33208",
    "data-name": "Path 33208",
    d: "M1024,284.18l.206.206Z",
    transform: "translate(-505.645 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33209",
    "data-name": "Path 33209",
    d: "M1024.206,284.18l-.206.412.206-.412m1.788.068.136.068Z",
    transform: "translate(-505.645 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33210",
    "data-name": "Path 33210",
    d: "M1035.67,284.51l.136.068Z",
    transform: "translate(-514.908 -225.839)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33211",
    "data-name": "Path 33211",
    d: "M1037,284.18l.206.206-.206-.206m3.505,0,.206.206Z",
    transform: "translate(-515.964 -225.577)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33212",
    "data-name": "Path 33212",
    d: "M1055,284.18l.206.206-.206-.206m2.062,0,.206.412h.206l.206-.412Z",
    transform: "translate(-530.252 -225.577)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33213",
    "data-name": "Path 33213",
    d: "M858,285.18l.206.206Z",
    transform: "translate(-373.875 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33214",
    "data-name": "Path 33214",
    d: "M858.206,285.18l-.206.412.206-.412m2.268,0,.206.206Z",
    transform: "translate(-373.875 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33215",
    "data-name": "Path 33215",
    d: "M871,285.18l.206.206Z",
    transform: "translate(-384.195 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33216",
    "data-name": "Path 33216",
    d: "M883,285.18l.206.206Z",
    transform: "translate(-393.72 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33217",
    "data-name": "Path 33217",
    d: "M884,285.18l.206.206Z",
    transform: "translate(-394.514 -226.371)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33218",
    "data-name": "Path 33218",
    d: "M888,285.18l.206.206Z",
    transform: "translate(-397.689 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33219",
    "data-name": "Path 33219",
    d: "M893,285.18l.206.206Z",
    transform: "translate(-401.658 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33220",
    "data-name": "Path 33220",
    d: "M894.33,285.318l.068.138-.068-.138m.344-.138v.619h.206l-.206-.619m.619,0,.206.206Z",
    transform: "translate(-402.714 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33221",
    "data-name": "Path 33221",
    d: "M900,285.18l.206.206Z",
    transform: "translate(-407.215 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33222",
    "data-name": "Path 33222",
    d: "M901,285.18l.206.206L901,285.18m2.819.068.138.068Z",
    transform: "translate(-408.008 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33223",
    "data-name": "Path 33223",
    d: "M916.67,285.51l.138.068Z",
    transform: "translate(-420.447 -226.633)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33224",
    "data-name": "Path 33224",
    d: "M918,285.18l.206.206Z",
    transform: "translate(-421.503 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33225",
    "data-name": "Path 33225",
    d: "M919,285.18l.206.206L919,285.18m.619,0,.206.206Z",
    transform: "translate(-422.297 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33226",
    "data-name": "Path 33226",
    d: "M923,285.18l.206.206L923,285.18m1.237,0,.206.206Z",
    transform: "translate(-425.472 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33227",
    "data-name": "Path 33227",
    d: "M947,285.18l.206.206Z",
    transform: "translate(-444.523 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33228",
    "data-name": "Path 33228",
    d: "M948,285.18l.206.206Z",
    transform: "translate(-445.316 -226.371)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33229",
    "data-name": "Path 33229",
    d: "M949.67,285.51l.138.068Z",
    transform: "translate(-446.642 -226.633)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33230",
    "data-name": "Path 33230",
    d: "M951,285.18l.206.206Z",
    transform: "translate(-447.698 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33231",
    "data-name": "Path 33231",
    d: "M951.206,285.18l-.206.412.206-.412m6.324.068.138.068-.138-.068m2.887,0,.138.068Z",
    transform: "translate(-447.698 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33232",
    "data-name": "Path 33232",
    d: "M998.67,285.51l.138.068Z",
    transform: "translate(-485.538 -226.633)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33233",
    "data-name": "Path 33233",
    d: "M1000,285.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-486.594 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33234",
    "data-name": "Path 33234",
    d: "M1008.67,285.51l.136.068Z",
    transform: "translate(-493.476 -226.633)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33235",
    "data-name": "Path 33235",
    d: "M1015,285.18l.206.206-.206-.206m.619,0-.206.412Z",
    transform: "translate(-498.5 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33236",
    "data-name": "Path 33236",
    d: "M1025,285.18l.206.206Z",
    transform: "translate(-506.438 -226.371)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33237",
    "data-name": "Path 33237",
    d: "M1026,285.18l.206.206Z",
    transform: "translate(-507.232 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33238",
    "data-name": "Path 33238",
    d: "M1027,285.18l.206.206-.206-.206m3.3,0,.206.206Z",
    transform: "translate(-508.026 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33239",
    "data-name": "Path 33239",
    d: "M1044,285.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-521.52 -226.371)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33240",
    "data-name": "Path 33240",
    d: "M1051,285.18l.206.206Z",
    transform: "translate(-527.077 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33241",
    "data-name": "Path 33241",
    d: "M1052,285.18l.206.206Z",
    transform: "translate(-527.871 -226.371)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33242",
    "data-name": "Path 33242",
    d: "M1059,285.18l.206.206Z",
    transform: "translate(-533.427 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33243",
    "data-name": "Path 33243",
    d: "M1060,285.18l.206.206Z",
    transform: "translate(-534.221 -226.371)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33244",
    "data-name": "Path 33244",
    d: "M1067,285.18l.206.206Z",
    transform: "translate(-539.778 -226.371)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33245",
    "data-name": "Path 33245",
    d: "M778.67,286.51l.138.068-.138-.068m16.7,0,.138.068Z",
    transform: "translate(-310.904 -227.427)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33246",
    "data-name": "Path 33246",
    d: "M861.33,286.85l.068.138Z",
    transform: "translate(-376.519 -227.696)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33247",
    "data-name": "Path 33247",
    d: "M862,286.18l.206.206L862,286.18m4.949,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-377.05 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33248",
    "data-name": "Path 33248",
    d: "M895,286.18l.206.206Z",
    transform: "translate(-403.246 -227.165)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33249",
    "data-name": "Path 33249",
    d: "M925,286.18l.206.206Z",
    transform: "translate(-427.059 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33250",
    "data-name": "Path 33250",
    d: "M926,286.18l.206.206Z",
    transform: "translate(-427.853 -227.165)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33251",
    "data-name": "Path 33251",
    d: "M932,286.18l.206.206Z",
    transform: "translate(-432.616 -227.165)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33252",
    "data-name": "Path 33252",
    d: "M933,286.18l.206.206L933,286.18m2.268,0v.206h.619Z",
    transform: "translate(-433.41 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33253",
    "data-name": "Path 33253",
    d: "M952,286.18l.206.206Z",
    transform: "translate(-448.492 -227.165)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33254",
    "data-name": "Path 33254",
    d: "M953,286.18l.206.206Z",
    transform: "translate(-449.285 -227.165)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33255",
    "data-name": "Path 33255",
    d: "M954,286.18l.206.206L954,286.18m1.994.068.138.068-.138-.068m2.268,0,.138.068Z",
    transform: "translate(-450.079 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33256",
    "data-name": "Path 33256",
    d: "M976,286.18l.206.206Z",
    transform: "translate(-467.543 -227.165)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33257",
    "data-name": "Path 33257",
    d: "M977,286.18l.206.206Z",
    transform: "translate(-468.336 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33258",
    "data-name": "Path 33258",
    d: "M1018,286.18l.206.206Z",
    transform: "translate(-500.882 -227.165)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33259",
    "data-name": "Path 33259",
    d: "M1019,286.18l.206.206Z",
    transform: "translate(-501.676 -227.165)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33260",
    "data-name": "Path 33260",
    d: "M1020,286.18l.206.206-.206-.206m7.768.068.136.068Z",
    transform: "translate(-502.469 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33261",
    "data-name": "Path 33261",
    d: "M1059,286.18l.206.206Z",
    transform: "translate(-533.427 -227.165)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33262",
    "data-name": "Path 33262",
    d: "M1060.67,286.51l.136.068Z",
    transform: "translate(-534.753 -227.427)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33263",
    "data-name": "Path 33263",
    d: "M1062,286.18l.206.206Z",
    transform: "translate(-535.809 -227.165)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33264",
    "data-name": "Path 33264",
    d: "M1063,286.18l.206.206Z",
    transform: "translate(-536.602 -227.165)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33265",
    "data-name": "Path 33265",
    d: "M1140.67,286.51l.136.068Z",
    transform: "translate(-598.256 -227.427)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33266",
    "data-name": "Path 33266",
    d: "M858,287.18l1.031.619v-.206Z",
    transform: "translate(-373.875 -227.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33267",
    "data-name": "Path 33267",
    d: "M860,287.18l.206.206Z",
    transform: "translate(-375.463 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33268",
    "data-name": "Path 33268",
    d: "M865,287.18l.206.206Z",
    transform: "translate(-379.432 -227.958)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33269",
    "data-name": "Path 33269",
    d: "M890,287.18l.206.206L890,287.18m.619,0,.206.206Z",
    transform: "translate(-399.277 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33270",
    "data-name": "Path 33270",
    d: "M897,287.18l.206.206Z",
    transform: "translate(-404.833 -227.958)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33271",
    "data-name": "Path 33271",
    d: "M902,287.18l.206.206Z",
    transform: "translate(-408.802 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33272",
    "data-name": "Path 33272",
    d: "M903,287.18l.206.206Z",
    transform: "translate(-409.596 -227.958)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33273",
    "data-name": "Path 33273",
    d: "M909.67,287.51l.138.068Z",
    transform: "translate(-414.89 -228.22)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33274",
    "data-name": "Path 33274",
    d: "M911,287.18l.206.206L911,287.18m3.712,0,.206.206Z",
    transform: "translate(-415.946 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33275",
    "data-name": "Path 33275",
    d: "M936,287.18l.206.206Z",
    transform: "translate(-435.791 -227.958)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33276",
    "data-name": "Path 33276",
    d: "M937,287.18l.206.206L937,287.18m2.062,0,.206.206Z",
    transform: "translate(-436.585 -227.958)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33277",
    "data-name": "Path 33277",
    d: "M948,287.18l.206.206Z",
    transform: "translate(-445.316 -227.958)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33278",
    "data-name": "Path 33278",
    d: "M949.33,287.85l.068.138Z",
    transform: "translate(-446.372 -228.49)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33279",
    "data-name": "Path 33279",
    d: "M950,287.18l.206.206Z",
    transform: "translate(-446.904 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33280",
    "data-name": "Path 33280",
    d: "M957.67,287.51l.138.068Z",
    transform: "translate(-452.992 -228.22)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33281",
    "data-name": "Path 33281",
    d: "M961,287.18l.206.206Z",
    transform: "translate(-455.636 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33282",
    "data-name": "Path 33282",
    d: "M968.67,287.51l.138.068Z",
    transform: "translate(-461.724 -228.22)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33283",
    "data-name": "Path 33283",
    d: "M970,287.18l.206.206Z",
    transform: "translate(-462.78 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33284",
    "data-name": "Path 33284",
    d: "M980,287.18l.206.206Z",
    transform: "translate(-470.718 -227.958)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33285",
    "data-name": "Path 33285",
    d: "M981,287.18l.206.206L981,287.18m.757.068.138.068-.138-.068m4.6-.068.206.206Z",
    transform: "translate(-471.512 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33286",
    "data-name": "Path 33286",
    d: "M1020.67,287.51l.136.068Z",
    transform: "translate(-503.001 -228.22)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33287",
    "data-name": "Path 33287",
    d: "M1022,287.18l.412.412-.412-.412m.412,0,.206.206Z",
    transform: "translate(-504.057 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33288",
    "data-name": "Path 33288",
    d: "M1025,287.18l.206.206Z",
    transform: "translate(-506.438 -227.958)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33289",
    "data-name": "Path 33289",
    d: "M1026,287.18l.206.206Z",
    transform: "translate(-507.232 -227.958)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33290",
    "data-name": "Path 33290",
    d: "M896.025,287.18l.206.206-.206-.206M862,287.386l.206.206-.206-.206m1.856,0v.206h.619l-.619-.206m2.681,0,.206.206Z",
    transform: "translate(-377.05 -227.958)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33291",
    "data-name": "Path 33291",
    d: "M885,288.18l.206.206Z",
    transform: "translate(-395.308 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33292",
    "data-name": "Path 33292",
    d: "M886,288.18l.206.206Z",
    transform: "translate(-396.101 -228.752)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33293",
    "data-name": "Path 33293",
    d: "M887,288.18l.206.206Z",
    transform: "translate(-396.895 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33294",
    "data-name": "Path 33294",
    d: "M888,288.18v.619h.206L888,288.18m1.443,0,.206.206Z",
    transform: "translate(-397.689 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33295",
    "data-name": "Path 33295",
    d: "M898,288.18l.206.206Z",
    transform: "translate(-405.627 -228.752)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33296",
    "data-name": "Path 33296",
    d: "M899,288.18l.206.206Z",
    transform: "translate(-406.421 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33297",
    "data-name": "Path 33297",
    d: "M904,288.18l.206.206Z",
    transform: "translate(-410.39 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33298",
    "data-name": "Path 33298",
    d: "M913,288.18v.206h.619Z",
    transform: "translate(-417.534 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33299",
    "data-name": "Path 33299",
    d: "M916,288.18v.206h.619Z",
    transform: "translate(-419.915 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33300",
    "data-name": "Path 33300",
    d: "M930.33,288.85l.068.138Z",
    transform: "translate(-431.29 -229.284)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33301",
    "data-name": "Path 33301",
    d: "M940,288.18l.206.206Z",
    transform: "translate(-438.966 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33302",
    "data-name": "Path 33302",
    d: "M941,288.18l.206.206Z",
    transform: "translate(-439.76 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33303",
    "data-name": "Path 33303",
    d: "M954,288.18v.206h.619Z",
    transform: "translate(-450.079 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33304",
    "data-name": "Path 33304",
    d: "M973,288.18l.206.206Z",
    transform: "translate(-465.161 -228.752)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33305",
    "data-name": "Path 33305",
    d: "M974,288.18l.206.206Z",
    transform: "translate(-465.955 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33306",
    "data-name": "Path 33306",
    d: "M975,288.18l.206.206Z",
    transform: "translate(-466.749 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33307",
    "data-name": "Path 33307",
    d: "M978,288.18l.206.206Z",
    transform: "translate(-469.13 -228.752)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33308",
    "data-name": "Path 33308",
    d: "M987,288.18l.206.206Z",
    transform: "translate(-476.274 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33309",
    "data-name": "Path 33309",
    d: "M989.67,288.51l.138.068Z",
    transform: "translate(-478.394 -229.014)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33310",
    "data-name": "Path 33310",
    d: "M991,288.18l.206.206Z",
    transform: "translate(-479.449 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33311",
    "data-name": "Path 33311",
    d: "M992,288.18l.206.206Z",
    transform: "translate(-480.243 -228.752)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33312",
    "data-name": "Path 33312",
    d: "M995,288.18v.206h1.031L995,288.18m3.093,0,.206.206-.206-.206m1.237,0,.412.412v-.412Z",
    transform: "translate(-482.625 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33313",
    "data-name": "Path 33313",
    d: "M1018,288.18l.206.206Z",
    transform: "translate(-500.882 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33314",
    "data-name": "Path 33314",
    d: "M1022,288.18l.206.206Z",
    transform: "translate(-504.057 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33315",
    "data-name": "Path 33315",
    d: "M1025,288.18l.206.206Z",
    transform: "translate(-506.438 -228.752)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33316",
    "data-name": "Path 33316",
    d: "M1040,288.18l.206.206Z",
    transform: "translate(-518.345 -228.752)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33317",
    "data-name": "Path 33317",
    d: "M1041,288.18l.206.206-.206-.206m4.33,0,.206.206Z",
    transform: "translate(-519.139 -228.752)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33318",
    "data-name": "Path 33318",
    d: "M1063.67,288.51l.136.068Z",
    transform: "translate(-537.134 -229.014)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33319",
    "data-name": "Path 33319",
    d: "M1065.67,288.51l.136.068Z",
    transform: "translate(-538.722 -229.014)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33320",
    "data-name": "Path 33320",
    d: "M1067.67,288.51l.136.068Z",
    transform: "translate(-540.309 -229.014)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33321",
    "data-name": "Path 33321",
    d: "M859,289.18l.206.206Z",
    transform: "translate(-374.669 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33322",
    "data-name": "Path 33322",
    d: "M860,289.18l.206.206L860,289.18m.619,0-.206.412Z",
    transform: "translate(-375.463 -229.546)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33323",
    "data-name": "Path 33323",
    d: "M875,289.18l.206.206Z",
    transform: "translate(-387.37 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33324",
    "data-name": "Path 33324",
    d: "M876,289.18l.206.206Z",
    transform: "translate(-388.164 -229.546)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33325",
    "data-name": "Path 33325",
    d: "M881,289.18l.206.206Z",
    transform: "translate(-392.132 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33326",
    "data-name": "Path 33326",
    d: "M882,289.18l.206.206Z",
    transform: "translate(-392.926 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33327",
    "data-name": "Path 33327",
    d: "M883,289.18l.206.206Z",
    transform: "translate(-393.72 -229.546)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33328",
    "data-name": "Path 33328",
    d: "M889,289.18l.206.206Z",
    transform: "translate(-398.483 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33329",
    "data-name": "Path 33329",
    d: "M890,289.18l.206.206Z",
    transform: "translate(-399.277 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33330",
    "data-name": "Path 33330",
    d: "M891,289.18l.206.206Z",
    transform: "translate(-400.07 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33331",
    "data-name": "Path 33331",
    d: "M892,289.18l.206.206L892,289.18m1.237,0,.206.206Z",
    transform: "translate(-400.864 -229.546)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33332",
    "data-name": "Path 33332",
    d: "M901,289.18l.206.206Z",
    transform: "translate(-408.008 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33333",
    "data-name": "Path 33333",
    d: "M906,289.18l.206.206L906,289.18m3.3,0,.206.206Z",
    transform: "translate(-411.977 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33334",
    "data-name": "Path 33334",
    d: "M923,289.18l.206.206Z",
    transform: "translate(-425.472 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33335",
    "data-name": "Path 33335",
    d: "M924.67,289.51l.138.068Z",
    transform: "translate(-426.797 -229.808)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33336",
    "data-name": "Path 33336",
    d: "M943,289.18l.206.206L943,289.18m1.512.138.068.138Z",
    transform: "translate(-441.347 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33337",
    "data-name": "Path 33337",
    d: "M1011,289.18l.206.206-.206-.206m1.856,0,.206.206-.206-.206m5.155,0,.206.206Z",
    transform: "translate(-495.325 -229.546)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33338",
    "data-name": "Path 33338",
    d: "M1046,289.18l.206.206Z",
    transform: "translate(-523.108 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33339",
    "data-name": "Path 33339",
    d: "M1047,289.18v.206h.619l-.619-.206m2.406.068.136.068Z",
    transform: "translate(-523.902 -229.546)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33340",
    "data-name": "Path 33340",
    d: "M903.623,289.18l.206.206-.206-.206M863,289.386l.206.206-.206-.206m3.093,0,.206.206Z",
    transform: "translate(-377.844 -229.546)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33341",
    "data-name": "Path 33341",
    d: "M879,290.18l.206.206L879,290.18m1.443,0,.206.206Z",
    transform: "translate(-390.545 -230.34)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33342",
    "data-name": "Path 33342",
    d: "M887,290.18l.206.206Z",
    transform: "translate(-396.895 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33343",
    "data-name": "Path 33343",
    d: "M895,290.18l.206.206Z",
    transform: "translate(-403.246 -230.34)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33344",
    "data-name": "Path 33344",
    d: "M896,290.18l.206.206Z",
    transform: "translate(-404.039 -230.34)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33345",
    "data-name": "Path 33345",
    d: "M897,290.18l.206.206Z",
    transform: "translate(-404.833 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33346",
    "data-name": "Path 33346",
    d: "M898,290.18l.206.206Z",
    transform: "translate(-405.627 -230.34)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33347",
    "data-name": "Path 33347",
    d: "M903,290.18l.206.206Z",
    transform: "translate(-409.596 -230.34)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33348",
    "data-name": "Path 33348",
    d: "M905.206,290.18l-.206.412.206-.412m8.248,0,.206.206Z",
    transform: "translate(-411.183 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33349",
    "data-name": "Path 33349",
    d: "M947,290.18l.206.206Z",
    transform: "translate(-444.523 -230.34)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33350",
    "data-name": "Path 33350",
    d: "M1013,290.18l.206.206Z",
    transform: "translate(-496.913 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33351",
    "data-name": "Path 33351",
    d: "M1018,290.18l.206.206Z",
    transform: "translate(-500.882 -230.34)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33352",
    "data-name": "Path 33352",
    d: "M1022,290.18l.206.206Z",
    transform: "translate(-504.057 -230.34)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33353",
    "data-name": "Path 33353",
    d: "M1023,290.18l.206.206Z",
    transform: "translate(-504.851 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33354",
    "data-name": "Path 33354",
    d: "M1024,290.18l.206.206Z",
    transform: "translate(-505.645 -230.34)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33355",
    "data-name": "Path 33355",
    d: "M1025,290.18l.206.206-.206-.206m5.912.068.136.068Z",
    transform: "translate(-506.438 -230.34)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33356",
    "data-name": "Path 33356",
    d: "M1055.67,290.51l.136.068Z",
    transform: "translate(-530.784 -230.602)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33357",
    "data-name": "Path 33357",
    d: "M926.818,290.18l.206.206-.206-.206M893,290.386l.206.206Z",
    transform: "translate(-401.658 -230.34)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33358",
    "data-name": "Path 33358",
    d: "M894,291.18l.206.206Z",
    transform: "translate(-402.452 -231.133)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33359",
    "data-name": "Path 33359",
    d: "M906,291.18l.206.206Z",
    transform: "translate(-411.977 -231.133)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33360",
    "data-name": "Path 33360",
    d: "M1015,291.18l.206.206Z",
    transform: "translate(-498.5 -231.133)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33361",
    "data-name": "Path 33361",
    d: "M1016.825,291.18l.206.206-.206-.206m-.825.206.206.206Z",
    transform: "translate(-499.294 -231.133)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33362",
    "data-name": "Path 33362",
    d: "M1017,292.18l.206.206Z",
    transform: "translate(-500.088 -231.927)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33363",
    "data-name": "Path 33363",
    d: "M1018,293.18l.206.206Z",
    transform: "translate(-500.882 -232.721)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33364",
    "data-name": "Path 33364",
    d: "M1019,293.18l.206.206Z",
    transform: "translate(-501.676 -232.721)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33365",
    "data-name": "Path 33365",
    d: "M912,299.18l.206.206Z",
    transform: "translate(-416.74 -237.484)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33366",
    "data-name": "Path 33366",
    d: "M903.268,299.947v.206l.825.412v.206L901,300.359l.619,1.237,1.237.206-.825-1.443,7.63,1.443v-.619l.619.206-.825-1.031,5.774,1.443V301.6l-1.031-.206v-.206l3.918.825-.206-.619,4.949.619,2.062-.619v-.206l-1.443-.206v-.206l2.062.412v-.619h.206c1.664,1.485,4.743.808,6.8,1.443l.412-.825,1.65.412v-.825l.619.206-.206.619.619-1.031-1.443-.206.206,1.031-6.186-.45-3.712-.994.412.619c-1.784-.74-2.159-.266-3.918,0l.412.619-5.361-.619-1.65.274-6.186-.893,1.237,1.65C907.836,300.943,904.965,299.584,903.268,299.947Z",
    transform: "translate(-408.008 -238.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33367",
    "data-name": "Path 33367",
    d: "M916.67,299.51l.138.068Z",
    transform: "translate(-420.447 -237.746)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33368",
    "data-name": "Path 33368",
    d: "M918,299.18l.206.206Z",
    transform: "translate(-421.503 -237.484)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33369",
    "data-name": "Path 33369",
    d: "M937,299.18l.206.206Z",
    transform: "translate(-436.585 -237.484)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33370",
    "data-name": "Path 33370",
    d: "M1005,299.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-490.563 -237.484)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33371",
    "data-name": "Path 33371",
    d: "M1010,299.18l.206.206Z",
    transform: "translate(-494.531 -237.484)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33372",
    "data-name": "Path 33372",
    d: "M1014,299.18l.206.206Z",
    transform: "translate(-497.707 -237.484)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33373",
    "data-name": "Path 33373",
    d: "M1015,299.18l.206.206Z",
    transform: "translate(-498.5 -237.484)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33374",
    "data-name": "Path 33374",
    d: "M1016,299.18l.206.206Z",
    transform: "translate(-499.294 -237.484)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33375",
    "data-name": "Path 33375",
    d: "M873.67,300.51l.138.068Z",
    transform: "translate(-386.314 -238.54)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33376",
    "data-name": "Path 33376",
    d: "M920,300.18l.206.206Z",
    transform: "translate(-423.09 -238.278)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33377",
    "data-name": "Path 33377",
    d: "M921,300.18l.206.206Z",
    transform: "translate(-423.884 -238.278)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33378",
    "data-name": "Path 33378",
    d: "M939,300.18l.206.206Z",
    transform: "translate(-438.172 -238.278)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33379",
    "data-name": "Path 33379",
    d: "M940.67,300.51l.138.068Z",
    transform: "translate(-439.498 -238.54)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33380",
    "data-name": "Path 33380",
    d: "M942,300.18l.206.206Z",
    transform: "translate(-440.554 -238.278)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33381",
    "data-name": "Path 33381",
    d: "M1004,300.18l.206.206Z",
    transform: "translate(-489.769 -238.278)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33382",
    "data-name": "Path 33382",
    d: "M1007.67,300.248l.136.068-.136-.068m.687-.068.206.206Z",
    transform: "translate(-492.682 -238.278)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33383",
    "data-name": "Path 33383",
    d: "M1012,300.18l.206.206Z",
    transform: "translate(-496.119 -238.278)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33384",
    "data-name": "Path 33384",
    d: "M1013,300.386v.206l.825.206-.412-.619Z",
    transform: "translate(-496.913 -238.278)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33385",
    "data-name": "Path 33385",
    d: "M1018,300.18l.206.206Z",
    transform: "translate(-500.882 -238.278)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33386",
    "data-name": "Path 33386",
    d: "M861.093,301.18v.206l.619.206v.206l-2.268-.206.412.619L858,301.8c.456,1.557,2.45.305,3.518.334.726.021,1.536.738,2.05.078l3.506.206v-.206Z",
    transform: "translate(-373.875 -239.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33387",
    "data-name": "Path 33387",
    d: "M875,301.18l.206.206Z",
    transform: "translate(-387.37 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33388",
    "data-name": "Path 33388",
    d: "M900,301.18l.206.206Z",
    transform: "translate(-407.215 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33389",
    "data-name": "Path 33389",
    d: "M901,301.18l.206.206Z",
    transform: "translate(-408.008 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33390",
    "data-name": "Path 33390",
    d: "M902.67,301.51l.138.068Z",
    transform: "translate(-409.334 -239.333)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33391",
    "data-name": "Path 33391",
    d: "M908,301.18l.206.206Z",
    transform: "translate(-413.565 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33392",
    "data-name": "Path 33392",
    d: "M909,301.18l.206.206Z",
    transform: "translate(-414.359 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33393",
    "data-name": "Path 33393",
    d: "M912.33,301.85l.068.138Z",
    transform: "translate(-417.002 -239.603)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33394",
    "data-name": "Path 33394",
    d: "M915,301.18l.206.206Z",
    transform: "translate(-419.121 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33395",
    "data-name": "Path 33395",
    d: "M916,301.18l.619.412v-.206Z",
    transform: "translate(-419.915 -239.071)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33396",
    "data-name": "Path 33396",
    d: "M917,301.18l.206.206Z",
    transform: "translate(-420.709 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33397",
    "data-name": "Path 33397",
    d: "M922,301.18l.206.206L922,301.18m3.367.138.068.138-.068-.138m1.169-.138.206.206Z",
    transform: "translate(-424.678 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33398",
    "data-name": "Path 33398",
    d: "M1001.206,301.18l-.206.412Z",
    transform: "translate(-487.387 -239.071)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33399",
    "data-name": "Path 33399",
    d: "M1003,301.18l.206.206Z",
    transform: "translate(-488.975 -239.071)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33400",
    "data-name": "Path 33400",
    d: "M1006,301.18l.206.206Z",
    transform: "translate(-491.356 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33401",
    "data-name": "Path 33401",
    d: "M1007,301.18v.206h.619Z",
    transform: "translate(-492.15 -239.071)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33402",
    "data-name": "Path 33402",
    d: "M1010,301.18l.206.206Z",
    transform: "translate(-494.531 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33403",
    "data-name": "Path 33403",
    d: "M1014,301.18l.206.206Z",
    transform: "translate(-497.707 -239.071)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33404",
    "data-name": "Path 33404",
    d: "M1019.67,301.51l.136.068Z",
    transform: "translate(-502.207 -239.333)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33405",
    "data-name": "Path 33405",
    d: "M896.375,301.18l.206.206-.206-.206M864,301.386l.206.206Z",
    transform: "translate(-378.638 -239.071)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33406",
    "data-name": "Path 33406",
    d: "M865,302.18l.206.206L865,302.18m.619,0,.206.206Z",
    transform: "translate(-379.432 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33407",
    "data-name": "Path 33407",
    d: "M869,302.18l.206.206L869,302.18m.893.138.068.138Z",
    transform: "translate(-382.607 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33408",
    "data-name": "Path 33408",
    d: "M877,302.18l.206.206Z",
    transform: "translate(-388.957 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M878,302.18l.206.206Z",
    transform: "translate(-389.751 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33410",
    "data-name": "Path 33410",
    d: "M881,302.18l.206.206Z",
    transform: "translate(-392.132 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33411",
    "data-name": "Path 33411",
    d: "M900,302.18l.206.206Z",
    transform: "translate(-407.215 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33412",
    "data-name": "Path 33412",
    d: "M906.67,302.248l.138.068-.138-.068m.893-.068.206.206Z",
    transform: "translate(-412.509 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33413",
    "data-name": "Path 33413",
    d: "M913,302.18l.206.206Z",
    transform: "translate(-417.534 -239.865)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33414",
    "data-name": "Path 33414",
    d: "M914,302.18l.206.206Z",
    transform: "translate(-418.328 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33415",
    "data-name": "Path 33415",
    d: "M919,302.18l.206.206Z",
    transform: "translate(-422.297 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33416",
    "data-name": "Path 33416",
    d: "M923,302.18l.206.206Z",
    transform: "translate(-425.472 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33417",
    "data-name": "Path 33417",
    d: "M936,302.18l.206.206Z",
    transform: "translate(-435.791 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33418",
    "data-name": "Path 33418",
    d: "M939,302.18l.206.206Z",
    transform: "translate(-438.172 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33419",
    "data-name": "Path 33419",
    d: "M942.67,302.248l.138.068-.138-.068m1.305-.068.206.206Z",
    transform: "translate(-441.086 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33420",
    "data-name": "Path 33420",
    d: "M950,302.18l.206.206L950,302.18m5.087.068.138.068-.138-.068m4.811-.068.206.206Z",
    transform: "translate(-446.904 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33421",
    "data-name": "Path 33421",
    d: "M999,302.18l.206.206Z",
    transform: "translate(-485.8 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33422",
    "data-name": "Path 33422",
    d: "M1000,302.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-486.594 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33423",
    "data-name": "Path 33423",
    d: "M1010.67,302.51l.136.068Z",
    transform: "translate(-495.063 -240.127)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33424",
    "data-name": "Path 33424",
    d: "M1024,302.18l.206.206Z",
    transform: "translate(-505.645 -239.865)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33425",
    "data-name": "Path 33425",
    d: "M1025,302.18l.206.206Z",
    transform: "translate(-506.438 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33426",
    "data-name": "Path 33426",
    d: "M1061.33,302.318l.07.138-.07-.138m.963-.138.206.206Z",
    transform: "translate(-535.277 -239.865)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33427",
    "data-name": "Path 33427",
    d: "M1067,302.18l.206.206Z",
    transform: "translate(-539.778 -239.865)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33428",
    "data-name": "Path 33428",
    d: "M858,303.18l.206.206Z",
    transform: "translate(-373.875 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33429",
    "data-name": "Path 33429",
    d: "M859,303.18l.206.206Z",
    transform: "translate(-374.669 -240.659)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33430",
    "data-name": "Path 33430",
    d: "M864,303.18l.206.206L864,303.18m1.65,0,.206.206Z",
    transform: "translate(-378.638 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33431",
    "data-name": "Path 33431",
    d: "M874,303.18l.206.206Z",
    transform: "translate(-386.576 -240.659)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33432",
    "data-name": "Path 33432",
    d: "M875,303.18l.206.206L875,303.18m1.65,0v.206h.825Z",
    transform: "translate(-387.37 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33433",
    "data-name": "Path 33433",
    d: "M887,303.18v.206h1.443L887,303.18m2.887,0,.206.206Z",
    transform: "translate(-396.895 -240.659)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33434",
    "data-name": "Path 33434",
    d: "M909,303.18l.206.206Z",
    transform: "translate(-414.359 -240.659)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33435",
    "data-name": "Path 33435",
    d: "M910,303.18l.206.206Z",
    transform: "translate(-415.152 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33436",
    "data-name": "Path 33436",
    d: "M914.67,303.248l.138.068-.138-.068m.687-.068.206.206Z",
    transform: "translate(-418.859 -240.659)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33437",
    "data-name": "Path 33437",
    d: "M919,303.18l.206.206L919,303.18m1.237,0v.206h.825Z",
    transform: "translate(-422.297 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33438",
    "data-name": "Path 33438",
    d: "M929,303.18l.206.206Z",
    transform: "translate(-430.234 -240.659)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33439",
    "data-name": "Path 33439",
    d: "M937,303.18l.206.206L937,303.18m.619,0,.206.206-.206-.206m.619,0,.619.619Z",
    transform: "translate(-436.585 -240.659)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33440",
    "data-name": "Path 33440",
    d: "M944,303.18l.206.206Z",
    transform: "translate(-442.141 -240.659)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33441",
    "data-name": "Path 33441",
    d: "M945,303.18l.206.206Z",
    transform: "translate(-442.935 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33442",
    "data-name": "Path 33442",
    d: "M952,303.18l.206.206Z",
    transform: "translate(-448.492 -240.659)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33443",
    "data-name": "Path 33443",
    d: "M977,303.18l.206.206L977,303.18m8.867,0v.619h.206l-.206-.619m1.443,0,.206.206Z",
    transform: "translate(-468.336 -240.659)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33444",
    "data-name": "Path 33444",
    d: "M1044,303.18l.206.206-.206-.206m1.788.068.136.068Z",
    transform: "translate(-521.52 -240.659)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33445",
    "data-name": "Path 33445",
    d: "M860,304.18l.206.206Z",
    transform: "translate(-375.463 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33446",
    "data-name": "Path 33446",
    d: "M861,304.18l.206.206Z",
    transform: "translate(-376.257 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33447",
    "data-name": "Path 33447",
    d: "M863,304.386v.206h.825l-.825-.206m1.237-.206v.206h.619l-.619-.206m5.98,0,.206.206Z",
    transform: "translate(-377.844 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33448",
    "data-name": "Path 33448",
    d: "M899,304.18l.206.206Z",
    transform: "translate(-406.421 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33449",
    "data-name": "Path 33449",
    d: "M900,304.18v.206h.619v-.206Z",
    transform: "translate(-407.215 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33450",
    "data-name": "Path 33450",
    d: "M901,304.18l.206.206Z",
    transform: "translate(-408.008 -241.453)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33451",
    "data-name": "Path 33451",
    d: "M907,304.18l.206.206Z",
    transform: "translate(-412.771 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33452",
    "data-name": "Path 33452",
    d: "M912,304.18l.206.206L912,304.18m4.537,0,.206.206-.206-.206m.825,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-416.74 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33453",
    "data-name": "Path 33453",
    d: "M945,304.18l.206.206Z",
    transform: "translate(-442.935 -241.453)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33454",
    "data-name": "Path 33454",
    d: "M946,304.18l.206.206Z",
    transform: "translate(-443.729 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33455",
    "data-name": "Path 33455",
    d: "M950,304.18l.206.206Z",
    transform: "translate(-446.904 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33456",
    "data-name": "Path 33456",
    d: "M954,304.18v.206h.825Z",
    transform: "translate(-450.079 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33457",
    "data-name": "Path 33457",
    d: "M958,304.18l.206.206Z",
    transform: "translate(-453.254 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33458",
    "data-name": "Path 33458",
    d: "M964.67,304.248l.138.068-.138-.068m1.305-.068v.206h.619Z",
    transform: "translate(-458.549 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33459",
    "data-name": "Path 33459",
    d: "M974,304.18l.206.206L974,304.18m1.031,0,.206.206Z",
    transform: "translate(-465.955 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33460",
    "data-name": "Path 33460",
    d: "M998,304.18l.206.206Z",
    transform: "translate(-485.006 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33461",
    "data-name": "Path 33461",
    d: "M1010.67,304.51l.136.068Z",
    transform: "translate(-495.063 -241.715)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33462",
    "data-name": "Path 33462",
    d: "M1012,304.18l.206.206Z",
    transform: "translate(-496.119 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33463",
    "data-name": "Path 33463",
    d: "M1013,304.18l.619.412-.619-.412m1.856,0,.206.206Z",
    transform: "translate(-496.913 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33464",
    "data-name": "Path 33464",
    d: "M1030.67,304.51l.136.068Z",
    transform: "translate(-510.939 -241.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33465",
    "data-name": "Path 33465",
    d: "M1032,304.18v.206h1.443Z",
    transform: "translate(-511.995 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33466",
    "data-name": "Path 33466",
    d: "M1039,304.18v.206h.825Z",
    transform: "translate(-517.551 -241.453)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33467",
    "data-name": "Path 33467",
    d: "M1047,304.18l.206.206Z",
    transform: "translate(-523.902 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33468",
    "data-name": "Path 33468",
    d: "M1049.67,304.51l.136.068Z",
    transform: "translate(-526.021 -241.715)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33469",
    "data-name": "Path 33469",
    d: "M1055,304.18l.206.206Z",
    transform: "translate(-530.252 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33470",
    "data-name": "Path 33470",
    d: "M1056,304.18l.206.206Z",
    transform: "translate(-531.046 -241.453)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33471",
    "data-name": "Path 33471",
    d: "M1064,304.18l.412.412Z",
    transform: "translate(-537.396 -241.453)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33472",
    "data-name": "Path 33472",
    d: "M1065,304.18l.206.206Z",
    transform: "translate(-538.19 -241.453)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33473",
    "data-name": "Path 33473",
    d: "M872,305.18l.206.206Z",
    transform: "translate(-384.988 -242.247)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33474",
    "data-name": "Path 33474",
    d: "M873,305.18l.206.206Z",
    transform: "translate(-385.782 -242.247)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33475",
    "data-name": "Path 33475",
    d: "M874,305.18l.206.206Z",
    transform: "translate(-386.576 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33476",
    "data-name": "Path 33476",
    d: "M875,305.18l.206.206Z",
    transform: "translate(-387.37 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33477",
    "data-name": "Path 33477",
    d: "M902.67,305.51l.138.068Z",
    transform: "translate(-409.334 -242.509)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33478",
    "data-name": "Path 33478",
    d: "M901.619,305.18l-.619.412v.206Z",
    transform: "translate(-408.008 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33479",
    "data-name": "Path 33479",
    d: "M908,305.18l.206.206L908,305.18m1.443,0,.206.206Z",
    transform: "translate(-413.565 -242.247)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33480",
    "data-name": "Path 33480",
    d: "M916,305.18l.206.206Z",
    transform: "translate(-419.915 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33481",
    "data-name": "Path 33481",
    d: "M917,305.18l.206.206L917,305.18m.757.068.138.068Z",
    transform: "translate(-420.709 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33482",
    "data-name": "Path 33482",
    d: "M922.67,305.51l.138.068Z",
    transform: "translate(-425.21 -242.509)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33483",
    "data-name": "Path 33483",
    d: "M924.67,305.248l.138.068-.138-.068m2.13-.068.206.206Z",
    transform: "translate(-426.797 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33484",
    "data-name": "Path 33484",
    d: "M938.206,305.18l-.206.412Z",
    transform: "translate(-437.379 -242.247)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33485",
    "data-name": "Path 33485",
    d: "M948,305.18l.206.206Z",
    transform: "translate(-445.316 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33486",
    "data-name": "Path 33486",
    d: "M960,305.18l.206.206Z",
    transform: "translate(-454.842 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33487",
    "data-name": "Path 33487",
    d: "M961.67,305.51l.138.068Z",
    transform: "translate(-456.168 -242.509)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33488",
    "data-name": "Path 33488",
    d: "M967,305.18v.206h.825Z",
    transform: "translate(-460.398 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33489",
    "data-name": "Path 33489",
    d: "M983,305.18l.206.206Z",
    transform: "translate(-473.099 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33490",
    "data-name": "Path 33490",
    d: "M989.67,305.51l.138.068Z",
    transform: "translate(-478.394 -242.509)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33491",
    "data-name": "Path 33491",
    d: "M991,305.18v.206h.619Z",
    transform: "translate(-479.449 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33492",
    "data-name": "Path 33492",
    d: "M994.67,305.51l.138.068Z",
    transform: "translate(-482.363 -242.509)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33493",
    "data-name": "Path 33493",
    d: "M996,305.18v.206h.825L996,305.18m1.443,0,.206.206Z",
    transform: "translate(-483.418 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33494",
    "data-name": "Path 33494",
    d: "M1004,305.18l.206.206Z",
    transform: "translate(-489.769 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33495",
    "data-name": "Path 33495",
    d: "M1016.67,305.51l.136.068Z",
    transform: "translate(-499.826 -242.509)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33496",
    "data-name": "Path 33496",
    d: "M1018,305.18l.206.206Z",
    transform: "translate(-500.882 -242.247)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33497",
    "data-name": "Path 33497",
    d: "M1023,305.18l.206.206-.206-.206m5.155,0,.206.206Z",
    transform: "translate(-504.851 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33498",
    "data-name": "Path 33498",
    d: "M1058,305.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-532.633 -242.247)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33499",
    "data-name": "Path 33499",
    d: "M1064,305.18l.206.619h.206Z",
    transform: "translate(-537.396 -242.247)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33500",
    "data-name": "Path 33500",
    d: "M912,305.18l.206.206L912,305.18m-40,.206.206.206Z",
    transform: "translate(-384.988 -242.247)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33501",
    "data-name": "Path 33501",
    d: "M879,306.18l.206.206Z",
    transform: "translate(-390.545 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33502",
    "data-name": "Path 33502",
    d: "M885,306.18l.206.206Z",
    transform: "translate(-395.308 -243.04)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33503",
    "data-name": "Path 33503",
    d: "M886,306.18l.206.206L886,306.18m.825,0,.206.206Z",
    transform: "translate(-396.101 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33504",
    "data-name": "Path 33504",
    d: "M891,306.18l.206.206L891,306.18m.412,0,.206.206Z",
    transform: "translate(-400.07 -243.04)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33505",
    "data-name": "Path 33505",
    d: "M894,306.18l.206.206Z",
    transform: "translate(-402.452 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33506",
    "data-name": "Path 33506",
    d: "M895.67,306.51l.138.068Z",
    transform: "translate(-403.777 -243.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33507",
    "data-name": "Path 33507",
    d: "M909,306.18l.206.206L909,306.18m4.743,0,.206.206Z",
    transform: "translate(-414.359 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33508",
    "data-name": "Path 33508",
    d: "M937,306.18l.206.206Z",
    transform: "translate(-436.585 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33509",
    "data-name": "Path 33509",
    d: "M939.67,306.51l.138.068Z",
    transform: "translate(-438.704 -243.302)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33510",
    "data-name": "Path 33510",
    d: "M941,306.18l.206.206Z",
    transform: "translate(-439.76 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33511",
    "data-name": "Path 33511",
    d: "M943.67,306.51l.138.068Z",
    transform: "translate(-441.879 -243.302)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33512",
    "data-name": "Path 33512",
    d: "M946,306.18l.206.206Z",
    transform: "translate(-443.729 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33513",
    "data-name": "Path 33513",
    d: "M949,306.18l.206.206Z",
    transform: "translate(-446.11 -243.04)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33514",
    "data-name": "Path 33514",
    d: "M950,306.18l.206.206L950,306.18m.412,0,.206.206Z",
    transform: "translate(-446.904 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33515",
    "data-name": "Path 33515",
    d: "M965,306.18l.206.206Z",
    transform: "translate(-458.811 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33516",
    "data-name": "Path 33516",
    d: "M966,306.18l.206.206Z",
    transform: "translate(-459.605 -243.04)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33517",
    "data-name": "Path 33517",
    d: "M977,306.18l.206.206L977,306.18m.825,0,.206.206Z",
    transform: "translate(-468.336 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33518",
    "data-name": "Path 33518",
    d: "M986.67,306.248l.138.068-.138-.068m5.017-.068.206.206Z",
    transform: "translate(-476.012 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33519",
    "data-name": "Path 33519",
    d: "M1024,306.18l.206.206Z",
    transform: "translate(-505.645 -243.04)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33520",
    "data-name": "Path 33520",
    d: "M1025.67,306.248l.136.068-.136-.068m6.254-.068.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-506.97 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33521",
    "data-name": "Path 33521",
    d: "M1061.67,306.51l.136.068Z",
    transform: "translate(-535.547 -243.302)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33522",
    "data-name": "Path 33522",
    d: "M1064,306.18l.206.206Z",
    transform: "translate(-537.396 -243.04)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33523",
    "data-name": "Path 33523",
    d: "M859,307.18l.206.206Z",
    transform: "translate(-374.669 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33524",
    "data-name": "Path 33524",
    d: "M860,307.18l.206.206Z",
    transform: "translate(-375.463 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33525",
    "data-name": "Path 33525",
    d: "M865,307.18l.206.206Z",
    transform: "translate(-379.432 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33526",
    "data-name": "Path 33526",
    d: "M881,307.18l.206.206L881,307.18m.825,0-.206.412Z",
    transform: "translate(-392.132 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33527",
    "data-name": "Path 33527",
    d: "M900,307.18l.206.206Z",
    transform: "translate(-407.215 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33528",
    "data-name": "Path 33528",
    d: "M905,307.18l.206.206Z",
    transform: "translate(-411.183 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33529",
    "data-name": "Path 33529",
    d: "M910,307.18l.206.206Z",
    transform: "translate(-415.152 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33530",
    "data-name": "Path 33530",
    d: "M935,307.18l.206.206Z",
    transform: "translate(-434.997 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33531",
    "data-name": "Path 33531",
    d: "M936,307.18l.206.206L936,307.18m1.031,0,.206.206-.206-.206m.963.068.138.068Z",
    transform: "translate(-435.791 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33532",
    "data-name": "Path 33532",
    d: "M952,307.18l.206.206L952,307.18m.412,0,.206.206Z",
    transform: "translate(-448.492 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33533",
    "data-name": "Path 33533",
    d: "M955,307.18l.206.206L955,307.18m1.443,0,.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-450.873 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33534",
    "data-name": "Path 33534",
    d: "M969,307.18l.206.206Z",
    transform: "translate(-461.986 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33535",
    "data-name": "Path 33535",
    d: "M983.33,307.85l.068.138Z",
    transform: "translate(-473.361 -244.366)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33536",
    "data-name": "Path 33536",
    d: "M991,307.18l.206.206Z",
    transform: "translate(-479.449 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33537",
    "data-name": "Path 33537",
    d: "M992,307.18l.206.206L992,307.18m1.856,0,.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-480.243 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33538",
    "data-name": "Path 33538",
    d: "M1006,307.18l.206.206Z",
    transform: "translate(-491.356 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33539",
    "data-name": "Path 33539",
    d: "M1008,307.18l.206.206Z",
    transform: "translate(-492.944 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33540",
    "data-name": "Path 33540",
    d: "M1015.67,307.51l.136.068Z",
    transform: "translate(-499.032 -244.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33541",
    "data-name": "Path 33541",
    d: "M1029,307.18v.206h.619Z",
    transform: "translate(-509.613 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33542",
    "data-name": "Path 33542",
    d: "M1032,307.18l.206.206Z",
    transform: "translate(-511.995 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33543",
    "data-name": "Path 33543",
    d: "M1034,307.18l.206.206Z",
    transform: "translate(-513.582 -243.834)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33544",
    "data-name": "Path 33544",
    d: "M1035,307.18l.206.206Z",
    transform: "translate(-514.376 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33545",
    "data-name": "Path 33545",
    d: "M1039.67,307.51l.136.068Z",
    transform: "translate(-518.083 -244.096)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33546",
    "data-name": "Path 33546",
    d: "M1041.67,307.51l.136.068Z",
    transform: "translate(-519.671 -244.096)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33547",
    "data-name": "Path 33547",
    d: "M1047,307.18l.206.206Z",
    transform: "translate(-523.902 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33548",
    "data-name": "Path 33548",
    d: "M1048,307.18l.206.206Z",
    transform: "translate(-524.695 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33549",
    "data-name": "Path 33549",
    d: "M1058,307.18l.206.206Z",
    transform: "translate(-532.633 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33550",
    "data-name": "Path 33550",
    d: "M1059,307.18l.206.206Z",
    transform: "translate(-533.427 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33551",
    "data-name": "Path 33551",
    d: "M1064,307.18l.206.206Z",
    transform: "translate(-537.396 -243.834)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33552",
    "data-name": "Path 33552",
    d: "M1068,307.18l.206.206Z",
    transform: "translate(-540.571 -243.834)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33553",
    "data-name": "Path 33553",
    d: "M862,308.18l.206.206Z",
    transform: "translate(-377.05 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33554",
    "data-name": "Path 33554",
    d: "M863,308.18l.206.206Z",
    transform: "translate(-377.844 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33555",
    "data-name": "Path 33555",
    d: "M864,308.18l.206.206Z",
    transform: "translate(-378.638 -244.628)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33556",
    "data-name": "Path 33556",
    d: "M883,308.18l.206.206L883,308.18m.412,0,.206.206-.206-.206m4.537,0,.206.206Z",
    transform: "translate(-393.72 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33557",
    "data-name": "Path 33557",
    d: "M909.206,308.18l-.206.412Z",
    transform: "translate(-414.359 -244.628)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33558",
    "data-name": "Path 33558",
    d: "M938,308.18l.206.206Z",
    transform: "translate(-437.379 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33559",
    "data-name": "Path 33559",
    d: "M939.67,308.248l.138.068-.138-.068m.687-.068.206.206Z",
    transform: "translate(-438.704 -244.628)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33560",
    "data-name": "Path 33560",
    d: "M957,308.18l.206.206L957,308.18m.619,0,.206.206Z",
    transform: "translate(-452.461 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33561",
    "data-name": "Path 33561",
    d: "M961,308.18l.206.206Z",
    transform: "translate(-455.636 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33562",
    "data-name": "Path 33562",
    d: "M964,308.18l.206.206Z",
    transform: "translate(-458.017 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33563",
    "data-name": "Path 33563",
    d: "M965,308.18l.206.206Z",
    transform: "translate(-458.811 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33564",
    "data-name": "Path 33564",
    d: "M966,308.18l.206.206Z",
    transform: "translate(-459.605 -244.628)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33565",
    "data-name": "Path 33565",
    d: "M978,308.18l.206.206Z",
    transform: "translate(-469.13 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33566",
    "data-name": "Path 33566",
    d: "M1003,308.18l.206.206Z",
    transform: "translate(-488.975 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33567",
    "data-name": "Path 33567",
    d: "M1049,308.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-525.489 -244.628)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33568",
    "data-name": "Path 33568",
    d: "M939.9,308.18l.206.206-.206-.206m-29.9.206.206.206-.206-.206m12.166,0,.206.206Z",
    transform: "translate(-415.152 -244.628)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33569",
    "data-name": "Path 33569",
    d: "M980,309.18l.206.206Z",
    transform: "translate(-470.718 -245.422)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33570",
    "data-name": "Path 33570",
    d: "M1004,309.18l.206.206Z",
    transform: "translate(-489.769 -245.422)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33571",
    "data-name": "Path 33571",
    d: "M1005,309.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-490.563 -245.422)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33572",
    "data-name": "Path 33572",
    d: "M995.435,309.18l.206.206-.206-.206m.619,0,.206.206-.206-.206M981,309.386v.206h.619Z",
    transform: "translate(-471.512 -245.422)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33573",
    "data-name": "Path 33573",
    d: "M889,317.18l.412,1.856v.206h.825l-1.031-1.65a2.987,2.987,0,0,0,2.681.825l3.918,1.237h.412l.412-.825L894.568,318h.825l-2.066.283Z",
    transform: "translate(-398.483 -251.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33574",
    "data-name": "Path 33574",
    d: "M891,317.18l.206.206Z",
    transform: "translate(-400.07 -251.772)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33575",
    "data-name": "Path 33575",
    d: "M892,317.18l.206.206L892,317.18m18.765,0-.206.412Z",
    transform: "translate(-400.864 -251.772)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33576",
    "data-name": "Path 33576",
    d: "M989,317.18l.206.206Z",
    transform: "translate(-477.862 -251.772)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33577",
    "data-name": "Path 33577",
    d: "M935.228,317.18l.619.412v.206l-2.062-.412v.206l.619.206V318l-5.568.619v-.206h.619v-.206l-5.98-.619,1.031,1.237c-.775-.264-2.219-1.258-2.887-.619l-.412-.206H921v.206l3.712.825-.825-1.237,4.949,1.349,9.279-.524v-.412l.825.206c2.239-1.27,6.083.635,8.455.825l-.825-.619v-.206l4.949.412-.619-.412v-.206h.619V318c-1.992-.437-4.382-.1-6.446,0-.594.031-1.868-.837-2.008,0l-3.3-.619.206.619c-.621-.2-2.934-1.114-3.093-.206Z",
    transform: "translate(-423.884 -251.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33578",
    "data-name": "Path 33578",
    d: "M991,317.18l.206.206Z",
    transform: "translate(-479.449 -251.772)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33579",
    "data-name": "Path 33579",
    d: "M992,317.18l.206.206Z",
    transform: "translate(-480.243 -251.772)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33580",
    "data-name": "Path 33580",
    d: "M998,317.18l.206.206L998,317.18m2.887,0v.206h.825Z",
    transform: "translate(-485.006 -251.772)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33581",
    "data-name": "Path 33581",
    d: "M1016,317.18l.206.206Z",
    transform: "translate(-499.294 -251.772)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33582",
    "data-name": "Path 33582",
    d: "M859.206,318.18l-.206.412Z",
    transform: "translate(-374.669 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33583",
    "data-name": "Path 33583",
    d: "M858.412,319.132l.412.412v.206l-.825-.206v.825h.825c0-1.637,4.875.136,5.774.206C863.341,319.153,860.2,319.077,858.412,319.132Z",
    transform: "translate(-373.875 -253.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33584",
    "data-name": "Path 33584",
    d: "M862,318.18l.206.206Z",
    transform: "translate(-377.05 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33585",
    "data-name": "Path 33585",
    d: "M888.33,318.318l.068.138-.068-.138m.963-.138.206.206Z",
    transform: "translate(-397.951 -252.566)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33586",
    "data-name": "Path 33586",
    d: "M933,318.18l.206.206Z",
    transform: "translate(-433.41 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33587",
    "data-name": "Path 33587",
    d: "M934.67,318.51l.138.068Z",
    transform: "translate(-434.735 -252.828)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33588",
    "data-name": "Path 33588",
    d: "M936,318.18l.206.206Z",
    transform: "translate(-435.791 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33589",
    "data-name": "Path 33589",
    d: "M986,318.18l.206.206Z",
    transform: "translate(-475.48 -252.566)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33590",
    "data-name": "Path 33590",
    d: "M987,318.18l.206.206Z",
    transform: "translate(-476.274 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33591",
    "data-name": "Path 33591",
    d: "M989,318.18l.206.206L989,318.18m1.031,0,.206.206Z",
    transform: "translate(-477.862 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33592",
    "data-name": "Path 33592",
    d: "M1000,318.18l.206.206Z",
    transform: "translate(-486.594 -252.566)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33593",
    "data-name": "Path 33593",
    d: "M1001,318.18l.206.206Z",
    transform: "translate(-487.387 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33594",
    "data-name": "Path 33594",
    d: "M1002,318.18l.206.206Z",
    transform: "translate(-488.181 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33595",
    "data-name": "Path 33595",
    d: "M1005,318.18l.206.206Z",
    transform: "translate(-490.563 -252.566)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33596",
    "data-name": "Path 33596",
    d: "M1006,318.18l.206.206Z",
    transform: "translate(-491.356 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33597",
    "data-name": "Path 33597",
    d: "M1011,318.18l.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-495.325 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33598",
    "data-name": "Path 33598",
    d: "M1027,318.18l.206.206Z",
    transform: "translate(-508.026 -252.566)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33599",
    "data-name": "Path 33599",
    d: "M1028,318.18l.206.206Z",
    transform: "translate(-508.82 -252.566)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33600",
    "data-name": "Path 33600",
    d: "M1029,318.18l.206.206Z",
    transform: "translate(-509.613 -252.566)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33601",
    "data-name": "Path 33601",
    d: "M864,319.18l.206.206Z",
    transform: "translate(-378.638 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33602",
    "data-name": "Path 33602",
    d: "M865,319.18l.206.206Z",
    transform: "translate(-379.432 -253.36)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33603",
    "data-name": "Path 33603",
    d: "M869,319.18l.206.206L869,319.18m.551.068.138.068Z",
    transform: "translate(-382.607 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33604",
    "data-name": "Path 33604",
    d: "M873,319.18l.206.206Z",
    transform: "translate(-385.782 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33605",
    "data-name": "Path 33605",
    d: "M890,319.18l.206.206Z",
    transform: "translate(-399.277 -253.36)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33606",
    "data-name": "Path 33606",
    d: "M891,319.18l.206.206Z",
    transform: "translate(-400.07 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33607",
    "data-name": "Path 33607",
    d: "M895,319.18l.206.206L895,319.18m4.469.068.138.068Z",
    transform: "translate(-403.246 -253.36)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33608",
    "data-name": "Path 33608",
    d: "M918,319.18l.206.206L918,319.18m1.237,0,.206.206Z",
    transform: "translate(-421.503 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33609",
    "data-name": "Path 33609",
    d: "M938,319.18l.206.206Z",
    transform: "translate(-437.379 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33610",
    "data-name": "Path 33610",
    d: "M983,319.18l.206.206Z",
    transform: "translate(-473.099 -253.36)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33611",
    "data-name": "Path 33611",
    d: "M989,319.18l.206.206Z",
    transform: "translate(-477.862 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33612",
    "data-name": "Path 33612",
    d: "M990,319.18l.206.206Z",
    transform: "translate(-478.656 -253.36)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33613",
    "data-name": "Path 33613",
    d: "M991,319.18l.206.206Z",
    transform: "translate(-479.449 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33614",
    "data-name": "Path 33614",
    d: "M992,319.18l.206.206Z",
    transform: "translate(-480.243 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33615",
    "data-name": "Path 33615",
    d: "M996.67,319.51l.138.068Z",
    transform: "translate(-483.95 -253.622)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33616",
    "data-name": "Path 33616",
    d: "M1008,319.18l.206.206Z",
    transform: "translate(-492.944 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33617",
    "data-name": "Path 33617",
    d: "M1009,319.18l.206.206-.206-.206m.412,0,.412.412-.412-.412m.619,0,.206.206Z",
    transform: "translate(-493.738 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33618",
    "data-name": "Path 33618",
    d: "M1021,319.18l.206.206Z",
    transform: "translate(-503.263 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33619",
    "data-name": "Path 33619",
    d: "M1022,319.18l.206.206Z",
    transform: "translate(-504.057 -253.36)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33620",
    "data-name": "Path 33620",
    d: "M1023,319.18l.206.206Z",
    transform: "translate(-504.851 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33621",
    "data-name": "Path 33621",
    d: "M1032,319.18l.206.206Z",
    transform: "translate(-511.995 -253.36)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33622",
    "data-name": "Path 33622",
    d: "M1059,319.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-533.427 -253.36)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33623",
    "data-name": "Path 33623",
    d: "M1064,319.18l.206.206Z",
    transform: "translate(-537.396 -253.36)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33624",
    "data-name": "Path 33624",
    d: "M859.33,320.588l.068.138-.068-.138m3.367-.068.138.068Z",
    transform: "translate(-374.931 -254.423)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33625",
    "data-name": "Path 33625",
    d: "M877.67,320.51l.138.068Z",
    transform: "translate(-389.489 -254.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33626",
    "data-name": "Path 33626",
    d: "M879,320.18l.206.206L879,320.18m1.856,0,.206.206Z",
    transform: "translate(-390.545 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33627",
    "data-name": "Path 33627",
    d: "M890,320.18v.206l.619.206L890,320.18m1.237,0,.206.206-.206-.206m3.918,0,.206.206-.206-.206m1.1.138.068.138Z",
    transform: "translate(-399.277 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33628",
    "data-name": "Path 33628",
    d: "M921,320.18l.206.206Z",
    transform: "translate(-423.884 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33629",
    "data-name": "Path 33629",
    d: "M923,320.18l.206.206Z",
    transform: "translate(-425.472 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33630",
    "data-name": "Path 33630",
    d: "M926,320.18l.206.206Z",
    transform: "translate(-427.853 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33631",
    "data-name": "Path 33631",
    d: "M927,320.18l.206.206Z",
    transform: "translate(-428.647 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33632",
    "data-name": "Path 33632",
    d: "M933,320.18l.206.206Z",
    transform: "translate(-433.41 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33633",
    "data-name": "Path 33633",
    d: "M935,320.18l.206.206Z",
    transform: "translate(-434.997 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33634",
    "data-name": "Path 33634",
    d: "M936.33,320.85l.068.138Z",
    transform: "translate(-436.053 -254.685)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33635",
    "data-name": "Path 33635",
    d: "M937,320.18l.206.206L937,320.18m1.65,0,.206.206Z",
    transform: "translate(-436.585 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33636",
    "data-name": "Path 33636",
    d: "M946,320.18l.206.206L946,320.18m8.042,0,.206.206Z",
    transform: "translate(-443.729 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33637",
    "data-name": "Path 33637",
    d: "M998,320.18l.206.206Z",
    transform: "translate(-485.006 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33638",
    "data-name": "Path 33638",
    d: "M999,320.18l.206.206L999,320.18m1.65,0,.206.206-.206-.206m.825,0,.206.206-.206-.206m3.093,0,.206.206Z",
    transform: "translate(-485.8 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33639",
    "data-name": "Path 33639",
    d: "M1027,320.18l.206.206Z",
    transform: "translate(-508.026 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33640",
    "data-name": "Path 33640",
    d: "M1034,320.18l.206.206Z",
    transform: "translate(-513.582 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33641",
    "data-name": "Path 33641",
    d: "M1035,320.18l.206.206Z",
    transform: "translate(-514.376 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33642",
    "data-name": "Path 33642",
    d: "M1038,320.18l.206.206Z",
    transform: "translate(-516.758 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33643",
    "data-name": "Path 33643",
    d: "M1042,320.18l.206.206Z",
    transform: "translate(-519.933 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33644",
    "data-name": "Path 33644",
    d: "M1043,320.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-520.727 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33645",
    "data-name": "Path 33645",
    d: "M1048,320.18v.206h1.031Z",
    transform: "translate(-524.695 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33646",
    "data-name": "Path 33646",
    d: "M1053.67,320.51l.136.068Z",
    transform: "translate(-529.196 -254.415)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33647",
    "data-name": "Path 33647",
    d: "M1055,320.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-530.252 -254.153)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33648",
    "data-name": "Path 33648",
    d: "M1066,320.18l.206.206Z",
    transform: "translate(-538.984 -254.153)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33649",
    "data-name": "Path 33649",
    d: "M902.685,320.18l.206.206-.206-.206M860,320.386l.206.206Z",
    transform: "translate(-375.463 -254.153)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33650",
    "data-name": "Path 33650",
    d: "M861,321.18l.206.206Z",
    transform: "translate(-376.257 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33651",
    "data-name": "Path 33651",
    d: "M868,321.18l.206.206Z",
    transform: "translate(-381.813 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33652",
    "data-name": "Path 33652",
    d: "M869.67,321.248l.138.068-.138-.068m2.749-.068.206.206Z",
    transform: "translate(-383.139 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33653",
    "data-name": "Path 33653",
    d: "M884,321.18l.206.206Z",
    transform: "translate(-394.514 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33654",
    "data-name": "Path 33654",
    d: "M889,321.18l.206.206Z",
    transform: "translate(-398.483 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33655",
    "data-name": "Path 33655",
    d: "M891,321.18l.206.206Z",
    transform: "translate(-400.07 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33656",
    "data-name": "Path 33656",
    d: "M901,321.18v.206h.825Z",
    transform: "translate(-408.008 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33657",
    "data-name": "Path 33657",
    d: "M905.67,321.51l.138.068Z",
    transform: "translate(-411.715 -255.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33658",
    "data-name": "Path 33658",
    d: "M916,321.18l.206.206Z",
    transform: "translate(-419.915 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33659",
    "data-name": "Path 33659",
    d: "M919,321.18l.206.206Z",
    transform: "translate(-422.297 -254.947)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33660",
    "data-name": "Path 33660",
    d: "M923,321.18l.206.206L923,321.18m1.237,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-425.472 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33661",
    "data-name": "Path 33661",
    d: "M939,321.18l.206.206Z",
    transform: "translate(-438.172 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33662",
    "data-name": "Path 33662",
    d: "M948,321.18l.206.206Z",
    transform: "translate(-445.316 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33663",
    "data-name": "Path 33663",
    d: "M949,321.18l.206.206Z",
    transform: "translate(-446.11 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33664",
    "data-name": "Path 33664",
    d: "M953.67,321.248l.138.068-.138-.068m4.811-.068.206.206Z",
    transform: "translate(-449.817 -254.947)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33665",
    "data-name": "Path 33665",
    d: "M978.67,321.51l.138.068Z",
    transform: "translate(-469.662 -255.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33666",
    "data-name": "Path 33666",
    d: "M980.67,321.51l.138.068Z",
    transform: "translate(-471.249 -255.209)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33667",
    "data-name": "Path 33667",
    d: "M1000,321.18l.206.206Z",
    transform: "translate(-486.594 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33668",
    "data-name": "Path 33668",
    d: "M1008.67,321.51l.136.068Z",
    transform: "translate(-493.476 -255.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33669",
    "data-name": "Path 33669",
    d: "M1010,321.18l.206.206Z",
    transform: "translate(-494.531 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33670",
    "data-name": "Path 33670",
    d: "M1017,321.18l.206.206Z",
    transform: "translate(-500.088 -254.947)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33671",
    "data-name": "Path 33671",
    d: "M1018.67,321.248l.136.068-.136-.068m2.955-.068.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-501.414 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33672",
    "data-name": "Path 33672",
    d: "M1037.67,321.51l.136.068Z",
    transform: "translate(-516.496 -255.209)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33673",
    "data-name": "Path 33673",
    d: "M1063.67,321.51l.136.068Z",
    transform: "translate(-537.134 -255.209)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33674",
    "data-name": "Path 33674",
    d: "M900.685,321.18l.206.206-.206-.206M858,321.386l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-373.875 -254.947)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33675",
    "data-name": "Path 33675",
    d: "M873,322.18l.206.206Z",
    transform: "translate(-385.782 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33676",
    "data-name": "Path 33676",
    d: "M874,322.18l.206.206L874,322.18m2.613.068.138.068Z",
    transform: "translate(-386.576 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33677",
    "data-name": "Path 33677",
    d: "M892,322.18l.412.412v-.412Z",
    transform: "translate(-400.864 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33678",
    "data-name": "Path 33678",
    d: "M910,322.18l.206.206Z",
    transform: "translate(-415.152 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33679",
    "data-name": "Path 33679",
    d: "M911,322.18l.206.206Z",
    transform: "translate(-415.946 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33680",
    "data-name": "Path 33680",
    d: "M912,322.18l.206.206L912,322.18m1.031,0,.206.206Z",
    transform: "translate(-416.74 -255.741)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33681",
    "data-name": "Path 33681",
    d: "M922,322.18l.206.206Z",
    transform: "translate(-424.678 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33682",
    "data-name": "Path 33682",
    d: "M931,322.18l.206.206Z",
    transform: "translate(-431.822 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33683",
    "data-name": "Path 33683",
    d: "M932,322.18l.206.206Z",
    transform: "translate(-432.616 -255.741)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33684",
    "data-name": "Path 33684",
    d: "M935,322.18l.412.412Z",
    transform: "translate(-434.997 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33685",
    "data-name": "Path 33685",
    d: "M937,322.18l.206.206Z",
    transform: "translate(-436.585 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33686",
    "data-name": "Path 33686",
    d: "M941,322.18l.206.206Z",
    transform: "translate(-439.76 -255.741)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33687",
    "data-name": "Path 33687",
    d: "M942,322.18l.206.206L942,322.18m3.506.206v.206l1.65-.206Z",
    transform: "translate(-440.554 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33688",
    "data-name": "Path 33688",
    d: "M967,322.18v.206h.825Z",
    transform: "translate(-460.398 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33689",
    "data-name": "Path 33689",
    d: "M971,322.18v.206h.619L971,322.18m3.712,0,.206.206Z",
    transform: "translate(-463.574 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33690",
    "data-name": "Path 33690",
    d: "M990,322.18l.206.206L990,322.18m.412,0,.206.206Z",
    transform: "translate(-478.656 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33691",
    "data-name": "Path 33691",
    d: "M993,322.18v.206h.825Z",
    transform: "translate(-481.037 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33692",
    "data-name": "Path 33692",
    d: "M997,322.18l.206.206Z",
    transform: "translate(-484.212 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33693",
    "data-name": "Path 33693",
    d: "M998,322.18l.206.206L998,322.18m1.375.068.136.068-.136-.068m.687-.068.206.206Z",
    transform: "translate(-485.006 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33694",
    "data-name": "Path 33694",
    d: "M1013,322.18l.206.206Z",
    transform: "translate(-496.913 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33695",
    "data-name": "Path 33695",
    d: "M1014,322.18l.206.206Z",
    transform: "translate(-497.707 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33696",
    "data-name": "Path 33696",
    d: "M1016,322.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-499.294 -255.741)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33697",
    "data-name": "Path 33697",
    d: "M1023,322.18l.206.206Z",
    transform: "translate(-504.851 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33698",
    "data-name": "Path 33698",
    d: "M1028,322.18l.206.206Z",
    transform: "translate(-508.82 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33699",
    "data-name": "Path 33699",
    d: "M1029,322.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-509.613 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33700",
    "data-name": "Path 33700",
    d: "M1039,322.18l.206.206Z",
    transform: "translate(-517.551 -255.741)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33701",
    "data-name": "Path 33701",
    d: "M1040,322.18l.206.206-.206-.206m.757.068.136.068-.136-.068m4.6-.068.206.206Z",
    transform: "translate(-518.345 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33702",
    "data-name": "Path 33702",
    d: "M1067,322.18l.206.206Z",
    transform: "translate(-539.778 -255.741)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33703",
    "data-name": "Path 33703",
    d: "M903.685,322.18l.206.206-.206-.206M861,322.386l.206.206Z",
    transform: "translate(-376.257 -255.741)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33704",
    "data-name": "Path 33704",
    d: "M877,323.18l.206.206Z",
    transform: "translate(-388.957 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33705",
    "data-name": "Path 33705",
    d: "M878,323.18l.206.206Z",
    transform: "translate(-389.751 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33706",
    "data-name": "Path 33706",
    d: "M888.33,323.318l.068.138-.068-.138m1.788-.138.206.206Z",
    transform: "translate(-397.951 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33707",
    "data-name": "Path 33707",
    d: "M898,323.18l.206.206L898,323.18m.825,0,.206.206Z",
    transform: "translate(-405.627 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33708",
    "data-name": "Path 33708",
    d: "M918,323.18l.206.206L918,323.18m1.443,0,.206.206Z",
    transform: "translate(-421.503 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33709",
    "data-name": "Path 33709",
    d: "M933,323.18l.206.206Z",
    transform: "translate(-433.41 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33710",
    "data-name": "Path 33710",
    d: "M934,323.18l.206.206Z",
    transform: "translate(-434.203 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33711",
    "data-name": "Path 33711",
    d: "M935,323.18l.206.206Z",
    transform: "translate(-434.997 -256.535)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33712",
    "data-name": "Path 33712",
    d: "M938,323.18l.206.206Z",
    transform: "translate(-437.379 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33713",
    "data-name": "Path 33713",
    d: "M944,323.18l.206.206Z",
    transform: "translate(-442.141 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33714",
    "data-name": "Path 33714",
    d: "M945,323.18l.206.206Z",
    transform: "translate(-442.935 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33715",
    "data-name": "Path 33715",
    d: "M986,323.18l.206.206Z",
    transform: "translate(-475.48 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33716",
    "data-name": "Path 33716",
    d: "M987,323.18l.206.206Z",
    transform: "translate(-476.274 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33717",
    "data-name": "Path 33717",
    d: "M1000,323.18l.206.206Z",
    transform: "translate(-486.594 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33718",
    "data-name": "Path 33718",
    d: "M1001,323.18l.206.206Z",
    transform: "translate(-487.387 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33719",
    "data-name": "Path 33719",
    d: "M1004,323.18l.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-489.769 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33720",
    "data-name": "Path 33720",
    d: "M1008,323.18l.206.206Z",
    transform: "translate(-492.944 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33721",
    "data-name": "Path 33721",
    d: "M1026,323.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-507.232 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33722",
    "data-name": "Path 33722",
    d: "M1033,323.18l.206.206Z",
    transform: "translate(-512.789 -256.535)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33723",
    "data-name": "Path 33723",
    d: "M1041,323.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-519.139 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33724",
    "data-name": "Path 33724",
    d: "M1046.67,323.51l.136.068Z",
    transform: "translate(-523.64 -256.797)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33725",
    "data-name": "Path 33725",
    d: "M1048,323.18l.206.206Z",
    transform: "translate(-524.695 -256.535)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33726",
    "data-name": "Path 33726",
    d: "M1049,323.18l.206.206Z",
    transform: "translate(-525.489 -256.535)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33727",
    "data-name": "Path 33727",
    d: "M1050.67,323.51l.136.068Z",
    transform: "translate(-526.815 -256.797)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33728",
    "data-name": "Path 33728",
    d: "M862,324.18l.206.206Z",
    transform: "translate(-377.05 -257.329)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33729",
    "data-name": "Path 33729",
    d: "M881,324.18l.206.206Z",
    transform: "translate(-392.132 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33730",
    "data-name": "Path 33730",
    d: "M882,324.18l.206.206Z",
    transform: "translate(-392.926 -257.329)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33731",
    "data-name": "Path 33731",
    d: "M883,324.18l.206.206L883,324.18m2.268,0,.206.206Z",
    transform: "translate(-393.72 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33732",
    "data-name": "Path 33732",
    d: "M899,324.18l.206.206Z",
    transform: "translate(-406.421 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33733",
    "data-name": "Path 33733",
    d: "M900.67,324.248l.138.068-.138-.068m3.986-.068.206.206Z",
    transform: "translate(-407.746 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33734",
    "data-name": "Path 33734",
    d: "M921.67,324.51l.138.068Z",
    transform: "translate(-424.416 -257.591)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33735",
    "data-name": "Path 33735",
    d: "M923,324.18l.206.206Z",
    transform: "translate(-425.472 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33736",
    "data-name": "Path 33736",
    d: "M928,324.18l.206.206Z",
    transform: "translate(-429.441 -257.329)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33737",
    "data-name": "Path 33737",
    d: "M929,324.18l.206.206L929,324.18m1.582.068.138.068Z",
    transform: "translate(-430.234 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33738",
    "data-name": "Path 33738",
    d: "M939.33,324.85l.068.138Z",
    transform: "translate(-438.434 -257.86)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33739",
    "data-name": "Path 33739",
    d: "M947,324.18l.206.206Z",
    transform: "translate(-444.523 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33740",
    "data-name": "Path 33740",
    d: "M948,324.18l.206.206L948,324.18m4.469.068.138.068-.138-.068m2.543-.068.206.206Z",
    transform: "translate(-445.316 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33741",
    "data-name": "Path 33741",
    d: "M983,324.18l.206.206Z",
    transform: "translate(-473.099 -257.329)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33742",
    "data-name": "Path 33742",
    d: "M1035,324.18l.206.206Z",
    transform: "translate(-514.376 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33743",
    "data-name": "Path 33743",
    d: "M1036,324.18l.206.206-.206-.206m1.443,0,.206.206Z",
    transform: "translate(-515.17 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33744",
    "data-name": "Path 33744",
    d: "M1047,324.18l.206.206Z",
    transform: "translate(-523.902 -257.329)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33745",
    "data-name": "Path 33745",
    d: "M1060.67,324.51l.136.068Z",
    transform: "translate(-534.753 -257.591)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33746",
    "data-name": "Path 33746",
    d: "M1062,324.18v.206h.825Z",
    transform: "translate(-535.809 -257.329)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33747",
    "data-name": "Path 33747",
    d: "M885,325.18l.206.206Z",
    transform: "translate(-395.308 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33748",
    "data-name": "Path 33748",
    d: "M886,325.18l.206.206Z",
    transform: "translate(-396.101 -258.122)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33749",
    "data-name": "Path 33749",
    d: "M890.33,325.85l.068.138Z",
    transform: "translate(-399.539 -258.654)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33750",
    "data-name": "Path 33750",
    d: "M891,325.18l.206.206Z",
    transform: "translate(-400.07 -258.122)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33751",
    "data-name": "Path 33751",
    d: "M892,325.18l.206.206L892,325.18m.619,0,.206.206-.206-.206m1.65,0,.206.206Z",
    transform: "translate(-400.864 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33752",
    "data-name": "Path 33752",
    d: "M904,325.18l.206.206L904,325.18m1.169.068.138.068Z",
    transform: "translate(-410.39 -258.122)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33753",
    "data-name": "Path 33753",
    d: "M926.33,325.85l.068.138Z",
    transform: "translate(-428.115 -258.654)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33754",
    "data-name": "Path 33754",
    d: "M933,325.18l.206.206Z",
    transform: "translate(-433.41 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33755",
    "data-name": "Path 33755",
    d: "M934,325.18l.206.206Z",
    transform: "translate(-434.203 -258.122)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33756",
    "data-name": "Path 33756",
    d: "M951,325.18l.206.206Z",
    transform: "translate(-447.698 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33757",
    "data-name": "Path 33757",
    d: "M952,325.18l.206.206L952,325.18m5.361,0,.206.206Z",
    transform: "translate(-448.492 -258.122)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33758",
    "data-name": "Path 33758",
    d: "M979,325.18l.206.206Z",
    transform: "translate(-469.924 -258.122)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33759",
    "data-name": "Path 33759",
    d: "M980,325.18l.206.206L980,325.18m11.96,0,.206.206Z",
    transform: "translate(-470.718 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33760",
    "data-name": "Path 33760",
    d: "M1039,325.18l.206.206Z",
    transform: "translate(-517.551 -258.122)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33761",
    "data-name": "Path 33761",
    d: "M1045,325.18l.206.206-.206-.206m.619,0v.619h.206Z",
    transform: "translate(-522.314 -258.122)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33762",
    "data-name": "Path 33762",
    d: "M1049,325.18l.206.206Z",
    transform: "translate(-525.489 -258.122)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33763",
    "data-name": "Path 33763",
    d: "M889,326.18l.206.206Z",
    transform: "translate(-398.483 -258.916)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33764",
    "data-name": "Path 33764",
    d: "M906,326.18l.206.206Z",
    transform: "translate(-411.977 -258.916)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33765",
    "data-name": "Path 33765",
    d: "M907,326.18l.206.206L907,326.18m.825,0,.619.412Z",
    transform: "translate(-412.771 -258.916)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33766",
    "data-name": "Path 33766",
    d: "M913.67,326.51l.138.068Z",
    transform: "translate(-418.066 -259.178)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33767",
    "data-name": "Path 33767",
    d: "M915,326.18l.206.206Z",
    transform: "translate(-419.121 -258.916)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33768",
    "data-name": "Path 33768",
    d: "M916.67,326.51l.138.068Z",
    transform: "translate(-420.447 -259.178)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33769",
    "data-name": "Path 33769",
    d: "M918,326.18l.825.619v-.412Z",
    transform: "translate(-421.503 -258.916)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33770",
    "data-name": "Path 33770",
    d: "M937.67,326.51l.138.068Z",
    transform: "translate(-437.117 -259.178)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33771",
    "data-name": "Path 33771",
    d: "M955,326.18l.206.206Z",
    transform: "translate(-450.873 -258.916)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33772",
    "data-name": "Path 33772",
    d: "M956,326.18l.206.206Z",
    transform: "translate(-451.667 -258.916)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33773",
    "data-name": "Path 33773",
    d: "M960,326.18v.206h.825Z",
    transform: "translate(-454.842 -258.916)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33774",
    "data-name": "Path 33774",
    d: "M964,326.18l.206.206Z",
    transform: "translate(-458.017 -258.916)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33775",
    "data-name": "Path 33775",
    d: "M971,326.18v.206h1.031L971,326.18m14.847,0,.206.206Z",
    transform: "translate(-463.574 -258.916)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33776",
    "data-name": "Path 33776",
    d: "M1044,326.18l.206.206Z",
    transform: "translate(-521.52 -258.916)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33777",
    "data-name": "Path 33777",
    d: "M910.67,327.51l.138.068Z",
    transform: "translate(-415.684 -259.972)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33778",
    "data-name": "Path 33778",
    d: "M914,327.18v.206h1.031Z",
    transform: "translate(-418.328 -259.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33779",
    "data-name": "Path 33779",
    d: "M920,327.18l.206.206L920,327.18m.825,0,.206.206-.206-.206m25.364,0,.206.206Z",
    transform: "translate(-423.09 -259.71)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33780",
    "data-name": "Path 33780",
    d: "M1049,327.18l.206.206Z",
    transform: "translate(-525.489 -259.71)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33781",
    "data-name": "Path 33781",
    d: "M918.67,328.51l.138.068Z",
    transform: "translate(-422.035 -260.766)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33782",
    "data-name": "Path 33782",
    d: "M924,328.18l.206.206Z",
    transform: "translate(-426.265 -260.504)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33783",
    "data-name": "Path 33783",
    d: "M954,334.18l.206.206Z",
    transform: "translate(-450.079 -265.266)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33784",
    "data-name": "Path 33784",
    d: "M953.412,334.18l.825.619V335L953,334.8V335l4.743,1.443-.825-.619v-.206l6.6.412c0-.779,1.5-.1,2.062-.035,1.365.153,2.936-.53,4.33-.1.895.274,1.538.971,2.474,1.169l-1.031-1.237,1.856.412-.206-.619,3.918.412c-.324-1.109-3.438-1.309-4.537-1.443v.206l1.237.412v.206l-2.474-.619V335l1.65.825v.206l-2.887-1.237.206.619-1.65-.412c0,.86-1.483.262-2.062.206-1.891-.184-4.71-.695-6.186.412l-2.681-.825V335l1.031.412v.206Z",
    transform: "translate(-449.285 -265.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33785",
    "data-name": "Path 33785",
    d: "M956,334.18l.206.206Z",
    transform: "translate(-451.667 -265.266)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33786",
    "data-name": "Path 33786",
    d: "M957,334.18l.206.206Z",
    transform: "translate(-452.461 -265.266)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33787",
    "data-name": "Path 33787",
    d: "M883,335.18l.206.206Z",
    transform: "translate(-393.72 -266.06)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33788",
    "data-name": "Path 33788",
    d: "M871.093,336.18l1.237.825a7.786,7.786,0,0,0-4.33-.619l4.33,1.65-1.856-1.237v-.206l6.8,1.237v-.206h-.825v-.206l1.856.206v.206h-.825v.206l2.062-.206-.412-.619,2.062.825-.825-.619v-.206l5.774.619-2.062-1.443h1.237v-.206h-1.443V337c-1.025-.012-4.611-1.256-4.743-.206l-1.856-.619.206.619-1.443-.206v.619Z",
    transform: "translate(-381.813 -266.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33789",
    "data-name": "Path 33789",
    d: "M885.67,335.51l.138.068Z",
    transform: "translate(-395.839 -266.322)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33790",
    "data-name": "Path 33790",
    d: "M887,335.18l.206.206Z",
    transform: "translate(-396.895 -266.06)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33791",
    "data-name": "Path 33791",
    d: "M922.67,335.51l.138.068Z",
    transform: "translate(-425.21 -266.322)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33792",
    "data-name": "Path 33792",
    d: "M924,335.18l.206.206L924,335.18m4.537,0,.206.206Z",
    transform: "translate(-426.265 -266.06)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33793",
    "data-name": "Path 33793",
    d: "M947.67,335.51l.138.068Z",
    transform: "translate(-445.055 -266.322)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33794",
    "data-name": "Path 33794",
    d: "M949,335.18l.206.206Z",
    transform: "translate(-446.11 -266.06)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33795",
    "data-name": "Path 33795",
    d: "M886.559,335.18l.206.206-.206-.206M868,335.386l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-381.813 -266.06)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33796",
    "data-name": "Path 33796",
    d: "M873,336.18l.206.206Z",
    transform: "translate(-385.782 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33797",
    "data-name": "Path 33797",
    d: "M889,336.18l.206.206Z",
    transform: "translate(-398.483 -266.854)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33798",
    "data-name": "Path 33798",
    d: "M916,336.18l.206.206Z",
    transform: "translate(-419.915 -266.854)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33799",
    "data-name": "Path 33799",
    d: "M917,336.18l.206.206Z",
    transform: "translate(-420.709 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33800",
    "data-name": "Path 33800",
    d: "M921,336.18l.206.206Z",
    transform: "translate(-423.884 -266.854)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33801",
    "data-name": "Path 33801",
    d: "M927,336.18l.206.206L927,336.18m3.506,0,.206.206Z",
    transform: "translate(-428.647 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33802",
    "data-name": "Path 33802",
    d: "M952.33,336.85l.068.138Z",
    transform: "translate(-448.754 -267.386)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33803",
    "data-name": "Path 33803",
    d: "M953,336.18l.206.206Z",
    transform: "translate(-449.285 -266.854)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33804",
    "data-name": "Path 33804",
    d: "M954,336.18l.206.206Z",
    transform: "translate(-450.079 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33805",
    "data-name": "Path 33805",
    d: "M955,336.18l.206.206Z",
    transform: "translate(-450.873 -266.854)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33806",
    "data-name": "Path 33806",
    d: "M956,336.18l.206.206Z",
    transform: "translate(-451.667 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33807",
    "data-name": "Path 33807",
    d: "M957.33,336.318l.068.138-.068-.138m.551-.138.206.206Z",
    transform: "translate(-452.722 -266.854)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33808",
    "data-name": "Path 33808",
    d: "M961,336.18l.206.206L961,336.18m2.887,0,.206.206Z",
    transform: "translate(-455.636 -266.854)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33809",
    "data-name": "Path 33809",
    d: "M976,336.18l.206.206Z",
    transform: "translate(-467.543 -266.854)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33810",
    "data-name": "Path 33810",
    d: "M1046,336.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-523.108 -266.854)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33811",
    "data-name": "Path 33811",
    d: "M911.293,336.18l.206.206-.206-.206M875,336.386l.206.206Z",
    transform: "translate(-387.37 -266.854)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33812",
    "data-name": "Path 33812",
    d: "M876,337.18l.206.206Z",
    transform: "translate(-388.164 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33813",
    "data-name": "Path 33813",
    d: "M877,337.18l.206.206L877,337.18m1.031,0,.206.206Z",
    transform: "translate(-388.957 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33814",
    "data-name": "Path 33814",
    d: "M883.67,337.51l.138.068Z",
    transform: "translate(-394.252 -267.91)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33815",
    "data-name": "Path 33815",
    d: "M885.33,337.318l.068.138-.068-.138m1.169-.138.206.206Z",
    transform: "translate(-395.57 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33816",
    "data-name": "Path 33816",
    d: "M892,337.18l.206.206L892,337.18m3.3,0,.206.206Z",
    transform: "translate(-400.864 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33817",
    "data-name": "Path 33817",
    d: "M918,337.18l.206.206Z",
    transform: "translate(-421.503 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33818",
    "data-name": "Path 33818",
    d: "M919,337.18l.206.206Z",
    transform: "translate(-422.297 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33819",
    "data-name": "Path 33819",
    d: "M929,337.18l.206.206Z",
    transform: "translate(-430.234 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33820",
    "data-name": "Path 33820",
    d: "M944.33,337.318l.068.138-.068-.138m.344-.138.206.206Z",
    transform: "translate(-442.403 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33821",
    "data-name": "Path 33821",
    d: "M950,337.18l.206.206Z",
    transform: "translate(-446.904 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33822",
    "data-name": "Path 33822",
    d: "M951,337.18l.206.206L951,337.18m1.443,0,.206.206Z",
    transform: "translate(-447.698 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33823",
    "data-name": "Path 33823",
    d: "M963,337.18l.206.206Z",
    transform: "translate(-457.223 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33824",
    "data-name": "Path 33824",
    d: "M979,337.18l.206.206Z",
    transform: "translate(-469.924 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33825",
    "data-name": "Path 33825",
    d: "M990,337.18l.206.206Z",
    transform: "translate(-478.656 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33826",
    "data-name": "Path 33826",
    d: "M996.67,337.51l.138.068Z",
    transform: "translate(-483.95 -267.91)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33827",
    "data-name": "Path 33827",
    d: "M998,337.18l.206.206Z",
    transform: "translate(-485.006 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33828",
    "data-name": "Path 33828",
    d: "M999,337.18l.206.206Z",
    transform: "translate(-485.8 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33829",
    "data-name": "Path 33829",
    d: "M1028,337.18l.206.206Z",
    transform: "translate(-508.82 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33830",
    "data-name": "Path 33830",
    d: "M1029,337.18l.206.206Z",
    transform: "translate(-509.613 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33831",
    "data-name": "Path 33831",
    d: "M1030,337.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-510.407 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33832",
    "data-name": "Path 33832",
    d: "M1036,337.18l.206.206Z",
    transform: "translate(-515.17 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33833",
    "data-name": "Path 33833",
    d: "M1037,337.18l.206.206Z",
    transform: "translate(-515.964 -267.648)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33834",
    "data-name": "Path 33834",
    d: "M1040,337.18l.206.206Z",
    transform: "translate(-518.345 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33835",
    "data-name": "Path 33835",
    d: "M1044,337.18l.206.206Z",
    transform: "translate(-521.52 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33836",
    "data-name": "Path 33836",
    d: "M1046.206,337.18l-.206.412.206-.412m1.443,0,.206.206Z",
    transform: "translate(-523.108 -267.648)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33837",
    "data-name": "Path 33837",
    d: "M907.355,337.18l.206.206-.206-.206M869,337.386l.206.206Z",
    transform: "translate(-382.607 -267.648)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33838",
    "data-name": "Path 33838",
    d: "M870,338.18l.206.206L870,338.18m2.2.068.138.068Z",
    transform: "translate(-383.401 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33839",
    "data-name": "Path 33839",
    d: "M886.67,338.51l.138.068Z",
    transform: "translate(-396.633 -268.704)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33840",
    "data-name": "Path 33840",
    d: "M888.33,338.318l.068.138-.068-.138m.963-.138.206.206Z",
    transform: "translate(-397.951 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33841",
    "data-name": "Path 33841",
    d: "M894,338.18l.206.206Z",
    transform: "translate(-402.452 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33842",
    "data-name": "Path 33842",
    d: "M906.33,338.85l.068.138Z",
    transform: "translate(-412.239 -268.974)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33843",
    "data-name": "Path 33843",
    d: "M911,338.18l.206.206Z",
    transform: "translate(-415.946 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33844",
    "data-name": "Path 33844",
    d: "M912.67,338.51l.138.068Z",
    transform: "translate(-417.272 -268.704)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33845",
    "data-name": "Path 33845",
    d: "M916,338.18l1.237,1.031V339Z",
    transform: "translate(-419.915 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33846",
    "data-name": "Path 33846",
    d: "M917,338.18l.206.206Z",
    transform: "translate(-420.709 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33847",
    "data-name": "Path 33847",
    d: "M920,338.18l.206.206Z",
    transform: "translate(-423.09 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33848",
    "data-name": "Path 33848",
    d: "M921,338.18l.206.206Z",
    transform: "translate(-423.884 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33849",
    "data-name": "Path 33849",
    d: "M931,338.18l.206.206Z",
    transform: "translate(-431.822 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33850",
    "data-name": "Path 33850",
    d: "M932.67,338.51l.138.068Z",
    transform: "translate(-433.148 -268.704)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33851",
    "data-name": "Path 33851",
    d: "M946,338.18l.206.206Z",
    transform: "translate(-443.729 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33852",
    "data-name": "Path 33852",
    d: "M955.33,338.318l.068.138-.068-.138m2.613-.138.206.206Z",
    transform: "translate(-451.135 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33853",
    "data-name": "Path 33853",
    d: "M969,338.18l.206.206L969,338.18m1.237,0,.206.206Z",
    transform: "translate(-461.986 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33854",
    "data-name": "Path 33854",
    d: "M983,338.18l.206.206Z",
    transform: "translate(-473.099 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33855",
    "data-name": "Path 33855",
    d: "M984,338.18l.206.206L984,338.18m1.031,0,.206.206Z",
    transform: "translate(-473.893 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33856",
    "data-name": "Path 33856",
    d: "M994,338.18l.206.206L994,338.18m1.65,0,.206.206Z",
    transform: "translate(-481.831 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33857",
    "data-name": "Path 33857",
    d: "M1003,338.18l.206.206Z",
    transform: "translate(-488.975 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33858",
    "data-name": "Path 33858",
    d: "M1012,338.18l.206.206Z",
    transform: "translate(-496.119 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33859",
    "data-name": "Path 33859",
    d: "M1013,338.18v.206h.825Z",
    transform: "translate(-496.913 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33860",
    "data-name": "Path 33860",
    d: "M1017,338.18l.206.206Z",
    transform: "translate(-500.088 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33861",
    "data-name": "Path 33861",
    d: "M1031,338.18l.206.206Z",
    transform: "translate(-511.201 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33862",
    "data-name": "Path 33862",
    d: "M1032,338.18l.206.206Z",
    transform: "translate(-511.995 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33863",
    "data-name": "Path 33863",
    d: "M1034,338.18l.206.206Z",
    transform: "translate(-513.582 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33864",
    "data-name": "Path 33864",
    d: "M1039,338.18l.206.206Z",
    transform: "translate(-517.551 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33865",
    "data-name": "Path 33865",
    d: "M1040,338.18l.206.206Z",
    transform: "translate(-518.345 -268.442)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33866",
    "data-name": "Path 33866",
    d: "M1041,338.18l.206.206Z",
    transform: "translate(-519.139 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33867",
    "data-name": "Path 33867",
    d: "M1047,338.18l.206.206Z",
    transform: "translate(-523.902 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33868",
    "data-name": "Path 33868",
    d: "M1048,338.18l.206.206Z",
    transform: "translate(-524.695 -268.442)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33869",
    "data-name": "Path 33869",
    d: "M1049,338.18l.206.206Z",
    transform: "translate(-525.489 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33870",
    "data-name": "Path 33870",
    d: "M1049.206,338.18l-.206.412.206-.412m1.788.068.136.068Z",
    transform: "translate(-525.489 -268.442)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33871",
    "data-name": "Path 33871",
    d: "M1060,338.18l.206.206Z",
    transform: "translate(-534.221 -268.442)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33872",
    "data-name": "Path 33872",
    d: "M1061,338.18l.206.206Z",
    transform: "translate(-535.015 -268.442)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33873",
    "data-name": "Path 33873",
    d: "M858,339.18l.206.206Z",
    transform: "translate(-373.875 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33874",
    "data-name": "Path 33874",
    d: "M859,339.18l.206.206Z",
    transform: "translate(-374.669 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33875",
    "data-name": "Path 33875",
    d: "M861,339.18l.206.206Z",
    transform: "translate(-376.257 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33876",
    "data-name": "Path 33876",
    d: "M862,339.18v.206h.825Z",
    transform: "translate(-377.05 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33877",
    "data-name": "Path 33877",
    d: "M866,339.18l.206.206L866,339.18m1.237.412.619-.412Z",
    transform: "translate(-380.226 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33878",
    "data-name": "Path 33878",
    d: "M875,339.18l.206.206Z",
    transform: "translate(-387.37 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33879",
    "data-name": "Path 33879",
    d: "M881,339.18l.206.206Z",
    transform: "translate(-392.132 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33880",
    "data-name": "Path 33880",
    d: "M882,339.18l.206.206Z",
    transform: "translate(-392.926 -269.235)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33881",
    "data-name": "Path 33881",
    d: "M883,339.18l.206.206Z",
    transform: "translate(-393.72 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33882",
    "data-name": "Path 33882",
    d: "M884,339.18l.206.206Z",
    transform: "translate(-394.514 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33883",
    "data-name": "Path 33883",
    d: "M896,339.18l.206.206Z",
    transform: "translate(-404.039 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33884",
    "data-name": "Path 33884",
    d: "M909,339.18v.206l.825.206v-.206Z",
    transform: "translate(-414.359 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33885",
    "data-name": "Path 33885",
    d: "M914,339.18l.206.206Z",
    transform: "translate(-418.328 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33886",
    "data-name": "Path 33886",
    d: "M916,339.18v.206l.825.206v-.206Z",
    transform: "translate(-419.915 -269.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33887",
    "data-name": "Path 33887",
    d: "M918.67,339.51l.138.068Z",
    transform: "translate(-422.035 -269.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33888",
    "data-name": "Path 33888",
    d: "M922,339.18l.206.206Z",
    transform: "translate(-424.678 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33889",
    "data-name": "Path 33889",
    d: "M925,339.18l.412.412v-.412Z",
    transform: "translate(-427.059 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33890",
    "data-name": "Path 33890",
    d: "M938.67,339.51l.138.068Z",
    transform: "translate(-437.91 -269.497)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33891",
    "data-name": "Path 33891",
    d: "M940.67,339.51l.138.068Z",
    transform: "translate(-439.498 -269.497)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33892",
    "data-name": "Path 33892",
    d: "M942,339.18l.206.206L942,339.18m.412,0,.206.206Z",
    transform: "translate(-440.554 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33893",
    "data-name": "Path 33893",
    d: "M948,339.18l.206.206Z",
    transform: "translate(-445.316 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33894",
    "data-name": "Path 33894",
    d: "M972,339.18l.206.206Z",
    transform: "translate(-464.367 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33895",
    "data-name": "Path 33895",
    d: "M973,339.18l.206.206L973,339.18m.893.138.068.138Z",
    transform: "translate(-465.161 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33896",
    "data-name": "Path 33896",
    d: "M988.206,339.18l-.206.412h.412l-.206-.412m3.85.068.136.068-.136-.068m2.681,0,.136.068Z",
    transform: "translate(-477.068 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33897",
    "data-name": "Path 33897",
    d: "M1022,339.18v.206h.619Z",
    transform: "translate(-504.057 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33898",
    "data-name": "Path 33898",
    d: "M1025,339.18l.206.206Z",
    transform: "translate(-506.438 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33899",
    "data-name": "Path 33899",
    d: "M1028,339.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-508.82 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33900",
    "data-name": "Path 33900",
    d: "M1034,339.18l.206.206Z",
    transform: "translate(-513.582 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33901",
    "data-name": "Path 33901",
    d: "M1035,339.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-514.376 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33902",
    "data-name": "Path 33902",
    d: "M1041,339.18l.206.206Z",
    transform: "translate(-519.139 -269.235)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33903",
    "data-name": "Path 33903",
    d: "M1042,339.18l.206.206Z",
    transform: "translate(-519.933 -269.235)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33904",
    "data-name": "Path 33904",
    d: "M1043.33,339.318l.07.138-.07-.138m1.375-.138.206.206Z",
    transform: "translate(-520.988 -269.235)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33905",
    "data-name": "Path 33905",
    d: "M1051,339.18l.206.206Z",
    transform: "translate(-527.077 -269.235)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33906",
    "data-name": "Path 33906",
    d: "M1052,339.18l.206.206-.206-.206m2.887,0v.206h.619Z",
    transform: "translate(-527.871 -269.235)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33907",
    "data-name": "Path 33907",
    d: "M858,340.18v.619c1.427.113,2.825.608,4.124-.206Z",
    transform: "translate(-373.875 -270.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33908",
    "data-name": "Path 33908",
    d: "M870.67,340.51l.138.068Z",
    transform: "translate(-383.933 -270.291)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33909",
    "data-name": "Path 33909",
    d: "M874,340.18v.206h.619Z",
    transform: "translate(-386.576 -270.029)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33910",
    "data-name": "Path 33910",
    d: "M877,340.18l.619.619Z",
    transform: "translate(-388.957 -270.029)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33911",
    "data-name": "Path 33911",
    d: "M884,340.18l.206.206Z",
    transform: "translate(-394.514 -270.029)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33912",
    "data-name": "Path 33912",
    d: "M885,340.18l.206.206Z",
    transform: "translate(-395.308 -270.029)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33913",
    "data-name": "Path 33913",
    d: "M886.33,340.85l.068.138Z",
    transform: "translate(-396.363 -270.561)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33914",
    "data-name": "Path 33914",
    d: "M887,340.18l.206.206L887,340.18m2.887,0v.206h1.237Z",
    transform: "translate(-396.895 -270.029)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33915",
    "data-name": "Path 33915",
    d: "M920.67,340.51l.138.068Z",
    transform: "translate(-423.622 -270.291)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33916",
    "data-name": "Path 33916",
    d: "M950,340.18l.206.206Z",
    transform: "translate(-446.904 -270.029)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33917",
    "data-name": "Path 33917",
    d: "M951,340.18l.206.206L951,340.18m1.237,0,.206.206Z",
    transform: "translate(-447.698 -270.029)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33918",
    "data-name": "Path 33918",
    d: "M958,340.18l.206.206L958,340.18m2.268,0v.206h.619l-.619-.206m1.443,0,.206.206Z",
    transform: "translate(-453.254 -270.029)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33919",
    "data-name": "Path 33919",
    d: "M978,340.18l.206.206Z",
    transform: "translate(-469.13 -270.029)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33920",
    "data-name": "Path 33920",
    d: "M979,340.18l.206.206Z",
    transform: "translate(-469.924 -270.029)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33921",
    "data-name": "Path 33921",
    d: "M1000,340.18v.206h.619Z",
    transform: "translate(-486.594 -270.029)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33922",
    "data-name": "Path 33922",
    d: "M1044,340.18l.206.206Z",
    transform: "translate(-521.52 -270.029)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33923",
    "data-name": "Path 33923",
    d: "M1045,340.18l.206.206Z",
    transform: "translate(-522.314 -270.029)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33924",
    "data-name": "Path 33924",
    d: "M885,341.18l.206.206Z",
    transform: "translate(-395.308 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33925",
    "data-name": "Path 33925",
    d: "M890,341.18l.206.206Z",
    transform: "translate(-399.277 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33926",
    "data-name": "Path 33926",
    d: "M891,341.18l.206.206Z",
    transform: "translate(-400.07 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33927",
    "data-name": "Path 33927",
    d: "M922,341.18l.206.206Z",
    transform: "translate(-424.678 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33928",
    "data-name": "Path 33928",
    d: "M923.33,341.318l.068.138-.068-.138m.963-.138.206.206Z",
    transform: "translate(-425.734 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33929",
    "data-name": "Path 33929",
    d: "M929,341.18v.206h.825Z",
    transform: "translate(-430.234 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33930",
    "data-name": "Path 33930",
    d: "M933,341.18l.206.206Z",
    transform: "translate(-433.41 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33931",
    "data-name": "Path 33931",
    d: "M934,341.18l.206.206Z",
    transform: "translate(-434.203 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33932",
    "data-name": "Path 33932",
    d: "M935.67,341.51l.138.068Z",
    transform: "translate(-435.529 -271.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33933",
    "data-name": "Path 33933",
    d: "M955,341.18l.206.206Z",
    transform: "translate(-450.873 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33934",
    "data-name": "Path 33934",
    d: "M961,341.18l.206.206Z",
    transform: "translate(-455.636 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33935",
    "data-name": "Path 33935",
    d: "M962,341.18l.206.206Z",
    transform: "translate(-456.43 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33936",
    "data-name": "Path 33936",
    d: "M963,341.18l.206.206L963,341.18m1.856,0,.206.206Z",
    transform: "translate(-457.223 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33937",
    "data-name": "Path 33937",
    d: "M973,341.18l.206.206Z",
    transform: "translate(-465.161 -270.823)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33938",
    "data-name": "Path 33938",
    d: "M974,341.18l.206.206Z",
    transform: "translate(-465.955 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33939",
    "data-name": "Path 33939",
    d: "M975,341.18l.206.206Z",
    transform: "translate(-466.749 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33940",
    "data-name": "Path 33940",
    d: "M983,341.18l.206.206Z",
    transform: "translate(-473.099 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33941",
    "data-name": "Path 33941",
    d: "M984,341.18l.206.206Z",
    transform: "translate(-473.893 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33942",
    "data-name": "Path 33942",
    d: "M993,341.18l.206.206Z",
    transform: "translate(-481.037 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33943",
    "data-name": "Path 33943",
    d: "M994.67,341.51l.138.068Z",
    transform: "translate(-482.363 -271.085)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33944",
    "data-name": "Path 33944",
    d: "M1003,341.18l.206.206Z",
    transform: "translate(-488.975 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33945",
    "data-name": "Path 33945",
    d: "M1005,341.18l.206.206Z",
    transform: "translate(-490.563 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33946",
    "data-name": "Path 33946",
    d: "M1006,341.18l.206.206-.206-.206m.963.068.136.068-.136-.068m7.079-.068.206.206Z",
    transform: "translate(-491.356 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33947",
    "data-name": "Path 33947",
    d: "M1046,341.18l.206.206Z",
    transform: "translate(-523.108 -270.823)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33948",
    "data-name": "Path 33948",
    d: "M1047,341.18l.206.206Z",
    transform: "translate(-523.902 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33949",
    "data-name": "Path 33949",
    d: "M1050,341.18l.206.206Z",
    transform: "translate(-526.283 -270.823)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33950",
    "data-name": "Path 33950",
    d: "M1051,341.18l.206.206Z",
    transform: "translate(-527.077 -270.823)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33951",
    "data-name": "Path 33951",
    d: "M909.118,341.18l.206.206-.206-.206M872,341.386l.206.206Z",
    transform: "translate(-384.988 -270.823)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33952",
    "data-name": "Path 33952",
    d: "M880,342.18v.206h.619Z",
    transform: "translate(-391.339 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33953",
    "data-name": "Path 33953",
    d: "M883,342.18l.206.206Z",
    transform: "translate(-393.72 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33954",
    "data-name": "Path 33954",
    d: "M888,342.18l.206.206L888,342.18m.825,0,.206.206Z",
    transform: "translate(-397.689 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33955",
    "data-name": "Path 33955",
    d: "M909,342.18l.206.206Z",
    transform: "translate(-414.359 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33956",
    "data-name": "Path 33956",
    d: "M910,342.18l.206.206Z",
    transform: "translate(-415.152 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33957",
    "data-name": "Path 33957",
    d: "M911,342.18l.206.206Z",
    transform: "translate(-415.946 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33958",
    "data-name": "Path 33958",
    d: "M912,342.18l.206.206Z",
    transform: "translate(-416.74 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33959",
    "data-name": "Path 33959",
    d: "M913,342.18v.619h.206Z",
    transform: "translate(-417.534 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33960",
    "data-name": "Path 33960",
    d: "M924,342.18l.206.206Z",
    transform: "translate(-426.265 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33961",
    "data-name": "Path 33961",
    d: "M925,342.18l.206.206Z",
    transform: "translate(-427.059 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33962",
    "data-name": "Path 33962",
    d: "M930,342.18l.206.206L930,342.18m1.65,0,.206.206Z",
    transform: "translate(-431.028 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33963",
    "data-name": "Path 33963",
    d: "M939,342.18v.206h.825Z",
    transform: "translate(-438.172 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33964",
    "data-name": "Path 33964",
    d: "M965,342.18l.206.206Z",
    transform: "translate(-458.811 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33965",
    "data-name": "Path 33965",
    d: "M966,342.18l.206.206L966,342.18m1.65,0,.206.206Z",
    transform: "translate(-459.605 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33966",
    "data-name": "Path 33966",
    d: "M978,342.18l.206.206Z",
    transform: "translate(-469.13 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33967",
    "data-name": "Path 33967",
    d: "M979,342.18l.206.206Z",
    transform: "translate(-469.924 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33968",
    "data-name": "Path 33968",
    d: "M980.67,342.51l.138.068Z",
    transform: "translate(-471.249 -271.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33969",
    "data-name": "Path 33969",
    d: "M982,342.18l.206.206Z",
    transform: "translate(-472.305 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33970",
    "data-name": "Path 33970",
    d: "M998,342.18l.206.206Z",
    transform: "translate(-485.006 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33971",
    "data-name": "Path 33971",
    d: "M999,342.18l.206.206Z",
    transform: "translate(-485.8 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33972",
    "data-name": "Path 33972",
    d: "M1000,342.18l.206.206Z",
    transform: "translate(-486.594 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33973",
    "data-name": "Path 33973",
    d: "M1012,342.18l.206.206Z",
    transform: "translate(-496.119 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33974",
    "data-name": "Path 33974",
    d: "M1016.67,342.51l.136.068Z",
    transform: "translate(-499.826 -271.879)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33975",
    "data-name": "Path 33975",
    d: "M1018,342.18v.206h2.268Z",
    transform: "translate(-500.882 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33976",
    "data-name": "Path 33976",
    d: "M1035,342.18l.206.206Z",
    transform: "translate(-514.376 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33977",
    "data-name": "Path 33977",
    d: "M1042,342.18l.206.206Z",
    transform: "translate(-519.933 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33978",
    "data-name": "Path 33978",
    d: "M1042.206,342.18l-.206.412.206-.412m.825,0,.206.206Z",
    transform: "translate(-519.933 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33979",
    "data-name": "Path 33979",
    d: "M1048,342.18l.206.206Z",
    transform: "translate(-524.695 -271.617)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33980",
    "data-name": "Path 33980",
    d: "M1065,342.18l.206.206Z",
    transform: "translate(-538.19 -271.617)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33981",
    "data-name": "Path 33981",
    d: "M1066,342.18l.206.206Z",
    transform: "translate(-538.984 -271.617)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33982",
    "data-name": "Path 33982",
    d: "M859.67,343.51l.138.068Z",
    transform: "translate(-375.201 -272.673)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33983",
    "data-name": "Path 33983",
    d: "M861.67,343.248l.138.068-.138-.068m2.749-.068.206.206Z",
    transform: "translate(-376.788 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33984",
    "data-name": "Path 33984",
    d: "M876,343.18l.206.206L876,343.18m1.65,0,.206.206Z",
    transform: "translate(-388.164 -272.411)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33985",
    "data-name": "Path 33985",
    d: "M885,343.18l.206.206Z",
    transform: "translate(-395.308 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33986",
    "data-name": "Path 33986",
    d: "M889.33,343.85l.068.138Z",
    transform: "translate(-398.745 -272.942)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33987",
    "data-name": "Path 33987",
    d: "M900,343.18l.206.206Z",
    transform: "translate(-407.215 -272.411)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33988",
    "data-name": "Path 33988",
    d: "M901,343.18l.206.206L901,343.18m.825,0,.206.206Z",
    transform: "translate(-408.008 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33989",
    "data-name": "Path 33989",
    d: "M906.67,343.51l.138.068Z",
    transform: "translate(-412.509 -272.673)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33990",
    "data-name": "Path 33990",
    d: "M908,343.18l.206.206Z",
    transform: "translate(-413.565 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33991",
    "data-name": "Path 33991",
    d: "M914,343.18l.206.206Z",
    transform: "translate(-418.328 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33992",
    "data-name": "Path 33992",
    d: "M915,343.18l.206.206Z",
    transform: "translate(-419.121 -272.411)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33993",
    "data-name": "Path 33993",
    d: "M916,343.18l.206.206Z",
    transform: "translate(-419.915 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33994",
    "data-name": "Path 33994",
    d: "M917,343.18l.206.206Z",
    transform: "translate(-420.709 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33995",
    "data-name": "Path 33995",
    d: "M924,343.18l.206.206Z",
    transform: "translate(-426.265 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33996",
    "data-name": "Path 33996",
    d: "M926,343.18l.206.206Z",
    transform: "translate(-427.853 -272.411)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33997",
    "data-name": "Path 33997",
    d: "M931,343.18l.206.206Z",
    transform: "translate(-431.822 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33998",
    "data-name": "Path 33998",
    d: "M947.67,343.51l.138.068Z",
    transform: "translate(-445.055 -272.673)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33999",
    "data-name": "Path 33999",
    d: "M949,343.18l.206.206Z",
    transform: "translate(-446.11 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34000",
    "data-name": "Path 34000",
    d: "M968,343.18l.206.206Z",
    transform: "translate(-461.192 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34001",
    "data-name": "Path 34001",
    d: "M969,343.18l.206.206Z",
    transform: "translate(-461.986 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34002",
    "data-name": "Path 34002",
    d: "M1037,343.18l.206.206Z",
    transform: "translate(-515.964 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34003",
    "data-name": "Path 34003",
    d: "M1043.67,343.51l.136.068Z",
    transform: "translate(-521.258 -272.673)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34004",
    "data-name": "Path 34004",
    d: "M1045,343.18l.206.206Z",
    transform: "translate(-522.314 -272.411)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34005",
    "data-name": "Path 34005",
    d: "M1046,343.18l.206.206Z",
    transform: "translate(-523.108 -272.411)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34006",
    "data-name": "Path 34006",
    d: "M905.474,343.18l.206.206-.206-.206m-37.8.274.138.068Z",
    transform: "translate(-381.551 -272.411)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34007",
    "data-name": "Path 34007",
    d: "M869,344.18l.206.206Z",
    transform: "translate(-382.607 -273.204)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34008",
    "data-name": "Path 34008",
    d: "M872,344.18l.206.206L872,344.18m3.093,0,.206.206Z",
    transform: "translate(-384.988 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34009",
    "data-name": "Path 34009",
    d: "M903,344.18l.206.206Z",
    transform: "translate(-409.596 -273.204)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34010",
    "data-name": "Path 34010",
    d: "M904,344.18l.206.206Z",
    transform: "translate(-410.39 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34011",
    "data-name": "Path 34011",
    d: "M905,344.18l.206.206L905,344.18m1.237,0,.206.206Z",
    transform: "translate(-411.183 -273.204)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34012",
    "data-name": "Path 34012",
    d: "M912,344.18l.206.206L912,344.18m1.994.068.138.068Z",
    transform: "translate(-416.74 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34013",
    "data-name": "Path 34013",
    d: "M923,344.18l.206.206Z",
    transform: "translate(-425.472 -273.204)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34014",
    "data-name": "Path 34014",
    d: "M924,344.18l.206.206Z",
    transform: "translate(-426.265 -273.204)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34015",
    "data-name": "Path 34015",
    d: "M928,344.18l.206.206L928,344.18m8.867,0,.206.206Z",
    transform: "translate(-429.441 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34016",
    "data-name": "Path 34016",
    d: "M972,344.18l.206.206Z",
    transform: "translate(-464.367 -273.204)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34017",
    "data-name": "Path 34017",
    d: "M976,344.18l.206.206Z",
    transform: "translate(-467.543 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34018",
    "data-name": "Path 34018",
    d: "M1038,344.18l.206.206Z",
    transform: "translate(-516.758 -273.204)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34019",
    "data-name": "Path 34019",
    d: "M1039,344.18l.206.206Z",
    transform: "translate(-517.551 -273.204)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34020",
    "data-name": "Path 34020",
    d: "M1044,344.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-521.52 -273.204)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34021",
    "data-name": "Path 34021",
    d: "M1049.67,344.51l.136.068Z",
    transform: "translate(-526.021 -273.466)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34022",
    "data-name": "Path 34022",
    d: "M1051,344.18l.206.206Z",
    transform: "translate(-527.077 -273.204)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34023",
    "data-name": "Path 34023",
    d: "M917,345.18v.206h.825Z",
    transform: "translate(-420.709 -273.998)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34024",
    "data-name": "Path 34024",
    d: "M930,345.18l.206.206Z",
    transform: "translate(-431.028 -273.998)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34025",
    "data-name": "Path 34025",
    d: "M931,345.18l.206.206Z",
    transform: "translate(-431.822 -273.998)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34026",
    "data-name": "Path 34026",
    d: "M932,345.18l.206.206L932,345.18m22.271,0,.206.206Z",
    transform: "translate(-432.616 -273.998)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34027",
    "data-name": "Path 34027",
    d: "M1045,345.18l.206.206Z",
    transform: "translate(-522.314 -273.998)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34028",
    "data-name": "Path 34028",
    d: "M975.322,346.18l.206.206-.206-.206m.825,0,.206.206-.206-.206m-.412.206.206.206-.206-.206M958,347.417l.206.206Z",
    transform: "translate(-453.254 -274.792)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34029",
    "data-name": "Path 34029",
    d: "M949.268,353.18v.206l.825.412V354c-.757-.247-1.858-.885-2.474-.206l-.619-.206.825.619-.412.412v.206l1.65.206-1.031-1.443c1.947.817,3.809.466,5.774,1.031.734.21,1.848.8,2.062-.206l.619.412-.825-1.031,5.568,1.237v-.206l-1.031-.206v-.206l.825-.206V354l-6.8-.825,1.444,1.443Z",
    transform: "translate(-444.523 -280.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34030",
    "data-name": "Path 34030",
    d: "M961,352.18v.206h.619Z",
    transform: "translate(-455.636 -279.555)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34031",
    "data-name": "Path 34031",
    d: "M964,352.18l.206.206Z",
    transform: "translate(-458.017 -279.555)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34032",
    "data-name": "Path 34032",
    d: "M1051,352.18l.206.206Z",
    transform: "translate(-527.077 -279.555)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34033",
    "data-name": "Path 34033",
    d: "M1021.774,353.8l.412.619-5.361-.619-.825.412v.206l2.887.825-.206-.619,4.949.619,2.062-.619v-.206l-1.237-.206V354l2.062.412.413-.825-1.65-.412.412.619C1023.877,353.044,1023.543,353.6,1021.774,353.8Z",
    transform: "translate(-499.294 -280.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34034",
    "data-name": "Path 34034",
    d: "M1055,352.18l.206.206Z",
    transform: "translate(-530.252 -279.555)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34035",
    "data-name": "Path 34035",
    d: "M1056,352.18l.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-531.046 -279.555)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34036",
    "data-name": "Path 34036",
    d: "M1061,352.18l.206.206Z",
    transform: "translate(-535.015 -279.555)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34037",
    "data-name": "Path 34037",
    d: "M1062,352.18l.206.206Z",
    transform: "translate(-535.809 -279.555)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34038",
    "data-name": "Path 34038",
    d: "M966,353.18l.206.206Z",
    transform: "translate(-459.605 -280.349)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34039",
    "data-name": "Path 34039",
    d: "M985,353.18l.206.206Z",
    transform: "translate(-474.687 -280.349)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34040",
    "data-name": "Path 34040",
    d: "M1050,353.18l.206.206Z",
    transform: "translate(-526.283 -280.349)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34041",
    "data-name": "Path 34041",
    d: "M1057,353.18l.206.206Z",
    transform: "translate(-531.84 -280.349)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34042",
    "data-name": "Path 34042",
    d: "M1058,353.18l.206.206Z",
    transform: "translate(-532.633 -280.349)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34043",
    "data-name": "Path 34043",
    d: "M1059,353.386v.206l.825.206-.412-.619Z",
    transform: "translate(-533.427 -280.349)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34044",
    "data-name": "Path 34044",
    d: "M1064,353.18l.206.206Z",
    transform: "translate(-537.396 -280.349)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34045",
    "data-name": "Path 34045",
    d: "M870.579,354.18v.206l.619.206v.206l-2.268-.206.412.619-3.3-.825.412,1.031L858,354.386c.538,1.662,4.865,1.18,6.393,1.65l.412-.825c.7.295,1.668.635,1.65-.412l.619.206-.206.619,4.143-.468,2.044.056,3.506.206v-.206Z",
    transform: "translate(-373.875 -281.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34046",
    "data-name": "Path 34046",
    d: "M921,354.18l.206.206Z",
    transform: "translate(-423.884 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34047",
    "data-name": "Path 34047",
    d: "M946.33,354.85l.068.138Z",
    transform: "translate(-443.991 -281.674)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34048",
    "data-name": "Path 34048",
    d: "M947,354.18l.206.206Z",
    transform: "translate(-444.523 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34049",
    "data-name": "Path 34049",
    d: "M948,354.18l.206.206Z",
    transform: "translate(-445.316 -281.142)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34050",
    "data-name": "Path 34050",
    d: "M954,354.18l.206.206Z",
    transform: "translate(-450.079 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34051",
    "data-name": "Path 34051",
    d: "M955,354.18l.206.206L955,354.18m.687.138.068.138Z",
    transform: "translate(-450.873 -281.142)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34052",
    "data-name": "Path 34052",
    d: "M961,354.18l.206.206Z",
    transform: "translate(-455.636 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34053",
    "data-name": "Path 34053",
    d: "M962,354.18l.619.412v-.206Z",
    transform: "translate(-456.43 -281.142)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34054",
    "data-name": "Path 34054",
    d: "M963,354.18l.206.206Z",
    transform: "translate(-457.223 -281.142)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34055",
    "data-name": "Path 34055",
    d: "M968,354.18l.412.412Z",
    transform: "translate(-461.192 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34056",
    "data-name": "Path 34056",
    d: "M969,354.18l.206.206Z",
    transform: "translate(-461.986 -281.142)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34057",
    "data-name": "Path 34057",
    d: "M990,354.18l.206.206Z",
    transform: "translate(-478.656 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34058",
    "data-name": "Path 34058",
    d: "M1049,354.18l.206.206Z",
    transform: "translate(-525.489 -281.142)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34059",
    "data-name": "Path 34059",
    d: "M1050,354.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-526.283 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34060",
    "data-name": "Path 34060",
    d: "M1053,354.18v.206h.619Z",
    transform: "translate(-528.664 -281.142)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34061",
    "data-name": "Path 34061",
    d: "M1056,354.18l.206.206Z",
    transform: "translate(-531.046 -281.142)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34062",
    "data-name": "Path 34062",
    d: "M1060,354.18l.206.206Z",
    transform: "translate(-534.221 -281.142)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34063",
    "data-name": "Path 34063",
    d: "M1065,354.18l.206.206Z",
    transform: "translate(-538.19 -281.142)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34064",
    "data-name": "Path 34064",
    d: "M1066,354.18l.206.206Z",
    transform: "translate(-538.984 -281.142)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34065",
    "data-name": "Path 34065",
    d: "M1067,354.18l.206.206Z",
    transform: "translate(-539.778 -281.142)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34066",
    "data-name": "Path 34066",
    d: "M859,355.18l.206.206Z",
    transform: "translate(-374.669 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34067",
    "data-name": "Path 34067",
    d: "M860,355.18l.206.206Z",
    transform: "translate(-375.463 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34068",
    "data-name": "Path 34068",
    d: "M896.33,355.85l.068.138Z",
    transform: "translate(-404.301 -282.468)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34069",
    "data-name": "Path 34069",
    d: "M901,355.18l.206.206Z",
    transform: "translate(-408.008 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34070",
    "data-name": "Path 34070",
    d: "M902,355.18l.206.206L902,355.18m1.65,0,.206.206Z",
    transform: "translate(-408.802 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34071",
    "data-name": "Path 34071",
    d: "M911,355.18v.206h.825Z",
    transform: "translate(-415.946 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34072",
    "data-name": "Path 34072",
    d: "M915,355.18l.206.206Z",
    transform: "translate(-419.121 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34073",
    "data-name": "Path 34073",
    d: "M919.33,355.85l.068.138Z",
    transform: "translate(-422.558 -282.468)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34074",
    "data-name": "Path 34074",
    d: "M923,355.18l.206.206Z",
    transform: "translate(-425.472 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34075",
    "data-name": "Path 34075",
    d: "M924,355.18l.206.206Z",
    transform: "translate(-426.265 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34076",
    "data-name": "Path 34076",
    d: "M927,355.18l.206.206Z",
    transform: "translate(-428.647 -281.936)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34077",
    "data-name": "Path 34077",
    d: "M949,355.18l.206.206L949,355.18m.619,0,.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-446.11 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34078",
    "data-name": "Path 34078",
    d: "M959,355.18l.206.206Z",
    transform: "translate(-454.048 -281.936)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34079",
    "data-name": "Path 34079",
    d: "M960,355.18l.206.206Z",
    transform: "translate(-454.842 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34080",
    "data-name": "Path 34080",
    d: "M965,355.18l.206.206L965,355.18m3.506,0,.206.206Z",
    transform: "translate(-458.811 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34081",
    "data-name": "Path 34081",
    d: "M984,355.18l.206.206Z",
    transform: "translate(-473.893 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34082",
    "data-name": "Path 34082",
    d: "M985,355.18l.206.206Z",
    transform: "translate(-474.687 -281.936)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34083",
    "data-name": "Path 34083",
    d: "M994.67,355.51l.138.068Z",
    transform: "translate(-482.363 -282.198)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34084",
    "data-name": "Path 34084",
    d: "M996,355.18l.206.206L996,355.18m4.949,0,.206.206Z",
    transform: "translate(-483.418 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34085",
    "data-name": "Path 34085",
    d: "M1021,355.18l.206.206Z",
    transform: "translate(-503.263 -281.936)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34086",
    "data-name": "Path 34086",
    d: "M1044,355.18l.206.206Z",
    transform: "translate(-521.52 -281.936)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34087",
    "data-name": "Path 34087",
    d: "M1045,355.18l.206.206Z",
    transform: "translate(-522.314 -281.936)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34088",
    "data-name": "Path 34088",
    d: "M1046,355.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-523.108 -281.936)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34089",
    "data-name": "Path 34089",
    d: "M902.143,355.51l.136.068-.136-.068M862,355.648l.206.206Z",
    transform: "translate(-377.051 -282.198)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34090",
    "data-name": "Path 34090",
    d: "M863,356.18l.206.206Z",
    transform: "translate(-377.844 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34091",
    "data-name": "Path 34091",
    d: "M904,356.18l.206.206Z",
    transform: "translate(-410.39 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34092",
    "data-name": "Path 34092",
    d: "M905,356.18l.206.206Z",
    transform: "translate(-411.183 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34093",
    "data-name": "Path 34093",
    d: "M910,356.18l.206.206L910,356.18m1.65,0,.206.206Z",
    transform: "translate(-415.152 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34094",
    "data-name": "Path 34094",
    d: "M920,356.18l.206.206Z",
    transform: "translate(-423.09 -282.73)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34095",
    "data-name": "Path 34095",
    d: "M921,356.18l.206.206L921,356.18m1.65,0,.206.206Z",
    transform: "translate(-423.884 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34096",
    "data-name": "Path 34096",
    d: "M930,356.18l.206.206Z",
    transform: "translate(-431.028 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34097",
    "data-name": "Path 34097",
    d: "M931,356.18l.206.206Z",
    transform: "translate(-431.822 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34098",
    "data-name": "Path 34098",
    d: "M932.67,356.51l.138.068Z",
    transform: "translate(-433.148 -282.992)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34099",
    "data-name": "Path 34099",
    d: "M934,356.18l.206.206Z",
    transform: "translate(-434.203 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34100",
    "data-name": "Path 34100",
    d: "M947,356.18l.206.206Z",
    transform: "translate(-444.523 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34101",
    "data-name": "Path 34101",
    d: "M955,356.18l.206.206Z",
    transform: "translate(-450.873 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34102",
    "data-name": "Path 34102",
    d: "M956,356.18l.206.206Z",
    transform: "translate(-451.667 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34103",
    "data-name": "Path 34103",
    d: "M960.67,356.248l.138.068-.138-.068m.687-.068.206.206Z",
    transform: "translate(-455.374 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34104",
    "data-name": "Path 34104",
    d: "M965,356.18l.206.206L965,356.18m1.237,0v.206h.619Z",
    transform: "translate(-458.811 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34105",
    "data-name": "Path 34105",
    d: "M974,356.18l.206.206Z",
    transform: "translate(-465.955 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34106",
    "data-name": "Path 34106",
    d: "M975,356.18l.206.206Z",
    transform: "translate(-466.749 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34107",
    "data-name": "Path 34107",
    d: "M983,356.18l.206.206Z",
    transform: "translate(-473.099 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34108",
    "data-name": "Path 34108",
    d: "M986,356.18l.206.206Z",
    transform: "translate(-475.48 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34109",
    "data-name": "Path 34109",
    d: "M989,356.18l.619.619Z",
    transform: "translate(-477.862 -282.73)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34110",
    "data-name": "Path 34110",
    d: "M990,356.18l.206.206L990,356.18m1.65,0,.206.206Z",
    transform: "translate(-478.656 -282.73)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34111",
    "data-name": "Path 34111",
    d: "M1023,356.18l.206.206-.206-.206m8.867,0,.206.206Z",
    transform: "translate(-504.851 -282.73)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34112",
    "data-name": "Path 34112",
    d: "M865,357.18l.206.206Z",
    transform: "translate(-379.432 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34113",
    "data-name": "Path 34113",
    d: "M866,357.18l.206.206Z",
    transform: "translate(-380.226 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34114",
    "data-name": "Path 34114",
    d: "M867,357.18l.206.206Z",
    transform: "translate(-381.019 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34115",
    "data-name": "Path 34115",
    d: "M868.67,357.51l.138.068Z",
    transform: "translate(-382.345 -283.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34116",
    "data-name": "Path 34116",
    d: "M870,357.18v.206h1.443Z",
    transform: "translate(-383.401 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34117",
    "data-name": "Path 34117",
    d: "M878,357.18l.206.206L878,357.18m.825,0,.206.206Z",
    transform: "translate(-389.751 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34118",
    "data-name": "Path 34118",
    d: "M883.67,357.51l.138.068Z",
    transform: "translate(-394.252 -283.786)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34119",
    "data-name": "Path 34119",
    d: "M885,357.18l.206.206L885,357.18m.412,0,.206.206Z",
    transform: "translate(-395.308 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34120",
    "data-name": "Path 34120",
    d: "M890,357.18l.206.206Z",
    transform: "translate(-399.277 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34121",
    "data-name": "Path 34121",
    d: "M891,357.18l.206.206Z",
    transform: "translate(-400.07 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34122",
    "data-name": "Path 34122",
    d: "M897,357.18l.206.206Z",
    transform: "translate(-404.833 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34123",
    "data-name": "Path 34123",
    d: "M899,357.18l.206.206Z",
    transform: "translate(-406.421 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34124",
    "data-name": "Path 34124",
    d: "M900,357.18l.206.206Z",
    transform: "translate(-407.215 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34125",
    "data-name": "Path 34125",
    d: "M906,357.18l.206.206Z",
    transform: "translate(-411.977 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34126",
    "data-name": "Path 34126",
    d: "M907,357.18l.206.206Z",
    transform: "translate(-412.771 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34127",
    "data-name": "Path 34127",
    d: "M909,357.386v.206h.825l-.825-.206m1.443-.206.206.206-.206-.206m5.706.068.138.068Z",
    transform: "translate(-414.359 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34128",
    "data-name": "Path 34128",
    d: "M945,357.18l.206.206Z",
    transform: "translate(-442.935 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34129",
    "data-name": "Path 34129",
    d: "M947.206,357.18l-.206.412.206-.412m1.031,0,.206.206Z",
    transform: "translate(-444.523 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34130",
    "data-name": "Path 34130",
    d: "M958,357.18l.206.206Z",
    transform: "translate(-453.254 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34131",
    "data-name": "Path 34131",
    d: "M978.67,357.51l.138.068Z",
    transform: "translate(-469.662 -283.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34132",
    "data-name": "Path 34132",
    d: "M980,357.18l.206.206L980,357.18m.825,0,.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-470.718 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34133",
    "data-name": "Path 34133",
    d: "M991,357.18l.206.206Z",
    transform: "translate(-479.449 -283.524)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34134",
    "data-name": "Path 34134",
    d: "M992,357.18l.206.206Z",
    transform: "translate(-480.243 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34135",
    "data-name": "Path 34135",
    d: "M996,357.18l.206.206Z",
    transform: "translate(-483.418 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34136",
    "data-name": "Path 34136",
    d: "M1000,357.18v.206h.825Z",
    transform: "translate(-486.594 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34137",
    "data-name": "Path 34137",
    d: "M1004,357.18l.206.206-.206-.206m1.237,0,.206.206Z",
    transform: "translate(-489.769 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34138",
    "data-name": "Path 34138",
    d: "M1011.67,357.51l.136.068-.136-.068m.48.138v.206l1.237-.206Z",
    transform: "translate(-495.857 -283.786)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34139",
    "data-name": "Path 34139",
    d: "M1020,357.18l.206.206-.206-.206m1.031,0,.206.206Z",
    transform: "translate(-502.469 -283.524)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34140",
    "data-name": "Path 34140",
    d: "M1043,358.18v.206h.619Z",
    transform: "translate(-520.727 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34141",
    "data-name": "Path 34141",
    d: "M1057,357.18v.206l.825.206Z",
    transform: "translate(-531.84 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34142",
    "data-name": "Path 34142",
    d: "M1067,357.18l.206.206Z",
    transform: "translate(-539.778 -283.524)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34143",
    "data-name": "Path 34143",
    d: "M1068,357.18l.206.206Z",
    transform: "translate(-540.571 -283.524)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34144",
    "data-name": "Path 34144",
    d: "M858,358.18l.206.206Z",
    transform: "translate(-373.875 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34145",
    "data-name": "Path 34145",
    d: "M884,358.18l.206.206Z",
    transform: "translate(-394.514 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34146",
    "data-name": "Path 34146",
    d: "M893,358.18l.206.206Z",
    transform: "translate(-401.658 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34147",
    "data-name": "Path 34147",
    d: "M900,358.18v.412l.412-.412H900m3.712,0,.206.206Z",
    transform: "translate(-407.215 -284.317)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34148",
    "data-name": "Path 34148",
    d: "M919,358.18l.206.206Z",
    transform: "translate(-422.297 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34149",
    "data-name": "Path 34149",
    d: "M920.67,358.51l.138.068Z",
    transform: "translate(-423.622 -284.579)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34150",
    "data-name": "Path 34150",
    d: "M948.67,358.51l.138.068Z",
    transform: "translate(-445.848 -284.579)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34151",
    "data-name": "Path 34151",
    d: "M947.619,358.18l-.619.412v.206Z",
    transform: "translate(-444.523 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34152",
    "data-name": "Path 34152",
    d: "M954,358.18l.206.206Z",
    transform: "translate(-450.079 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34153",
    "data-name": "Path 34153",
    d: "M961,358.18l.206.206Z",
    transform: "translate(-455.636 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34154",
    "data-name": "Path 34154",
    d: "M962,358.18l.206.206L962,358.18m1.169.068.138.068Z",
    transform: "translate(-456.43 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34155",
    "data-name": "Path 34155",
    d: "M969,358.18l.206.206Z",
    transform: "translate(-461.986 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34156",
    "data-name": "Path 34156",
    d: "M970,358.18l.206.206L970,358.18m2.268,0,.206.206Z",
    transform: "translate(-462.78 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34157",
    "data-name": "Path 34157",
    d: "M984.206,358.18l-.206.412Z",
    transform: "translate(-473.893 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34158",
    "data-name": "Path 34158",
    d: "M994,358.18l.206.206Z",
    transform: "translate(-481.831 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34159",
    "data-name": "Path 34159",
    d: "M998,358.18l.206.206L998,358.18m1.65,0,.206.206Z",
    transform: "translate(-485.006 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34160",
    "data-name": "Path 34160",
    d: "M1007.67,358.248l.136.068-.136-.068m3.78-.068.206.206-.206-.206m.619,0,.206.206Z",
    transform: "translate(-492.682 -284.317)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34161",
    "data-name": "Path 34161",
    d: "M1030,358.18l.206.206-.206-.206m1.169.068.136.068Z",
    transform: "translate(-510.407 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34162",
    "data-name": "Path 34162",
    d: "M1037,358.18l.206.206-.206-.206m.412,0v.206h.825Z",
    transform: "translate(-515.964 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34163",
    "data-name": "Path 34163",
    d: "M1044,358.18l.206.206Z",
    transform: "translate(-521.52 -284.317)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34164",
    "data-name": "Path 34164",
    d: "M1049,358.18l.206.206Z",
    transform: "translate(-525.489 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34165",
    "data-name": "Path 34165",
    d: "M1050,358.18l.206.206Z",
    transform: "translate(-526.283 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M1061,358.18l.206.206Z",
    transform: "translate(-535.015 -284.317)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M1062.67,358.51l.136.068Z",
    transform: "translate(-536.34 -284.579)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34168",
    "data-name": "Path 34168",
    d: "M1064,358.18l.206.206Z",
    transform: "translate(-537.396 -284.317)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34169",
    "data-name": "Path 34169",
    d: "M859,359.18l.206.206Z",
    transform: "translate(-374.669 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34170",
    "data-name": "Path 34170",
    d: "M860.67,359.248l.138.068-.138-.068m6.254-.068.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-375.995 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34171",
    "data-name": "Path 34171",
    d: "M896.67,359.51l.138.068Z",
    transform: "translate(-404.571 -285.373)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34172",
    "data-name": "Path 34172",
    d: "M898,359.18l.206.206Z",
    transform: "translate(-405.627 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34173",
    "data-name": "Path 34173",
    d: "M918,359.18l.206.206Z",
    transform: "translate(-421.503 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34174",
    "data-name": "Path 34174",
    d: "M924,359.18l.206.206Z",
    transform: "translate(-426.265 -285.111)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34175",
    "data-name": "Path 34175",
    d: "M925,359.18l.206.206L925,359.18m1.237,0,.206.206Z",
    transform: "translate(-427.059 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34176",
    "data-name": "Path 34176",
    d: "M932,359.18l.206.206Z",
    transform: "translate(-432.616 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34177",
    "data-name": "Path 34177",
    d: "M937,359.18l.206.206L937,359.18m.551.068.138.068Z",
    transform: "translate(-436.585 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34178",
    "data-name": "Path 34178",
    d: "M941,359.18l.206.206Z",
    transform: "translate(-439.76 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34179",
    "data-name": "Path 34179",
    d: "M950,359.18l.206.206L950,359.18m1.031,0,.206.206Z",
    transform: "translate(-446.904 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34180",
    "data-name": "Path 34180",
    d: "M977,359.18l.206.206Z",
    transform: "translate(-468.336 -285.111)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34181",
    "data-name": "Path 34181",
    d: "M978,359.18l.206.206L978,359.18m1.031,0,.206.206Z",
    transform: "translate(-469.13 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34182",
    "data-name": "Path 34182",
    d: "M985.67,359.51l.138.068Z",
    transform: "translate(-475.219 -285.373)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34183",
    "data-name": "Path 34183",
    d: "M987,359.18l.206.206Z",
    transform: "translate(-476.274 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34184",
    "data-name": "Path 34184",
    d: "M990,359.18l.412.412Z",
    transform: "translate(-478.656 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34185",
    "data-name": "Path 34185",
    d: "M992,359.18l.206.206Z",
    transform: "translate(-480.243 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34186",
    "data-name": "Path 34186",
    d: "M995,359.18l.206.206Z",
    transform: "translate(-482.625 -285.111)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34187",
    "data-name": "Path 34187",
    d: "M1011,359.18l.206.206Z",
    transform: "translate(-495.325 -285.111)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34188",
    "data-name": "Path 34188",
    d: "M1023,359.18l.206.206Z",
    transform: "translate(-504.851 -285.111)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34189",
    "data-name": "Path 34189",
    d: "M1027,359.18l.206.206Z",
    transform: "translate(-508.026 -285.111)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34190",
    "data-name": "Path 34190",
    d: "M864,360.18v.206h.825Z",
    transform: "translate(-378.638 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34191",
    "data-name": "Path 34191",
    d: "M868,360.18l.206.206Z",
    transform: "translate(-381.813 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34192",
    "data-name": "Path 34192",
    d: "M869,360.18l.206.206Z",
    transform: "translate(-382.607 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34193",
    "data-name": "Path 34193",
    d: "M870,360.18l.206.206L870,360.18m.825,0,.206.206Z",
    transform: "translate(-383.401 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34194",
    "data-name": "Path 34194",
    d: "M875,360.18v.206h1.031Z",
    transform: "translate(-387.37 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34195",
    "data-name": "Path 34195",
    d: "M880,360.18l.206.206Z",
    transform: "translate(-391.339 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34196",
    "data-name": "Path 34196",
    d: "M883,360.18l.206.206Z",
    transform: "translate(-393.72 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34197",
    "data-name": "Path 34197",
    d: "M891,360.18l.206.206Z",
    transform: "translate(-400.07 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34198",
    "data-name": "Path 34198",
    d: "M893,360.18l.206.206Z",
    transform: "translate(-401.658 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34199",
    "data-name": "Path 34199",
    d: "M894,360.18l.206.206L894,360.18m1.031,0,.206.206Z",
    transform: "translate(-402.452 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34200",
    "data-name": "Path 34200",
    d: "M900,360.18l.206.206L900,360.18m.825,0,.206.206Z",
    transform: "translate(-407.215 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34201",
    "data-name": "Path 34201",
    d: "M905,360.18l.206.206Z",
    transform: "translate(-411.183 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34202",
    "data-name": "Path 34202",
    d: "M906,360.18l.206.206L906,360.18m1.031,0-.206.412.206-.412m3.3,0,.206.206-.206-.206m.825,0-.206.412h.412Z",
    transform: "translate(-411.977 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34203",
    "data-name": "Path 34203",
    d: "M945,360.18l.206.206Z",
    transform: "translate(-442.935 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34204",
    "data-name": "Path 34204",
    d: "M946,360.18l.206.206L946,360.18m2.062,0,.206.206Z",
    transform: "translate(-443.729 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34205",
    "data-name": "Path 34205",
    d: "M980,360.18l.206.206Z",
    transform: "translate(-470.718 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34206",
    "data-name": "Path 34206",
    d: "M981,360.18l.206.206Z",
    transform: "translate(-471.512 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34207",
    "data-name": "Path 34207",
    d: "M986,360.18v.206h.619Z",
    transform: "translate(-475.48 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34208",
    "data-name": "Path 34208",
    d: "M990,360.18l.206.206L990,360.18m1.443,0,.206.206Z",
    transform: "translate(-478.656 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34209",
    "data-name": "Path 34209",
    d: "M998,360.18l.206.206Z",
    transform: "translate(-485.006 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34210",
    "data-name": "Path 34210",
    d: "M1000,360.18l.206.206Z",
    transform: "translate(-486.594 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34211",
    "data-name": "Path 34211",
    d: "M1001,360.18l.206.206-.206-.206m2.681,0,.206.206Z",
    transform: "translate(-487.387 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34212",
    "data-name": "Path 34212",
    d: "M1015,360.18l.206.206Z",
    transform: "translate(-498.5 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34213",
    "data-name": "Path 34213",
    d: "M1029,360.18l.206.206Z",
    transform: "translate(-509.613 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34214",
    "data-name": "Path 34214",
    d: "M1037,360.18l.206.206Z",
    transform: "translate(-515.964 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34215",
    "data-name": "Path 34215",
    d: "M1038.67,360.248l.136.068-.136-.068m.893-.068v.206h.619l-.619-.206m.825,0,.206.206-.206-.206m.825,0,.206.206Z",
    transform: "translate(-517.289 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34216",
    "data-name": "Path 34216",
    d: "M1052,360.18l.206.206Z",
    transform: "translate(-527.871 -285.905)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34217",
    "data-name": "Path 34217",
    d: "M1054,360.18l.206.206Z",
    transform: "translate(-529.458 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34218",
    "data-name": "Path 34218",
    d: "M1055.67,360.51l.136.068Z",
    transform: "translate(-530.784 -286.167)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34219",
    "data-name": "Path 34219",
    d: "M1061,360.18l.206.206Z",
    transform: "translate(-535.015 -285.905)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34220",
    "data-name": "Path 34220",
    d: "M911.18,360.18l.206.206-.206-.206m-39.18.206.206.206Z",
    transform: "translate(-384.988 -285.905)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34221",
    "data-name": "Path 34221",
    d: "M873,361.18l.206.206Z",
    transform: "translate(-385.782 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34222",
    "data-name": "Path 34222",
    d: "M884,361.18l.206.206Z",
    transform: "translate(-394.514 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34223",
    "data-name": "Path 34223",
    d: "M889,361.18l.206.206Z",
    transform: "translate(-398.483 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34224",
    "data-name": "Path 34224",
    d: "M890,361.18l.206.206Z",
    transform: "translate(-399.277 -286.699)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34225",
    "data-name": "Path 34225",
    d: "M891,361.18l.206.206Z",
    transform: "translate(-400.07 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34226",
    "data-name": "Path 34226",
    d: "M902,361.18l.206.206Z",
    transform: "translate(-408.802 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34227",
    "data-name": "Path 34227",
    d: "M908,361.18l.206.206Z",
    transform: "translate(-413.565 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34228",
    "data-name": "Path 34228",
    d: "M909,361.18l.206.206Z",
    transform: "translate(-414.359 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34229",
    "data-name": "Path 34229",
    d: "M911,361.18l.206.206Z",
    transform: "translate(-415.946 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34230",
    "data-name": "Path 34230",
    d: "M929,361.18l.206.206L929,361.18m4.949,0,.206.206-.206-.206m6.393,0,.206.206Z",
    transform: "translate(-430.234 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34231",
    "data-name": "Path 34231",
    d: "M985,361.18l.206.206Z",
    transform: "translate(-474.687 -286.699)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34232",
    "data-name": "Path 34232",
    d: "M1003,361.18l.206.206Z",
    transform: "translate(-488.975 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34233",
    "data-name": "Path 34233",
    d: "M1004,361.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-489.769 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34234",
    "data-name": "Path 34234",
    d: "M1007,361.18l.206.206Z",
    transform: "translate(-492.15 -286.699)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34235",
    "data-name": "Path 34235",
    d: "M1010,361.18l.206.206Z",
    transform: "translate(-494.531 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34236",
    "data-name": "Path 34236",
    d: "M1011.67,361.51l.136.068Z",
    transform: "translate(-495.857 -286.961)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34237",
    "data-name": "Path 34237",
    d: "M1016.33,361.318l.07.138-.07-.138m1.582-.138.206.206Z",
    transform: "translate(-499.556 -286.699)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34238",
    "data-name": "Path 34238",
    d: "M1029,361.18l.206.206-.206-.206m4.124,0,.206.206Z",
    transform: "translate(-509.613 -286.699)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34239",
    "data-name": "Path 34239",
    d: "M886,362.18l.206.206Z",
    transform: "translate(-396.101 -287.493)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34240",
    "data-name": "Path 34240",
    d: "M889,362.18l.206.206L889,362.18m13.748.068.138.068Z",
    transform: "translate(-398.483 -287.493)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34241",
    "data-name": "Path 34241",
    d: "M1014,362.18l.206.206Z",
    transform: "translate(-497.707 -287.493)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34242",
    "data-name": "Path 34242",
    d: "M1015,362.18l.206.206Z",
    transform: "translate(-498.5 -287.493)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34243",
    "data-name": "Path 34243",
    d: "M1026,362.18l.206.206Z",
    transform: "translate(-507.232 -287.493)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34244",
    "data-name": "Path 34244",
    d: "M1030.33,362.318l.07.138-.07-.138m4.056-.138.206.206Z",
    transform: "translate(-510.669 -287.493)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34245",
    "data-name": "Path 34245",
    d: "M1051,362.18l.206.206-.206-.206m.412,0,.206.206Z",
    transform: "translate(-527.077 -287.493)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34246",
    "data-name": "Path 34246",
    d: "M888.67,363.51l.138.068Z",
    transform: "translate(-398.221 -288.548)",
    fill: "#f79b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34247",
    "data-name": "Path 34247",
    d: "M1027.67,363.51l.136.068Z",
    transform: "translate(-508.558 -288.548)",
    fill: "#f9b280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34248",
    "data-name": "Path 34248",
    d: "M1029,363.18l.206.206Z",
    transform: "translate(-509.613 -288.286)",
    fill: "#fcd5ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19679",
    "data-name": "Group 19679",
    transform: "translate(387 96.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34249",
    "data-name": "Path 34249",
    d: "M859.776,503.3h.412c5.712-8.467,11.944-16.542,17.74-24.951,2.654-3.85,5.97-7.859,7.83-12.166l-5.667.212-1.757,2.468-3.86,5.774-9.31,12.785-4.976,7.011h-.412l-5.182-7.217-9.166-12.579-3.862-5.774-1.712-2.468L834,466.18c1.714,3.625,4.363,7.03,6.656,10.31C846.874,485.388,854.4,493.866,859.776,503.3Z",
    transform: "translate(-741.824 -466.18)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34250",
    "data-name": "Path 34250",
    d: "M559.272,534.389l-7.716-20.209-18.146,4.149-7.384,1.819-1.771,2.487-3.423,5.774c8.9-.388,17.5-5.386,26.395-5.774.711,4.135,3.06,8.459,4.576,12.373,2.4,6.2,4.359,12.74,7.178,18.765l-37.324,7.836-1.2-14.847L519.18,531.3c-1.4,1.157-3.842,4.59-4.19,6.393-.377,1.955.324,4.417.46,6.392.4,5.745,1.256,11.564,1.256,17.322l-39.8-9.873L462.266,548c.695-2.194,2.367-4.219,3.547-6.186,2.565-4.275,5.188-8.512,7.753-12.785.895-1.491,2.538-5.669,4.186-6.3a5.708,5.708,0,0,1,2.66.276c1.99.382,3.99.7,5.98,1.072-.625-1.978-2.1-3.774-3.124-5.568a6.588,6.588,0,0,0-1.687-2.439c-2.384-1.476-6.061-.732-8.593-.241-5.693,1.1-11.42,2.035-17.115,3.134-5.351,1.033-10.729,1.924-16.084,2.926-2.126.4-5.089.39-7.011,1.4-1.866.979-3.468,3.227-4.949,4.71l-9.9,9.9c-6.972,6.972-14.057,13.849-21.033,20.827-3.223,3.223-7.275,6.38-9.9,10.1,16.26-3.153,32.445-6.747,48.665-10.1l14.847-3.093c2.217-.46,4.747-1.406,7.011-1.406,1.749,0,3.666.821,5.361,1.223,3.512.833,7.015,1.7,10.517,2.58l30.313,7.578c4.937,1.235,10.2,3.188,15.26,3.726,1.384.146,2.978-.483,4.33-.753,3.167-.633,6.318-1.347,9.486-1.98,11.888-2.378,23.863-5.912,35.88-7.465l-9.4-24.745Zm-102.41,12.426c-1.087.8-3.186.88-4.493,1.142-3.235.647-6.456,1.373-9.692,2.021-11.247,2.254-22.716,4.219-33.818,7.094,1.608-2.285,4.013-4.015,5.98-5.98l12.373-12.373c2.672-2.672,5.726-7.077,9.073-8.834,3.025-1.588,7.974-1.575,11.341-2.184,7.8-1.408,15.641-3.244,23.508-4.244-2.5,5.8-6.689,11.333-10.018,16.7-1.2,1.94-2.4,5.287-4.254,6.652Z",
    transform: "translate(-387 -504.282)",
    fill: "#f57d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19680",
    "data-name": "Group 19680",
    transform: "translate(613.724 37.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34251",
    "data-name": "Path 34251",
    d: "M306.029,1066.18c-10.537,0-21.9,2.533-29.654,10.132-6.793,6.653-10.178,16.563-11.42,25.805-1.378,10.244-1.57,23.29,7.229,30.543,10.272,8.464,26.667,7.672,39.078,5.89,2.641-.38,10.171-.509,11.852-2.784.708-.963.359-2.868.359-3.991v-10.467c-11.308,1.521-33.352,8.681-38.3-6.978A23.776,23.776,0,0,1,284.4,1107h45.358c2.048-9.923,5.663-22.016-.164-31.4C324.748,1067.8,314.459,1066.18,306.029,1066.18Zm6.978,28.959H286.141c1.375-4.846,3.444-9.672,8.025-12.323,5.2-3.008,16.057-4.037,19.068,2.554C314.717,1088.618,313.688,1091.845,313.007,1095.139Z",
    transform: "translate(-172.049 -1042.454)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34252",
    "data-name": "Path 34252",
    d: "M71.086,998.539l-.911,3.827-1.535,10.816-6.186,44.312-21.193-42.218-5.935-12.212-2.666-4.525-4.4-.359H17.445l-4.33.81-1.347,8.611-2.742,19.888-6.333,45.358L0,1093.781H13.607l4.975-.359.956-3.828,1.441-10.467,3.887-27.564,2-15.352h.349l7.4,14.654,14.138,27.215,5.586,10.816,2.666,4.525,5.446.359H76.411c3.409-18.307,5.115-37.044,7.77-55.476,1.884-13.081,5.216-26.918,5.488-40.124H76.062Z",
    transform: "translate(0 -998.18)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34253",
    "data-name": "Path 34253",
    d: "M670.769,1070.18l-3.095,22.679-6.675,47.8h13.258l5.024-.359,1.054-4.526,1.745-12.561,4.783-34.193,2.4-18.841Z",
    transform: "translate(-430.373 -1045.058)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34255",
    "data-name": "Path 34255",
    d: "M712.934,998.18H694.442L692,1017.719h18.492Z",
    transform: "translate(-450.557 -998.18)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34256",
    "data-name": "Path 34256",
    d: "M805.735,1069.908c-1.5,0-4.138-.5-5.436.359-1.158.764-1.71,2.952-2.24,4.176-1.361,3.154-2.826,6.267-4.187,9.421-5.157,11.947-12.477,24.134-16.05,36.635h-.349l-8.723-50.592H748.165c.269,6.193,2.592,12.795,3.96,18.841q3.9,17.261,7.7,34.542c1.165,5.276,4.005,12.055,3.74,17.445-.1,2.059-2.1,4.407-3.353,5.932-5.059,6.172-11.73,8.164-19.375,6.28l-3.838,15.7c8.869.7,17.592,2.268,26.168-1.2,11.988-4.857,18.373-16.978,23.485-28.1,4.567-9.947,9.389-19.867,14.284-29.657,4.211-8.423,8.116-17,12.215-25.47,2.135-4.41,5.677-9.473,6.538-14.305Z",
    transform: "translate(-479.856 -1044.787)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34258",
    "data-name": "Path 34258",
    d: "M498.609,1081.547c8.9-1.563,19.678.75,28.261,3.168l5.583-15c-7.46-2.1-15.007-2.645-22.679-3.172-7.753-.53-16.461-.687-23.726,2.582-11.21,5.049-18.377,20.324-11.35,31.642,4.682,7.543,14.891,9.127,22.864,10.746,3.042.617,9.5,1.6,10.3,5.3.869,4.009-5.209,6.675-8.206,7.324-6.566,1.42-14.4.01-20.934-1.071-2.237-.37-6.5-2.142-8.646-1.448-1.1.359-1.4,1.922-1.755,2.871-1.057,2.774-2.118,5.569-3.088,8.374-.338.984-1.144,2.6,0,3.339,4.169,2.7,12.519,2.191,17.33,2.652,16.842,1.608,39.936.987,43.872-19.947a25.1,25.1,0,0,0,.279-8.723c-1.961-10.893-14.406-13.827-23.562-15.927-3.6-.827-8.506-1.441-11.085-4.341-3.646-4.1,3.217-7.784,6.549-8.37Z",
    transform: "translate(-302.524 -1042.497)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34259",
    "data-name": "Path 34259",
    d: "M1467.248,1068.947a33.687,33.687,0,0,0-8.723-2.345,39.317,39.317,0,0,0-10.816-.408c-9.152,1.2-18.028,2.906-24.713,9.986-9.3,9.846-12.913,25.847-11.632,39.064.656,6.765,2.435,13.067,7.735,17.731,7.533,6.626,19.521,7.058,28.96,5.893,20.843-2.568,31.872-20.9,32.451-40.721.345-11.7-1.2-23.761-13.261-29.2Zm-6.28,27.8c0,9.829-2.847,24.657-14.305,26.834-4.686.886-10.38.37-13.384-3.807-2.285-3.172-2.317-7.083-2.317-10.816,0-10.049,2.945-24.947,14.654-27.054,4.417-.792,10.143-.181,12.983,3.681C1461.034,1088.9,1460.968,1092.844,1460.968,1096.751Z",
    transform: "translate(-918.767 -1042.322)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34260",
    "data-name": "Path 34260",
    d: "M1879.112,1067.37l-4.42.359-3.953,6.27c-5.157-3.618-9.225-6.6-15.7-7.383a30.709,30.709,0,0,0-8.722.209c-19.225,3.095-25.721,24.594-26.9,41.366-.506,7.233-.607,14.968,2.756,21.632,7.477,14.821,28.831,10.669,39.144,1.744l-1.047,6.629h18.841l2.7-20.236,7.073-50.592h-9.77Zm-12.166,24.772c-.663,4.77-1.288,9.543-1.992,14.305-.527,3.569-.16,10.209-2.191,13.192-1.647,2.425-6.047,3.65-8.771,4.162-19.769,3.712-16.668-24.34-9.955-35.149a14,14,0,0,1,8.908-6.465c3.768-.708,12.662-.213,14.445,4.086C1868.063,1087.9,1867.18,1090.464,1866.946,1092.142Z",
    transform: "translate(-1184.439 -1042.598)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34261",
    "data-name": "Path 34261",
    d: "M1335.781,1015.625l2.093-17.445h-69.781L1266,1015.625h24.772l-2.7,19.888-8.119,58.267h19.888l2.345-17.794,5.586-40.125,2.041-14.3,1.1-5.373,6.371-.558Z",
    transform: "translate(-824.284 -998.18)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34262",
    "data-name": "Path 34262",
    d: "M1015.961,1067.716l-4.32,6.619c-1.842-3.273-5.987-5.24-9.421-6.4a28.611,28.611,0,0,0-28.247,5.5c-3.273,2.931-5.492,6.786-7.428,10.666-6.221,12.477-9.354,32.337-3.231,45.358,7.044,14.982,29.113,11.35,39.256,2.094l-.7,6.629h18.492c1.019-23.718,8.751-47.109,9.769-70.828h-9.769Zm-7.714,24.413c-.7,4.881-1.319,9.776-2.041,14.654-.5,3.349-.122,10.4-2.191,13.073-1.654,2.143-5.879,3.346-8.422,3.866-19.849,4.058-17.254-24.221-10.223-35.083a14.146,14.146,0,0,1,8.827-6.448c3.7-.789,12.8-.167,14.546,4.037C1009.4,1087.817,1008.484,1090.486,1008.247,1092.129Z",
    transform: "translate(-625.053 -1042.585)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34263",
    "data-name": "Path 34263",
    d: "M1684.569,1069.916c-1.518,0-4.117-.492-5.446.359-1.169.747-1.605,2.631-2.149,3.827-1.483,3.249-2.987,6.5-4.414,9.77-5.171,11.849-12.7,23.865-16.252,36.286h-.349l-8.374-50.243H1627l3.7,19.19,10.607,51.987h16.05c1.671,0,4.986.632,6.406-.359,1.33-.928,2.048-3.464,2.753-4.874,2.139-4.285,4.138-8.625,6.28-12.91,5.907-11.817,11.542-23.771,17.446-35.588,2.648-5.3,7.247-11.6,8.286-17.446Z",
    transform: "translate(-1059.328 -1044.795)",
    fill: "#f57d2b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34264",
    "data-name": "Path 34264",
    d: "M1371.474,703.067h.206l3.712,10.723,1.918-.212,1.165-2.674,2.691-7.836h.206V713.79h2.475V700.18l-3.774.212-1.241,2.675-2.408,6.186-2.435-6.392-1.176-2.468L1369,700.18v13.61h2.474Z",
    transform: "translate(-780.833 -552.261)",
    fill: "#f57d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34265",
    "data-name": "Path 34265",
    d: "M1312.124,713.79h2.681V702.242h4.124V700.18H1308v2.062h4.124Z",
    transform: "translate(-732.411 -552.261)",
    fill: "#f57d2b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2bede3e55eb5ef339be379ea53a4a47a.svg";
export { ForwardRef as ReactComponent };